import MessageType from "./messageType";
export var AccessType;
(function (AccessType) {
    AccessType[AccessType["Seen"] = 1] = "Seen";
    AccessType[AccessType["Entered"] = 2] = "Entered";
})(AccessType || (AccessType = {}));
export var NodeProperty;
(function (NodeProperty) {
    NodeProperty["defaultValidationMessage"] = "defaultValidationMessage";
    NodeProperty["toUpperCase"] = "toUpperCase";
    NodeProperty["removeWhiteSpaces"] = "removeWhiteSpaces";
    NodeProperty["placeholder"] = "placeholder";
    NodeProperty["maxLengthValidationMessage"] = "maxLengthValidationMessage";
    NodeProperty["minimumPeriod"] = "minimumPeriod";
    NodeProperty["maximumPeriod"] = "maximumPeriod";
    NodeProperty["confirmButton"] = "confirmButton";
    NodeProperty["datePreset"] = "datePreset";
    NodeProperty["dateAvailabilityType"] = "dateAvailabilityType";
    NodeProperty["yearMask"] = "yearMask";
    NodeProperty["monthMask"] = "monthMask";
    NodeProperty["dayMask"] = "dayMask";
    NodeProperty["shouldNotExeedNow"] = "shouldNotExeedNow";
    NodeProperty["exeedsNowMessage"] = "exeedsNowMessage";
    NodeProperty["date"] = "date";
    NodeProperty["dateFormat"] = "dateFormat";
    NodeProperty["timeZoneId"] = "timeZoneId";
    NodeProperty["hourMask"] = "hourMask";
    NodeProperty["minutesMask"] = "minutesMask";
    NodeProperty["hours"] = "hours";
    NodeProperty["minutes"] = "minutes";
    NodeProperty["dateTimeFormat"] = "dateTimeFormat";
    NodeProperty["countryCode"] = "countryCode";
    NodeProperty["accessId"] = "accessId";
    NodeProperty["allowedFileExtensions"] = "allowedFileExtensions";
    NodeProperty["claimNumberRegex"] = "claimNumberRegex";
    NodeProperty["aclName"] = "aclName";
    NodeProperty["contentOwner"] = "contentOwner";
    NodeProperty["country"] = "country";
    NodeProperty["customerType"] = "customerType";
    NodeProperty["lineOfBusiness"] = "lineOfBusiness";
    NodeProperty["policyType"] = "policyType";
    NodeProperty["headerText"] = "headerText";
    NodeProperty["uploadFilesButtonText"] = "uploadFilesButtonText";
    NodeProperty["uploadInProgressButtonText"] = "uploadInProgressButtonText";
    NodeProperty["browseFilesButtonText"] = "browseFilesButtonText";
    NodeProperty["dropZoneContainerText"] = "dropZoneContainerText";
    NodeProperty["uploadFailedErrorMessage"] = "uploadFailedErrorMessage";
    NodeProperty["fileTypeErrorMessage"] = "fileTypeErrorMessage";
    NodeProperty["maxFileSizeInBytes"] = "maxFileSizeInBytes";
    NodeProperty["fileSizeErrorMessage"] = "fileSizeErrorMessage";
    NodeProperty["fileEmptyErrorMessage"] = "fileEmptyErrorMessage";
    NodeProperty["maxFileCount"] = "maxFileCount";
    NodeProperty["fileCountErrorMessage"] = "fileCountErrorMessage";
    NodeProperty["title"] = "title";
    NodeProperty["openButtonText"] = "openButtonText";
    NodeProperty["maxItemsToSelect"] = "maxItemsToSelect";
    NodeProperty["maxItemsToSelectErrorMessage"] = "maxItemsToSelectErrorMessage";
    NodeProperty["dataSource"] = "dataSource";
    NodeProperty["item"] = "item";
    NodeProperty["defaultButton"] = "defaultButton";
    NodeProperty["submitHint"] = "submitHint";
    NodeProperty["ratingHint"] = "ratingHint";
    NodeProperty["displayRecorded"] = "displayRecorded";
    NodeProperty["recordNodeValueBag"] = "recordNodeValueBag";
    NodeProperty["statisticsEventType"] = "statisticsEventType";
    NodeProperty["inputPlaceholder"] = "inputPlaceholder";
    NodeProperty["noResultsFoundMessage"] = "noResultsFoundMessage";
    NodeProperty["allowAnyValue"] = "allowAnyValue";
    NodeProperty["carouselNodeName"] = "carouselNodeName";
    NodeProperty["listItemDisplayPattern"] = "listItemDisplayPattern";
    NodeProperty["column1"] = "column1";
    NodeProperty["column2"] = "column2";
    NodeProperty["column3"] = "column3";
    NodeProperty["noItemsInListMessage"] = "noItemsInListMessage";
    NodeProperty["removeButtonText"] = "removeButtonText";
    NodeProperty["undoRemoveButtonText"] = "undoRemoveButtonText";
    NodeProperty["minItemCount"] = "minItemCount";
    NodeProperty["maxItemCount"] = "maxItemCount";
    NodeProperty["minCountErrorMessage"] = "minCountErrorMessage";
    NodeProperty["maxCountErrorMessage"] = "maxCountErrorMessage";
    NodeProperty["sumVariableName"] = "sumVariableName";
    NodeProperty["addItemButtons"] = "addItemButtons";
    NodeProperty["continueButtons"] = "continueButtons";
    NodeProperty["showTotalSum"] = "showTotalSum";
    NodeProperty["totalSumLabel"] = "totalSumLabel";
    NodeProperty["totalSumUnits"] = "totalSumUnits";
    NodeProperty["designType"] = "designType";
    NodeProperty["conditionalDesignType"] = "conditionalDesignType";
    NodeProperty["summaryTemplateData"] = "summaryTemplateData";
    NodeProperty["language"] = "language";
    NodeProperty["defaultCurrency"] = "defaultCurrency";
    NodeProperty["encryptedValue"] = "encryptedValue";
    NodeProperty["frontenSummaryDefinition"] = "frontenSummaryDefinition";
    NodeProperty["frontenHtmlFileName"] = "frontenHtmlFileName";
    NodeProperty["frontenBusinessArea"] = "frontenBusinessArea";
    NodeProperty["frontenCategory"] = "frontenCategory";
    NodeProperty["frontenDocumentType"] = "frontenDocumentType";
    NodeProperty["frontenQueue"] = "frontenQueue";
    NodeProperty["businessArea"] = "businessArea";
    NodeProperty["insuredObject"] = "insuredObject";
    NodeProperty["customerNumber"] = "customerNumber";
    NodeProperty["policyNumber"] = "policyNumber";
    NodeProperty["claimNumber"] = "claimNumber";
    NodeProperty["claimType"] = "claimType";
    NodeProperty["parentType"] = "parentType";
    NodeProperty["claimReportName"] = "claimReportName";
    NodeProperty["customerEmail"] = "customerEmail";
    NodeProperty["customerName"] = "customerName";
    NodeProperty["customerPhone"] = "customerPhone";
    NodeProperty["incidentDate"] = "incidentDate";
    NodeProperty["stargateTemplate"] = "stargateTemplate";
    NodeProperty["vehicleRegistrationNumber"] = "vehicleRegistrationNumber";
    NodeProperty["fileName"] = "fileName";
    NodeProperty["summaryDefinition"] = "summaryDefinition";
    NodeProperty["pageHeightInMillimeters"] = "pageHeightInMillimeters";
    NodeProperty["customerSsn"] = "customerSsn";
    NodeProperty["owner"] = "owner";
    NodeProperty["summary"] = "summary";
    NodeProperty["compassSubject"] = "compassSubject";
    NodeProperty["tags"] = "tags";
    NodeProperty["legalNumber"] = "legalNumber";
    NodeProperty["loginButton"] = "loginButton";
    NodeProperty["authenticationDataType"] = "authenticationDataType";
    NodeProperty["ssnCountryCode"] = "ssnCountryCode";
    NodeProperty["defaultCountry"] = "defaultCountry";
    NodeProperty["loginMobileButton"] = "loginMobileButton";
    NodeProperty["vehiclesData"] = "vehiclesData";
    NodeProperty["ssn"] = "ssn";
    NodeProperty["reporterSsn"] = "reporterSsn";
    NodeProperty["driverSsn"] = "driverSsn";
    NodeProperty["birthDate"] = "birthDate";
    NodeProperty["incidentType"] = "incidentType";
    NodeProperty["incidentTime"] = "incidentTime";
    NodeProperty["incidentCircumstance"] = "incidentCircumstance";
    NodeProperty["incidentCause"] = "incidentCause";
    NodeProperty["hasSummerTires"] = "hasSummerTires";
    NodeProperty["speedLimit"] = "speedLimit";
    NodeProperty["speed"] = "speed";
    NodeProperty["currentMileage"] = "currentMileage";
    NodeProperty["hasPoliceBeenInPlace"] = "hasPoliceBeenInPlace";
    NodeProperty["isOwnVehicleDamaged"] = "isOwnVehicleDamaged";
    NodeProperty["damageArea"] = "damageArea";
    NodeProperty["vehicleLocation"] = "vehicleLocation";
    NodeProperty["isDamagedObjects"] = "isDamagedObjects";
    NodeProperty["hasAlcoholOrDrugsInvolved"] = "hasAlcoholOrDrugsInvolved";
    NodeProperty["hasDriverTheLicense"] = "hasDriverTheLicense";
    NodeProperty["hasFallenAsleep"] = "hasFallenAsleep";
    NodeProperty["hasMobileOrOtherScreenUsed"] = "hasMobileOrOtherScreenUsed";
    NodeProperty["isInjuredPersons"] = "isInjuredPersons";
    NodeProperty["injuredRole"] = "injuredRole";
    NodeProperty["isOtherCosts"] = "isOtherCosts";
    NodeProperty["emailAddress"] = "emailAddress";
    NodeProperty["phoneNumber"] = "phoneNumber";
    NodeProperty["carPolicyNumber"] = "carPolicyNumber";
    NodeProperty["brand"] = "brand";
    NodeProperty["claimTypeText"] = "claimTypeText";
    NodeProperty["reportersFirstName"] = "reportersFirstName";
    NodeProperty["reportersLastName"] = "reportersLastName";
    NodeProperty["counterpartRegistrationNumber"] = "counterpartRegistrationNumber";
    NodeProperty["damagedOtherArea"] = "damagedOtherArea";
    NodeProperty["oldDamagesDescription"] = "oldDamagesDescription";
    NodeProperty["isOldDamages"] = "isOldDamages";
    NodeProperty["isPoliceInformed"] = "isPoliceInformed";
    NodeProperty["policeInformed"] = "policeInformed";
    NodeProperty["locationKnown"] = "locationKnown";
    NodeProperty["incidentTimeKnown"] = "incidentTimeKnown";
    NodeProperty["isCounterparts"] = "isCounterparts";
    NodeProperty["perpetratorKnown"] = "perpetratorKnown";
    NodeProperty["damageDescription"] = "damageDescription";
    NodeProperty["bankAccountOwner"] = "bankAccountOwner";
    NodeProperty["bankAccountNumber"] = "bankAccountNumber";
    NodeProperty["bankAccountOwnerSummaryMessage"] = "bankAccountOwnerSummaryMessage";
    NodeProperty["notBankAccountOwnerSummaryMessage"] = "notBankAccountOwnerSummaryMessage";
    NodeProperty["bankAccountNotVerifiedSummaryMessage"] = "bankAccountNotVerifiedSummaryMessage";
    NodeProperty["userInformationData"] = "userInformationData";
    NodeProperty["counterpartRegistrationNumbers"] = "counterpartRegistrationNumbers";
    NodeProperty["whatHasHappened"] = "whatHasHappened";
    NodeProperty["incidentLocation"] = "incidentLocation";
    NodeProperty["registrationNumber"] = "registrationNumber";
    NodeProperty["reporterEmail"] = "reporterEmail";
    NodeProperty["reporterPhoneNumber"] = "reporterPhoneNumber";
    NodeProperty["reporterFirstname"] = "reporterFirstname";
    NodeProperty["reporterSurname"] = "reporterSurname";
    NodeProperty["reporterSocialSecurityNumber"] = "reporterSocialSecurityNumber";
    NodeProperty["policyHolderSocialSecurityNumber"] = "policyHolderSocialSecurityNumber";
    NodeProperty["compassOwner"] = "compassOwner";
    NodeProperty["incidentCountryName"] = "incidentCountryName";
    NodeProperty["incidentCountryId"] = "incidentCountryId";
    NodeProperty["hasForeignCounterparts"] = "hasForeignCounterparts";
    NodeProperty["policyValidDaysAgo"] = "policyValidDaysAgo";
    NodeProperty["policyData"] = "policyData";
    NodeProperty["systemType"] = "systemType";
    NodeProperty["authorizedUserNode"] = "authorizedUserNode";
    NodeProperty["customerInformationNode"] = "customerInformationNode";
    NodeProperty["submissionChannel"] = "submissionChannel";
    NodeProperty["claimCategory"] = "claimCategory";
    NodeProperty["claimTypeCode"] = "claimTypeCode";
    NodeProperty["travelType"] = "travelType";
    NodeProperty["destinationCountry"] = "destinationCountry";
    NodeProperty["destinationCountryText"] = "destinationCountryText";
    NodeProperty["placeOfAccident"] = "placeOfAccident";
    NodeProperty["routeStartDate"] = "routeStartDate";
    NodeProperty["routeEndDate"] = "routeEndDate";
    NodeProperty["reporterIsPolicyHolder"] = "reporterIsPolicyHolder";
    NodeProperty["reporterPhone"] = "reporterPhone";
    NodeProperty["reporterName"] = "reporterName";
    NodeProperty["reporterStreetName"] = "reporterStreetName";
    NodeProperty["reporterHouseNumber"] = "reporterHouseNumber";
    NodeProperty["reporterPostalCode"] = "reporterPostalCode";
    NodeProperty["reporterClaimantTypeText"] = "reporterClaimantTypeText";
    NodeProperty["reporterMemberOfCompany"] = "reporterMemberOfCompany";
    NodeProperty["reporterMemberOfCompanyEmail"] = "reporterMemberOfCompanyEmail";
    NodeProperty["reporterRelationToMember"] = "reporterRelationToMember";
    NodeProperty["typeOfTripText"] = "typeOfTripText";
    NodeProperty["recourseIndicatorText"] = "recourseIndicatorText";
    NodeProperty["knownCardNumber"] = "knownCardNumber";
    NodeProperty["cardFirstSixNumbers"] = "cardFirstSixNumbers";
    NodeProperty["cardLastFourNumbers"] = "cardLastFourNumbers";
    NodeProperty["cardHolder"] = "cardHolder";
    NodeProperty["cancellationCauseText"] = "cancellationCauseText";
    NodeProperty["policyHolderInformationNode"] = "policyHolderInformationNode";
    NodeProperty["policyHolderEmail"] = "policyHolderEmail";
    NodeProperty["policyHolderPhone"] = "policyHolderPhone";
    NodeProperty["policyHolderName"] = "policyHolderName";
    NodeProperty["policyHolderSurname"] = "policyHolderSurname";
    NodeProperty["policyHolderSsn"] = "policyHolderSsn";
    NodeProperty["policyHolderStreetName"] = "policyHolderStreetName";
    NodeProperty["policyHolderHouseNumber"] = "policyHolderHouseNumber";
    NodeProperty["policyHolderPostalCode"] = "policyHolderPostalCode";
    NodeProperty["damageCause"] = "damageCause";
    NodeProperty["cancellationDate"] = "cancellationDate";
    NodeProperty["cancellationDocumentationDescription"] = "cancellationDocumentationDescription";
    NodeProperty["cancellationInvolvedPersonDescriptionNodeName"] = "cancellationInvolvedPersonDescriptionNodeName";
    NodeProperty["cancellationExpensesCaruselNode"] = "cancellationExpensesCaruselNode";
    NodeProperty["cancellationExpensesDescription"] = "cancellationExpensesDescription";
    NodeProperty["cancellationExpensesAdditionalDescription"] = "cancellationExpensesAdditionalDescription";
    NodeProperty["cancellationExpensesAmount"] = "cancellationExpensesAmount";
    NodeProperty["cancellationExpensesTaxes"] = "cancellationExpensesTaxes";
    NodeProperty["cancellationExpensesDate"] = "cancellationExpensesDate";
    NodeProperty["cancellationCancelledOperator"] = "cancellationCancelledOperator";
    NodeProperty["cancellationCancelledOperatorDate"] = "cancellationCancelledOperatorDate";
    NodeProperty["cancellationCostTypeText"] = "cancellationCostTypeText";
    NodeProperty["recourseIndicator"] = "recourseIndicator";
    NodeProperty["recourseReasonCode"] = "recourseReasonCode";
    NodeProperty["recourseCreditCardIssuer"] = "recourseCreditCardIssuer";
    NodeProperty["recourseCreditCardNumber"] = "recourseCreditCardNumber";
    NodeProperty["recourseInsuranceCompany"] = "recourseInsuranceCompany";
    NodeProperty["recoursePolicyId"] = "recoursePolicyId";
    NodeProperty["claimantListNodeName"] = "claimantListNodeName";
    NodeProperty["claimantTypeNodeName"] = "claimantTypeNodeName";
    NodeProperty["claimantTypeTextNodeName"] = "claimantTypeTextNodeName";
    NodeProperty["wpClaimantTypeNodeName"] = "wpClaimantTypeNodeName";
    NodeProperty["claimantNameNodeName"] = "claimantNameNodeName";
    NodeProperty["claimantSurnameNodeName"] = "claimantSurnameNodeName";
    NodeProperty["claimantSsnNodeName"] = "claimantSsnNodeName";
    NodeProperty["claimantStreetNameNodeName"] = "claimantStreetNameNodeName";
    NodeProperty["claimantHouseNumberNodeName"] = "claimantHouseNumberNodeName";
    NodeProperty["claimantPostalCodeNodeName"] = "claimantPostalCodeNodeName";
    NodeProperty["claimantPhoneNodeName"] = "claimantPhoneNodeName";
    NodeProperty["claimantEmailNodeName"] = "claimantEmailNodeName";
    NodeProperty["claimantCountryNodeName"] = "claimantCountryNodeName";
    NodeProperty["claimantEntranceCodeNodeName"] = "claimantEntranceCodeNodeName";
    NodeProperty["claimantPlaceNameNodeName"] = "claimantPlaceNameNodeName";
    NodeProperty["claimantStreetNumberNodeName"] = "claimantStreetNumberNodeName";
    NodeProperty["wpClaimType"] = "wpClaimType";
    NodeProperty["wpTravelType"] = "wpTravelType";
    NodeProperty["wpLuggageCauseType"] = "wpLuggageCauseType";
    NodeProperty["cancellationCause"] = "cancellationCause";
    NodeProperty["description"] = "description";
    NodeProperty["pIRNumber"] = "pIRNumber";
    NodeProperty["pIRNumberAvailable"] = "pIRNumberAvailable";
    NodeProperty["delayType"] = "delayType";
    NodeProperty["delayCause"] = "delayCause";
    NodeProperty["delayReason"] = "delayReason";
    NodeProperty["delayTransportationDetails"] = "delayTransportationDetails";
    NodeProperty["delayTransportationETD"] = "delayTransportationETD";
    NodeProperty["delayTransporterConfirmation"] = "delayTransporterConfirmation";
    NodeProperty["delayedLuggageActualArrivalDate"] = "delayedLuggageActualArrivalDate";
    NodeProperty["delayedLuggageNodeName"] = "delayedLuggageNodeName";
    NodeProperty["delayedLuggageTypeNodeName"] = "delayedLuggageTypeNodeName";
    NodeProperty["delayedLuggageTypeTextNodeName"] = "delayedLuggageTypeTextNodeName";
    NodeProperty["delayedLuggagePurchaseDateNodeName"] = "delayedLuggagePurchaseDateNodeName";
    NodeProperty["delayedLuggageCostsAmountNodeName"] = "delayedLuggageCostsAmountNodeName";
    NodeProperty["delayedLuggageHasCostsReceiptNodeName"] = "delayedLuggageHasCostsReceiptNodeName";
    NodeProperty["delayedLuggageHasCostsReceiptTextNodeName"] = "delayedLuggageHasCostsReceiptTextNodeName";
    NodeProperty["delayedLuggageAdditionalDescription"] = "delayedLuggageAdditionalDescription";
    NodeProperty["delayedLuggageResponsibleAirline"] = "delayedLuggageResponsibleAirline";
    NodeProperty["medicalExpensesNodeName"] = "medicalExpensesNodeName";
    NodeProperty["medicalExpensesExpenseTypeNodeName"] = "medicalExpensesExpenseTypeNodeName";
    NodeProperty["medicalExpensesExpenceTypeDescriptionNodeName"] = "medicalExpensesExpenceTypeDescriptionNodeName";
    NodeProperty["medicalExpensesAdditionalDescriptionNodeName"] = "medicalExpensesAdditionalDescriptionNodeName";
    NodeProperty["medicalExpensesCostsAmountNodeName"] = "medicalExpensesCostsAmountNodeName";
    NodeProperty["medicalExpensesDateNodeName"] = "medicalExpensesDateNodeName";
    NodeProperty["medicalExpensesHasCostsReceiptNodeName"] = "medicalExpensesHasCostsReceiptNodeName";
    NodeProperty["medicalTravelExpensesNodeName"] = "medicalTravelExpensesNodeName";
    NodeProperty["medicalTravelExpensesExpenseType"] = "medicalTravelExpensesExpenseType";
    NodeProperty["medicalTravelExpensesCostsAmount"] = "medicalTravelExpensesCostsAmount";
    NodeProperty["medicalTravelExpensesDate"] = "medicalTravelExpensesDate";
    NodeProperty["medicalTravelExpensesHasCostsReceipt"] = "medicalTravelExpensesHasCostsReceipt";
    NodeProperty["medicalCertificate"] = "medicalCertificate";
    NodeProperty["demandExpensesTypeDescription"] = "demandExpensesTypeDescription";
    NodeProperty["demandMedicContactDateTime"] = "demandMedicContactDateTime";
    NodeProperty["compensationOfLossHolidays"] = "compensationOfLossHolidays";
    NodeProperty["damagedLuggageNodeName"] = "damagedLuggageNodeName";
    NodeProperty["damagedLuggageCostItemCodeNodeName"] = "damagedLuggageCostItemCodeNodeName";
    NodeProperty["damagedLuggageDescriptionNodeName"] = "damagedLuggageDescriptionNodeName";
    NodeProperty["damagedLuggageAdditionalDescriptionNodeName"] = "damagedLuggageAdditionalDescriptionNodeName";
    NodeProperty["damagedLuggagePurchaseDateNodeName"] = "damagedLuggagePurchaseDateNodeName";
    NodeProperty["damagedLuggageCostsAmountNodeName"] = "damagedLuggageCostsAmountNodeName";
    NodeProperty["damagedLuggageHasCostsReceiptNodeName"] = "damagedLuggageHasCostsReceiptNodeName";
    NodeProperty["otherInformedDescription"] = "otherInformedDescription";
    NodeProperty["policeInformedIndicator"] = "policeInformedIndicator";
    NodeProperty["otherInformedIndicator"] = "otherInformedIndicator";
    NodeProperty["theftType"] = "theftType";
    NodeProperty["trackOfTheft"] = "trackOfTheft";
    NodeProperty["theftObjectLastObservedDate"] = "theftObjectLastObservedDate";
    NodeProperty["theftLockedIndicator"] = "theftLockedIndicator";
    NodeProperty["theftItemNodeName"] = "theftItemNodeName";
    NodeProperty["theftItemCostItemCodeNodeName"] = "theftItemCostItemCodeNodeName";
    NodeProperty["theftItemDescriptionNodeName"] = "theftItemDescriptionNodeName";
    NodeProperty["theftItemAdditionalDescriptionNodeName"] = "theftItemAdditionalDescriptionNodeName";
    NodeProperty["theftItemStoragePlaceNodeName"] = "theftItemStoragePlaceNodeName";
    NodeProperty["theftItemPurchaseDateNodeName"] = "theftItemPurchaseDateNodeName";
    NodeProperty["theftItemCostsAmountNodeName"] = "theftItemCostsAmountNodeName";
    NodeProperty["theftItemCurrentPriceNodeName"] = "theftItemCurrentPriceNodeName";
    NodeProperty["theftItemHasCostsReceiptNodeName"] = "theftItemHasCostsReceiptNodeName";
    NodeProperty["lossObjectType"] = "lossObjectType";
    NodeProperty["isTheClaimDueToCoronaVirus"] = "isTheClaimDueToCoronaVirus";
    NodeProperty["evacuationCause"] = "evacuationCause";
    NodeProperty["reportersCustomerNumber"] = "reportersCustomerNumber";
    NodeProperty["policyInformationNode"] = "policyInformationNode";
    NodeProperty["policyObjectNumber"] = "policyObjectNumber";
    NodeProperty["animalName"] = "animalName";
    NodeProperty["animalDiagnosis"] = "animalDiagnosis";
    NodeProperty["animalType"] = "animalType";
    NodeProperty["mitIdLoginButton"] = "mitIdLoginButton";
    NodeProperty["choosenVehicleNode"] = "choosenVehicleNode";
    NodeProperty["manuallyVehicleNumber"] = "manuallyVehicleNumber";
    NodeProperty["injuredNameFieldName"] = "injuredNameFieldName";
    NodeProperty["vehicleDamageDescription"] = "vehicleDamageDescription";
    NodeProperty["vehicleDamagedParts"] = "vehicleDamagedParts";
    NodeProperty["reportedPersonSsn"] = "reportedPersonSsn";
    NodeProperty["customerFirstName"] = "customerFirstName";
    NodeProperty["customerLastName"] = "customerLastName";
    NodeProperty["reporterCustomerNumber"] = "reporterCustomerNumber";
    NodeProperty["artNumber"] = "artNumber";
    NodeProperty["attachmentViewerUrl"] = "attachmentViewerUrl";
    NodeProperty["branch"] = "branch";
    NodeProperty["insuredObjectType"] = "insuredObjectType";
    NodeProperty["claimCause"] = "claimCause";
    NodeProperty["claimCausedBy"] = "claimCausedBy";
    NodeProperty["accidentCountry"] = "accidentCountry";
    NodeProperty["repairedAbroad"] = "repairedAbroad";
    NodeProperty["accidentCity"] = "accidentCity";
    NodeProperty["accidentStreetAddress"] = "accidentStreetAddress";
    NodeProperty["reporterBankAccountNumber"] = "reporterBankAccountNumber";
    NodeProperty["reporterRoleCode"] = "reporterRoleCode";
    NodeProperty["isReporterPolicyholder"] = "isReporterPolicyholder";
    NodeProperty["policyholderFirstName"] = "policyholderFirstName";
    NodeProperty["policyholderSurname"] = "policyholderSurname";
    NodeProperty["policyholderSsn"] = "policyholderSsn";
    NodeProperty["policyholderEmail"] = "policyholderEmail";
    NodeProperty["policyholderPhone"] = "policyholderPhone";
    NodeProperty["isPolicyHolderCompany"] = "isPolicyHolderCompany";
    NodeProperty["policyHolderCompanyName"] = "policyHolderCompanyName";
    NodeProperty["policyHolderCompanyId"] = "policyHolderCompanyId";
    NodeProperty["choosenInsuredVehicleNode"] = "choosenInsuredVehicleNode";
    NodeProperty["insuredVehicleRegistrationNumber"] = "insuredVehicleRegistrationNumber";
    NodeProperty["isReporterDriver"] = "isReporterDriver";
    NodeProperty["driverFirstName"] = "driverFirstName";
    NodeProperty["driverSurname"] = "driverSurname";
    NodeProperty["driverPhone"] = "driverPhone";
    NodeProperty["drunkenParticipant"] = "drunkenParticipant";
    NodeProperty["isReportedToPolice"] = "isReportedToPolice";
    NodeProperty["vehicleDamageLocation"] = "vehicleDamageLocation";
    NodeProperty["ownInsuranceUsed"] = "ownInsuranceUsed";
    NodeProperty["isOwnCarDamaged"] = "isOwnCarDamaged";
    NodeProperty["hasPersonalInjuries"] = "hasPersonalInjuries";
    NodeProperty["damagedPropertyDescription"] = "damagedPropertyDescription";
    NodeProperty["stolenPropertyDescription"] = "stolenPropertyDescription";
    NodeProperty["hasOtherExpenses"] = "hasOtherExpenses";
    NodeProperty["accidentCausedBy"] = "accidentCausedBy";
    NodeProperty["vehicleGlassDamageLocation"] = "vehicleGlassDamageLocation";
    NodeProperty["guiltyPartyKnown"] = "guiltyPartyKnown";
    NodeProperty["guiltyParty"] = "guiltyParty";
    NodeProperty["keyOwners"] = "keyOwners";
    NodeProperty["hasKeysSafe"] = "hasKeysSafe";
    NodeProperty["wasVehicleLocked"] = "wasVehicleLocked";
    NodeProperty["fireStartCircumstance"] = "fireStartCircumstance";
    NodeProperty["counterpartNode"] = "counterpartNode";
    NodeProperty["counterpartDriverName"] = "counterpartDriverName";
    NodeProperty["counterpartPhoneNumber"] = "counterpartPhoneNumber";
    NodeProperty["counterpartVehicleDamageDescription"] = "counterpartVehicleDamageDescription";
    NodeProperty["accidentPlace"] = "accidentPlace";
    NodeProperty["trafficLights"] = "trafficLights";
    NodeProperty["roadType"] = "roadType";
    NodeProperty["roadSurface"] = "roadSurface";
    NodeProperty["lightning"] = "lightning";
    NodeProperty["accidentSituation"] = "accidentSituation";
    NodeProperty["wasDenslyPopulatedArea"] = "wasDenslyPopulatedArea";
    NodeProperty["injuredContainerNode"] = "injuredContainerNode";
    NodeProperty["injuredFirstName"] = "injuredFirstName";
    NodeProperty["injuredSurname"] = "injuredSurname";
    NodeProperty["injuredSsn"] = "injuredSsn";
    NodeProperty["injuredPhone"] = "injuredPhone";
    NodeProperty["injuredSeverety"] = "injuredSeverety";
    NodeProperty["injuredActivity"] = "injuredActivity";
    NodeProperty["glassExpensesDescription"] = "glassExpensesDescription";
    NodeProperty["otherExpensesDescription"] = "otherExpensesDescription";
    NodeProperty["secureStorageNode"] = "secureStorageNode";
    NodeProperty["useValueAddedTax"] = "useValueAddedTax";
    NodeProperty["attachments"] = "attachments";
    NodeProperty["companyId"] = "companyId";
    NodeProperty["companyName"] = "companyName";
    NodeProperty["otherCosts"] = "otherCosts";
    NodeProperty["towingCostsSum"] = "towingCostsSum";
    NodeProperty["towingCostsDescription"] = "towingCostsDescription";
    NodeProperty["towingVatAmount"] = "towingVatAmount";
    NodeProperty["glassCompensationType"] = "glassCompensationType";
    NodeProperty["glassCostsSum"] = "glassCostsSum";
    NodeProperty["glassCostsDescription"] = "glassCostsDescription";
    NodeProperty["glassVatAmount"] = "glassVatAmount";
    NodeProperty["secureStorageId"] = "secureStorageId";
    NodeProperty["useAsAuthorization"] = "useAsAuthorization";
    NodeProperty["firstName"] = "firstName";
    NodeProperty["lastName"] = "lastName";
    NodeProperty["paymentDate"] = "paymentDate";
    NodeProperty["accidentDate"] = "accidentDate";
    NodeProperty["customerPhoneNumber"] = "customerPhoneNumber";
    NodeProperty["licenseNumber"] = "licenseNumber";
    NodeProperty["vAHAClaimIdentifier"] = "vAHAClaimIdentifier";
    NodeProperty["sAJPolicyNumber"] = "sAJPolicyNumber";
    NodeProperty["documentType"] = "documentType";
    NodeProperty["sSNDriver"] = "sSNDriver";
    NodeProperty["enteredPolicyNumber"] = "enteredPolicyNumber";
    NodeProperty["enteredRegistrationNumber"] = "enteredRegistrationNumber";
    NodeProperty["policyInformatioNode"] = "policyInformatioNode";
    NodeProperty["incidentCountry"] = "incidentCountry";
    NodeProperty["damagedSide"] = "damagedSide";
    NodeProperty["involvedRegistrationNumber"] = "involvedRegistrationNumber";
    NodeProperty["injuredAnimalType"] = "injuredAnimalType";
    NodeProperty["vehicleIsTowed"] = "vehicleIsTowed";
    NodeProperty["vehicleCurrentLocationType"] = "vehicleCurrentLocationType";
    NodeProperty["policeWasInformed"] = "policeWasInformed";
    NodeProperty["claimTypeWaypoint"] = "claimTypeWaypoint";
    NodeProperty["incidentDescription"] = "incidentDescription";
    NodeProperty["wasCollisionWithAnimal"] = "wasCollisionWithAnimal";
    NodeProperty["isDriverForeign"] = "isDriverForeign";
    NodeProperty["policeReferenceNumber"] = "policeReferenceNumber";
    NodeProperty["injuredPersonNode"] = "injuredPersonNode";
    NodeProperty["injuredPersonType"] = "injuredPersonType";
    NodeProperty["severityOfInjuries"] = "severityOfInjuries";
    NodeProperty["injuredSSN"] = "injuredSSN";
    NodeProperty["injuredName"] = "injuredName";
    NodeProperty["animalOwnerSsn"] = "animalOwnerSsn";
    NodeProperty["incidentTypeDescription"] = "incidentTypeDescription";
    NodeProperty["collisionTypeDescription"] = "collisionTypeDescription";
    NodeProperty["injuredAnimalTypeWaypoint"] = "injuredAnimalTypeWaypoint";
    NodeProperty["damagesToOwnCar"] = "damagesToOwnCar";
    NodeProperty["reporterRole"] = "reporterRole";
    NodeProperty["incidentTypeCode"] = "incidentTypeCode";
    NodeProperty["policyHolderContactEmail"] = "policyHolderContactEmail";
    NodeProperty["policyHolderContactPhone"] = "policyHolderContactPhone";
    NodeProperty["hasWitness"] = "hasWitness";
    NodeProperty["propertyOwnerOtherProperty"] = "propertyOwnerOtherProperty";
    NodeProperty["vehicleTypeDescription"] = "vehicleTypeDescription";
    NodeProperty["isAnythingElseDamaged"] = "isAnythingElseDamaged";
    NodeProperty["hasAnythingElseToTell"] = "hasAnythingElseToTell";
    NodeProperty["witnessesNode"] = "witnessesNode";
    NodeProperty["witnessRoleCode"] = "witnessRoleCode";
    NodeProperty["witnessIncidentDescription"] = "witnessIncidentDescription";
    NodeProperty["vehicleRegistrationCountryCode"] = "vehicleRegistrationCountryCode";
    NodeProperty["vehicleType"] = "vehicleType";
    NodeProperty["claimantRoleCode"] = "claimantRoleCode";
    NodeProperty["partyNumber"] = "partyNumber";
    NodeProperty["organisationNumber"] = "organisationNumber";
    NodeProperty["policyHolderBankAccountNr"] = "policyHolderBankAccountNr";
    NodeProperty["needOfRentalCar"] = "needOfRentalCar";
    NodeProperty["pullingVehicleRegistrationNumber"] = "pullingVehicleRegistrationNumber";
    NodeProperty["alarmActivatedIndicator"] = "alarmActivatedIndicator";
    NodeProperty["hasVehicleBeenPulled"] = "hasVehicleBeenPulled";
    NodeProperty["summaryDefiniton"] = "summaryDefiniton";
    NodeProperty["policeBreathTest"] = "policeBreathTest";
    NodeProperty["policeBreathTestResult"] = "policeBreathTestResult";
    NodeProperty["responsibility"] = "responsibility";
    NodeProperty["incidentTemplate"] = "incidentTemplate";
    NodeProperty["claimantSsn"] = "claimantSsn";
    NodeProperty["claimCoverageNumber"] = "claimCoverageNumber";
    NodeProperty["analysisCode"] = "analysisCode";
    NodeProperty["skipFenixRegistration"] = "skipFenixRegistration";
    NodeProperty["stargatePayloadType"] = "stargatePayloadType";
    NodeProperty["stargateClaimType"] = "stargateClaimType";
    NodeProperty["orderedProductParts"] = "orderedProductParts";
    NodeProperty["coverageTypeNumber"] = "coverageTypeNumber";
    NodeProperty["frontenUserId"] = "frontenUserId";
    NodeProperty["claimantStreetNodeName"] = "claimantStreetNodeName";
    NodeProperty["luggageCauseType"] = "luggageCauseType";
    NodeProperty["accidentInjuryType"] = "accidentInjuryType";
    NodeProperty["compensationBankAccountNumber"] = "compensationBankAccountNumber";
    NodeProperty["compensationBeneficiaryCity"] = "compensationBeneficiaryCity";
    NodeProperty["compensationBeneficiaryEmailAddress"] = "compensationBeneficiaryEmailAddress";
    NodeProperty["compensationBeneficiaryFirstName"] = "compensationBeneficiaryFirstName";
    NodeProperty["compensationBeneficiaryLastName"] = "compensationBeneficiaryLastName";
    NodeProperty["compensationBeneficiaryPersonId"] = "compensationBeneficiaryPersonId";
    NodeProperty["compensationBeneficiaryPhoneNumber"] = "compensationBeneficiaryPhoneNumber";
    NodeProperty["compensationBeneficiaryPostalCode"] = "compensationBeneficiaryPostalCode";
    NodeProperty["compensationBeneficiaryRole"] = "compensationBeneficiaryRole";
    NodeProperty["compensationBeneficiaryStreetAddress"] = "compensationBeneficiaryStreetAddress";
    NodeProperty["compensationCostItemNode"] = "compensationCostItemNode";
    NodeProperty["compensationCostItemCostAmount"] = "compensationCostItemCostAmount";
    NodeProperty["compensationCostItemCostDate"] = "compensationCostItemCostDate";
    NodeProperty["compensationCostItemCostDescription"] = "compensationCostItemCostDescription";
    NodeProperty["compensationCostItemCostType"] = "compensationCostItemCostType";
    NodeProperty["formType"] = "formType";
    NodeProperty["incidentAccidentBodyPart"] = "incidentAccidentBodyPart";
    NodeProperty["incidentAccidentBodyPartCodeName"] = "incidentAccidentBodyPartCodeName";
    NodeProperty["incidentAccidentBodyPartSide"] = "incidentAccidentBodyPartSide";
    NodeProperty["incidentAccidentHasOccurredInCompetition"] = "incidentAccidentHasOccurredInCompetition";
    NodeProperty["incidentAccidentHasSportLicence"] = "incidentAccidentHasSportLicence";
    NodeProperty["incidentAccidentSportCodeId"] = "incidentAccidentSportCodeId";
    NodeProperty["incidentAccidentSportCodeName"] = "incidentAccidentSportCodeName";
    NodeProperty["incidentAccidentSportLicenceName"] = "incidentAccidentSportLicenceName";
    NodeProperty["incidentAccidentSportUnionName"] = "incidentAccidentSportUnionName";
    NodeProperty["incidentAccidentWasAssault"] = "incidentAccidentWasAssault";
    NodeProperty["incidentDiagnosisCodeId"] = "incidentDiagnosisCodeId";
    NodeProperty["incidentDiagnosisCodeName"] = "incidentDiagnosisCodeName";
    NodeProperty["incidentEarlierTreatmentDate"] = "incidentEarlierTreatmentDate";
    NodeProperty["incidentEarlierTreatmentPlace"] = "incidentEarlierTreatmentPlace";
    NodeProperty["incidentHasAlcoholOrDrugsInvolved"] = "incidentHasAlcoholOrDrugsInvolved";
    NodeProperty["incidentHasEarlierSymptons"] = "incidentHasEarlierSymptons";
    NodeProperty["incidentHospitalAndTown"] = "incidentHospitalAndTown";
    NodeProperty["incidentHospitalName"] = "incidentHospitalName";
    NodeProperty["incidentHospitalTreatmentEndDate"] = "incidentHospitalTreatmentEndDate";
    NodeProperty["incidentHospitalTreatmentStartDate"] = "incidentHospitalTreatmentStartDate";
    NodeProperty["incidentIncidentCause"] = "incidentIncidentCause";
    NodeProperty["incidentIncidentDate"] = "incidentIncidentDate";
    NodeProperty["incidentIncidentTime"] = "incidentIncidentTime";
    NodeProperty["incidentIncidentType"] = "incidentIncidentType";
    NodeProperty["incidentInformedBefore"] = "incidentInformedBefore";
    NodeProperty["incidentInsuredCity"] = "incidentInsuredCity";
    NodeProperty["incidentInsuredFirsName"] = "incidentInsuredFirsName";
    NodeProperty["incidentInsuredLastName"] = "incidentInsuredLastName";
    NodeProperty["incidentInsuredPersonId"] = "incidentInsuredPersonId";
    NodeProperty["incidentInsuredPhoneNumber"] = "incidentInsuredPhoneNumber";
    NodeProperty["incidentInsuredPostalCode"] = "incidentInsuredPostalCode";
    NodeProperty["incidentInsuredStreetAddress"] = "incidentInsuredStreetAddress";
    NodeProperty["incidentMunicipality"] = "incidentMunicipality";
    NodeProperty["incidentTravelCancelationRefundApplied"] = "incidentTravelCancelationRefundApplied";
    NodeProperty["incidentTravelCancelReason"] = "incidentTravelCancelReason";
    NodeProperty["incidentTravelDelayReason"] = "incidentTravelDelayReason";
    NodeProperty["incidentTravelDelayReasonTransportation"] = "incidentTravelDelayReasonTransportation";
    NodeProperty["incidentTravelLeisureHomeDesription"] = "incidentTravelLeisureHomeDesription";
    NodeProperty["incidentTravelOriginalCost"] = "incidentTravelOriginalCost";
    NodeProperty["incidentTravelOriginalEndDate"] = "incidentTravelOriginalEndDate";
    NodeProperty["incidentTravelOriginalStarDate"] = "incidentTravelOriginalStarDate";
    NodeProperty["incidentTravelReason"] = "incidentTravelReason";
    NodeProperty["incidentTravelReservationDate"] = "incidentTravelReservationDate";
    NodeProperty["incidentTravelTravelEndDate"] = "incidentTravelTravelEndDate";
    NodeProperty["incidentTravelTravelStartDate"] = "incidentTravelTravelStartDate";
    NodeProperty["incidentTreatmentStartedDate"] = "incidentTreatmentStartedDate";
    NodeProperty["reporterCity"] = "reporterCity";
    NodeProperty["reporterCustomerReference"] = "reporterCustomerReference";
    NodeProperty["reporterEmailAddress"] = "reporterEmailAddress";
    NodeProperty["reporterFirstName"] = "reporterFirstName";
    NodeProperty["reporterLastName"] = "reporterLastName";
    NodeProperty["reporterPersonId"] = "reporterPersonId";
    NodeProperty["reporterStreetAddress"] = "reporterStreetAddress";
    NodeProperty["unionSelectedUnion"] = "unionSelectedUnion";
    NodeProperty["unionSelectedUnionName"] = "unionSelectedUnionName";
    NodeProperty["htmlNotification"] = "htmlNotification";
    NodeProperty["channel"] = "channel";
    NodeProperty["powerOfAttorney"] = "powerOfAttorney";
    NodeProperty["bankName"] = "bankName";
    NodeProperty["authTimestamp"] = "authTimestamp";
    NodeProperty["incidentTravelPlace"] = "incidentTravelPlace";
    NodeProperty["cancellationCostIncludeOthers"] = "cancellationCostIncludeOthers";
    NodeProperty["symptomCodes"] = "symptomCodes";
    NodeProperty["accidentIncidentCause"] = "accidentIncidentCause";
    NodeProperty["accidentBodyPart"] = "accidentBodyPart";
    NodeProperty["accidentHasOccurredInCompetition"] = "accidentHasOccurredInCompetition";
    NodeProperty["accidentWasAssault"] = "accidentWasAssault";
    NodeProperty["accidentHasAlcoholOrDrugsInvolved"] = "accidentHasAlcoholOrDrugsInvolved";
    NodeProperty["accidentCircumstance"] = "accidentCircumstance";
    NodeProperty["accidentHasEarlierSymptoms"] = "accidentHasEarlierSymptoms";
    NodeProperty["accidentIsWideAccident"] = "accidentIsWideAccident";
    NodeProperty["customerServiceLanguage"] = "customerServiceLanguage";
    NodeProperty["decicionDeductibleLeftAmount"] = "decicionDeductibleLeftAmount";
    NodeProperty["decicionDeductibleAmount"] = "decicionDeductibleAmount";
    NodeProperty["decisionDeductibleType"] = "decisionDeductibleType";
    NodeProperty["decisionIsClaimLiable"] = "decisionIsClaimLiable";
    NodeProperty["decisionCustomerNumber"] = "decisionCustomerNumber";
    NodeProperty["decisionPolicyNumber"] = "decisionPolicyNumber";
    NodeProperty["decisionTermEndDate"] = "decisionTermEndDate";
    NodeProperty["incidentAccidentHasSportLicense"] = "incidentAccidentHasSportLicense";
    NodeProperty["incidentAccidentInjuryType"] = "incidentAccidentInjuryType";
    NodeProperty["incidentAccidentSportLicenseName"] = "incidentAccidentSportLicenseName";
    NodeProperty["incidentAccidentSportCode"] = "incidentAccidentSportCode";
    NodeProperty["incidentCircumstanceDescription"] = "incidentCircumstanceDescription";
    NodeProperty["incidentIsReporterCaretaker"] = "incidentIsReporterCaretaker";
    NodeProperty["incidentSymptomCodes"] = "incidentSymptomCodes";
    NodeProperty["incidentSymptoms"] = "incidentSymptoms";
    NodeProperty["incidentInsuredFirstName"] = "incidentInsuredFirstName";
    NodeProperty["incidentIsWideAccident"] = "incidentIsWideAccident";
    NodeProperty["mRIPermission"] = "mRIPermission";
    NodeProperty["incidentInsuredCustomerNumber"] = "incidentInsuredCustomerNumber";
    NodeProperty["policyHolderCustomerNumber"] = "policyHolderCustomerNumber";
    NodeProperty["liabilityReasons"] = "liabilityReasons";
    NodeProperty["policyUnitAtRiskNumber"] = "policyUnitAtRiskNumber";
    NodeProperty["policyUnitAtRisksCoverageNumber"] = "policyUnitAtRisksCoverageNumber";
    NodeProperty["policyUnitAtRisksCoverageType"] = "policyUnitAtRisksCoverageType";
    NodeProperty["claimsCount"] = "claimsCount";
    NodeProperty["caseType"] = "caseType";
    NodeProperty["loginInfoBankName"] = "loginInfoBankName";
    NodeProperty["loginInfoAuthTimestamp"] = "loginInfoAuthTimestamp";
    NodeProperty["insuredPeople"] = "insuredPeople";
    NodeProperty["availableVariables"] = "availableVariables";
    NodeProperty["policies"] = "policies";
    NodeProperty["nationalIdentity"] = "nationalIdentity";
    NodeProperty["nationalIdentityCountry"] = "nationalIdentityCountry";
    NodeProperty["policy"] = "policy";
    NodeProperty["occupationalClasses"] = "occupationalClasses";
    NodeProperty["chosenExposure"] = "chosenExposure";
    NodeProperty["chosenExposureObjectId"] = "chosenExposureObjectId";
    NodeProperty["chosenPolicy"] = "chosenPolicy";
    NodeProperty["isReportedPolicyHolder"] = "isReportedPolicyHolder";
    NodeProperty["reportedPolicyHolderFirstName"] = "reportedPolicyHolderFirstName";
    NodeProperty["reportedPolicyHolderLastName"] = "reportedPolicyHolderLastName";
    NodeProperty["reportedPolicyHolderPersonId"] = "reportedPolicyHolderPersonId";
    NodeProperty["reportedPolicyHolderStreetAddress"] = "reportedPolicyHolderStreetAddress";
    NodeProperty["reportedPolicyHolderPostalCode"] = "reportedPolicyHolderPostalCode";
    NodeProperty["reportedPolicyHolderCity"] = "reportedPolicyHolderCity";
    NodeProperty["reportedPolicyHolderPhoneNumber"] = "reportedPolicyHolderPhoneNumber";
    NodeProperty["reportedPolicyHolderEmailAddress"] = "reportedPolicyHolderEmailAddress";
    NodeProperty["compensationCostItemsCaruselNode"] = "compensationCostItemsCaruselNode";
    NodeProperty["compensationCostType"] = "compensationCostType";
    NodeProperty["compensationCostDescription"] = "compensationCostDescription";
    NodeProperty["compensationCostDate"] = "compensationCostDate";
    NodeProperty["compensationCostAmount"] = "compensationCostAmount";
    NodeProperty["deathDate"] = "deathDate";
    NodeProperty["circumstanceDescr"] = "circumstanceDescr";
    NodeProperty["diagnosisCode"] = "diagnosisCode";
    NodeProperty["incidentSymptomsStartedDate"] = "incidentSymptomsStartedDate";
    NodeProperty["insuredAnimalSpecies"] = "insuredAnimalSpecies";
    NodeProperty["insuredAnimalNickName"] = "insuredAnimalNickName";
    NodeProperty["insuredAnimalOfficialName"] = "insuredAnimalOfficialName";
    NodeProperty["insuredAnimalBreed"] = "insuredAnimalBreed";
    NodeProperty["insuredAnimalBreedDescription"] = "insuredAnimalBreedDescription";
    NodeProperty["insuredAnimalDateOfBirth"] = "insuredAnimalDateOfBirth";
    NodeProperty["insuredAnimalGender"] = "insuredAnimalGender";
    NodeProperty["insuredAnimalOwnerType"] = "insuredAnimalOwnerType";
    NodeProperty["insuredAnimalOwnerName"] = "insuredAnimalOwnerName";
    NodeProperty["objectSearchXml"] = "objectSearchXml";
    NodeProperty["policyHolderFirstname"] = "policyHolderFirstname";
    NodeProperty["policyHolderAddress"] = "policyHolderAddress";
    NodeProperty["policyHolderPostCode"] = "policyHolderPostCode";
    NodeProperty["policyHolderCity"] = "policyHolderCity";
    NodeProperty["claimantFirstname"] = "claimantFirstname";
    NodeProperty["claimantSurname"] = "claimantSurname";
    NodeProperty["claimantAddress"] = "claimantAddress";
    NodeProperty["claimantPostCode"] = "claimantPostCode";
    NodeProperty["claimantCity"] = "claimantCity";
    NodeProperty["claimantPhone"] = "claimantPhone";
    NodeProperty["claimantEmail"] = "claimantEmail";
    NodeProperty["claimantBankAccountNumber"] = "claimantBankAccountNumber";
    NodeProperty["reporterAddress"] = "reporterAddress";
    NodeProperty["reporterPostCode"] = "reporterPostCode";
    NodeProperty["incidentHasHappenedWhileTraveling"] = "incidentHasHappenedWhileTraveling";
    NodeProperty["incidentAddressStreet"] = "incidentAddressStreet";
    NodeProperty["incidentAddressCity"] = "incidentAddressCity";
    NodeProperty["incidentAddressPostalCode"] = "incidentAddressPostalCode";
    NodeProperty["incidentAddressCountry"] = "incidentAddressCountry";
    NodeProperty["incidentAddressMunicipality"] = "incidentAddressMunicipality";
    NodeProperty["incidentWhenDidTravelStart"] = "incidentWhenDidTravelStart";
    NodeProperty["incidentPoliceReport"] = "incidentPoliceReport";
    NodeProperty["partnerPermisson"] = "partnerPermisson";
    NodeProperty["incidentTheftLastSeenDate"] = "incidentTheftLastSeenDate";
    NodeProperty["incidentTheftLastSeenTime"] = "incidentTheftLastSeenTime";
    NodeProperty["incidentTheftWhenNoticedDate"] = "incidentTheftWhenNoticedDate";
    NodeProperty["incidentTheftWhenNoticedTime"] = "incidentTheftWhenNoticedTime";
    NodeProperty["incidentTheftLastSeenLocationDescription"] = "incidentTheftLastSeenLocationDescription";
    NodeProperty["lossObjectsCarouselName"] = "lossObjectsCarouselName";
    NodeProperty["lossObjectMake"] = "lossObjectMake";
    NodeProperty["lossObjectOtherItemDamaged"] = "lossObjectOtherItemDamaged";
    NodeProperty["lossObjectModel"] = "lossObjectModel";
    NodeProperty["lossObjectDescription"] = "lossObjectDescription";
    NodeProperty["lossObjectAge"] = "lossObjectAge";
    NodeProperty["lossObjectPriceAsNewAmount"] = "lossObjectPriceAsNewAmount";
    NodeProperty["lossObjectRepairCostAmount"] = "lossObjectRepairCostAmount";
    NodeProperty["lossObjectRepairType"] = "lossObjectRepairType";
    NodeProperty["lossObjectOwnerName"] = "lossObjectOwnerName";
    NodeProperty["lossObjectOwnerType"] = "lossObjectOwnerType";
    NodeProperty["lossObjectOwnerIsSameHouseHold"] = "lossObjectOwnerIsSameHouseHold";
    NodeProperty["lossObjectOwnerPersonId"] = "lossObjectOwnerPersonId";
    NodeProperty["lossObjectIsScreenDamaged"] = "lossObjectIsScreenDamaged";
    NodeProperty["hasBeenPurchasedAsUsed"] = "hasBeenPurchasedAsUsed";
    NodeProperty["usedPhonePurchaseLocation"] = "usedPhonePurchaseLocation";
    NodeProperty["accidentTime"] = "accidentTime";
    NodeProperty["domesticOrForeignCountry"] = "domesticOrForeignCountry";
    NodeProperty["incidentCity"] = "incidentCity";
    NodeProperty["incidentCountryNew"] = "incidentCountryNew";
    NodeProperty["moreDefinedAccidentPlace"] = "moreDefinedAccidentPlace";
    NodeProperty["whatCausedAccident"] = "whatCausedAccident";
    NodeProperty["fireCause"] = "fireCause";
    NodeProperty["incidentCauseDescription"] = "incidentCauseDescription";
    NodeProperty["descriptionOfTheAccidentAndDamages"] = "descriptionOfTheAccidentAndDamages";
    NodeProperty["descriptionOfTheAccidentAndDamagesTheft"] = "descriptionOfTheAccidentAndDamagesTheft";
    NodeProperty["lockedOrNot"] = "lockedOrNot";
    NodeProperty["howItemsWereLocked"] = "howItemsWereLocked";
    NodeProperty["policeReport"] = "policeReport";
    NodeProperty["policeReportNr"] = "policeReportNr";
    NodeProperty["alcoholOrDrugs"] = "alcoholOrDrugs";
    NodeProperty["boatMakeAndModel"] = "boatMakeAndModel";
    NodeProperty["isTheBoatRegistered"] = "isTheBoatRegistered";
    NodeProperty["boatRegisterNumber"] = "boatRegisterNumber";
    NodeProperty["boatOwner"] = "boatOwner";
    NodeProperty["boatOwnerBankName"] = "boatOwnerBankName";
    NodeProperty["boatOwnerOtherName"] = "boatOwnerOtherName";
    NodeProperty["boatOwnerOtherSSN"] = "boatOwnerOtherSSN";
    NodeProperty["boatOwnersName"] = "boatOwnersName";
    NodeProperty["rentalUsage"] = "rentalUsage";
    NodeProperty["rentalUsageWhat"] = "rentalUsageWhat";
    NodeProperty["damageToMotor"] = "damageToMotor";
    NodeProperty["motorMakeAndModel"] = "motorMakeAndModel";
    NodeProperty["motorDamages"] = "motorDamages";
    NodeProperty["customerCompanyID"] = "customerCompanyID";
    NodeProperty["vahaClaimIdentifier"] = "vahaClaimIdentifier";
    NodeProperty["sajPolicyNumber"] = "sajPolicyNumber";
    NodeProperty["claimDate"] = "claimDate";
    NodeProperty["costDate"] = "costDate";
    NodeProperty["intoQueueId"] = "intoQueueId";
    NodeProperty["typeId"] = "typeId";
    NodeProperty["headingData"] = "headingData";
    NodeProperty["resultProperties"] = "resultProperties";
    NodeProperty["claimantCountry"] = "claimantCountry";
    NodeProperty["claimantFirstName"] = "claimantFirstName";
    NodeProperty["claimantSocialSecurityNumber"] = "claimantSocialSecurityNumber";
    NodeProperty["claimantType"] = "claimantType";
    NodeProperty["claimantCustomerNumber"] = "claimantCustomerNumber";
    NodeProperty["countryId"] = "countryId";
    NodeProperty["countryName"] = "countryName";
    NodeProperty["placeOfAccidentLocation"] = "placeOfAccidentLocation";
    NodeProperty["employmentDateStart"] = "employmentDateStart";
    NodeProperty["languageCode"] = "languageCode";
    NodeProperty["productArea"] = "productArea";
    NodeProperty["webFormCaimType"] = "webFormCaimType";
    NodeProperty["naturalDamageCode"] = "naturalDamageCode";
    NodeProperty["frontenClaimReporterName"] = "frontenClaimReporterName";
    NodeProperty["reporterMunicipality"] = "reporterMunicipality";
    NodeProperty["reportedPolicyHolderMunicipality"] = "reportedPolicyHolderMunicipality";
    NodeProperty["tradeUnion"] = "tradeUnion";
    NodeProperty["compensationBeneficiaryMunicipality"] = "compensationBeneficiaryMunicipality";
    NodeProperty["incidentCountryCode"] = "incidentCountryCode";
    NodeProperty["incidentMunicipalityCode"] = "incidentMunicipalityCode";
    NodeProperty["incidentCircumstanceDescr"] = "incidentCircumstanceDescr";
    NodeProperty["incidentTravelStartDate"] = "incidentTravelStartDate";
    NodeProperty["lossObjectTypeDesc"] = "lossObjectTypeDesc";
    NodeProperty["lossObjectBrand"] = "lossObjectBrand";
    NodeProperty["lossObjectOtherBrand"] = "lossObjectOtherBrand";
    NodeProperty["lossObjectOtherModel"] = "lossObjectOtherModel";
    NodeProperty["lossObjectDeviceDescription"] = "lossObjectDeviceDescription";
    NodeProperty["lossObjectYearOfPurchace"] = "lossObjectYearOfPurchace";
    NodeProperty["lossObjectNewPurchaseValue"] = "lossObjectNewPurchaseValue";
    NodeProperty["lossObjectRepairCosts"] = "lossObjectRepairCosts";
    NodeProperty["lossObjectOwner"] = "lossObjectOwner";
    NodeProperty["lossObjectRepairCostEstimatedOnType"] = "lossObjectRepairCostEstimatedOnType";
    NodeProperty["lossObjectQuantity"] = "lossObjectQuantity";
    NodeProperty["theftIsTheftNoticed"] = "theftIsTheftNoticed";
    NodeProperty["theftPlaceLastSeenDescr"] = "theftPlaceLastSeenDescr";
    NodeProperty["theftDateLastSeen"] = "theftDateLastSeen";
    NodeProperty["theftTimeLastSeen"] = "theftTimeLastSeen";
    NodeProperty["theftDateNoticed"] = "theftDateNoticed";
    NodeProperty["theftTimeNoticed"] = "theftTimeNoticed";
    NodeProperty["theftActivityDescr"] = "theftActivityDescr";
    NodeProperty["theftAdditionalDescr"] = "theftAdditionalDescr";
    NodeProperty["delayDestinationCountry"] = "delayDestinationCountry";
    NodeProperty["delayOriginalArrivalDate"] = "delayOriginalArrivalDate";
    NodeProperty["delayOriginalArrivalTime"] = "delayOriginalArrivalTime";
    NodeProperty["delayActualArrivalDate"] = "delayActualArrivalDate";
    NodeProperty["delayActualArrivalTime"] = "delayActualArrivalTime";
    NodeProperty["delayQuantityOfLuggage"] = "delayQuantityOfLuggage";
    NodeProperty["delayNecessitiesCosts"] = "delayNecessitiesCosts";
    NodeProperty["missingDestinationCountry"] = "missingDestinationCountry";
    NodeProperty["missingOriginalArrivalDate"] = "missingOriginalArrivalDate";
    NodeProperty["missingOriginalArrivalTime"] = "missingOriginalArrivalTime";
    NodeProperty["pasiNotificationHtml"] = "pasiNotificationHtml";
})(NodeProperty || (NodeProperty = {}));
// Properties all nodes should have
export var BaseNodeProperty;
(function (BaseNodeProperty) {
    BaseNodeProperty["message"] = "message";
    BaseNodeProperty["variableName"] = "variableName";
    BaseNodeProperty["validationRegex"] = "validationRegex";
    BaseNodeProperty["validationMessage"] = "validationMessage";
    BaseNodeProperty["validationMaxLengthValue"] = "validationMaxLengthValue";
    BaseNodeProperty["excludeFromSummary"] = "excludeFromSummary";
    BaseNodeProperty["questionContainsPersonalData"] = "questionContainsPersonalData";
    BaseNodeProperty["answerCanContainPersonalData"] = "answerCanContainPersonalData";
    BaseNodeProperty["summaryMessage"] = "summaryMessage";
    BaseNodeProperty["comment"] = "comment";
})(BaseNodeProperty || (BaseNodeProperty = {}));
export class BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        this.nodeParams = params;
        this.messageType = params.messageType || MessageType._undefined;
        this.id = params.id || '';
        this.name = params.name || '';
        this.x = params.x || 0;
        this.y = params.y || 0;
        this.accessLogData = params.accessLogData || [];
        this.properties = {
            [BaseNodeProperty.variableName]: {
                value: (_b = (_a = params.properties.variableName) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "",
            },
            [BaseNodeProperty.message]: {
                value: (_d = (_c = params.properties.message) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : "",
            },
            [BaseNodeProperty.validationRegex]: {
                value: (_f = (_e = params.properties.validationRegex) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : "",
            },
            [BaseNodeProperty.validationMessage]: {
                value: (_h = (_g = params.properties.validationMessage) === null || _g === void 0 ? void 0 : _g.value) !== null && _h !== void 0 ? _h : "",
            },
            [BaseNodeProperty.validationMaxLengthValue]: {
                value: (_k = (_j = params.properties.validationMaxLengthValue) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : "",
            },
            [BaseNodeProperty.excludeFromSummary]: {
                value: (_m = (_l = params.properties.excludeFromSummary) === null || _l === void 0 ? void 0 : _l.value) !== null && _m !== void 0 ? _m : "",
            },
            [BaseNodeProperty.questionContainsPersonalData]: {
                value: (_p = (_o = params.properties.questionContainsPersonalData) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : "",
            },
            [BaseNodeProperty.answerCanContainPersonalData]: {
                value: (_r = (_q = params.properties.answerCanContainPersonalData) === null || _q === void 0 ? void 0 : _q.value) !== null && _r !== void 0 ? _r : "",
            },
            [BaseNodeProperty.summaryMessage]: {
                value: (_t = (_s = params.properties.summaryMessage) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : "",
            },
            [BaseNodeProperty.comment]: {
                value: (_v = (_u = params.properties.comment) === null || _u === void 0 ? void 0 : _u.value) !== null && _v !== void 0 ? _v : "",
            },
        };
        this.customProperties = params.customProperties;
        this.outputProperties = [];
    }
}
export class _undefinedNode extends BaseNode {
}
export class MessageNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { defaultValidationMessage: {
                value: (_b = (_a = params.properties.defaultValidationMessage) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.defaultValidationMessage) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class InputTextNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { toUpperCase: {
                value: (_b = (_a = params.properties.toUpperCase) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.toUpperCase) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, removeWhiteSpaces: {
                value: (_f = (_e = params.properties.removeWhiteSpaces) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.removeWhiteSpaces) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, placeholder: {
                value: (_k = (_j = params.properties.placeholder) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.placeholder) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, maxLengthValidationMessage: {
                value: (_p = (_o = params.properties.maxLengthValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.maxLengthValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_t = (_s = params.properties.defaultValidationMessage) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.defaultValidationMessage) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class InputChoiceNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { defaultValidationMessage: {
                value: (_b = (_a = params.properties.defaultValidationMessage) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.defaultValidationMessage) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class InputDateNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { minimumPeriod: {
                value: (_b = (_a = params.properties.minimumPeriod) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.minimumPeriod) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, maximumPeriod: {
                value: (_f = (_e = params.properties.maximumPeriod) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.maximumPeriod) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, confirmButton: {
                value: (_k = (_j = params.properties.confirmButton) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.confirmButton) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, datePreset: {
                value: (_p = (_o = params.properties.datePreset) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.datePreset) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: 'dd.mm.yyyy',
                possibleValues: ['dd.mm.yyyy', 'mm.dd.yyyy', 'dd/mm/yyyy', 'mm/dd/yyyy', 'yyyy.mm.dd', 'yyyy-mm-dd'],
            }, dateAvailabilityType: {
                value: (_t = (_s = params.properties.dateAvailabilityType) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.dateAvailabilityType) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: 'PastAndCurrent',
                possibleValues: ['Any', 'Future', 'FutureAndCurrent', 'Past', 'PastAndCurrent'],
            }, yearMask: {
                value: (_x = (_w = params.properties.yearMask) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.yearMask) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, monthMask: {
                value: (_1 = (_0 = params.properties.monthMask) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.monthMask) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, dayMask: {
                value: (_5 = (_4 = params.properties.dayMask) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.dayMask) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_9 = (_8 = params.properties.defaultValidationMessage) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.defaultValidationMessage) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'userInputValue',
                possibleValues: ['Date in format what customer sees']
            }
        ];
    }
}
export class InputTimeNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { shouldNotExeedNow: {
                value: (_b = (_a = params.properties.shouldNotExeedNow) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.shouldNotExeedNow) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, exeedsNowMessage: {
                value: (_f = (_e = params.properties.exeedsNowMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.exeedsNowMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, date: {
                value: (_k = (_j = params.properties.date) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.date) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, dateFormat: {
                value: (_p = (_o = params.properties.dateFormat) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.dateFormat) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: 'dd.MM.yyyy',
                possibleValues: null,
            }, timeZoneId: {
                value: (_t = (_s = params.properties.timeZoneId) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.timeZoneId) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: 'FLE Standard Time',
                possibleValues: null,
            }, hourMask: {
                value: (_x = (_w = params.properties.hourMask) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.hourMask) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, minutesMask: {
                value: (_1 = (_0 = params.properties.minutesMask) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.minutesMask) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, hours: {
                value: (_5 = (_4 = params.properties.hours) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.hours) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, minutes: {
                value: (_9 = (_8 = params.properties.minutes) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.minutes) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_13 = (_12 = params.properties.defaultValidationMessage) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.defaultValidationMessage) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class InputDateTimeNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { dateTimeFormat: {
                value: (_b = (_a = params.properties.dateTimeFormat) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.dateTimeFormat) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: 'yyyy-MM-dd HH:mm',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class InputSsnNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { placeholder: {
                value: (_b = (_a = params.properties.placeholder) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.placeholder) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, countryCode: {
                value: (_f = (_e = params.properties.countryCode) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.countryCode) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, maxLengthValidationMessage: {
                value: (_k = (_j = params.properties.maxLengthValidationMessage) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.maxLengthValidationMessage) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class FileUpload_AttachmentViewerNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { accessId: {
                value: (_b = (_a = params.properties.accessId) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.accessId) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, allowedFileExtensions: {
                value: (_f = (_e = params.properties.allowedFileExtensions) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.allowedFileExtensions) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '.txt, .pdf, .png, .jpeg, .jpg, .bmp, .tif, .tiff, .rtf, .doc, .docx, .ppt, .pptx, .xls, .xlsx, .html, .avi, .gif, .wmv, .mov, .mp4, .eml, .msg, .xml, .xlsm, .zip',
                possibleValues: null,
            }, claimNumberRegex: {
                value: (_k = (_j = params.properties.claimNumberRegex) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.claimNumberRegex) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, aclName: {
                value: (_p = (_o = params.properties.aclName) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.aclName) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, contentOwner: {
                value: (_t = (_s = params.properties.contentOwner) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.contentOwner) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: ['PRI', 'COM', 'IND', 'FIN'],
            }, country: {
                value: (_x = (_w = params.properties.country) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.country) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: ['NO', 'DK', 'SE', 'FI'],
            }, customerType: {
                value: (_1 = (_0 = params.properties.customerType) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.customerType) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: ['MCDB', 'LH', 'WP', 'SAJ', 'FK', 'FX', 'CG', 'CCID'],
            }, lineOfBusiness: {
                value: (_5 = (_4 = params.properties.lineOfBusiness) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.lineOfBusiness) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyType: {
                value: (_9 = (_8 = params.properties.policyType) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.policyType) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: 'PLCY',
                possibleValues: ['AGRM', 'PLCY', 'LH', 'WP', 'FX', 'CG', 'NOR', 'PPA', 'SMPA', 'PRUS'],
            }, headerText: {
                value: (_13 = (_12 = params.properties.headerText) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.headerText) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, uploadFilesButtonText: {
                value: (_17 = (_16 = params.properties.uploadFilesButtonText) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.uploadFilesButtonText) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, uploadInProgressButtonText: {
                value: (_21 = (_20 = params.properties.uploadInProgressButtonText) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.uploadInProgressButtonText) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, browseFilesButtonText: {
                value: (_25 = (_24 = params.properties.browseFilesButtonText) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.browseFilesButtonText) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, dropZoneContainerText: {
                value: (_29 = (_28 = params.properties.dropZoneContainerText) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.dropZoneContainerText) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            }, uploadFailedErrorMessage: {
                value: (_33 = (_32 = params.properties.uploadFailedErrorMessage) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.uploadFailedErrorMessage) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '',
                possibleValues: null,
            }, fileTypeErrorMessage: {
                value: (_37 = (_36 = params.properties.fileTypeErrorMessage) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.fileTypeErrorMessage) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '',
                possibleValues: null,
            }, maxFileSizeInBytes: {
                value: (_41 = (_40 = params.properties.maxFileSizeInBytes) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.maxFileSizeInBytes) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '52428800',
                possibleValues: null,
            }, fileSizeErrorMessage: {
                value: (_45 = (_44 = params.properties.fileSizeErrorMessage) === null || _44 === void 0 ? void 0 : _44.value) !== null && _45 !== void 0 ? _45 : '',
                values: (_47 = (_46 = params.properties.fileSizeErrorMessage) === null || _46 === void 0 ? void 0 : _46.values) !== null && _47 !== void 0 ? _47 : [],
                defaultValue: '',
                possibleValues: null,
            }, fileEmptyErrorMessage: {
                value: (_49 = (_48 = params.properties.fileEmptyErrorMessage) === null || _48 === void 0 ? void 0 : _48.value) !== null && _49 !== void 0 ? _49 : '',
                values: (_51 = (_50 = params.properties.fileEmptyErrorMessage) === null || _50 === void 0 ? void 0 : _50.values) !== null && _51 !== void 0 ? _51 : [],
                defaultValue: '',
                possibleValues: null,
            }, maxFileCount: {
                value: (_53 = (_52 = params.properties.maxFileCount) === null || _52 === void 0 ? void 0 : _52.value) !== null && _53 !== void 0 ? _53 : '',
                values: (_55 = (_54 = params.properties.maxFileCount) === null || _54 === void 0 ? void 0 : _54.values) !== null && _55 !== void 0 ? _55 : [],
                defaultValue: '20',
                possibleValues: null,
            }, fileCountErrorMessage: {
                value: (_57 = (_56 = params.properties.fileCountErrorMessage) === null || _56 === void 0 ? void 0 : _56.value) !== null && _57 !== void 0 ? _57 : '',
                values: (_59 = (_58 = params.properties.fileCountErrorMessage) === null || _58 === void 0 ? void 0 : _58.values) !== null && _59 !== void 0 ? _59 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_61 = (_60 = params.properties.defaultValidationMessage) === null || _60 === void 0 ? void 0 : _60.value) !== null && _61 !== void 0 ? _61 : '',
                values: (_63 = (_62 = params.properties.defaultValidationMessage) === null || _62 === void 0 ? void 0 : _62.values) !== null && _63 !== void 0 ? _63 : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'AttachmentViewerLink',
                possibleValues: []
            }, {
                name: 'UploadedFileList',
                possibleValues: []
            }, {
                name: 'FailedFileList',
                possibleValues: []
            }, {
                name: 'ErrorMessageList',
                possibleValues: []
            }, {
                name: 'ErrorCodeList',
                possibleValues: []
            }
        ];
    }
}
export class FileUploadNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { allowedFileExtensions: {
                value: (_b = (_a = params.properties.allowedFileExtensions) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.allowedFileExtensions) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '.txt, .pdf, .png, .jpeg, .jpg, .bmp, .tif, .tiff, .rtf, .doc, .docx, .ppt, .pptx, .xls, .xlsx, .html, .avi, .gif, .wmv, .mov, .mp4, .eml, .msg, .xml, .xlsm, .zip',
                possibleValues: null,
            }, headerText: {
                value: (_f = (_e = params.properties.headerText) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.headerText) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, uploadFilesButtonText: {
                value: (_k = (_j = params.properties.uploadFilesButtonText) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.uploadFilesButtonText) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, uploadInProgressButtonText: {
                value: (_p = (_o = params.properties.uploadInProgressButtonText) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.uploadInProgressButtonText) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, browseFilesButtonText: {
                value: (_t = (_s = params.properties.browseFilesButtonText) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.browseFilesButtonText) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, dropZoneContainerText: {
                value: (_x = (_w = params.properties.dropZoneContainerText) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.dropZoneContainerText) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, uploadFailedErrorMessage: {
                value: (_1 = (_0 = params.properties.uploadFailedErrorMessage) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.uploadFailedErrorMessage) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, fileTypeErrorMessage: {
                value: (_5 = (_4 = params.properties.fileTypeErrorMessage) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.fileTypeErrorMessage) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, maxFileSizeInBytes: {
                value: (_9 = (_8 = params.properties.maxFileSizeInBytes) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.maxFileSizeInBytes) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '52428800',
                possibleValues: null,
            }, fileSizeErrorMessage: {
                value: (_13 = (_12 = params.properties.fileSizeErrorMessage) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.fileSizeErrorMessage) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, fileEmptyErrorMessage: {
                value: (_17 = (_16 = params.properties.fileEmptyErrorMessage) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.fileEmptyErrorMessage) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, maxFileCount: {
                value: (_21 = (_20 = params.properties.maxFileCount) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.maxFileCount) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '20',
                possibleValues: null,
            }, fileCountErrorMessage: {
                value: (_25 = (_24 = params.properties.fileCountErrorMessage) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.fileCountErrorMessage) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_29 = (_28 = params.properties.defaultValidationMessage) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.defaultValidationMessage) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'UploadedFileList',
                possibleValues: []
            }, {
                name: 'UploadedFiles',
                possibleValues: []
            }
        ];
    }
}
export class LongListNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { title: {
                value: (_b = (_a = params.properties.title) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.title) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, openButtonText: {
                value: (_f = (_e = params.properties.openButtonText) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.openButtonText) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, maxItemsToSelect: {
                value: (_k = (_j = params.properties.maxItemsToSelect) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.maxItemsToSelect) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '0',
                possibleValues: null,
            }, maxItemsToSelectErrorMessage: {
                value: (_p = (_o = params.properties.maxItemsToSelectErrorMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.maxItemsToSelectErrorMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, dataSource: {
                value: (_t = (_s = params.properties.dataSource) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.dataSource) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_x = (_w = params.properties.defaultValidationMessage) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.defaultValidationMessage) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'Text',
                possibleValues: []
            }, {
                name: 'Code',
                possibleValues: []
            }, {
                name: 'Texts',
                possibleValues: []
            }, {
                name: 'Codes',
                possibleValues: []
            }
        ];
    }
}
export class SetValueNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { defaultValidationMessage: {
                value: (_b = (_a = params.properties.defaultValidationMessage) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.defaultValidationMessage) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class SectionNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { defaultValidationMessage: {
                value: (_b = (_a = params.properties.defaultValidationMessage) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.defaultValidationMessage) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class ContainerNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { defaultValidationMessage: {
                value: (_b = (_a = params.properties.defaultValidationMessage) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.defaultValidationMessage) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class CarouselNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { defaultValidationMessage: {
                value: (_b = (_a = params.properties.defaultValidationMessage) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.defaultValidationMessage) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class EndOfConversationNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { defaultValidationMessage: {
                value: (_b = (_a = params.properties.defaultValidationMessage) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.defaultValidationMessage) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class InputMultipleChoiceNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { item: {
                value: (_b = (_a = params.properties.item) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.item) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultButton: {
                value: (_f = (_e = params.properties.defaultButton) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultButton) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: 'Ok',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_k = (_j = params.properties.defaultValidationMessage) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.defaultValidationMessage) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'item',
                possibleValues: ['Get if choice is checked - item.ChoiceItemDisplayName returns true/false']
            }, {
                name: 'code',
                possibleValues: ['Get code value for item - code.ChoiceItemDisplayName returns code value']
            }, {
                name: 'codes',
                possibleValues: ['Get codes for cheked items - codes returns coma separated code value of checked items']
            }, {
                name: 'Count',
                possibleValues: ['Get count of checked items - count returns checked item count']
            }
        ];
    }
}
export class RatingStarsNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { submitHint: {
                value: (_b = (_a = params.properties.submitHint) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.submitHint) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, ratingHint: {
                value: (_f = (_e = params.properties.ratingHint) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.ratingHint) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_k = (_j = params.properties.defaultValidationMessage) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.defaultValidationMessage) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class SetStatisticsNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { displayRecorded: {
                value: (_b = (_a = params.properties.displayRecorded) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.displayRecorded) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: 'false',
                possibleValues: null,
            }, recordNodeValueBag: {
                value: (_f = (_e = params.properties.recordNodeValueBag) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.recordNodeValueBag) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, statisticsEventType: {
                value: (_k = (_j = params.properties.statisticsEventType) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.statisticsEventType) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: ['', 'started', 'claimSent'],
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class InputClassifierNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { inputPlaceholder: {
                value: (_b = (_a = params.properties.inputPlaceholder) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.inputPlaceholder) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, noResultsFoundMessage: {
                value: (_f = (_e = params.properties.noResultsFoundMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.noResultsFoundMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, allowAnyValue: {
                value: (_k = (_j = params.properties.allowAnyValue) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.allowAnyValue) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'code',
                possibleValues: []
            }, {
                name: 'text',
                possibleValues: []
            }
        ];
    }
}
export class InputChoiceFromCarouselNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { carouselNodeName: {
                value: (_b = (_a = params.properties.carouselNodeName) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.carouselNodeName) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, listItemDisplayPattern: {
                value: (_f = (_e = params.properties.listItemDisplayPattern) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.listItemDisplayPattern) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: 'Ok',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_k = (_j = params.properties.defaultValidationMessage) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.defaultValidationMessage) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class ListFromCarouselNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { carouselNodeName: {
                value: (_b = (_a = params.properties.carouselNodeName) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.carouselNodeName) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, column1: {
                value: (_f = (_e = params.properties.column1) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.column1) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, column2: {
                value: (_k = (_j = params.properties.column2) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.column2) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, column3: {
                value: (_p = (_o = params.properties.column3) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.column3) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, noItemsInListMessage: {
                value: (_t = (_s = params.properties.noItemsInListMessage) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.noItemsInListMessage) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, removeButtonText: {
                value: (_x = (_w = params.properties.removeButtonText) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.removeButtonText) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, undoRemoveButtonText: {
                value: (_1 = (_0 = params.properties.undoRemoveButtonText) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.undoRemoveButtonText) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, minItemCount: {
                value: (_5 = (_4 = params.properties.minItemCount) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.minItemCount) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '1',
                possibleValues: null,
            }, maxItemCount: {
                value: (_9 = (_8 = params.properties.maxItemCount) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.maxItemCount) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, minCountErrorMessage: {
                value: (_13 = (_12 = params.properties.minCountErrorMessage) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.minCountErrorMessage) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, maxCountErrorMessage: {
                value: (_17 = (_16 = params.properties.maxCountErrorMessage) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.maxCountErrorMessage) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, sumVariableName: {
                value: (_21 = (_20 = params.properties.sumVariableName) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.sumVariableName) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, addItemButtons: {
                value: (_25 = (_24 = params.properties.addItemButtons) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.addItemButtons) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, continueButtons: {
                value: (_29 = (_28 = params.properties.continueButtons) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.continueButtons) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            }, showTotalSum: {
                value: (_33 = (_32 = params.properties.showTotalSum) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.showTotalSum) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, totalSumLabel: {
                value: (_37 = (_36 = params.properties.totalSumLabel) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.totalSumLabel) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '',
                possibleValues: null,
            }, totalSumUnits: {
                value: (_41 = (_40 = params.properties.totalSumUnits) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.totalSumUnits) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_45 = (_44 = params.properties.defaultValidationMessage) === null || _44 === void 0 ? void 0 : _44.value) !== null && _45 !== void 0 ? _45 : '',
                values: (_47 = (_46 = params.properties.defaultValidationMessage) === null || _46 === void 0 ? void 0 : _46.values) !== null && _47 !== void 0 ? _47 : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'Sum',
                possibleValues: ['Calculates the sum of variable values in list items. Variable name is specified in sumVariableName']
            }, {
                name: 'Count',
                possibleValues: ['Get count of list items']
            }
        ];
    }
}
export class DefineSummaryNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { designType: {
                value: (_b = (_a = params.properties.designType) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.designType) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: 'IfBlue',
                possibleValues: ['IfBlue', 'IfGrey', 'Europeiske', 'Volvia', 'Polestar', 'EuropeiskeRebranded'],
            }, conditionalDesignType: {
                value: (_f = (_e = params.properties.conditionalDesignType) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.conditionalDesignType) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, summaryTemplateData: {
                value: (_k = (_j = params.properties.summaryTemplateData) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.summaryTemplateData) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, title: {
                value: (_p = (_o = params.properties.title) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.title) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, language: {
                value: (_t = (_s = params.properties.language) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.language) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: 'en',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_x = (_w = params.properties.defaultValidationMessage) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.defaultValidationMessage) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'summaryContentOutput',
                possibleValues: []
            }
        ];
    }
}
export class InputCurrencyNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { placeholder: {
                value: (_b = (_a = params.properties.placeholder) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.placeholder) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultCurrency: {
                value: (_f = (_e = params.properties.defaultCurrency) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultCurrency) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: ['EUR', 'DKK', 'NOK', 'SEK', 'USD'],
            }, maxLengthValidationMessage: {
                value: (_k = (_j = params.properties.maxLengthValidationMessage) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.maxLengthValidationMessage) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Sweden_FollowUp_DecryptNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { encryptedValue: {
                value: (_b = (_a = params.properties.encryptedValue) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.encryptedValue) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Common_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { frontenSummaryDefinition: {
                value: (_b = (_a = params.properties.frontenSummaryDefinition) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.frontenSummaryDefinition) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '[XXXXX.summaryContentOutput]',
                possibleValues: null,
            }, frontenHtmlFileName: {
                value: (_f = (_e = params.properties.frontenHtmlFileName) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.frontenHtmlFileName) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenBusinessArea: {
                value: (_k = (_j = params.properties.frontenBusinessArea) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.frontenBusinessArea) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenCategory: {
                value: (_p = (_o = params.properties.frontenCategory) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.frontenCategory) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenDocumentType: {
                value: (_t = (_s = params.properties.frontenDocumentType) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.frontenDocumentType) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenQueue: {
                value: (_x = (_w = params.properties.frontenQueue) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.frontenQueue) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, businessArea: {
                value: (_1 = (_0 = params.properties.businessArea) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.businessArea) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, lineOfBusiness: {
                value: (_5 = (_4 = params.properties.lineOfBusiness) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.lineOfBusiness) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, insuredObject: {
                value: (_9 = (_8 = params.properties.insuredObject) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.insuredObject) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, customerNumber: {
                value: (_13 = (_12 = params.properties.customerNumber) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.customerNumber) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyNumber: {
                value: (_17 = (_16 = params.properties.policyNumber) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.policyNumber) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimNumber: {
                value: (_21 = (_20 = params.properties.claimNumber) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.claimNumber) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimType: {
                value: (_25 = (_24 = params.properties.claimType) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.claimType) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, parentType: {
                value: (_29 = (_28 = params.properties.parentType) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.parentType) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimReportName: {
                value: (_33 = (_32 = params.properties.claimReportName) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.claimReportName) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '',
                possibleValues: null,
            }, country: {
                value: (_37 = (_36 = params.properties.country) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.country) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '',
                possibleValues: null,
            }, customerEmail: {
                value: (_41 = (_40 = params.properties.customerEmail) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.customerEmail) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '',
                possibleValues: null,
            }, customerName: {
                value: (_45 = (_44 = params.properties.customerName) === null || _44 === void 0 ? void 0 : _44.value) !== null && _45 !== void 0 ? _45 : '',
                values: (_47 = (_46 = params.properties.customerName) === null || _46 === void 0 ? void 0 : _46.values) !== null && _47 !== void 0 ? _47 : [],
                defaultValue: '',
                possibleValues: null,
            }, customerPhone: {
                value: (_49 = (_48 = params.properties.customerPhone) === null || _48 === void 0 ? void 0 : _48.value) !== null && _49 !== void 0 ? _49 : '',
                values: (_51 = (_50 = params.properties.customerPhone) === null || _50 === void 0 ? void 0 : _50.values) !== null && _51 !== void 0 ? _51 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDate: {
                value: (_53 = (_52 = params.properties.incidentDate) === null || _52 === void 0 ? void 0 : _52.value) !== null && _53 !== void 0 ? _53 : '',
                values: (_55 = (_54 = params.properties.incidentDate) === null || _54 === void 0 ? void 0 : _54.values) !== null && _55 !== void 0 ? _55 : [],
                defaultValue: '',
                possibleValues: null,
            }, stargateTemplate: {
                value: (_57 = (_56 = params.properties.stargateTemplate) === null || _56 === void 0 ? void 0 : _56.value) !== null && _57 !== void 0 ? _57 : '',
                values: (_59 = (_58 = params.properties.stargateTemplate) === null || _58 === void 0 ? void 0 : _58.values) !== null && _59 !== void 0 ? _59 : [],
                defaultValue: '',
                possibleValues: null,
            }, vehicleRegistrationNumber: {
                value: (_61 = (_60 = params.properties.vehicleRegistrationNumber) === null || _60 === void 0 ? void 0 : _60.value) !== null && _61 !== void 0 ? _61 : '',
                values: (_63 = (_62 = params.properties.vehicleRegistrationNumber) === null || _62 === void 0 ? void 0 : _62.values) !== null && _63 !== void 0 ? _63 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_65 = (_64 = params.properties.defaultValidationMessage) === null || _64 === void 0 ? void 0 : _64.value) !== null && _65 !== void 0 ? _65 : '',
                values: (_67 = (_66 = params.properties.defaultValidationMessage) === null || _66 === void 0 ? void 0 : _66.values) !== null && _67 !== void 0 ? _67 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class SummaryNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { fileName: {
                value: (_b = (_a = params.properties.fileName) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.fileName) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: 'Summary.pdf',
                possibleValues: null,
            }, summaryDefinition: {
                value: (_f = (_e = params.properties.summaryDefinition) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.summaryDefinition) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, pageHeightInMillimeters: {
                value: (_k = (_j = params.properties.pageHeightInMillimeters) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.pageHeightInMillimeters) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '297',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Common_SendDataCompassNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { customerSsn: {
                value: (_b = (_a = params.properties.customerSsn) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.customerSsn) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, vehicleRegistrationNumber: {
                value: (_f = (_e = params.properties.vehicleRegistrationNumber) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.vehicleRegistrationNumber) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, customerEmail: {
                value: (_k = (_j = params.properties.customerEmail) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.customerEmail) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, customerName: {
                value: (_p = (_o = params.properties.customerName) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.customerName) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, customerPhone: {
                value: (_t = (_s = params.properties.customerPhone) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.customerPhone) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, countryCode: {
                value: (_x = (_w = params.properties.countryCode) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.countryCode) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, owner: {
                value: (_1 = (_0 = params.properties.owner) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.owner) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, businessArea: {
                value: (_5 = (_4 = params.properties.businessArea) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.businessArea) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimType: {
                value: (_9 = (_8 = params.properties.claimType) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.claimType) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, insuredObject: {
                value: (_13 = (_12 = params.properties.insuredObject) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.insuredObject) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, lineOfBusiness: {
                value: (_17 = (_16 = params.properties.lineOfBusiness) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.lineOfBusiness) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyNumber: {
                value: (_21 = (_20 = params.properties.policyNumber) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.policyNumber) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, summary: {
                value: (_25 = (_24 = params.properties.summary) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.summary) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, compassSubject: {
                value: (_29 = (_28 = params.properties.compassSubject) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.compassSubject) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            }, stargateTemplate: {
                value: (_33 = (_32 = params.properties.stargateTemplate) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.stargateTemplate) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '',
                possibleValues: null,
            }, tags: {
                value: (_37 = (_36 = params.properties.tags) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.tags) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '',
                possibleValues: null,
            }, legalNumber: {
                value: (_41 = (_40 = params.properties.legalNumber) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.legalNumber) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_45 = (_44 = params.properties.defaultValidationMessage) === null || _44 === void 0 ? void 0 : _44.value) !== null && _45 !== void 0 ? _45 : '',
                values: (_47 = (_46 = params.properties.defaultValidationMessage) === null || _46 === void 0 ? void 0 : _46.values) !== null && _47 !== void 0 ? _47 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class EmployeeAuthenticationNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { loginButton: {
                value: (_b = (_a = params.properties.loginButton) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.loginButton) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: 'Employee',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'username',
                possibleValues: []
            }, {
                name: 'name',
                possibleValues: []
            }, {
                name: 'surname',
                possibleValues: []
            }, {
                name: 'nameSurname',
                possibleValues: []
            }, {
                name: 'country',
                possibleValues: []
            }, {
                name: 'bankName',
                possibleValues: []
            }, {
                name: 'authTimestamp',
                possibleValues: []
            }, {
                name: 'AuthorizedUser',
                possibleValues: []
            }
        ];
    }
}
export class WeakAuthenticationNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { authenticationDataType: {
                value: (_b = (_a = params.properties.authenticationDataType) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.authenticationDataType) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: 'Ssn',
                possibleValues: ['Ssn', 'Name', 'Surname'],
            }, ssnCountryCode: {
                value: (_f = (_e = params.properties.ssnCountryCode) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.ssnCountryCode) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: 'None',
                possibleValues: ['None', 'Dk', 'No', 'Fi', 'Se'],
            }, toUpperCase: {
                value: (_k = (_j = params.properties.toUpperCase) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.toUpperCase) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, removeWhiteSpaces: {
                value: (_p = (_o = params.properties.removeWhiteSpaces) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.removeWhiteSpaces) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, placeholder: {
                value: (_t = (_s = params.properties.placeholder) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.placeholder) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, maxLengthValidationMessage: {
                value: (_x = (_w = params.properties.maxLengthValidationMessage) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.maxLengthValidationMessage) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_1 = (_0 = params.properties.defaultValidationMessage) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.defaultValidationMessage) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'ssn',
                possibleValues: []
            }, {
                name: 'name',
                possibleValues: []
            }, {
                name: 'surname',
                possibleValues: []
            }, {
                name: 'nameSurname',
                possibleValues: []
            }, {
                name: 'country',
                possibleValues: []
            }, {
                name: 'bankName',
                possibleValues: []
            }, {
                name: 'authTimestamp',
                possibleValues: []
            }, {
                name: 'AuthorizedUser',
                possibleValues: []
            }
        ];
    }
}
export class SilentAuthenticationNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { defaultValidationMessage: {
                value: (_b = (_a = params.properties.defaultValidationMessage) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.defaultValidationMessage) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'ssn',
                possibleValues: []
            }, {
                name: 'name',
                possibleValues: []
            }, {
                name: 'surname',
                possibleValues: []
            }, {
                name: 'nameSurname',
                possibleValues: []
            }, {
                name: 'country',
                possibleValues: []
            }, {
                name: 'bankName',
                possibleValues: []
            }, {
                name: 'authTimestamp',
                possibleValues: []
            }, {
                name: 'AuthorizedUser',
                possibleValues: []
            }
        ];
    }
}
export class SilentEmployeeAuthenticationNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { defaultValidationMessage: {
                value: (_b = (_a = params.properties.defaultValidationMessage) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.defaultValidationMessage) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'username',
                possibleValues: []
            }, {
                name: 'name',
                possibleValues: []
            }, {
                name: 'surname',
                possibleValues: []
            }, {
                name: 'nameSurname',
                possibleValues: []
            }, {
                name: 'country',
                possibleValues: []
            }, {
                name: 'bankName',
                possibleValues: []
            }, {
                name: 'authTimestamp',
                possibleValues: []
            }, {
                name: 'AuthorizedUser',
                possibleValues: []
            }
        ];
    }
}
export class InputPhoneNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { defaultCountry: {
                value: (_b = (_a = params.properties.defaultCountry) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.defaultCountry) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: ['SE', 'NO', 'FI', 'DK'],
            }, maxLengthValidationMessage: {
                value: (_f = (_e = params.properties.maxLengthValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.maxLengthValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_k = (_j = params.properties.defaultValidationMessage) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.defaultValidationMessage) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class StartNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { defaultValidationMessage: {
                value: (_b = (_a = params.properties.defaultValidationMessage) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.defaultValidationMessage) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Norway_AuthenticationNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { loginButton: {
                value: (_b = (_a = params.properties.loginButton) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.loginButton) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: 'BankID',
                possibleValues: null,
            }, loginMobileButton: {
                value: (_f = (_e = params.properties.loginMobileButton) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.loginMobileButton) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: 'BankID mobile',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_k = (_j = params.properties.defaultValidationMessage) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.defaultValidationMessage) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'ssn',
                possibleValues: []
            }, {
                name: 'name',
                possibleValues: []
            }, {
                name: 'surname',
                possibleValues: []
            }, {
                name: 'nameSurname',
                possibleValues: []
            }, {
                name: 'country',
                possibleValues: []
            }, {
                name: 'bankName',
                possibleValues: []
            }, {
                name: 'authTimestamp',
                possibleValues: []
            }, {
                name: 'AuthorizedUser',
                possibleValues: []
            }
        ];
    }
}
export class Norway_Motor_ShowVehiclesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { vehiclesData: {
                value: (_b = (_a = params.properties.vehiclesData) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.vehiclesData) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Norway_Motor_GetPoliciesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { incidentDate: {
                value: (_b = (_a = params.properties.incidentDate) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.incidentDate) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, vehicleRegistrationNumber: {
                value: (_f = (_e = params.properties.vehicleRegistrationNumber) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.vehicleRegistrationNumber) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, policyNumber: {
                value: (_k = (_j = params.properties.policyNumber) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.policyNumber) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'policy',
                possibleValues: []
            }, {
                name: 'policySystem',
                possibleValues: []
            }, {
                name: 'fullPolicyNumber',
                possibleValues: []
            }, {
                name: 'policyType',
                possibleValues: []
            }, {
                name: 'groupPolicyNumber',
                possibleValues: []
            }, {
                name: 'validFrom',
                possibleValues: []
            }, {
                name: 'validTo',
                possibleValues: []
            }, {
                name: 'businessArea',
                possibleValues: []
            }, {
                name: 'lineOfBusiness',
                possibleValues: []
            }, {
                name: 'productName',
                possibleValues: []
            }, {
                name: 'country',
                possibleValues: []
            }, {
                name: 'holderName',
                possibleValues: []
            }, {
                name: 'holderEmail',
                possibleValues: []
            }, {
                name: 'holderPhone',
                possibleValues: []
            }
        ];
    }
}
export class Norway_SummaryNode extends BaseNode {
}
export class Norway_GetUserInformationNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { ssn: {
                value: (_b = (_a = params.properties.ssn) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.ssn) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'FamilyName',
                possibleValues: []
            }, {
                name: 'MiddleName',
                possibleValues: []
            }, {
                name: 'GivenName',
                possibleValues: []
            }, {
                name: 'PhoneNumber',
                possibleValues: []
            }, {
                name: 'Email',
                possibleValues: []
            }, {
                name: 'StreetName',
                possibleValues: []
            }, {
                name: 'HouseNumber',
                possibleValues: []
            }, {
                name: 'PostalCode',
                possibleValues: []
            }, {
                name: 'EntranceCode',
                possibleValues: []
            }, {
                name: 'PlaceName',
                possibleValues: []
            }, {
                name: 'StreetNumber',
                possibleValues: []
            }, {
                name: 'CustomerNumber',
                possibleValues: []
            }, {
                name: 'userInformationData',
                possibleValues: []
            }, {
                name: 'firstName',
                possibleValues: []
            }, {
                name: 'surname',
                possibleValues: []
            }
        ];
    }
}
export class Norway_Motor_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143, _144, _145, _146, _147, _148, _149, _150, _151, _152, _153, _154, _155, _156, _157, _158, _159, _160, _161, _162, _163, _164, _165, _166, _167, _168, _169, _170, _171, _172, _173, _174, _175, _176, _177, _178, _179;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { reporterSsn: {
                value: (_b = (_a = params.properties.reporterSsn) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.reporterSsn) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, driverSsn: {
                value: (_f = (_e = params.properties.driverSsn) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.driverSsn) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, birthDate: {
                value: (_k = (_j = params.properties.birthDate) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.birthDate) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, vehicleRegistrationNumber: {
                value: (_p = (_o = params.properties.vehicleRegistrationNumber) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.vehicleRegistrationNumber) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '[REPLACE_THIS.selectedVehicleRegistrationNumber]',
                possibleValues: null,
            }, incidentType: {
                value: (_t = (_s = params.properties.incidentType) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.incidentType) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDate: {
                value: (_x = (_w = params.properties.incidentDate) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.incidentDate) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTime: {
                value: (_1 = (_0 = params.properties.incidentTime) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.incidentTime) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentCircumstance: {
                value: (_5 = (_4 = params.properties.incidentCircumstance) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.incidentCircumstance) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentCause: {
                value: (_9 = (_8 = params.properties.incidentCause) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.incidentCause) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, hasSummerTires: {
                value: (_13 = (_12 = params.properties.hasSummerTires) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.hasSummerTires) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, speedLimit: {
                value: (_17 = (_16 = params.properties.speedLimit) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.speedLimit) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, speed: {
                value: (_21 = (_20 = params.properties.speed) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.speed) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, currentMileage: {
                value: (_25 = (_24 = params.properties.currentMileage) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.currentMileage) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, hasPoliceBeenInPlace: {
                value: (_29 = (_28 = params.properties.hasPoliceBeenInPlace) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.hasPoliceBeenInPlace) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            }, isOwnVehicleDamaged: {
                value: (_33 = (_32 = params.properties.isOwnVehicleDamaged) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.isOwnVehicleDamaged) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '',
                possibleValues: null,
            }, damageArea: {
                value: (_37 = (_36 = params.properties.damageArea) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.damageArea) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '',
                possibleValues: null,
            }, vehicleLocation: {
                value: (_41 = (_40 = params.properties.vehicleLocation) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.vehicleLocation) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '',
                possibleValues: null,
            }, isDamagedObjects: {
                value: (_45 = (_44 = params.properties.isDamagedObjects) === null || _44 === void 0 ? void 0 : _44.value) !== null && _45 !== void 0 ? _45 : '',
                values: (_47 = (_46 = params.properties.isDamagedObjects) === null || _46 === void 0 ? void 0 : _46.values) !== null && _47 !== void 0 ? _47 : [],
                defaultValue: '',
                possibleValues: null,
            }, hasAlcoholOrDrugsInvolved: {
                value: (_49 = (_48 = params.properties.hasAlcoholOrDrugsInvolved) === null || _48 === void 0 ? void 0 : _48.value) !== null && _49 !== void 0 ? _49 : '',
                values: (_51 = (_50 = params.properties.hasAlcoholOrDrugsInvolved) === null || _50 === void 0 ? void 0 : _50.values) !== null && _51 !== void 0 ? _51 : [],
                defaultValue: '',
                possibleValues: null,
            }, hasDriverTheLicense: {
                value: (_53 = (_52 = params.properties.hasDriverTheLicense) === null || _52 === void 0 ? void 0 : _52.value) !== null && _53 !== void 0 ? _53 : '',
                values: (_55 = (_54 = params.properties.hasDriverTheLicense) === null || _54 === void 0 ? void 0 : _54.values) !== null && _55 !== void 0 ? _55 : [],
                defaultValue: '',
                possibleValues: null,
            }, hasFallenAsleep: {
                value: (_57 = (_56 = params.properties.hasFallenAsleep) === null || _56 === void 0 ? void 0 : _56.value) !== null && _57 !== void 0 ? _57 : '',
                values: (_59 = (_58 = params.properties.hasFallenAsleep) === null || _58 === void 0 ? void 0 : _58.values) !== null && _59 !== void 0 ? _59 : [],
                defaultValue: '',
                possibleValues: null,
            }, hasMobileOrOtherScreenUsed: {
                value: (_61 = (_60 = params.properties.hasMobileOrOtherScreenUsed) === null || _60 === void 0 ? void 0 : _60.value) !== null && _61 !== void 0 ? _61 : '',
                values: (_63 = (_62 = params.properties.hasMobileOrOtherScreenUsed) === null || _62 === void 0 ? void 0 : _62.values) !== null && _63 !== void 0 ? _63 : [],
                defaultValue: '',
                possibleValues: null,
            }, isInjuredPersons: {
                value: (_65 = (_64 = params.properties.isInjuredPersons) === null || _64 === void 0 ? void 0 : _64.value) !== null && _65 !== void 0 ? _65 : '',
                values: (_67 = (_66 = params.properties.isInjuredPersons) === null || _66 === void 0 ? void 0 : _66.values) !== null && _67 !== void 0 ? _67 : [],
                defaultValue: '',
                possibleValues: null,
            }, injuredRole: {
                value: (_69 = (_68 = params.properties.injuredRole) === null || _68 === void 0 ? void 0 : _68.value) !== null && _69 !== void 0 ? _69 : '',
                values: (_71 = (_70 = params.properties.injuredRole) === null || _70 === void 0 ? void 0 : _70.values) !== null && _71 !== void 0 ? _71 : [],
                defaultValue: '',
                possibleValues: null,
            }, isOtherCosts: {
                value: (_73 = (_72 = params.properties.isOtherCosts) === null || _72 === void 0 ? void 0 : _72.value) !== null && _73 !== void 0 ? _73 : '',
                values: (_75 = (_74 = params.properties.isOtherCosts) === null || _74 === void 0 ? void 0 : _74.values) !== null && _75 !== void 0 ? _75 : [],
                defaultValue: '',
                possibleValues: null,
            }, emailAddress: {
                value: (_77 = (_76 = params.properties.emailAddress) === null || _76 === void 0 ? void 0 : _76.value) !== null && _77 !== void 0 ? _77 : '',
                values: (_79 = (_78 = params.properties.emailAddress) === null || _78 === void 0 ? void 0 : _78.values) !== null && _79 !== void 0 ? _79 : [],
                defaultValue: '',
                possibleValues: null,
            }, phoneNumber: {
                value: (_81 = (_80 = params.properties.phoneNumber) === null || _80 === void 0 ? void 0 : _80.value) !== null && _81 !== void 0 ? _81 : '',
                values: (_83 = (_82 = params.properties.phoneNumber) === null || _82 === void 0 ? void 0 : _82.values) !== null && _83 !== void 0 ? _83 : [],
                defaultValue: '',
                possibleValues: null,
            }, summaryDefinition: {
                value: (_85 = (_84 = params.properties.summaryDefinition) === null || _84 === void 0 ? void 0 : _84.value) !== null && _85 !== void 0 ? _85 : '',
                values: (_87 = (_86 = params.properties.summaryDefinition) === null || _86 === void 0 ? void 0 : _86.values) !== null && _87 !== void 0 ? _87 : [],
                defaultValue: '[REPLACE_THIS.summaryContentOutput]',
                possibleValues: null,
            }, customerNumber: {
                value: (_89 = (_88 = params.properties.customerNumber) === null || _88 === void 0 ? void 0 : _88.value) !== null && _89 !== void 0 ? _89 : '',
                values: (_91 = (_90 = params.properties.customerNumber) === null || _90 === void 0 ? void 0 : _90.values) !== null && _91 !== void 0 ? _91 : [],
                defaultValue: '[REPLACE_THIS.CustomerNumber]',
                possibleValues: null,
            }, carPolicyNumber: {
                value: (_93 = (_92 = params.properties.carPolicyNumber) === null || _92 === void 0 ? void 0 : _92.value) !== null && _93 !== void 0 ? _93 : '',
                values: (_95 = (_94 = params.properties.carPolicyNumber) === null || _94 === void 0 ? void 0 : _94.values) !== null && _95 !== void 0 ? _95 : [],
                defaultValue: '[REPLACE_THIS.carPolicyNumber]',
                possibleValues: null,
            }, brand: {
                value: (_97 = (_96 = params.properties.brand) === null || _96 === void 0 ? void 0 : _96.value) !== null && _97 !== void 0 ? _97 : '',
                values: (_99 = (_98 = params.properties.brand) === null || _98 === void 0 ? void 0 : _98.values) !== null && _99 !== void 0 ? _99 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimTypeText: {
                value: (_101 = (_100 = params.properties.claimTypeText) === null || _100 === void 0 ? void 0 : _100.value) !== null && _101 !== void 0 ? _101 : '',
                values: (_103 = (_102 = params.properties.claimTypeText) === null || _102 === void 0 ? void 0 : _102.values) !== null && _103 !== void 0 ? _103 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportersFirstName: {
                value: (_105 = (_104 = params.properties.reportersFirstName) === null || _104 === void 0 ? void 0 : _104.value) !== null && _105 !== void 0 ? _105 : '',
                values: (_107 = (_106 = params.properties.reportersFirstName) === null || _106 === void 0 ? void 0 : _106.values) !== null && _107 !== void 0 ? _107 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportersLastName: {
                value: (_109 = (_108 = params.properties.reportersLastName) === null || _108 === void 0 ? void 0 : _108.value) !== null && _109 !== void 0 ? _109 : '',
                values: (_111 = (_110 = params.properties.reportersLastName) === null || _110 === void 0 ? void 0 : _110.values) !== null && _111 !== void 0 ? _111 : [],
                defaultValue: '',
                possibleValues: null,
            }, counterpartRegistrationNumber: {
                value: (_113 = (_112 = params.properties.counterpartRegistrationNumber) === null || _112 === void 0 ? void 0 : _112.value) !== null && _113 !== void 0 ? _113 : '',
                values: (_115 = (_114 = params.properties.counterpartRegistrationNumber) === null || _114 === void 0 ? void 0 : _114.values) !== null && _115 !== void 0 ? _115 : [],
                defaultValue: '',
                possibleValues: null,
            }, damagedOtherArea: {
                value: (_117 = (_116 = params.properties.damagedOtherArea) === null || _116 === void 0 ? void 0 : _116.value) !== null && _117 !== void 0 ? _117 : '',
                values: (_119 = (_118 = params.properties.damagedOtherArea) === null || _118 === void 0 ? void 0 : _118.values) !== null && _119 !== void 0 ? _119 : [],
                defaultValue: '',
                possibleValues: null,
            }, oldDamagesDescription: {
                value: (_121 = (_120 = params.properties.oldDamagesDescription) === null || _120 === void 0 ? void 0 : _120.value) !== null && _121 !== void 0 ? _121 : '',
                values: (_123 = (_122 = params.properties.oldDamagesDescription) === null || _122 === void 0 ? void 0 : _122.values) !== null && _123 !== void 0 ? _123 : [],
                defaultValue: '',
                possibleValues: null,
            }, isOldDamages: {
                value: (_125 = (_124 = params.properties.isOldDamages) === null || _124 === void 0 ? void 0 : _124.value) !== null && _125 !== void 0 ? _125 : '',
                values: (_127 = (_126 = params.properties.isOldDamages) === null || _126 === void 0 ? void 0 : _126.values) !== null && _127 !== void 0 ? _127 : [],
                defaultValue: '',
                possibleValues: null,
            }, isPoliceInformed: {
                value: (_129 = (_128 = params.properties.isPoliceInformed) === null || _128 === void 0 ? void 0 : _128.value) !== null && _129 !== void 0 ? _129 : '',
                values: (_131 = (_130 = params.properties.isPoliceInformed) === null || _130 === void 0 ? void 0 : _130.values) !== null && _131 !== void 0 ? _131 : [],
                defaultValue: '',
                possibleValues: null,
            }, policeInformed: {
                value: (_133 = (_132 = params.properties.policeInformed) === null || _132 === void 0 ? void 0 : _132.value) !== null && _133 !== void 0 ? _133 : '',
                values: (_135 = (_134 = params.properties.policeInformed) === null || _134 === void 0 ? void 0 : _134.values) !== null && _135 !== void 0 ? _135 : [],
                defaultValue: '',
                possibleValues: null,
            }, locationKnown: {
                value: (_137 = (_136 = params.properties.locationKnown) === null || _136 === void 0 ? void 0 : _136.value) !== null && _137 !== void 0 ? _137 : '',
                values: (_139 = (_138 = params.properties.locationKnown) === null || _138 === void 0 ? void 0 : _138.values) !== null && _139 !== void 0 ? _139 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTimeKnown: {
                value: (_141 = (_140 = params.properties.incidentTimeKnown) === null || _140 === void 0 ? void 0 : _140.value) !== null && _141 !== void 0 ? _141 : '',
                values: (_143 = (_142 = params.properties.incidentTimeKnown) === null || _142 === void 0 ? void 0 : _142.values) !== null && _143 !== void 0 ? _143 : [],
                defaultValue: '',
                possibleValues: null,
            }, isCounterparts: {
                value: (_145 = (_144 = params.properties.isCounterparts) === null || _144 === void 0 ? void 0 : _144.value) !== null && _145 !== void 0 ? _145 : '',
                values: (_147 = (_146 = params.properties.isCounterparts) === null || _146 === void 0 ? void 0 : _146.values) !== null && _147 !== void 0 ? _147 : [],
                defaultValue: '',
                possibleValues: null,
            }, perpetratorKnown: {
                value: (_149 = (_148 = params.properties.perpetratorKnown) === null || _148 === void 0 ? void 0 : _148.value) !== null && _149 !== void 0 ? _149 : '',
                values: (_151 = (_150 = params.properties.perpetratorKnown) === null || _150 === void 0 ? void 0 : _150.values) !== null && _151 !== void 0 ? _151 : [],
                defaultValue: '',
                possibleValues: null,
            }, damageDescription: {
                value: (_153 = (_152 = params.properties.damageDescription) === null || _152 === void 0 ? void 0 : _152.value) !== null && _153 !== void 0 ? _153 : '',
                values: (_155 = (_154 = params.properties.damageDescription) === null || _154 === void 0 ? void 0 : _154.values) !== null && _155 !== void 0 ? _155 : [],
                defaultValue: '',
                possibleValues: null,
            }, bankAccountOwner: {
                value: (_157 = (_156 = params.properties.bankAccountOwner) === null || _156 === void 0 ? void 0 : _156.value) !== null && _157 !== void 0 ? _157 : '',
                values: (_159 = (_158 = params.properties.bankAccountOwner) === null || _158 === void 0 ? void 0 : _158.values) !== null && _159 !== void 0 ? _159 : [],
                defaultValue: '',
                possibleValues: null,
            }, bankAccountNumber: {
                value: (_161 = (_160 = params.properties.bankAccountNumber) === null || _160 === void 0 ? void 0 : _160.value) !== null && _161 !== void 0 ? _161 : '',
                values: (_163 = (_162 = params.properties.bankAccountNumber) === null || _162 === void 0 ? void 0 : _162.values) !== null && _163 !== void 0 ? _163 : [],
                defaultValue: '',
                possibleValues: null,
            }, bankAccountOwnerSummaryMessage: {
                value: (_165 = (_164 = params.properties.bankAccountOwnerSummaryMessage) === null || _164 === void 0 ? void 0 : _164.value) !== null && _165 !== void 0 ? _165 : '',
                values: (_167 = (_166 = params.properties.bankAccountOwnerSummaryMessage) === null || _166 === void 0 ? void 0 : _166.values) !== null && _167 !== void 0 ? _167 : [],
                defaultValue: 'KAR-sjekk utført. [bankAccountNumber] er bekreftet tilhørende fnr. [bankAccountOwner].',
                possibleValues: null,
            }, notBankAccountOwnerSummaryMessage: {
                value: (_169 = (_168 = params.properties.notBankAccountOwnerSummaryMessage) === null || _168 === void 0 ? void 0 : _168.value) !== null && _169 !== void 0 ? _169 : '',
                values: (_171 = (_170 = params.properties.notBankAccountOwnerSummaryMessage) === null || _170 === void 0 ? void 0 : _170.values) !== null && _171 !== void 0 ? _171 : [],
                defaultValue: 'KAR-sjekk utført. [bankAccountNumber] tilhører IKKE fnr. [bankAccountOwner].',
                possibleValues: null,
            }, bankAccountNotVerifiedSummaryMessage: {
                value: (_173 = (_172 = params.properties.bankAccountNotVerifiedSummaryMessage) === null || _172 === void 0 ? void 0 : _172.value) !== null && _173 !== void 0 ? _173 : '',
                values: (_175 = (_174 = params.properties.bankAccountNotVerifiedSummaryMessage) === null || _174 === void 0 ? void 0 : _174.values) !== null && _175 !== void 0 ? _175 : [],
                defaultValue: 'KAR-sjekk IKKE utført. Må gjøres av skaderådgiver.',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_177 = (_176 = params.properties.defaultValidationMessage) === null || _176 === void 0 ? void 0 : _176.value) !== null && _177 !== void 0 ? _177 : '',
                values: (_179 = (_178 = params.properties.defaultValidationMessage) === null || _178 === void 0 ? void 0 : _178.values) !== null && _179 !== void 0 ? _179 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Norway_Motor_GetVehiclesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { userInformationData: {
                value: (_b = (_a = params.properties.userInformationData) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.userInformationData) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, customerNumber: {
                value: (_f = (_e = params.properties.customerNumber) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.customerNumber) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_k = (_j = params.properties.defaultValidationMessage) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.defaultValidationMessage) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Norway_CarGlass_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { vehicleRegistrationNumber: {
                value: (_b = (_a = params.properties.vehicleRegistrationNumber) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.vehicleRegistrationNumber) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, claimNumber: {
                value: (_f = (_e = params.properties.claimNumber) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.claimNumber) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, customerNumber: {
                value: (_k = (_j = params.properties.customerNumber) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.customerNumber) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, customerEmail: {
                value: (_p = (_o = params.properties.customerEmail) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.customerEmail) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, customerName: {
                value: (_t = (_s = params.properties.customerName) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.customerName) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, customerPhone: {
                value: (_x = (_w = params.properties.customerPhone) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.customerPhone) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDate: {
                value: (_1 = (_0 = params.properties.incidentDate) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.incidentDate) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenSummaryDefinition: {
                value: (_5 = (_4 = params.properties.frontenSummaryDefinition) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.frontenSummaryDefinition) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '[XXXXX.summaryContentOutput]',
                possibleValues: null,
            }, frontenHtmlFileName: {
                value: (_9 = (_8 = params.properties.frontenHtmlFileName) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.frontenHtmlFileName) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenQueue: {
                value: (_13 = (_12 = params.properties.frontenQueue) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.frontenQueue) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenDocumentType: {
                value: (_17 = (_16 = params.properties.frontenDocumentType) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.frontenDocumentType) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenBusinessArea: {
                value: (_21 = (_20 = params.properties.frontenBusinessArea) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.frontenBusinessArea) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenCategory: {
                value: (_25 = (_24 = params.properties.frontenCategory) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.frontenCategory) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, parentType: {
                value: (_29 = (_28 = params.properties.parentType) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.parentType) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimReportName: {
                value: (_33 = (_32 = params.properties.claimReportName) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.claimReportName) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_37 = (_36 = params.properties.defaultValidationMessage) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.defaultValidationMessage) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Norway_Motor_Commercial_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { counterpartRegistrationNumbers: {
                value: (_b = (_a = params.properties.counterpartRegistrationNumbers) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.counterpartRegistrationNumbers) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDate: {
                value: (_f = (_e = params.properties.incidentDate) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.incidentDate) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTime: {
                value: (_k = (_j = params.properties.incidentTime) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.incidentTime) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentType: {
                value: (_p = (_o = params.properties.incidentType) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.incidentType) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, whatHasHappened: {
                value: (_t = (_s = params.properties.whatHasHappened) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.whatHasHappened) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentLocation: {
                value: (_x = (_w = params.properties.incidentLocation) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.incidentLocation) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, policyNumber: {
                value: (_1 = (_0 = params.properties.policyNumber) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.policyNumber) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, registrationNumber: {
                value: (_5 = (_4 = params.properties.registrationNumber) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.registrationNumber) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterEmail: {
                value: (_9 = (_8 = params.properties.reporterEmail) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.reporterEmail) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPhoneNumber: {
                value: (_13 = (_12 = params.properties.reporterPhoneNumber) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.reporterPhoneNumber) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterFirstname: {
                value: (_17 = (_16 = params.properties.reporterFirstname) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.reporterFirstname) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterSurname: {
                value: (_21 = (_20 = params.properties.reporterSurname) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.reporterSurname) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterSocialSecurityNumber: {
                value: (_25 = (_24 = params.properties.reporterSocialSecurityNumber) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.reporterSocialSecurityNumber) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, summaryDefinition: {
                value: (_29 = (_28 = params.properties.summaryDefinition) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.summaryDefinition) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyHolderSocialSecurityNumber: {
                value: (_33 = (_32 = params.properties.policyHolderSocialSecurityNumber) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.policyHolderSocialSecurityNumber) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '',
                possibleValues: null,
            }, compassOwner: {
                value: (_37 = (_36 = params.properties.compassOwner) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.compassOwner) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentCountryName: {
                value: (_41 = (_40 = params.properties.incidentCountryName) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.incidentCountryName) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentCountryId: {
                value: (_45 = (_44 = params.properties.incidentCountryId) === null || _44 === void 0 ? void 0 : _44.value) !== null && _45 !== void 0 ? _45 : '',
                values: (_47 = (_46 = params.properties.incidentCountryId) === null || _46 === void 0 ? void 0 : _46.values) !== null && _47 !== void 0 ? _47 : [],
                defaultValue: '',
                possibleValues: null,
            }, tags: {
                value: (_49 = (_48 = params.properties.tags) === null || _48 === void 0 ? void 0 : _48.value) !== null && _49 !== void 0 ? _49 : '',
                values: (_51 = (_50 = params.properties.tags) === null || _50 === void 0 ? void 0 : _50.values) !== null && _51 !== void 0 ? _51 : [],
                defaultValue: '',
                possibleValues: null,
            }, hasForeignCounterparts: {
                value: (_53 = (_52 = params.properties.hasForeignCounterparts) === null || _52 === void 0 ? void 0 : _52.value) !== null && _53 !== void 0 ? _53 : '',
                values: (_55 = (_54 = params.properties.hasForeignCounterparts) === null || _54 === void 0 ? void 0 : _54.values) !== null && _55 !== void 0 ? _55 : [],
                defaultValue: '',
                possibleValues: null,
            }, injuredRole: {
                value: (_57 = (_56 = params.properties.injuredRole) === null || _56 === void 0 ? void 0 : _56.value) !== null && _57 !== void 0 ? _57 : '',
                values: (_59 = (_58 = params.properties.injuredRole) === null || _58 === void 0 ? void 0 : _58.values) !== null && _59 !== void 0 ? _59 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_61 = (_60 = params.properties.defaultValidationMessage) === null || _60 === void 0 ? void 0 : _60.value) !== null && _61 !== void 0 ? _61 : '',
                values: (_63 = (_62 = params.properties.defaultValidationMessage) === null || _62 === void 0 ? void 0 : _62.values) !== null && _63 !== void 0 ? _63 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Norway_Travel_GetPoliciesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { customerNumber: {
                value: (_b = (_a = params.properties.customerNumber) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.customerNumber) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, policyValidDaysAgo: {
                value: (_f = (_e = params.properties.policyValidDaysAgo) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.policyValidDaysAgo) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '30',
                possibleValues: null,
            }, policyNumber: {
                value: (_k = (_j = params.properties.policyNumber) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.policyNumber) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'policyCount',
                possibleValues: []
            }, {
                name: 'policyData',
                possibleValues: []
            }
        ];
    }
}
export class Norway_Travel_ShowPoliciesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { policyData: {
                value: (_b = (_a = params.properties.policyData) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.policyData) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'policyType',
                possibleValues: []
            }, {
                name: 'chosenPolicy',
                possibleValues: []
            }, {
                name: 'policyNumber',
                possibleValues: []
            }, {
                name: 'personType',
                possibleValues: []
            }, {
                name: 'productCode',
                possibleValues: []
            }, {
                name: 'productName',
                possibleValues: []
            }, {
                name: 'policyHolderSsn',
                possibleValues: []
            }, {
                name: 'policyHolderCustomerNumber',
                possibleValues: []
            }, {
                name: 'coverageType',
                possibleValues: []
            }, {
                name: 'productArea',
                possibleValues: []
            }, {
                name: 'productSubCode',
                possibleValues: []
            }
        ];
    }
}
export class Norway_Travel_CountryNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { inputPlaceholder: {
                value: (_b = (_a = params.properties.inputPlaceholder) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.inputPlaceholder) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, noResultsFoundMessage: {
                value: (_f = (_e = params.properties.noResultsFoundMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.noResultsFoundMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, allowAnyValue: {
                value: (_k = (_j = params.properties.allowAnyValue) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.allowAnyValue) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'code',
                possibleValues: []
            }, {
                name: 'text',
                possibleValues: []
            }
        ];
    }
}
export class Norway_Travel_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143, _144, _145, _146, _147, _148, _149, _150, _151, _152, _153, _154, _155, _156, _157, _158, _159, _160, _161, _162, _163, _164, _165, _166, _167, _168, _169, _170, _171, _172, _173, _174, _175, _176, _177, _178, _179, _180, _181, _182, _183, _184, _185, _186, _187, _188, _189, _190, _191, _192, _193, _194, _195, _196, _197, _198, _199, _200, _201, _202, _203, _204, _205, _206, _207, _208, _209, _210, _211, _212, _213, _214, _215, _216, _217, _218, _219, _220, _221, _222, _223, _224, _225, _226, _227, _228, _229, _230, _231, _232, _233, _234, _235, _236, _237, _238, _239, _240, _241, _242, _243, _244, _245, _246, _247, _248, _249, _250, _251, _252, _253, _254, _255, _256, _257, _258, _259, _260, _261, _262, _263, _264, _265, _266, _267, _268, _269, _270, _271, _272, _273, _274, _275, _276, _277, _278, _279, _280, _281, _282, _283, _284, _285, _286, _287, _288, _289, _290, _291, _292, _293, _294, _295, _296, _297, _298, _299, _300, _301, _302, _303, _304, _305, _306, _307, _308, _309, _310, _311, _312, _313, _314, _315, _316, _317, _318, _319, _320, _321, _322, _323, _324, _325, _326, _327, _328, _329, _330, _331, _332, _333, _334, _335, _336, _337, _338, _339, _340, _341, _342, _343, _344, _345, _346, _347, _348, _349, _350, _351, _352, _353, _354, _355, _356, _357, _358, _359, _360, _361, _362, _363, _364, _365, _366, _367, _368, _369, _370, _371, _372, _373, _374, _375, _376, _377, _378, _379, _380, _381, _382, _383, _384, _385, _386, _387, _388, _389, _390, _391, _392, _393, _394, _395, _396, _397, _398, _399, _400, _401, _402, _403, _404, _405, _406, _407, _408, _409, _410, _411, _412, _413, _414, _415, _416, _417, _418, _419, _420, _421, _422, _423, _424, _425, _426, _427, _428, _429, _430, _431, _432, _433, _434, _435, _436, _437, _438, _439, _440, _441, _442, _443, _444, _445, _446, _447, _448, _449, _450, _451, _452, _453, _454, _455, _456, _457, _458, _459, _460, _461, _462, _463, _464, _465, _466, _467, _468, _469, _470, _471, _472, _473, _474, _475, _476, _477, _478, _479, _480, _481, _482, _483, _484, _485, _486, _487, _488, _489, _490, _491, _492, _493, _494, _495, _496, _497, _498, _499, _500, _501, _502, _503, _504, _505, _506, _507, _508, _509, _510, _511, _512, _513, _514, _515, _516, _517, _518, _519, _520, _521, _522, _523, _524, _525, _526, _527, _528, _529, _530, _531, _532, _533, _534, _535, _536, _537, _538, _539, _540, _541, _542, _543, _544, _545, _546, _547, _548, _549, _550, _551, _552, _553, _554, _555, _556, _557, _558, _559, _560, _561, _562, _563, _564, _565, _566, _567, _568, _569, _570, _571, _572, _573, _574, _575, _576, _577, _578, _579, _580, _581, _582, _583;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { systemType: {
                value: (_b = (_a = params.properties.systemType) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.systemType) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, authorizedUserNode: {
                value: (_f = (_e = params.properties.authorizedUserNode) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.authorizedUserNode) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '[authorizedUserNode]',
                possibleValues: null,
            }, customerInformationNode: {
                value: (_k = (_j = params.properties.customerInformationNode) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.customerInformationNode) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '[customerInformationNode]',
                possibleValues: null,
            }, businessArea: {
                value: (_p = (_o = params.properties.businessArea) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.businessArea) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '[businessArea]',
                possibleValues: null,
            }, submissionChannel: {
                value: (_t = (_s = params.properties.submissionChannel) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.submissionChannel) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '[submissionChannel]',
                possibleValues: null,
            }, claimCategory: {
                value: (_x = (_w = params.properties.claimCategory) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.claimCategory) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '[claimCategory]',
                possibleValues: null,
            }, claimType: {
                value: (_1 = (_0 = params.properties.claimType) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.claimType) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '[claimType]',
                possibleValues: null,
            }, claimTypeCode: {
                value: (_5 = (_4 = params.properties.claimTypeCode) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.claimTypeCode) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '[claimTypeCode]',
                possibleValues: null,
            }, claimNumber: {
                value: (_9 = (_8 = params.properties.claimNumber) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.claimNumber) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '[claimNumber]',
                possibleValues: null,
            }, customerNumber: {
                value: (_13 = (_12 = params.properties.customerNumber) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.customerNumber) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '[customerNumber]',
                possibleValues: null,
            }, travelType: {
                value: (_17 = (_16 = params.properties.travelType) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.travelType) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '[travelType]',
                possibleValues: null,
            }, destinationCountry: {
                value: (_21 = (_20 = params.properties.destinationCountry) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.destinationCountry) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '[destinationCountry]',
                possibleValues: null,
            }, destinationCountryText: {
                value: (_25 = (_24 = params.properties.destinationCountryText) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.destinationCountryText) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '[destinationCountryText]',
                possibleValues: null,
            }, placeOfAccident: {
                value: (_29 = (_28 = params.properties.placeOfAccident) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.placeOfAccident) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '[placeOfAccident]',
                possibleValues: null,
            }, routeStartDate: {
                value: (_33 = (_32 = params.properties.routeStartDate) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.routeStartDate) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '[routeStartDate]',
                possibleValues: null,
            }, routeEndDate: {
                value: (_37 = (_36 = params.properties.routeEndDate) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.routeEndDate) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '[routeEndDate]',
                possibleValues: null,
            }, incidentDate: {
                value: (_41 = (_40 = params.properties.incidentDate) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.incidentDate) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '[incidentDate]',
                possibleValues: null,
            }, incidentTime: {
                value: (_45 = (_44 = params.properties.incidentTime) === null || _44 === void 0 ? void 0 : _44.value) !== null && _45 !== void 0 ? _45 : '',
                values: (_47 = (_46 = params.properties.incidentTime) === null || _46 === void 0 ? void 0 : _46.values) !== null && _47 !== void 0 ? _47 : [],
                defaultValue: '[incidentTime]',
                possibleValues: null,
            }, bankAccountNumber: {
                value: (_49 = (_48 = params.properties.bankAccountNumber) === null || _48 === void 0 ? void 0 : _48.value) !== null && _49 !== void 0 ? _49 : '',
                values: (_51 = (_50 = params.properties.bankAccountNumber) === null || _50 === void 0 ? void 0 : _50.values) !== null && _51 !== void 0 ? _51 : [],
                defaultValue: '[bankAccountNumber]',
                possibleValues: null,
            }, policyNumber: {
                value: (_53 = (_52 = params.properties.policyNumber) === null || _52 === void 0 ? void 0 : _52.value) !== null && _53 !== void 0 ? _53 : '',
                values: (_55 = (_54 = params.properties.policyNumber) === null || _54 === void 0 ? void 0 : _54.values) !== null && _55 !== void 0 ? _55 : [],
                defaultValue: '[policyNumber]',
                possibleValues: null,
            }, reporterIsPolicyHolder: {
                value: (_57 = (_56 = params.properties.reporterIsPolicyHolder) === null || _56 === void 0 ? void 0 : _56.value) !== null && _57 !== void 0 ? _57 : '',
                values: (_59 = (_58 = params.properties.reporterIsPolicyHolder) === null || _58 === void 0 ? void 0 : _58.values) !== null && _59 !== void 0 ? _59 : [],
                defaultValue: '[reporterIsPolicyHolder]',
                possibleValues: null,
            }, reporterEmail: {
                value: (_61 = (_60 = params.properties.reporterEmail) === null || _60 === void 0 ? void 0 : _60.value) !== null && _61 !== void 0 ? _61 : '',
                values: (_63 = (_62 = params.properties.reporterEmail) === null || _62 === void 0 ? void 0 : _62.values) !== null && _63 !== void 0 ? _63 : [],
                defaultValue: '[reporterEmail]',
                possibleValues: null,
            }, reporterPhone: {
                value: (_65 = (_64 = params.properties.reporterPhone) === null || _64 === void 0 ? void 0 : _64.value) !== null && _65 !== void 0 ? _65 : '',
                values: (_67 = (_66 = params.properties.reporterPhone) === null || _66 === void 0 ? void 0 : _66.values) !== null && _67 !== void 0 ? _67 : [],
                defaultValue: '[reporterPhone]',
                possibleValues: null,
            }, reporterName: {
                value: (_69 = (_68 = params.properties.reporterName) === null || _68 === void 0 ? void 0 : _68.value) !== null && _69 !== void 0 ? _69 : '',
                values: (_71 = (_70 = params.properties.reporterName) === null || _70 === void 0 ? void 0 : _70.values) !== null && _71 !== void 0 ? _71 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterSurname: {
                value: (_73 = (_72 = params.properties.reporterSurname) === null || _72 === void 0 ? void 0 : _72.value) !== null && _73 !== void 0 ? _73 : '',
                values: (_75 = (_74 = params.properties.reporterSurname) === null || _74 === void 0 ? void 0 : _74.values) !== null && _75 !== void 0 ? _75 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterSsn: {
                value: (_77 = (_76 = params.properties.reporterSsn) === null || _76 === void 0 ? void 0 : _76.value) !== null && _77 !== void 0 ? _77 : '',
                values: (_79 = (_78 = params.properties.reporterSsn) === null || _78 === void 0 ? void 0 : _78.values) !== null && _79 !== void 0 ? _79 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterStreetName: {
                value: (_81 = (_80 = params.properties.reporterStreetName) === null || _80 === void 0 ? void 0 : _80.value) !== null && _81 !== void 0 ? _81 : '',
                values: (_83 = (_82 = params.properties.reporterStreetName) === null || _82 === void 0 ? void 0 : _82.values) !== null && _83 !== void 0 ? _83 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterHouseNumber: {
                value: (_85 = (_84 = params.properties.reporterHouseNumber) === null || _84 === void 0 ? void 0 : _84.value) !== null && _85 !== void 0 ? _85 : '',
                values: (_87 = (_86 = params.properties.reporterHouseNumber) === null || _86 === void 0 ? void 0 : _86.values) !== null && _87 !== void 0 ? _87 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPostalCode: {
                value: (_89 = (_88 = params.properties.reporterPostalCode) === null || _88 === void 0 ? void 0 : _88.value) !== null && _89 !== void 0 ? _89 : '',
                values: (_91 = (_90 = params.properties.reporterPostalCode) === null || _90 === void 0 ? void 0 : _90.values) !== null && _91 !== void 0 ? _91 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterClaimantTypeText: {
                value: (_93 = (_92 = params.properties.reporterClaimantTypeText) === null || _92 === void 0 ? void 0 : _92.value) !== null && _93 !== void 0 ? _93 : '',
                values: (_95 = (_94 = params.properties.reporterClaimantTypeText) === null || _94 === void 0 ? void 0 : _94.values) !== null && _95 !== void 0 ? _95 : [],
                defaultValue: '[reporterClaimantTypeText]',
                possibleValues: null,
            }, reporterMemberOfCompany: {
                value: (_97 = (_96 = params.properties.reporterMemberOfCompany) === null || _96 === void 0 ? void 0 : _96.value) !== null && _97 !== void 0 ? _97 : '',
                values: (_99 = (_98 = params.properties.reporterMemberOfCompany) === null || _98 === void 0 ? void 0 : _98.values) !== null && _99 !== void 0 ? _99 : [],
                defaultValue: '[reporterMemberOfCompany]',
                possibleValues: null,
            }, reporterMemberOfCompanyEmail: {
                value: (_101 = (_100 = params.properties.reporterMemberOfCompanyEmail) === null || _100 === void 0 ? void 0 : _100.value) !== null && _101 !== void 0 ? _101 : '',
                values: (_103 = (_102 = params.properties.reporterMemberOfCompanyEmail) === null || _102 === void 0 ? void 0 : _102.values) !== null && _103 !== void 0 ? _103 : [],
                defaultValue: '[reporterMemberOfCompanyEmail]',
                possibleValues: null,
            }, reporterRelationToMember: {
                value: (_105 = (_104 = params.properties.reporterRelationToMember) === null || _104 === void 0 ? void 0 : _104.value) !== null && _105 !== void 0 ? _105 : '',
                values: (_107 = (_106 = params.properties.reporterRelationToMember) === null || _106 === void 0 ? void 0 : _106.values) !== null && _107 !== void 0 ? _107 : [],
                defaultValue: '[reporterRelationToMember]',
                possibleValues: null,
            }, typeOfTripText: {
                value: (_109 = (_108 = params.properties.typeOfTripText) === null || _108 === void 0 ? void 0 : _108.value) !== null && _109 !== void 0 ? _109 : '',
                values: (_111 = (_110 = params.properties.typeOfTripText) === null || _110 === void 0 ? void 0 : _110.values) !== null && _111 !== void 0 ? _111 : [],
                defaultValue: '[typeOfTripText]',
                possibleValues: null,
            }, recourseIndicatorText: {
                value: (_113 = (_112 = params.properties.recourseIndicatorText) === null || _112 === void 0 ? void 0 : _112.value) !== null && _113 !== void 0 ? _113 : '',
                values: (_115 = (_114 = params.properties.recourseIndicatorText) === null || _114 === void 0 ? void 0 : _114.values) !== null && _115 !== void 0 ? _115 : [],
                defaultValue: '[recourseIndicatorText]',
                possibleValues: null,
            }, knownCardNumber: {
                value: (_117 = (_116 = params.properties.knownCardNumber) === null || _116 === void 0 ? void 0 : _116.value) !== null && _117 !== void 0 ? _117 : '',
                values: (_119 = (_118 = params.properties.knownCardNumber) === null || _118 === void 0 ? void 0 : _118.values) !== null && _119 !== void 0 ? _119 : [],
                defaultValue: '[knownCardNumber]',
                possibleValues: null,
            }, cardFirstSixNumbers: {
                value: (_121 = (_120 = params.properties.cardFirstSixNumbers) === null || _120 === void 0 ? void 0 : _120.value) !== null && _121 !== void 0 ? _121 : '',
                values: (_123 = (_122 = params.properties.cardFirstSixNumbers) === null || _122 === void 0 ? void 0 : _122.values) !== null && _123 !== void 0 ? _123 : [],
                defaultValue: '[cardFirstSixNumbers]',
                possibleValues: null,
            }, cardLastFourNumbers: {
                value: (_125 = (_124 = params.properties.cardLastFourNumbers) === null || _124 === void 0 ? void 0 : _124.value) !== null && _125 !== void 0 ? _125 : '',
                values: (_127 = (_126 = params.properties.cardLastFourNumbers) === null || _126 === void 0 ? void 0 : _126.values) !== null && _127 !== void 0 ? _127 : [],
                defaultValue: '[cardLastFourNumbers]',
                possibleValues: null,
            }, cardHolder: {
                value: (_129 = (_128 = params.properties.cardHolder) === null || _128 === void 0 ? void 0 : _128.value) !== null && _129 !== void 0 ? _129 : '',
                values: (_131 = (_130 = params.properties.cardHolder) === null || _130 === void 0 ? void 0 : _130.values) !== null && _131 !== void 0 ? _131 : [],
                defaultValue: '[cardHolder]',
                possibleValues: null,
            }, cancellationCauseText: {
                value: (_133 = (_132 = params.properties.cancellationCauseText) === null || _132 === void 0 ? void 0 : _132.value) !== null && _133 !== void 0 ? _133 : '',
                values: (_135 = (_134 = params.properties.cancellationCauseText) === null || _134 === void 0 ? void 0 : _134.values) !== null && _135 !== void 0 ? _135 : [],
                defaultValue: '[cancellationCauseText]',
                possibleValues: null,
            }, policyHolderInformationNode: {
                value: (_137 = (_136 = params.properties.policyHolderInformationNode) === null || _136 === void 0 ? void 0 : _136.value) !== null && _137 !== void 0 ? _137 : '',
                values: (_139 = (_138 = params.properties.policyHolderInformationNode) === null || _138 === void 0 ? void 0 : _138.values) !== null && _139 !== void 0 ? _139 : [],
                defaultValue: '[policyHolderInformationNode]',
                possibleValues: null,
            }, policyHolderEmail: {
                value: (_141 = (_140 = params.properties.policyHolderEmail) === null || _140 === void 0 ? void 0 : _140.value) !== null && _141 !== void 0 ? _141 : '',
                values: (_143 = (_142 = params.properties.policyHolderEmail) === null || _142 === void 0 ? void 0 : _142.values) !== null && _143 !== void 0 ? _143 : [],
                defaultValue: '[policyHolderEmail]',
                possibleValues: null,
            }, policyHolderPhone: {
                value: (_145 = (_144 = params.properties.policyHolderPhone) === null || _144 === void 0 ? void 0 : _144.value) !== null && _145 !== void 0 ? _145 : '',
                values: (_147 = (_146 = params.properties.policyHolderPhone) === null || _146 === void 0 ? void 0 : _146.values) !== null && _147 !== void 0 ? _147 : [],
                defaultValue: '[policyHolderPhone]',
                possibleValues: null,
            }, policyHolderName: {
                value: (_149 = (_148 = params.properties.policyHolderName) === null || _148 === void 0 ? void 0 : _148.value) !== null && _149 !== void 0 ? _149 : '',
                values: (_151 = (_150 = params.properties.policyHolderName) === null || _150 === void 0 ? void 0 : _150.values) !== null && _151 !== void 0 ? _151 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyHolderSurname: {
                value: (_153 = (_152 = params.properties.policyHolderSurname) === null || _152 === void 0 ? void 0 : _152.value) !== null && _153 !== void 0 ? _153 : '',
                values: (_155 = (_154 = params.properties.policyHolderSurname) === null || _154 === void 0 ? void 0 : _154.values) !== null && _155 !== void 0 ? _155 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyHolderSsn: {
                value: (_157 = (_156 = params.properties.policyHolderSsn) === null || _156 === void 0 ? void 0 : _156.value) !== null && _157 !== void 0 ? _157 : '',
                values: (_159 = (_158 = params.properties.policyHolderSsn) === null || _158 === void 0 ? void 0 : _158.values) !== null && _159 !== void 0 ? _159 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyHolderStreetName: {
                value: (_161 = (_160 = params.properties.policyHolderStreetName) === null || _160 === void 0 ? void 0 : _160.value) !== null && _161 !== void 0 ? _161 : '',
                values: (_163 = (_162 = params.properties.policyHolderStreetName) === null || _162 === void 0 ? void 0 : _162.values) !== null && _163 !== void 0 ? _163 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyHolderHouseNumber: {
                value: (_165 = (_164 = params.properties.policyHolderHouseNumber) === null || _164 === void 0 ? void 0 : _164.value) !== null && _165 !== void 0 ? _165 : '',
                values: (_167 = (_166 = params.properties.policyHolderHouseNumber) === null || _166 === void 0 ? void 0 : _166.values) !== null && _167 !== void 0 ? _167 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyHolderPostalCode: {
                value: (_169 = (_168 = params.properties.policyHolderPostalCode) === null || _168 === void 0 ? void 0 : _168.value) !== null && _169 !== void 0 ? _169 : '',
                values: (_171 = (_170 = params.properties.policyHolderPostalCode) === null || _170 === void 0 ? void 0 : _170.values) !== null && _171 !== void 0 ? _171 : [],
                defaultValue: '',
                possibleValues: null,
            }, damageCause: {
                value: (_173 = (_172 = params.properties.damageCause) === null || _172 === void 0 ? void 0 : _172.value) !== null && _173 !== void 0 ? _173 : '',
                values: (_175 = (_174 = params.properties.damageCause) === null || _174 === void 0 ? void 0 : _174.values) !== null && _175 !== void 0 ? _175 : [],
                defaultValue: '[damageCause]',
                possibleValues: null,
            }, cancellationDate: {
                value: (_177 = (_176 = params.properties.cancellationDate) === null || _176 === void 0 ? void 0 : _176.value) !== null && _177 !== void 0 ? _177 : '',
                values: (_179 = (_178 = params.properties.cancellationDate) === null || _178 === void 0 ? void 0 : _178.values) !== null && _179 !== void 0 ? _179 : [],
                defaultValue: '[cancellationDate]',
                possibleValues: null,
            }, cancellationDocumentationDescription: {
                value: (_181 = (_180 = params.properties.cancellationDocumentationDescription) === null || _180 === void 0 ? void 0 : _180.value) !== null && _181 !== void 0 ? _181 : '',
                values: (_183 = (_182 = params.properties.cancellationDocumentationDescription) === null || _182 === void 0 ? void 0 : _182.values) !== null && _183 !== void 0 ? _183 : [],
                defaultValue: '[cancellationDocumentationDescription]',
                possibleValues: null,
            }, cancellationInvolvedPersonDescriptionNodeName: {
                value: (_185 = (_184 = params.properties.cancellationInvolvedPersonDescriptionNodeName) === null || _184 === void 0 ? void 0 : _184.value) !== null && _185 !== void 0 ? _185 : '',
                values: (_187 = (_186 = params.properties.cancellationInvolvedPersonDescriptionNodeName) === null || _186 === void 0 ? void 0 : _186.values) !== null && _187 !== void 0 ? _187 : [],
                defaultValue: 'cancellationInvolvedPersonDescriptionNodeName',
                possibleValues: null,
            }, cancellationExpensesCaruselNode: {
                value: (_189 = (_188 = params.properties.cancellationExpensesCaruselNode) === null || _188 === void 0 ? void 0 : _188.value) !== null && _189 !== void 0 ? _189 : '',
                values: (_191 = (_190 = params.properties.cancellationExpensesCaruselNode) === null || _190 === void 0 ? void 0 : _190.values) !== null && _191 !== void 0 ? _191 : [],
                defaultValue: '[cancellationExpensesCaruselNode]',
                possibleValues: null,
            }, cancellationExpensesDescription: {
                value: (_193 = (_192 = params.properties.cancellationExpensesDescription) === null || _192 === void 0 ? void 0 : _192.value) !== null && _193 !== void 0 ? _193 : '',
                values: (_195 = (_194 = params.properties.cancellationExpensesDescription) === null || _194 === void 0 ? void 0 : _194.values) !== null && _195 !== void 0 ? _195 : [],
                defaultValue: '[cancellationExpensesDescription]',
                possibleValues: null,
            }, cancellationExpensesAdditionalDescription: {
                value: (_197 = (_196 = params.properties.cancellationExpensesAdditionalDescription) === null || _196 === void 0 ? void 0 : _196.value) !== null && _197 !== void 0 ? _197 : '',
                values: (_199 = (_198 = params.properties.cancellationExpensesAdditionalDescription) === null || _198 === void 0 ? void 0 : _198.values) !== null && _199 !== void 0 ? _199 : [],
                defaultValue: '[cancellationExpensesAdditionalDescription]',
                possibleValues: null,
            }, cancellationExpensesAmount: {
                value: (_201 = (_200 = params.properties.cancellationExpensesAmount) === null || _200 === void 0 ? void 0 : _200.value) !== null && _201 !== void 0 ? _201 : '',
                values: (_203 = (_202 = params.properties.cancellationExpensesAmount) === null || _202 === void 0 ? void 0 : _202.values) !== null && _203 !== void 0 ? _203 : [],
                defaultValue: '[cancellationExpensesAmount]',
                possibleValues: null,
            }, cancellationExpensesTaxes: {
                value: (_205 = (_204 = params.properties.cancellationExpensesTaxes) === null || _204 === void 0 ? void 0 : _204.value) !== null && _205 !== void 0 ? _205 : '',
                values: (_207 = (_206 = params.properties.cancellationExpensesTaxes) === null || _206 === void 0 ? void 0 : _206.values) !== null && _207 !== void 0 ? _207 : [],
                defaultValue: '[cancellationExpensesTaxes]',
                possibleValues: null,
            }, cancellationExpensesDate: {
                value: (_209 = (_208 = params.properties.cancellationExpensesDate) === null || _208 === void 0 ? void 0 : _208.value) !== null && _209 !== void 0 ? _209 : '',
                values: (_211 = (_210 = params.properties.cancellationExpensesDate) === null || _210 === void 0 ? void 0 : _210.values) !== null && _211 !== void 0 ? _211 : [],
                defaultValue: '[cancellationExpensesDate]',
                possibleValues: null,
            }, cancellationCancelledOperator: {
                value: (_213 = (_212 = params.properties.cancellationCancelledOperator) === null || _212 === void 0 ? void 0 : _212.value) !== null && _213 !== void 0 ? _213 : '',
                values: (_215 = (_214 = params.properties.cancellationCancelledOperator) === null || _214 === void 0 ? void 0 : _214.values) !== null && _215 !== void 0 ? _215 : [],
                defaultValue: '[cancellationCancelledOperator]',
                possibleValues: null,
            }, cancellationCancelledOperatorDate: {
                value: (_217 = (_216 = params.properties.cancellationCancelledOperatorDate) === null || _216 === void 0 ? void 0 : _216.value) !== null && _217 !== void 0 ? _217 : '',
                values: (_219 = (_218 = params.properties.cancellationCancelledOperatorDate) === null || _218 === void 0 ? void 0 : _218.values) !== null && _219 !== void 0 ? _219 : [],
                defaultValue: '[cancellationCancelledOperatorDate]',
                possibleValues: null,
            }, cancellationCostTypeText: {
                value: (_221 = (_220 = params.properties.cancellationCostTypeText) === null || _220 === void 0 ? void 0 : _220.value) !== null && _221 !== void 0 ? _221 : '',
                values: (_223 = (_222 = params.properties.cancellationCostTypeText) === null || _222 === void 0 ? void 0 : _222.values) !== null && _223 !== void 0 ? _223 : [],
                defaultValue: '[cancellationCostTypeText]',
                possibleValues: null,
            }, recourseIndicator: {
                value: (_225 = (_224 = params.properties.recourseIndicator) === null || _224 === void 0 ? void 0 : _224.value) !== null && _225 !== void 0 ? _225 : '',
                values: (_227 = (_226 = params.properties.recourseIndicator) === null || _226 === void 0 ? void 0 : _226.values) !== null && _227 !== void 0 ? _227 : [],
                defaultValue: '[recourseIndicator]',
                possibleValues: null,
            }, recourseReasonCode: {
                value: (_229 = (_228 = params.properties.recourseReasonCode) === null || _228 === void 0 ? void 0 : _228.value) !== null && _229 !== void 0 ? _229 : '',
                values: (_231 = (_230 = params.properties.recourseReasonCode) === null || _230 === void 0 ? void 0 : _230.values) !== null && _231 !== void 0 ? _231 : [],
                defaultValue: '[recourseReasonCode]',
                possibleValues: null,
            }, recourseCreditCardIssuer: {
                value: (_233 = (_232 = params.properties.recourseCreditCardIssuer) === null || _232 === void 0 ? void 0 : _232.value) !== null && _233 !== void 0 ? _233 : '',
                values: (_235 = (_234 = params.properties.recourseCreditCardIssuer) === null || _234 === void 0 ? void 0 : _234.values) !== null && _235 !== void 0 ? _235 : [],
                defaultValue: '[recourseCreditCardIssuer]',
                possibleValues: null,
            }, recourseCreditCardNumber: {
                value: (_237 = (_236 = params.properties.recourseCreditCardNumber) === null || _236 === void 0 ? void 0 : _236.value) !== null && _237 !== void 0 ? _237 : '',
                values: (_239 = (_238 = params.properties.recourseCreditCardNumber) === null || _238 === void 0 ? void 0 : _238.values) !== null && _239 !== void 0 ? _239 : [],
                defaultValue: '[recourseCreditCardNumber]',
                possibleValues: null,
            }, recourseInsuranceCompany: {
                value: (_241 = (_240 = params.properties.recourseInsuranceCompany) === null || _240 === void 0 ? void 0 : _240.value) !== null && _241 !== void 0 ? _241 : '',
                values: (_243 = (_242 = params.properties.recourseInsuranceCompany) === null || _242 === void 0 ? void 0 : _242.values) !== null && _243 !== void 0 ? _243 : [],
                defaultValue: '[recourseInsuranceCompany]',
                possibleValues: null,
            }, recoursePolicyId: {
                value: (_245 = (_244 = params.properties.recoursePolicyId) === null || _244 === void 0 ? void 0 : _244.value) !== null && _245 !== void 0 ? _245 : '',
                values: (_247 = (_246 = params.properties.recoursePolicyId) === null || _246 === void 0 ? void 0 : _246.values) !== null && _247 !== void 0 ? _247 : [],
                defaultValue: '[recoursePolicyId]',
                possibleValues: null,
            }, claimantListNodeName: {
                value: (_249 = (_248 = params.properties.claimantListNodeName) === null || _248 === void 0 ? void 0 : _248.value) !== null && _249 !== void 0 ? _249 : '',
                values: (_251 = (_250 = params.properties.claimantListNodeName) === null || _250 === void 0 ? void 0 : _250.values) !== null && _251 !== void 0 ? _251 : [],
                defaultValue: 'claimantListNodeName',
                possibleValues: null,
            }, claimantTypeNodeName: {
                value: (_253 = (_252 = params.properties.claimantTypeNodeName) === null || _252 === void 0 ? void 0 : _252.value) !== null && _253 !== void 0 ? _253 : '',
                values: (_255 = (_254 = params.properties.claimantTypeNodeName) === null || _254 === void 0 ? void 0 : _254.values) !== null && _255 !== void 0 ? _255 : [],
                defaultValue: 'claimantType',
                possibleValues: null,
            }, claimantTypeTextNodeName: {
                value: (_257 = (_256 = params.properties.claimantTypeTextNodeName) === null || _256 === void 0 ? void 0 : _256.value) !== null && _257 !== void 0 ? _257 : '',
                values: (_259 = (_258 = params.properties.claimantTypeTextNodeName) === null || _258 === void 0 ? void 0 : _258.values) !== null && _259 !== void 0 ? _259 : [],
                defaultValue: 'claimantTypeText',
                possibleValues: null,
            }, wpClaimantTypeNodeName: {
                value: (_261 = (_260 = params.properties.wpClaimantTypeNodeName) === null || _260 === void 0 ? void 0 : _260.value) !== null && _261 !== void 0 ? _261 : '',
                values: (_263 = (_262 = params.properties.wpClaimantTypeNodeName) === null || _262 === void 0 ? void 0 : _262.values) !== null && _263 !== void 0 ? _263 : [],
                defaultValue: 'wpClaimantType',
                possibleValues: null,
            }, claimantNameNodeName: {
                value: (_265 = (_264 = params.properties.claimantNameNodeName) === null || _264 === void 0 ? void 0 : _264.value) !== null && _265 !== void 0 ? _265 : '',
                values: (_267 = (_266 = params.properties.claimantNameNodeName) === null || _266 === void 0 ? void 0 : _266.values) !== null && _267 !== void 0 ? _267 : [],
                defaultValue: 'ClaimantNameDataId',
                possibleValues: null,
            }, claimantSurnameNodeName: {
                value: (_269 = (_268 = params.properties.claimantSurnameNodeName) === null || _268 === void 0 ? void 0 : _268.value) !== null && _269 !== void 0 ? _269 : '',
                values: (_271 = (_270 = params.properties.claimantSurnameNodeName) === null || _270 === void 0 ? void 0 : _270.values) !== null && _271 !== void 0 ? _271 : [],
                defaultValue: 'ClaimantSurnameDataId',
                possibleValues: null,
            }, claimantSsnNodeName: {
                value: (_273 = (_272 = params.properties.claimantSsnNodeName) === null || _272 === void 0 ? void 0 : _272.value) !== null && _273 !== void 0 ? _273 : '',
                values: (_275 = (_274 = params.properties.claimantSsnNodeName) === null || _274 === void 0 ? void 0 : _274.values) !== null && _275 !== void 0 ? _275 : [],
                defaultValue: 'ClaimantSsnDataId',
                possibleValues: null,
            }, claimantStreetNameNodeName: {
                value: (_277 = (_276 = params.properties.claimantStreetNameNodeName) === null || _276 === void 0 ? void 0 : _276.value) !== null && _277 !== void 0 ? _277 : '',
                values: (_279 = (_278 = params.properties.claimantStreetNameNodeName) === null || _278 === void 0 ? void 0 : _278.values) !== null && _279 !== void 0 ? _279 : [],
                defaultValue: 'ClaimantStreetNameDataId',
                possibleValues: null,
            }, claimantHouseNumberNodeName: {
                value: (_281 = (_280 = params.properties.claimantHouseNumberNodeName) === null || _280 === void 0 ? void 0 : _280.value) !== null && _281 !== void 0 ? _281 : '',
                values: (_283 = (_282 = params.properties.claimantHouseNumberNodeName) === null || _282 === void 0 ? void 0 : _282.values) !== null && _283 !== void 0 ? _283 : [],
                defaultValue: 'ClaimantHouseNumberDataId',
                possibleValues: null,
            }, claimantPostalCodeNodeName: {
                value: (_285 = (_284 = params.properties.claimantPostalCodeNodeName) === null || _284 === void 0 ? void 0 : _284.value) !== null && _285 !== void 0 ? _285 : '',
                values: (_287 = (_286 = params.properties.claimantPostalCodeNodeName) === null || _286 === void 0 ? void 0 : _286.values) !== null && _287 !== void 0 ? _287 : [],
                defaultValue: 'ClaimantPostalCodeDataId',
                possibleValues: null,
            }, claimantPhoneNodeName: {
                value: (_289 = (_288 = params.properties.claimantPhoneNodeName) === null || _288 === void 0 ? void 0 : _288.value) !== null && _289 !== void 0 ? _289 : '',
                values: (_291 = (_290 = params.properties.claimantPhoneNodeName) === null || _290 === void 0 ? void 0 : _290.values) !== null && _291 !== void 0 ? _291 : [],
                defaultValue: 'ClaimantPhoneDataId',
                possibleValues: null,
            }, claimantEmailNodeName: {
                value: (_293 = (_292 = params.properties.claimantEmailNodeName) === null || _292 === void 0 ? void 0 : _292.value) !== null && _293 !== void 0 ? _293 : '',
                values: (_295 = (_294 = params.properties.claimantEmailNodeName) === null || _294 === void 0 ? void 0 : _294.values) !== null && _295 !== void 0 ? _295 : [],
                defaultValue: 'ClaimantEmailDataId',
                possibleValues: null,
            }, claimantCountryNodeName: {
                value: (_297 = (_296 = params.properties.claimantCountryNodeName) === null || _296 === void 0 ? void 0 : _296.value) !== null && _297 !== void 0 ? _297 : '',
                values: (_299 = (_298 = params.properties.claimantCountryNodeName) === null || _298 === void 0 ? void 0 : _298.values) !== null && _299 !== void 0 ? _299 : [],
                defaultValue: 'ClaimantCountryDataId',
                possibleValues: null,
            }, claimantEntranceCodeNodeName: {
                value: (_301 = (_300 = params.properties.claimantEntranceCodeNodeName) === null || _300 === void 0 ? void 0 : _300.value) !== null && _301 !== void 0 ? _301 : '',
                values: (_303 = (_302 = params.properties.claimantEntranceCodeNodeName) === null || _302 === void 0 ? void 0 : _302.values) !== null && _303 !== void 0 ? _303 : [],
                defaultValue: 'ClaimantEntranceCodeDataId',
                possibleValues: null,
            }, claimantPlaceNameNodeName: {
                value: (_305 = (_304 = params.properties.claimantPlaceNameNodeName) === null || _304 === void 0 ? void 0 : _304.value) !== null && _305 !== void 0 ? _305 : '',
                values: (_307 = (_306 = params.properties.claimantPlaceNameNodeName) === null || _306 === void 0 ? void 0 : _306.values) !== null && _307 !== void 0 ? _307 : [],
                defaultValue: 'ClaimantPlaceNameDataId',
                possibleValues: null,
            }, claimantStreetNumberNodeName: {
                value: (_309 = (_308 = params.properties.claimantStreetNumberNodeName) === null || _308 === void 0 ? void 0 : _308.value) !== null && _309 !== void 0 ? _309 : '',
                values: (_311 = (_310 = params.properties.claimantStreetNumberNodeName) === null || _310 === void 0 ? void 0 : _310.values) !== null && _311 !== void 0 ? _311 : [],
                defaultValue: 'ClaimantStreetNumberDataId',
                possibleValues: null,
            }, wpClaimType: {
                value: (_313 = (_312 = params.properties.wpClaimType) === null || _312 === void 0 ? void 0 : _312.value) !== null && _313 !== void 0 ? _313 : '',
                values: (_315 = (_314 = params.properties.wpClaimType) === null || _314 === void 0 ? void 0 : _314.values) !== null && _315 !== void 0 ? _315 : [],
                defaultValue: '[wpClaimType]',
                possibleValues: null,
            }, claimTypeText: {
                value: (_317 = (_316 = params.properties.claimTypeText) === null || _316 === void 0 ? void 0 : _316.value) !== null && _317 !== void 0 ? _317 : '',
                values: (_319 = (_318 = params.properties.claimTypeText) === null || _318 === void 0 ? void 0 : _318.values) !== null && _319 !== void 0 ? _319 : [],
                defaultValue: '[claimTypeText]',
                possibleValues: null,
            }, wpTravelType: {
                value: (_321 = (_320 = params.properties.wpTravelType) === null || _320 === void 0 ? void 0 : _320.value) !== null && _321 !== void 0 ? _321 : '',
                values: (_323 = (_322 = params.properties.wpTravelType) === null || _322 === void 0 ? void 0 : _322.values) !== null && _323 !== void 0 ? _323 : [],
                defaultValue: '[wpTravelType]',
                possibleValues: null,
            }, wpLuggageCauseType: {
                value: (_325 = (_324 = params.properties.wpLuggageCauseType) === null || _324 === void 0 ? void 0 : _324.value) !== null && _325 !== void 0 ? _325 : '',
                values: (_327 = (_326 = params.properties.wpLuggageCauseType) === null || _326 === void 0 ? void 0 : _326.values) !== null && _327 !== void 0 ? _327 : [],
                defaultValue: '[wpLuggageCauseType]',
                possibleValues: null,
            }, cancellationCause: {
                value: (_329 = (_328 = params.properties.cancellationCause) === null || _328 === void 0 ? void 0 : _328.value) !== null && _329 !== void 0 ? _329 : '',
                values: (_331 = (_330 = params.properties.cancellationCause) === null || _330 === void 0 ? void 0 : _330.values) !== null && _331 !== void 0 ? _331 : [],
                defaultValue: '[cancellationCause]',
                possibleValues: null,
            }, description: {
                value: (_333 = (_332 = params.properties.description) === null || _332 === void 0 ? void 0 : _332.value) !== null && _333 !== void 0 ? _333 : '',
                values: (_335 = (_334 = params.properties.description) === null || _334 === void 0 ? void 0 : _334.values) !== null && _335 !== void 0 ? _335 : [],
                defaultValue: '[description]',
                possibleValues: null,
            }, pIRNumber: {
                value: (_337 = (_336 = params.properties.pIRNumber) === null || _336 === void 0 ? void 0 : _336.value) !== null && _337 !== void 0 ? _337 : '',
                values: (_339 = (_338 = params.properties.pIRNumber) === null || _338 === void 0 ? void 0 : _338.values) !== null && _339 !== void 0 ? _339 : [],
                defaultValue: '[PIRNumber]',
                possibleValues: null,
            }, pIRNumberAvailable: {
                value: (_341 = (_340 = params.properties.pIRNumberAvailable) === null || _340 === void 0 ? void 0 : _340.value) !== null && _341 !== void 0 ? _341 : '',
                values: (_343 = (_342 = params.properties.pIRNumberAvailable) === null || _342 === void 0 ? void 0 : _342.values) !== null && _343 !== void 0 ? _343 : [],
                defaultValue: '[PIRNumberAvailable]',
                possibleValues: null,
            }, delayType: {
                value: (_345 = (_344 = params.properties.delayType) === null || _344 === void 0 ? void 0 : _344.value) !== null && _345 !== void 0 ? _345 : '',
                values: (_347 = (_346 = params.properties.delayType) === null || _346 === void 0 ? void 0 : _346.values) !== null && _347 !== void 0 ? _347 : [],
                defaultValue: '[delayType]',
                possibleValues: null,
            }, delayCause: {
                value: (_349 = (_348 = params.properties.delayCause) === null || _348 === void 0 ? void 0 : _348.value) !== null && _349 !== void 0 ? _349 : '',
                values: (_351 = (_350 = params.properties.delayCause) === null || _350 === void 0 ? void 0 : _350.values) !== null && _351 !== void 0 ? _351 : [],
                defaultValue: '[delayCause]',
                possibleValues: null,
            }, delayReason: {
                value: (_353 = (_352 = params.properties.delayReason) === null || _352 === void 0 ? void 0 : _352.value) !== null && _353 !== void 0 ? _353 : '',
                values: (_355 = (_354 = params.properties.delayReason) === null || _354 === void 0 ? void 0 : _354.values) !== null && _355 !== void 0 ? _355 : [],
                defaultValue: '[delayReason]',
                possibleValues: null,
            }, delayTransportationDetails: {
                value: (_357 = (_356 = params.properties.delayTransportationDetails) === null || _356 === void 0 ? void 0 : _356.value) !== null && _357 !== void 0 ? _357 : '',
                values: (_359 = (_358 = params.properties.delayTransportationDetails) === null || _358 === void 0 ? void 0 : _358.values) !== null && _359 !== void 0 ? _359 : [],
                defaultValue: '[delayTransportationDetails]',
                possibleValues: null,
            }, delayTransportationETD: {
                value: (_361 = (_360 = params.properties.delayTransportationETD) === null || _360 === void 0 ? void 0 : _360.value) !== null && _361 !== void 0 ? _361 : '',
                values: (_363 = (_362 = params.properties.delayTransportationETD) === null || _362 === void 0 ? void 0 : _362.values) !== null && _363 !== void 0 ? _363 : [],
                defaultValue: '[delayTransportationETD]',
                possibleValues: null,
            }, delayTransporterConfirmation: {
                value: (_365 = (_364 = params.properties.delayTransporterConfirmation) === null || _364 === void 0 ? void 0 : _364.value) !== null && _365 !== void 0 ? _365 : '',
                values: (_367 = (_366 = params.properties.delayTransporterConfirmation) === null || _366 === void 0 ? void 0 : _366.values) !== null && _367 !== void 0 ? _367 : [],
                defaultValue: '[delayTransporterConfirmation]',
                possibleValues: null,
            }, delayedLuggageActualArrivalDate: {
                value: (_369 = (_368 = params.properties.delayedLuggageActualArrivalDate) === null || _368 === void 0 ? void 0 : _368.value) !== null && _369 !== void 0 ? _369 : '',
                values: (_371 = (_370 = params.properties.delayedLuggageActualArrivalDate) === null || _370 === void 0 ? void 0 : _370.values) !== null && _371 !== void 0 ? _371 : [],
                defaultValue: '[delayedLuggageActualArrivalDate]',
                possibleValues: null,
            }, delayedLuggageNodeName: {
                value: (_373 = (_372 = params.properties.delayedLuggageNodeName) === null || _372 === void 0 ? void 0 : _372.value) !== null && _373 !== void 0 ? _373 : '',
                values: (_375 = (_374 = params.properties.delayedLuggageNodeName) === null || _374 === void 0 ? void 0 : _374.values) !== null && _375 !== void 0 ? _375 : [],
                defaultValue: 'delayedLuggageNodeName',
                possibleValues: null,
            }, delayedLuggageTypeNodeName: {
                value: (_377 = (_376 = params.properties.delayedLuggageTypeNodeName) === null || _376 === void 0 ? void 0 : _376.value) !== null && _377 !== void 0 ? _377 : '',
                values: (_379 = (_378 = params.properties.delayedLuggageTypeNodeName) === null || _378 === void 0 ? void 0 : _378.values) !== null && _379 !== void 0 ? _379 : [],
                defaultValue: 'delayedLuggageType',
                possibleValues: null,
            }, delayedLuggageTypeTextNodeName: {
                value: (_381 = (_380 = params.properties.delayedLuggageTypeTextNodeName) === null || _380 === void 0 ? void 0 : _380.value) !== null && _381 !== void 0 ? _381 : '',
                values: (_383 = (_382 = params.properties.delayedLuggageTypeTextNodeName) === null || _382 === void 0 ? void 0 : _382.values) !== null && _383 !== void 0 ? _383 : [],
                defaultValue: 'delayedLuggageTypeText',
                possibleValues: null,
            }, delayedLuggagePurchaseDateNodeName: {
                value: (_385 = (_384 = params.properties.delayedLuggagePurchaseDateNodeName) === null || _384 === void 0 ? void 0 : _384.value) !== null && _385 !== void 0 ? _385 : '',
                values: (_387 = (_386 = params.properties.delayedLuggagePurchaseDateNodeName) === null || _386 === void 0 ? void 0 : _386.values) !== null && _387 !== void 0 ? _387 : [],
                defaultValue: 'delayedLuggagePurchaseDate',
                possibleValues: null,
            }, delayedLuggageCostsAmountNodeName: {
                value: (_389 = (_388 = params.properties.delayedLuggageCostsAmountNodeName) === null || _388 === void 0 ? void 0 : _388.value) !== null && _389 !== void 0 ? _389 : '',
                values: (_391 = (_390 = params.properties.delayedLuggageCostsAmountNodeName) === null || _390 === void 0 ? void 0 : _390.values) !== null && _391 !== void 0 ? _391 : [],
                defaultValue: 'delayedLuggageCostsAmount',
                possibleValues: null,
            }, delayedLuggageHasCostsReceiptNodeName: {
                value: (_393 = (_392 = params.properties.delayedLuggageHasCostsReceiptNodeName) === null || _392 === void 0 ? void 0 : _392.value) !== null && _393 !== void 0 ? _393 : '',
                values: (_395 = (_394 = params.properties.delayedLuggageHasCostsReceiptNodeName) === null || _394 === void 0 ? void 0 : _394.values) !== null && _395 !== void 0 ? _395 : [],
                defaultValue: 'delayedLuggageHasCostsReceipt',
                possibleValues: null,
            }, delayedLuggageHasCostsReceiptTextNodeName: {
                value: (_397 = (_396 = params.properties.delayedLuggageHasCostsReceiptTextNodeName) === null || _396 === void 0 ? void 0 : _396.value) !== null && _397 !== void 0 ? _397 : '',
                values: (_399 = (_398 = params.properties.delayedLuggageHasCostsReceiptTextNodeName) === null || _398 === void 0 ? void 0 : _398.values) !== null && _399 !== void 0 ? _399 : [],
                defaultValue: 'delayedLuggageHasCostsReceiptText',
                possibleValues: null,
            }, delayedLuggageAdditionalDescription: {
                value: (_401 = (_400 = params.properties.delayedLuggageAdditionalDescription) === null || _400 === void 0 ? void 0 : _400.value) !== null && _401 !== void 0 ? _401 : '',
                values: (_403 = (_402 = params.properties.delayedLuggageAdditionalDescription) === null || _402 === void 0 ? void 0 : _402.values) !== null && _403 !== void 0 ? _403 : [],
                defaultValue: 'delayedLuggageAdditionalDescription',
                possibleValues: null,
            }, delayedLuggageResponsibleAirline: {
                value: (_405 = (_404 = params.properties.delayedLuggageResponsibleAirline) === null || _404 === void 0 ? void 0 : _404.value) !== null && _405 !== void 0 ? _405 : '',
                values: (_407 = (_406 = params.properties.delayedLuggageResponsibleAirline) === null || _406 === void 0 ? void 0 : _406.values) !== null && _407 !== void 0 ? _407 : [],
                defaultValue: '[delayedLuggageResponsibleAirline]',
                possibleValues: null,
            }, medicalExpensesNodeName: {
                value: (_409 = (_408 = params.properties.medicalExpensesNodeName) === null || _408 === void 0 ? void 0 : _408.value) !== null && _409 !== void 0 ? _409 : '',
                values: (_411 = (_410 = params.properties.medicalExpensesNodeName) === null || _410 === void 0 ? void 0 : _410.values) !== null && _411 !== void 0 ? _411 : [],
                defaultValue: 'medicalExpensesNode',
                possibleValues: null,
            }, medicalExpensesExpenseTypeNodeName: {
                value: (_413 = (_412 = params.properties.medicalExpensesExpenseTypeNodeName) === null || _412 === void 0 ? void 0 : _412.value) !== null && _413 !== void 0 ? _413 : '',
                values: (_415 = (_414 = params.properties.medicalExpensesExpenseTypeNodeName) === null || _414 === void 0 ? void 0 : _414.values) !== null && _415 !== void 0 ? _415 : [],
                defaultValue: 'medicalExpensesExpenseType',
                possibleValues: null,
            }, medicalExpensesExpenceTypeDescriptionNodeName: {
                value: (_417 = (_416 = params.properties.medicalExpensesExpenceTypeDescriptionNodeName) === null || _416 === void 0 ? void 0 : _416.value) !== null && _417 !== void 0 ? _417 : '',
                values: (_419 = (_418 = params.properties.medicalExpensesExpenceTypeDescriptionNodeName) === null || _418 === void 0 ? void 0 : _418.values) !== null && _419 !== void 0 ? _419 : [],
                defaultValue: 'medicalExpensesExpenceTypeDescription',
                possibleValues: null,
            }, medicalExpensesAdditionalDescriptionNodeName: {
                value: (_421 = (_420 = params.properties.medicalExpensesAdditionalDescriptionNodeName) === null || _420 === void 0 ? void 0 : _420.value) !== null && _421 !== void 0 ? _421 : '',
                values: (_423 = (_422 = params.properties.medicalExpensesAdditionalDescriptionNodeName) === null || _422 === void 0 ? void 0 : _422.values) !== null && _423 !== void 0 ? _423 : [],
                defaultValue: 'medicalExpensesAdditionalDescription',
                possibleValues: null,
            }, medicalExpensesCostsAmountNodeName: {
                value: (_425 = (_424 = params.properties.medicalExpensesCostsAmountNodeName) === null || _424 === void 0 ? void 0 : _424.value) !== null && _425 !== void 0 ? _425 : '',
                values: (_427 = (_426 = params.properties.medicalExpensesCostsAmountNodeName) === null || _426 === void 0 ? void 0 : _426.values) !== null && _427 !== void 0 ? _427 : [],
                defaultValue: 'medicalExpensesCostsAmount',
                possibleValues: null,
            }, medicalExpensesDateNodeName: {
                value: (_429 = (_428 = params.properties.medicalExpensesDateNodeName) === null || _428 === void 0 ? void 0 : _428.value) !== null && _429 !== void 0 ? _429 : '',
                values: (_431 = (_430 = params.properties.medicalExpensesDateNodeName) === null || _430 === void 0 ? void 0 : _430.values) !== null && _431 !== void 0 ? _431 : [],
                defaultValue: 'medicalExpensesDate',
                possibleValues: null,
            }, medicalExpensesHasCostsReceiptNodeName: {
                value: (_433 = (_432 = params.properties.medicalExpensesHasCostsReceiptNodeName) === null || _432 === void 0 ? void 0 : _432.value) !== null && _433 !== void 0 ? _433 : '',
                values: (_435 = (_434 = params.properties.medicalExpensesHasCostsReceiptNodeName) === null || _434 === void 0 ? void 0 : _434.values) !== null && _435 !== void 0 ? _435 : [],
                defaultValue: 'medicalExpensesHasCostsReceipt',
                possibleValues: null,
            }, medicalTravelExpensesNodeName: {
                value: (_437 = (_436 = params.properties.medicalTravelExpensesNodeName) === null || _436 === void 0 ? void 0 : _436.value) !== null && _437 !== void 0 ? _437 : '',
                values: (_439 = (_438 = params.properties.medicalTravelExpensesNodeName) === null || _438 === void 0 ? void 0 : _438.values) !== null && _439 !== void 0 ? _439 : [],
                defaultValue: 'medicalTravelExpensesNode',
                possibleValues: null,
            }, medicalTravelExpensesExpenseType: {
                value: (_441 = (_440 = params.properties.medicalTravelExpensesExpenseType) === null || _440 === void 0 ? void 0 : _440.value) !== null && _441 !== void 0 ? _441 : '',
                values: (_443 = (_442 = params.properties.medicalTravelExpensesExpenseType) === null || _442 === void 0 ? void 0 : _442.values) !== null && _443 !== void 0 ? _443 : [],
                defaultValue: 'medicalTravelExpensesExpenseType',
                possibleValues: null,
            }, medicalTravelExpensesCostsAmount: {
                value: (_445 = (_444 = params.properties.medicalTravelExpensesCostsAmount) === null || _444 === void 0 ? void 0 : _444.value) !== null && _445 !== void 0 ? _445 : '',
                values: (_447 = (_446 = params.properties.medicalTravelExpensesCostsAmount) === null || _446 === void 0 ? void 0 : _446.values) !== null && _447 !== void 0 ? _447 : [],
                defaultValue: 'medicalTraveExpensesCostsAmount',
                possibleValues: null,
            }, medicalTravelExpensesDate: {
                value: (_449 = (_448 = params.properties.medicalTravelExpensesDate) === null || _448 === void 0 ? void 0 : _448.value) !== null && _449 !== void 0 ? _449 : '',
                values: (_451 = (_450 = params.properties.medicalTravelExpensesDate) === null || _450 === void 0 ? void 0 : _450.values) !== null && _451 !== void 0 ? _451 : [],
                defaultValue: 'medicalTraveExpensesDate',
                possibleValues: null,
            }, medicalTravelExpensesHasCostsReceipt: {
                value: (_453 = (_452 = params.properties.medicalTravelExpensesHasCostsReceipt) === null || _452 === void 0 ? void 0 : _452.value) !== null && _453 !== void 0 ? _453 : '',
                values: (_455 = (_454 = params.properties.medicalTravelExpensesHasCostsReceipt) === null || _454 === void 0 ? void 0 : _454.values) !== null && _455 !== void 0 ? _455 : [],
                defaultValue: 'medicalTraveExpensesHasCostsReceipt',
                possibleValues: null,
            }, medicalCertificate: {
                value: (_457 = (_456 = params.properties.medicalCertificate) === null || _456 === void 0 ? void 0 : _456.value) !== null && _457 !== void 0 ? _457 : '',
                values: (_459 = (_458 = params.properties.medicalCertificate) === null || _458 === void 0 ? void 0 : _458.values) !== null && _459 !== void 0 ? _459 : [],
                defaultValue: '[medicalCertificate]',
                possibleValues: null,
            }, demandExpensesTypeDescription: {
                value: (_461 = (_460 = params.properties.demandExpensesTypeDescription) === null || _460 === void 0 ? void 0 : _460.value) !== null && _461 !== void 0 ? _461 : '',
                values: (_463 = (_462 = params.properties.demandExpensesTypeDescription) === null || _462 === void 0 ? void 0 : _462.values) !== null && _463 !== void 0 ? _463 : [],
                defaultValue: '[demandExpensesTypeDescription]',
                possibleValues: null,
            }, demandMedicContactDateTime: {
                value: (_465 = (_464 = params.properties.demandMedicContactDateTime) === null || _464 === void 0 ? void 0 : _464.value) !== null && _465 !== void 0 ? _465 : '',
                values: (_467 = (_466 = params.properties.demandMedicContactDateTime) === null || _466 === void 0 ? void 0 : _466.values) !== null && _467 !== void 0 ? _467 : [],
                defaultValue: '[demandMedicContactDateTime]',
                possibleValues: null,
            }, compensationOfLossHolidays: {
                value: (_469 = (_468 = params.properties.compensationOfLossHolidays) === null || _468 === void 0 ? void 0 : _468.value) !== null && _469 !== void 0 ? _469 : '',
                values: (_471 = (_470 = params.properties.compensationOfLossHolidays) === null || _470 === void 0 ? void 0 : _470.values) !== null && _471 !== void 0 ? _471 : [],
                defaultValue: '[compensationOfLossHolidays]',
                possibleValues: null,
            }, damagedLuggageNodeName: {
                value: (_473 = (_472 = params.properties.damagedLuggageNodeName) === null || _472 === void 0 ? void 0 : _472.value) !== null && _473 !== void 0 ? _473 : '',
                values: (_475 = (_474 = params.properties.damagedLuggageNodeName) === null || _474 === void 0 ? void 0 : _474.values) !== null && _475 !== void 0 ? _475 : [],
                defaultValue: 'damagedLuggageNodeName',
                possibleValues: null,
            }, damagedLuggageCostItemCodeNodeName: {
                value: (_477 = (_476 = params.properties.damagedLuggageCostItemCodeNodeName) === null || _476 === void 0 ? void 0 : _476.value) !== null && _477 !== void 0 ? _477 : '',
                values: (_479 = (_478 = params.properties.damagedLuggageCostItemCodeNodeName) === null || _478 === void 0 ? void 0 : _478.values) !== null && _479 !== void 0 ? _479 : [],
                defaultValue: 'damagedLuggageCostItemCode',
                possibleValues: null,
            }, damagedLuggageDescriptionNodeName: {
                value: (_481 = (_480 = params.properties.damagedLuggageDescriptionNodeName) === null || _480 === void 0 ? void 0 : _480.value) !== null && _481 !== void 0 ? _481 : '',
                values: (_483 = (_482 = params.properties.damagedLuggageDescriptionNodeName) === null || _482 === void 0 ? void 0 : _482.values) !== null && _483 !== void 0 ? _483 : [],
                defaultValue: 'damagedLuggageDescription',
                possibleValues: null,
            }, damagedLuggageAdditionalDescriptionNodeName: {
                value: (_485 = (_484 = params.properties.damagedLuggageAdditionalDescriptionNodeName) === null || _484 === void 0 ? void 0 : _484.value) !== null && _485 !== void 0 ? _485 : '',
                values: (_487 = (_486 = params.properties.damagedLuggageAdditionalDescriptionNodeName) === null || _486 === void 0 ? void 0 : _486.values) !== null && _487 !== void 0 ? _487 : [],
                defaultValue: 'damagedLuggageAdditionalDescription',
                possibleValues: null,
            }, damagedLuggagePurchaseDateNodeName: {
                value: (_489 = (_488 = params.properties.damagedLuggagePurchaseDateNodeName) === null || _488 === void 0 ? void 0 : _488.value) !== null && _489 !== void 0 ? _489 : '',
                values: (_491 = (_490 = params.properties.damagedLuggagePurchaseDateNodeName) === null || _490 === void 0 ? void 0 : _490.values) !== null && _491 !== void 0 ? _491 : [],
                defaultValue: 'damagedLuggagePurchaseDate',
                possibleValues: null,
            }, damagedLuggageCostsAmountNodeName: {
                value: (_493 = (_492 = params.properties.damagedLuggageCostsAmountNodeName) === null || _492 === void 0 ? void 0 : _492.value) !== null && _493 !== void 0 ? _493 : '',
                values: (_495 = (_494 = params.properties.damagedLuggageCostsAmountNodeName) === null || _494 === void 0 ? void 0 : _494.values) !== null && _495 !== void 0 ? _495 : [],
                defaultValue: 'damagedLuggageCostsAmount',
                possibleValues: null,
            }, damagedLuggageHasCostsReceiptNodeName: {
                value: (_497 = (_496 = params.properties.damagedLuggageHasCostsReceiptNodeName) === null || _496 === void 0 ? void 0 : _496.value) !== null && _497 !== void 0 ? _497 : '',
                values: (_499 = (_498 = params.properties.damagedLuggageHasCostsReceiptNodeName) === null || _498 === void 0 ? void 0 : _498.values) !== null && _499 !== void 0 ? _499 : [],
                defaultValue: 'damagedLuggageHasCostsReceipt',
                possibleValues: null,
            }, otherInformedDescription: {
                value: (_501 = (_500 = params.properties.otherInformedDescription) === null || _500 === void 0 ? void 0 : _500.value) !== null && _501 !== void 0 ? _501 : '',
                values: (_503 = (_502 = params.properties.otherInformedDescription) === null || _502 === void 0 ? void 0 : _502.values) !== null && _503 !== void 0 ? _503 : [],
                defaultValue: '[otherInformedDescription]',
                possibleValues: null,
            }, policeInformedIndicator: {
                value: (_505 = (_504 = params.properties.policeInformedIndicator) === null || _504 === void 0 ? void 0 : _504.value) !== null && _505 !== void 0 ? _505 : '',
                values: (_507 = (_506 = params.properties.policeInformedIndicator) === null || _506 === void 0 ? void 0 : _506.values) !== null && _507 !== void 0 ? _507 : [],
                defaultValue: '[policeInformedIndicator]',
                possibleValues: null,
            }, otherInformedIndicator: {
                value: (_509 = (_508 = params.properties.otherInformedIndicator) === null || _508 === void 0 ? void 0 : _508.value) !== null && _509 !== void 0 ? _509 : '',
                values: (_511 = (_510 = params.properties.otherInformedIndicator) === null || _510 === void 0 ? void 0 : _510.values) !== null && _511 !== void 0 ? _511 : [],
                defaultValue: '[otherInformedIndicator]',
                possibleValues: null,
            }, theftType: {
                value: (_513 = (_512 = params.properties.theftType) === null || _512 === void 0 ? void 0 : _512.value) !== null && _513 !== void 0 ? _513 : '',
                values: (_515 = (_514 = params.properties.theftType) === null || _514 === void 0 ? void 0 : _514.values) !== null && _515 !== void 0 ? _515 : [],
                defaultValue: '[theftType]',
                possibleValues: null,
            }, trackOfTheft: {
                value: (_517 = (_516 = params.properties.trackOfTheft) === null || _516 === void 0 ? void 0 : _516.value) !== null && _517 !== void 0 ? _517 : '',
                values: (_519 = (_518 = params.properties.trackOfTheft) === null || _518 === void 0 ? void 0 : _518.values) !== null && _519 !== void 0 ? _519 : [],
                defaultValue: '[trackOfTheft]',
                possibleValues: null,
            }, theftObjectLastObservedDate: {
                value: (_521 = (_520 = params.properties.theftObjectLastObservedDate) === null || _520 === void 0 ? void 0 : _520.value) !== null && _521 !== void 0 ? _521 : '',
                values: (_523 = (_522 = params.properties.theftObjectLastObservedDate) === null || _522 === void 0 ? void 0 : _522.values) !== null && _523 !== void 0 ? _523 : [],
                defaultValue: '[theftObjectLastObservedDate]',
                possibleValues: null,
            }, theftLockedIndicator: {
                value: (_525 = (_524 = params.properties.theftLockedIndicator) === null || _524 === void 0 ? void 0 : _524.value) !== null && _525 !== void 0 ? _525 : '',
                values: (_527 = (_526 = params.properties.theftLockedIndicator) === null || _526 === void 0 ? void 0 : _526.values) !== null && _527 !== void 0 ? _527 : [],
                defaultValue: '[theftLockedIndicator]',
                possibleValues: null,
            }, theftItemNodeName: {
                value: (_529 = (_528 = params.properties.theftItemNodeName) === null || _528 === void 0 ? void 0 : _528.value) !== null && _529 !== void 0 ? _529 : '',
                values: (_531 = (_530 = params.properties.theftItemNodeName) === null || _530 === void 0 ? void 0 : _530.values) !== null && _531 !== void 0 ? _531 : [],
                defaultValue: 'theftItemNodeName',
                possibleValues: null,
            }, theftItemCostItemCodeNodeName: {
                value: (_533 = (_532 = params.properties.theftItemCostItemCodeNodeName) === null || _532 === void 0 ? void 0 : _532.value) !== null && _533 !== void 0 ? _533 : '',
                values: (_535 = (_534 = params.properties.theftItemCostItemCodeNodeName) === null || _534 === void 0 ? void 0 : _534.values) !== null && _535 !== void 0 ? _535 : [],
                defaultValue: 'theftItemCostItemCode',
                possibleValues: null,
            }, theftItemDescriptionNodeName: {
                value: (_537 = (_536 = params.properties.theftItemDescriptionNodeName) === null || _536 === void 0 ? void 0 : _536.value) !== null && _537 !== void 0 ? _537 : '',
                values: (_539 = (_538 = params.properties.theftItemDescriptionNodeName) === null || _538 === void 0 ? void 0 : _538.values) !== null && _539 !== void 0 ? _539 : [],
                defaultValue: 'theftItemDescription',
                possibleValues: null,
            }, theftItemAdditionalDescriptionNodeName: {
                value: (_541 = (_540 = params.properties.theftItemAdditionalDescriptionNodeName) === null || _540 === void 0 ? void 0 : _540.value) !== null && _541 !== void 0 ? _541 : '',
                values: (_543 = (_542 = params.properties.theftItemAdditionalDescriptionNodeName) === null || _542 === void 0 ? void 0 : _542.values) !== null && _543 !== void 0 ? _543 : [],
                defaultValue: 'theftItemAdditionalDescription',
                possibleValues: null,
            }, theftItemStoragePlaceNodeName: {
                value: (_545 = (_544 = params.properties.theftItemStoragePlaceNodeName) === null || _544 === void 0 ? void 0 : _544.value) !== null && _545 !== void 0 ? _545 : '',
                values: (_547 = (_546 = params.properties.theftItemStoragePlaceNodeName) === null || _546 === void 0 ? void 0 : _546.values) !== null && _547 !== void 0 ? _547 : [],
                defaultValue: 'theftItemStoragePlace',
                possibleValues: null,
            }, theftItemPurchaseDateNodeName: {
                value: (_549 = (_548 = params.properties.theftItemPurchaseDateNodeName) === null || _548 === void 0 ? void 0 : _548.value) !== null && _549 !== void 0 ? _549 : '',
                values: (_551 = (_550 = params.properties.theftItemPurchaseDateNodeName) === null || _550 === void 0 ? void 0 : _550.values) !== null && _551 !== void 0 ? _551 : [],
                defaultValue: 'theftItemPurchaseDate',
                possibleValues: null,
            }, theftItemCostsAmountNodeName: {
                value: (_553 = (_552 = params.properties.theftItemCostsAmountNodeName) === null || _552 === void 0 ? void 0 : _552.value) !== null && _553 !== void 0 ? _553 : '',
                values: (_555 = (_554 = params.properties.theftItemCostsAmountNodeName) === null || _554 === void 0 ? void 0 : _554.values) !== null && _555 !== void 0 ? _555 : [],
                defaultValue: 'theftItemCostsAmount',
                possibleValues: null,
            }, theftItemCurrentPriceNodeName: {
                value: (_557 = (_556 = params.properties.theftItemCurrentPriceNodeName) === null || _556 === void 0 ? void 0 : _556.value) !== null && _557 !== void 0 ? _557 : '',
                values: (_559 = (_558 = params.properties.theftItemCurrentPriceNodeName) === null || _558 === void 0 ? void 0 : _558.values) !== null && _559 !== void 0 ? _559 : [],
                defaultValue: 'theftItemCurrentPrice',
                possibleValues: null,
            }, theftItemHasCostsReceiptNodeName: {
                value: (_561 = (_560 = params.properties.theftItemHasCostsReceiptNodeName) === null || _560 === void 0 ? void 0 : _560.value) !== null && _561 !== void 0 ? _561 : '',
                values: (_563 = (_562 = params.properties.theftItemHasCostsReceiptNodeName) === null || _562 === void 0 ? void 0 : _562.values) !== null && _563 !== void 0 ? _563 : [],
                defaultValue: 'theftItemHasCostsReceipt',
                possibleValues: null,
            }, lossObjectType: {
                value: (_565 = (_564 = params.properties.lossObjectType) === null || _564 === void 0 ? void 0 : _564.value) !== null && _565 !== void 0 ? _565 : '',
                values: (_567 = (_566 = params.properties.lossObjectType) === null || _566 === void 0 ? void 0 : _566.values) !== null && _567 !== void 0 ? _567 : [],
                defaultValue: '[lossObjectType]',
                possibleValues: null,
            }, summaryDefinition: {
                value: (_569 = (_568 = params.properties.summaryDefinition) === null || _568 === void 0 ? void 0 : _568.value) !== null && _569 !== void 0 ? _569 : '',
                values: (_571 = (_570 = params.properties.summaryDefinition) === null || _570 === void 0 ? void 0 : _570.values) !== null && _571 !== void 0 ? _571 : [],
                defaultValue: '[summaryDefinition.summaryContentOutput]',
                possibleValues: null,
            }, isTheClaimDueToCoronaVirus: {
                value: (_573 = (_572 = params.properties.isTheClaimDueToCoronaVirus) === null || _572 === void 0 ? void 0 : _572.value) !== null && _573 !== void 0 ? _573 : '',
                values: (_575 = (_574 = params.properties.isTheClaimDueToCoronaVirus) === null || _574 === void 0 ? void 0 : _574.values) !== null && _575 !== void 0 ? _575 : [],
                defaultValue: 'false',
                possibleValues: null,
            }, evacuationCause: {
                value: (_577 = (_576 = params.properties.evacuationCause) === null || _576 === void 0 ? void 0 : _576.value) !== null && _577 !== void 0 ? _577 : '',
                values: (_579 = (_578 = params.properties.evacuationCause) === null || _578 === void 0 ? void 0 : _578.values) !== null && _579 !== void 0 ? _579 : [],
                defaultValue: 'None',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_581 = (_580 = params.properties.defaultValidationMessage) === null || _580 === void 0 ? void 0 : _580.value) !== null && _581 !== void 0 ? _581 : '',
                values: (_583 = (_582 = params.properties.defaultValidationMessage) === null || _582 === void 0 ? void 0 : _582.values) !== null && _583 !== void 0 ? _583 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Norway_Animal_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { reportersCustomerNumber: {
                value: (_b = (_a = params.properties.reportersCustomerNumber) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.reportersCustomerNumber) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '[reportersCustomerNumber]',
                possibleValues: null,
            }, claimType: {
                value: (_f = (_e = params.properties.claimType) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.claimType) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '[claimType]',
                possibleValues: null,
            }, customerEmail: {
                value: (_k = (_j = params.properties.customerEmail) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.customerEmail) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '[customerEmail]',
                possibleValues: null,
            }, customerPhone: {
                value: (_p = (_o = params.properties.customerPhone) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.customerPhone) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '[customerPhone]',
                possibleValues: null,
            }, incidentDate: {
                value: (_t = (_s = params.properties.incidentDate) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.incidentDate) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '[incidentDate]',
                possibleValues: null,
            }, customerName: {
                value: (_x = (_w = params.properties.customerName) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.customerName) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '[customerName]',
                possibleValues: null,
            }, authorizedUserNode: {
                value: (_1 = (_0 = params.properties.authorizedUserNode) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.authorizedUserNode) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '[authorizedUserNode]',
                possibleValues: null,
            }, customerInformationNode: {
                value: (_5 = (_4 = params.properties.customerInformationNode) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.customerInformationNode) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '[customerInformationNode]',
                possibleValues: null,
            }, policyInformationNode: {
                value: (_9 = (_8 = params.properties.policyInformationNode) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.policyInformationNode) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '[policyInformationNode]',
                possibleValues: null,
            }, policyNumber: {
                value: (_13 = (_12 = params.properties.policyNumber) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.policyNumber) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '[policyNumber]',
                possibleValues: null,
            }, policyObjectNumber: {
                value: (_17 = (_16 = params.properties.policyObjectNumber) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.policyObjectNumber) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '[policyObjectNumber]',
                possibleValues: null,
            }, animalName: {
                value: (_21 = (_20 = params.properties.animalName) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.animalName) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '[animalName]',
                possibleValues: null,
            }, animalDiagnosis: {
                value: (_25 = (_24 = params.properties.animalDiagnosis) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.animalDiagnosis) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '[animalDiagnosis]',
                possibleValues: null,
            }, animalType: {
                value: (_29 = (_28 = params.properties.animalType) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.animalType) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '[animalType]',
                possibleValues: null,
            }, summaryDefinition: {
                value: (_33 = (_32 = params.properties.summaryDefinition) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.summaryDefinition) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '[summaryDefinition]',
                possibleValues: null,
            }, customerNumber: {
                value: (_37 = (_36 = params.properties.customerNumber) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.customerNumber) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '[customerNumber]',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_41 = (_40 = params.properties.defaultValidationMessage) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.defaultValidationMessage) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Norway_Animal_GetPoliciesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { customerNumber: {
                value: (_b = (_a = params.properties.customerNumber) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.customerNumber) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, animalType: {
                value: (_f = (_e = params.properties.animalType) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.animalType) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '[animalType]',
                possibleValues: null,
            }, policyNumber: {
                value: (_k = (_j = params.properties.policyNumber) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.policyNumber) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '[policyNumber]',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Norway_Animal_ShowPoliciesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { policyData: {
                value: (_b = (_a = params.properties.policyData) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.policyData) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Norway_SilentAuthenticationNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { defaultValidationMessage: {
                value: (_b = (_a = params.properties.defaultValidationMessage) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.defaultValidationMessage) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'ssn',
                possibleValues: []
            }, {
                name: 'name',
                possibleValues: []
            }, {
                name: 'surname',
                possibleValues: []
            }, {
                name: 'nameSurname',
                possibleValues: []
            }, {
                name: 'country',
                possibleValues: []
            }, {
                name: 'bankName',
                possibleValues: []
            }, {
                name: 'authTimestamp',
                possibleValues: []
            }, {
                name: 'AuthorizedUser',
                possibleValues: []
            }
        ];
    }
}
export class SplitterNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { defaultValidationMessage: {
                value: (_b = (_a = params.properties.defaultValidationMessage) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.defaultValidationMessage) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Denmark_AuthenticationNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { loginButton: {
                value: (_b = (_a = params.properties.loginButton) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.loginButton) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: 'Nem-ID',
                possibleValues: null,
            }, mitIdLoginButton: {
                value: (_f = (_e = params.properties.mitIdLoginButton) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.mitIdLoginButton) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: 'MitID',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_k = (_j = params.properties.defaultValidationMessage) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.defaultValidationMessage) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'ssn',
                possibleValues: []
            }, {
                name: 'name',
                possibleValues: []
            }, {
                name: 'surname',
                possibleValues: []
            }, {
                name: 'nameSurname',
                possibleValues: []
            }, {
                name: 'country',
                possibleValues: []
            }, {
                name: 'bankName',
                possibleValues: []
            }, {
                name: 'authTimestamp',
                possibleValues: []
            }, {
                name: 'AuthorizedUser',
                possibleValues: []
            }
        ];
    }
}
export class Denmark_Motor_ShowVehiclesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { vehiclesData: {
                value: (_b = (_a = params.properties.vehiclesData) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.vehiclesData) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Denmark_Motor_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { claimType: {
                value: (_b = (_a = params.properties.claimType) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.claimType) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, authorizedUserNode: {
                value: (_f = (_e = params.properties.authorizedUserNode) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.authorizedUserNode) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, customerInformationNode: {
                value: (_k = (_j = params.properties.customerInformationNode) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.customerInformationNode) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, choosenVehicleNode: {
                value: (_p = (_o = params.properties.choosenVehicleNode) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.choosenVehicleNode) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, manuallyVehicleNumber: {
                value: (_t = (_s = params.properties.manuallyVehicleNumber) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.manuallyVehicleNumber) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDate: {
                value: (_x = (_w = params.properties.incidentDate) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.incidentDate) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTime: {
                value: (_1 = (_0 = params.properties.incidentTime) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.incidentTime) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, customerEmail: {
                value: (_5 = (_4 = params.properties.customerEmail) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.customerEmail) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, customerPhone: {
                value: (_9 = (_8 = params.properties.customerPhone) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.customerPhone) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, injuredNameFieldName: {
                value: (_13 = (_12 = params.properties.injuredNameFieldName) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.injuredNameFieldName) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, vehicleDamageDescription: {
                value: (_17 = (_16 = params.properties.vehicleDamageDescription) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.vehicleDamageDescription) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, vehicleDamagedParts: {
                value: (_21 = (_20 = params.properties.vehicleDamagedParts) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.vehicleDamagedParts) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, summaryDefinition: {
                value: (_25 = (_24 = params.properties.summaryDefinition) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.summaryDefinition) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_29 = (_28 = params.properties.defaultValidationMessage) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.defaultValidationMessage) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Denmark_SummaryNode extends BaseNode {
}
export class Denmark_GetUserInformationNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { ssn: {
                value: (_b = (_a = params.properties.ssn) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.ssn) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Denmark_Motor_GetVehiclesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { userInformationData: {
                value: (_b = (_a = params.properties.userInformationData) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.userInformationData) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Denmark_PersonalInjury_GetUserPoliciesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { incidentDate: {
                value: (_b = (_a = params.properties.incidentDate) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.incidentDate) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'policyData',
                possibleValues: []
            }
        ];
    }
}
export class Denmark_PersonalInjury_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { authorizedUserNode: {
                value: (_b = (_a = params.properties.authorizedUserNode) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.authorizedUserNode) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPersonSsn: {
                value: (_f = (_e = params.properties.reportedPersonSsn) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.reportedPersonSsn) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDate: {
                value: (_k = (_j = params.properties.incidentDate) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.incidentDate) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, customerEmail: {
                value: (_p = (_o = params.properties.customerEmail) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.customerEmail) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, customerPhone: {
                value: (_t = (_s = params.properties.customerPhone) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.customerPhone) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, claimType: {
                value: (_x = (_w = params.properties.claimType) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.claimType) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, summaryDefinition: {
                value: (_1 = (_0 = params.properties.summaryDefinition) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.summaryDefinition) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyNumber: {
                value: (_5 = (_4 = params.properties.policyNumber) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.policyNumber) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_9 = (_8 = params.properties.defaultValidationMessage) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.defaultValidationMessage) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Denmark_PersonalInjury_ShowUserPoliciesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { policyData: {
                value: (_b = (_a = params.properties.policyData) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.policyData) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'chosenPolicy',
                possibleValues: []
            }, {
                name: 'insuredObjectType',
                possibleValues: []
            }, {
                name: 'insuredName',
                possibleValues: []
            }, {
                name: 'insuredSsn',
                possibleValues: []
            }, {
                name: 'policyNumber',
                possibleValues: []
            }
        ];
    }
}
export class Denmark_Property_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { customerFirstName: {
                value: (_b = (_a = params.properties.customerFirstName) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.customerFirstName) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, customerLastName: {
                value: (_f = (_e = params.properties.customerLastName) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.customerLastName) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterCustomerNumber: {
                value: (_k = (_j = params.properties.reporterCustomerNumber) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.reporterCustomerNumber) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, customerPhone: {
                value: (_p = (_o = params.properties.customerPhone) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.customerPhone) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, customerEmail: {
                value: (_t = (_s = params.properties.customerEmail) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.customerEmail) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDate: {
                value: (_x = (_w = params.properties.incidentDate) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.incidentDate) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, claimType: {
                value: (_1 = (_0 = params.properties.claimType) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.claimType) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, summary: {
                value: (_5 = (_4 = params.properties.summary) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.summary) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, artNumber: {
                value: (_9 = (_8 = params.properties.artNumber) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.artNumber) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, attachmentViewerUrl: {
                value: (_13 = (_12 = params.properties.attachmentViewerUrl) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.attachmentViewerUrl) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyNumber: {
                value: (_17 = (_16 = params.properties.policyNumber) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.policyNumber) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, branch: {
                value: (_21 = (_20 = params.properties.branch) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.branch) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_25 = (_24 = params.properties.defaultValidationMessage) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.defaultValidationMessage) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Denmark_Property_GetPoliciesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { ssn: {
                value: (_b = (_a = params.properties.ssn) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.ssn) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, insuredObjectType: {
                value: (_f = (_e = params.properties.insuredObjectType) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.insuredObjectType) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_k = (_j = params.properties.defaultValidationMessage) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.defaultValidationMessage) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'policyData',
                possibleValues: []
            }, {
                name: 'chosenPolicy',
                possibleValues: []
            }, {
                name: 'policyNumber',
                possibleValues: []
            }
        ];
    }
}
export class Denmark_Property_ShowPoliciesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { policyData: {
                value: (_b = (_a = params.properties.policyData) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.policyData) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'chosenPolicy',
                possibleValues: []
            }, {
                name: 'policyNumber',
                possibleValues: []
            }
        ];
    }
}
export class Denmark_SilentAuthenticationNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { defaultValidationMessage: {
                value: (_b = (_a = params.properties.defaultValidationMessage) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.defaultValidationMessage) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'ssn',
                possibleValues: []
            }, {
                name: 'name',
                possibleValues: []
            }, {
                name: 'surname',
                possibleValues: []
            }, {
                name: 'nameSurname',
                possibleValues: []
            }, {
                name: 'country',
                possibleValues: []
            }, {
                name: 'bankName',
                possibleValues: []
            }, {
                name: 'authTimestamp',
                possibleValues: []
            }, {
                name: 'AuthorizedUser',
                possibleValues: []
            }
        ];
    }
}
export class Finland_AuthenticationNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { loginButton: {
                value: (_b = (_a = params.properties.loginButton) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.loginButton) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: 'Finnish POP Pankki',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'ssn',
                possibleValues: []
            }, {
                name: 'name',
                possibleValues: []
            }, {
                name: 'surname',
                possibleValues: []
            }, {
                name: 'nameSurname',
                possibleValues: []
            }, {
                name: 'country',
                possibleValues: []
            }, {
                name: 'bankName',
                possibleValues: []
            }, {
                name: 'authTimestamp',
                possibleValues: []
            }, {
                name: 'AuthorizedUser',
                possibleValues: []
            }
        ];
    }
}
export class Finland_Motor_ShowVehiclesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { vehiclesData: {
                value: (_b = (_a = params.properties.vehiclesData) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.vehiclesData) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Finland_Motor_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143, _144, _145, _146, _147, _148, _149, _150, _151, _152, _153, _154, _155, _156, _157, _158, _159, _160, _161, _162, _163, _164, _165, _166, _167, _168, _169, _170, _171, _172, _173, _174, _175, _176, _177, _178, _179, _180, _181, _182, _183, _184, _185, _186, _187, _188, _189, _190, _191, _192, _193, _194, _195, _196, _197, _198, _199, _200, _201, _202, _203, _204, _205, _206, _207, _208, _209, _210, _211, _212, _213, _214, _215, _216, _217, _218, _219, _220, _221, _222, _223, _224, _225, _226, _227, _228, _229, _230, _231, _232, _233, _234, _235, _236, _237, _238, _239, _240, _241, _242, _243, _244, _245, _246, _247, _248, _249, _250, _251, _252, _253, _254, _255, _256, _257, _258, _259, _260, _261, _262, _263, _264, _265, _266, _267, _268, _269, _270, _271, _272, _273, _274, _275, _276, _277, _278, _279, _280, _281, _282, _283, _284, _285, _286, _287, _288, _289, _290, _291, _292, _293, _294, _295, _296, _297, _298, _299, _300, _301, _302, _303, _304, _305, _306, _307, _308, _309, _310, _311, _312, _313, _314, _315, _316, _317, _318, _319, _320, _321, _322, _323, _324, _325, _326, _327, _328, _329, _330, _331;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { claimType: {
                value: (_b = (_a = params.properties.claimType) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.claimType) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '[claimType]',
                possibleValues: null,
            }, claimCause: {
                value: (_f = (_e = params.properties.claimCause) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.claimCause) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '[claimCause]',
                possibleValues: null,
            }, claimCausedBy: {
                value: (_k = (_j = params.properties.claimCausedBy) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.claimCausedBy) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '[claimCausedBy]',
                possibleValues: null,
            }, incidentDate: {
                value: (_p = (_o = params.properties.incidentDate) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.incidentDate) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '[incidentDate]',
                possibleValues: null,
            }, incidentTime: {
                value: (_t = (_s = params.properties.incidentTime) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.incidentTime) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '[incidentTime]',
                possibleValues: null,
            }, accidentCountry: {
                value: (_x = (_w = params.properties.accidentCountry) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.accidentCountry) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '[accidentCountry]',
                possibleValues: null,
            }, repairedAbroad: {
                value: (_1 = (_0 = params.properties.repairedAbroad) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.repairedAbroad) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '[repairedAbroad]',
                possibleValues: null,
            }, accidentCity: {
                value: (_5 = (_4 = params.properties.accidentCity) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.accidentCity) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '[accidentCity]',
                possibleValues: null,
            }, accidentStreetAddress: {
                value: (_9 = (_8 = params.properties.accidentStreetAddress) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.accidentStreetAddress) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '[accidentStreetAddress]',
                possibleValues: null,
            }, authorizedUserNode: {
                value: (_13 = (_12 = params.properties.authorizedUserNode) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.authorizedUserNode) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '[authorizedUserNode]',
                possibleValues: null,
            }, customerInformationNode: {
                value: (_17 = (_16 = params.properties.customerInformationNode) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.customerInformationNode) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '[customerInformationNode]',
                possibleValues: null,
            }, reporterPhone: {
                value: (_21 = (_20 = params.properties.reporterPhone) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.reporterPhone) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '[reporterPhone]',
                possibleValues: null,
            }, reporterEmail: {
                value: (_25 = (_24 = params.properties.reporterEmail) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.reporterEmail) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '[reporterEmail]',
                possibleValues: null,
            }, reporterBankAccountNumber: {
                value: (_29 = (_28 = params.properties.reporterBankAccountNumber) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.reporterBankAccountNumber) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '[reporterBankAccountNumber]',
                possibleValues: null,
            }, reporterRoleCode: {
                value: (_33 = (_32 = params.properties.reporterRoleCode) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.reporterRoleCode) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '[reporterRoleCode]',
                possibleValues: null,
            }, customerNumber: {
                value: (_37 = (_36 = params.properties.customerNumber) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.customerNumber) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '[customerNumber]',
                possibleValues: null,
            }, isReporterPolicyholder: {
                value: (_41 = (_40 = params.properties.isReporterPolicyholder) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.isReporterPolicyholder) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '[isReporterPolicyholder]',
                possibleValues: null,
            }, policyholderFirstName: {
                value: (_45 = (_44 = params.properties.policyholderFirstName) === null || _44 === void 0 ? void 0 : _44.value) !== null && _45 !== void 0 ? _45 : '',
                values: (_47 = (_46 = params.properties.policyholderFirstName) === null || _46 === void 0 ? void 0 : _46.values) !== null && _47 !== void 0 ? _47 : [],
                defaultValue: '[policyholderFirstName]',
                possibleValues: null,
            }, policyholderSurname: {
                value: (_49 = (_48 = params.properties.policyholderSurname) === null || _48 === void 0 ? void 0 : _48.value) !== null && _49 !== void 0 ? _49 : '',
                values: (_51 = (_50 = params.properties.policyholderSurname) === null || _50 === void 0 ? void 0 : _50.values) !== null && _51 !== void 0 ? _51 : [],
                defaultValue: '[policyholderSurname]',
                possibleValues: null,
            }, policyholderSsn: {
                value: (_53 = (_52 = params.properties.policyholderSsn) === null || _52 === void 0 ? void 0 : _52.value) !== null && _53 !== void 0 ? _53 : '',
                values: (_55 = (_54 = params.properties.policyholderSsn) === null || _54 === void 0 ? void 0 : _54.values) !== null && _55 !== void 0 ? _55 : [],
                defaultValue: '[policyholderSsn]',
                possibleValues: null,
            }, policyholderEmail: {
                value: (_57 = (_56 = params.properties.policyholderEmail) === null || _56 === void 0 ? void 0 : _56.value) !== null && _57 !== void 0 ? _57 : '',
                values: (_59 = (_58 = params.properties.policyholderEmail) === null || _58 === void 0 ? void 0 : _58.values) !== null && _59 !== void 0 ? _59 : [],
                defaultValue: '[policyholderEmail]',
                possibleValues: null,
            }, policyholderPhone: {
                value: (_61 = (_60 = params.properties.policyholderPhone) === null || _60 === void 0 ? void 0 : _60.value) !== null && _61 !== void 0 ? _61 : '',
                values: (_63 = (_62 = params.properties.policyholderPhone) === null || _62 === void 0 ? void 0 : _62.values) !== null && _63 !== void 0 ? _63 : [],
                defaultValue: '[policyholderPhone]',
                possibleValues: null,
            }, isPolicyHolderCompany: {
                value: (_65 = (_64 = params.properties.isPolicyHolderCompany) === null || _64 === void 0 ? void 0 : _64.value) !== null && _65 !== void 0 ? _65 : '',
                values: (_67 = (_66 = params.properties.isPolicyHolderCompany) === null || _66 === void 0 ? void 0 : _66.values) !== null && _67 !== void 0 ? _67 : [],
                defaultValue: '[isPolicyHolderCompany]',
                possibleValues: null,
            }, policyHolderCompanyName: {
                value: (_69 = (_68 = params.properties.policyHolderCompanyName) === null || _68 === void 0 ? void 0 : _68.value) !== null && _69 !== void 0 ? _69 : '',
                values: (_71 = (_70 = params.properties.policyHolderCompanyName) === null || _70 === void 0 ? void 0 : _70.values) !== null && _71 !== void 0 ? _71 : [],
                defaultValue: '[policyHolderCompanyName]',
                possibleValues: null,
            }, policyHolderCompanyId: {
                value: (_73 = (_72 = params.properties.policyHolderCompanyId) === null || _72 === void 0 ? void 0 : _72.value) !== null && _73 !== void 0 ? _73 : '',
                values: (_75 = (_74 = params.properties.policyHolderCompanyId) === null || _74 === void 0 ? void 0 : _74.values) !== null && _75 !== void 0 ? _75 : [],
                defaultValue: '[policyHolderCompanyId]',
                possibleValues: null,
            }, choosenInsuredVehicleNode: {
                value: (_77 = (_76 = params.properties.choosenInsuredVehicleNode) === null || _76 === void 0 ? void 0 : _76.value) !== null && _77 !== void 0 ? _77 : '',
                values: (_79 = (_78 = params.properties.choosenInsuredVehicleNode) === null || _78 === void 0 ? void 0 : _78.values) !== null && _79 !== void 0 ? _79 : [],
                defaultValue: '[choosenInsuredVehicleNode]',
                possibleValues: null,
            }, insuredVehicleRegistrationNumber: {
                value: (_81 = (_80 = params.properties.insuredVehicleRegistrationNumber) === null || _80 === void 0 ? void 0 : _80.value) !== null && _81 !== void 0 ? _81 : '',
                values: (_83 = (_82 = params.properties.insuredVehicleRegistrationNumber) === null || _82 === void 0 ? void 0 : _82.values) !== null && _83 !== void 0 ? _83 : [],
                defaultValue: '[insuredVehicleRegistrationNumber]',
                possibleValues: null,
            }, isReporterDriver: {
                value: (_85 = (_84 = params.properties.isReporterDriver) === null || _84 === void 0 ? void 0 : _84.value) !== null && _85 !== void 0 ? _85 : '',
                values: (_87 = (_86 = params.properties.isReporterDriver) === null || _86 === void 0 ? void 0 : _86.values) !== null && _87 !== void 0 ? _87 : [],
                defaultValue: '[isReporterDriver]',
                possibleValues: null,
            }, driverFirstName: {
                value: (_89 = (_88 = params.properties.driverFirstName) === null || _88 === void 0 ? void 0 : _88.value) !== null && _89 !== void 0 ? _89 : '',
                values: (_91 = (_90 = params.properties.driverFirstName) === null || _90 === void 0 ? void 0 : _90.values) !== null && _91 !== void 0 ? _91 : [],
                defaultValue: '[driverFirstName]',
                possibleValues: null,
            }, driverSurname: {
                value: (_93 = (_92 = params.properties.driverSurname) === null || _92 === void 0 ? void 0 : _92.value) !== null && _93 !== void 0 ? _93 : '',
                values: (_95 = (_94 = params.properties.driverSurname) === null || _94 === void 0 ? void 0 : _94.values) !== null && _95 !== void 0 ? _95 : [],
                defaultValue: '[driverSurname]',
                possibleValues: null,
            }, driverSsn: {
                value: (_97 = (_96 = params.properties.driverSsn) === null || _96 === void 0 ? void 0 : _96.value) !== null && _97 !== void 0 ? _97 : '',
                values: (_99 = (_98 = params.properties.driverSsn) === null || _98 === void 0 ? void 0 : _98.values) !== null && _99 !== void 0 ? _99 : [],
                defaultValue: '[driverSsn]',
                possibleValues: null,
            }, driverPhone: {
                value: (_101 = (_100 = params.properties.driverPhone) === null || _100 === void 0 ? void 0 : _100.value) !== null && _101 !== void 0 ? _101 : '',
                values: (_103 = (_102 = params.properties.driverPhone) === null || _102 === void 0 ? void 0 : _102.values) !== null && _103 !== void 0 ? _103 : [],
                defaultValue: '[driverPhone]',
                possibleValues: null,
            }, drunkenParticipant: {
                value: (_105 = (_104 = params.properties.drunkenParticipant) === null || _104 === void 0 ? void 0 : _104.value) !== null && _105 !== void 0 ? _105 : '',
                values: (_107 = (_106 = params.properties.drunkenParticipant) === null || _106 === void 0 ? void 0 : _106.values) !== null && _107 !== void 0 ? _107 : [],
                defaultValue: '[drunkenParticipant]',
                possibleValues: null,
            }, isReportedToPolice: {
                value: (_109 = (_108 = params.properties.isReportedToPolice) === null || _108 === void 0 ? void 0 : _108.value) !== null && _109 !== void 0 ? _109 : '',
                values: (_111 = (_110 = params.properties.isReportedToPolice) === null || _110 === void 0 ? void 0 : _110.values) !== null && _111 !== void 0 ? _111 : [],
                defaultValue: '[isReportedToPolice]',
                possibleValues: null,
            }, vehicleDamageLocation: {
                value: (_113 = (_112 = params.properties.vehicleDamageLocation) === null || _112 === void 0 ? void 0 : _112.value) !== null && _113 !== void 0 ? _113 : '',
                values: (_115 = (_114 = params.properties.vehicleDamageLocation) === null || _114 === void 0 ? void 0 : _114.values) !== null && _115 !== void 0 ? _115 : [],
                defaultValue: '[vehicleDamageLocation]',
                possibleValues: null,
            }, ownInsuranceUsed: {
                value: (_117 = (_116 = params.properties.ownInsuranceUsed) === null || _116 === void 0 ? void 0 : _116.value) !== null && _117 !== void 0 ? _117 : '',
                values: (_119 = (_118 = params.properties.ownInsuranceUsed) === null || _118 === void 0 ? void 0 : _118.values) !== null && _119 !== void 0 ? _119 : [],
                defaultValue: '[ownInsuranceUsed]',
                possibleValues: null,
            }, isOwnCarDamaged: {
                value: (_121 = (_120 = params.properties.isOwnCarDamaged) === null || _120 === void 0 ? void 0 : _120.value) !== null && _121 !== void 0 ? _121 : '',
                values: (_123 = (_122 = params.properties.isOwnCarDamaged) === null || _122 === void 0 ? void 0 : _122.values) !== null && _123 !== void 0 ? _123 : [],
                defaultValue: '[isOwnCarDamaged]',
                possibleValues: null,
            }, hasPersonalInjuries: {
                value: (_125 = (_124 = params.properties.hasPersonalInjuries) === null || _124 === void 0 ? void 0 : _124.value) !== null && _125 !== void 0 ? _125 : '',
                values: (_127 = (_126 = params.properties.hasPersonalInjuries) === null || _126 === void 0 ? void 0 : _126.values) !== null && _127 !== void 0 ? _127 : [],
                defaultValue: '[hasPersonalInjuries]',
                possibleValues: null,
            }, damagedPropertyDescription: {
                value: (_129 = (_128 = params.properties.damagedPropertyDescription) === null || _128 === void 0 ? void 0 : _128.value) !== null && _129 !== void 0 ? _129 : '',
                values: (_131 = (_130 = params.properties.damagedPropertyDescription) === null || _130 === void 0 ? void 0 : _130.values) !== null && _131 !== void 0 ? _131 : [],
                defaultValue: '[damagedPropertyDescription]',
                possibleValues: null,
            }, stolenPropertyDescription: {
                value: (_133 = (_132 = params.properties.stolenPropertyDescription) === null || _132 === void 0 ? void 0 : _132.value) !== null && _133 !== void 0 ? _133 : '',
                values: (_135 = (_134 = params.properties.stolenPropertyDescription) === null || _134 === void 0 ? void 0 : _134.values) !== null && _135 !== void 0 ? _135 : [],
                defaultValue: '[stolenPropertyDescription]',
                possibleValues: null,
            }, hasOtherExpenses: {
                value: (_137 = (_136 = params.properties.hasOtherExpenses) === null || _136 === void 0 ? void 0 : _136.value) !== null && _137 !== void 0 ? _137 : '',
                values: (_139 = (_138 = params.properties.hasOtherExpenses) === null || _138 === void 0 ? void 0 : _138.values) !== null && _139 !== void 0 ? _139 : [],
                defaultValue: '[hasOtherExpenses]',
                possibleValues: null,
            }, damageDescription: {
                value: (_141 = (_140 = params.properties.damageDescription) === null || _140 === void 0 ? void 0 : _140.value) !== null && _141 !== void 0 ? _141 : '',
                values: (_143 = (_142 = params.properties.damageDescription) === null || _142 === void 0 ? void 0 : _142.values) !== null && _143 !== void 0 ? _143 : [],
                defaultValue: '[damageDescription]',
                possibleValues: null,
            }, accidentCausedBy: {
                value: (_145 = (_144 = params.properties.accidentCausedBy) === null || _144 === void 0 ? void 0 : _144.value) !== null && _145 !== void 0 ? _145 : '',
                values: (_147 = (_146 = params.properties.accidentCausedBy) === null || _146 === void 0 ? void 0 : _146.values) !== null && _147 !== void 0 ? _147 : [],
                defaultValue: '[accidentCausedBy]',
                possibleValues: null,
            }, vehicleGlassDamageLocation: {
                value: (_149 = (_148 = params.properties.vehicleGlassDamageLocation) === null || _148 === void 0 ? void 0 : _148.value) !== null && _149 !== void 0 ? _149 : '',
                values: (_151 = (_150 = params.properties.vehicleGlassDamageLocation) === null || _150 === void 0 ? void 0 : _150.values) !== null && _151 !== void 0 ? _151 : [],
                defaultValue: '[vehicleGlassDamageLocation]',
                possibleValues: null,
            }, guiltyPartyKnown: {
                value: (_153 = (_152 = params.properties.guiltyPartyKnown) === null || _152 === void 0 ? void 0 : _152.value) !== null && _153 !== void 0 ? _153 : '',
                values: (_155 = (_154 = params.properties.guiltyPartyKnown) === null || _154 === void 0 ? void 0 : _154.values) !== null && _155 !== void 0 ? _155 : [],
                defaultValue: '[guiltyPartyKnown]',
                possibleValues: null,
            }, guiltyParty: {
                value: (_157 = (_156 = params.properties.guiltyParty) === null || _156 === void 0 ? void 0 : _156.value) !== null && _157 !== void 0 ? _157 : '',
                values: (_159 = (_158 = params.properties.guiltyParty) === null || _158 === void 0 ? void 0 : _158.values) !== null && _159 !== void 0 ? _159 : [],
                defaultValue: '[guiltyParty]',
                possibleValues: null,
            }, keyOwners: {
                value: (_161 = (_160 = params.properties.keyOwners) === null || _160 === void 0 ? void 0 : _160.value) !== null && _161 !== void 0 ? _161 : '',
                values: (_163 = (_162 = params.properties.keyOwners) === null || _162 === void 0 ? void 0 : _162.values) !== null && _163 !== void 0 ? _163 : [],
                defaultValue: '[keyOwners]',
                possibleValues: null,
            }, hasKeysSafe: {
                value: (_165 = (_164 = params.properties.hasKeysSafe) === null || _164 === void 0 ? void 0 : _164.value) !== null && _165 !== void 0 ? _165 : '',
                values: (_167 = (_166 = params.properties.hasKeysSafe) === null || _166 === void 0 ? void 0 : _166.values) !== null && _167 !== void 0 ? _167 : [],
                defaultValue: '[hasKeysSafe]',
                possibleValues: null,
            }, wasVehicleLocked: {
                value: (_169 = (_168 = params.properties.wasVehicleLocked) === null || _168 === void 0 ? void 0 : _168.value) !== null && _169 !== void 0 ? _169 : '',
                values: (_171 = (_170 = params.properties.wasVehicleLocked) === null || _170 === void 0 ? void 0 : _170.values) !== null && _171 !== void 0 ? _171 : [],
                defaultValue: '[wasVehicleLocked]',
                possibleValues: null,
            }, fireStartCircumstance: {
                value: (_173 = (_172 = params.properties.fireStartCircumstance) === null || _172 === void 0 ? void 0 : _172.value) !== null && _173 !== void 0 ? _173 : '',
                values: (_175 = (_174 = params.properties.fireStartCircumstance) === null || _174 === void 0 ? void 0 : _174.values) !== null && _175 !== void 0 ? _175 : [],
                defaultValue: '[fireStartCircumstance]',
                possibleValues: null,
            }, counterpartNode: {
                value: (_177 = (_176 = params.properties.counterpartNode) === null || _176 === void 0 ? void 0 : _176.value) !== null && _177 !== void 0 ? _177 : '',
                values: (_179 = (_178 = params.properties.counterpartNode) === null || _178 === void 0 ? void 0 : _178.values) !== null && _179 !== void 0 ? _179 : [],
                defaultValue: 'counterpartNode',
                possibleValues: null,
            }, counterpartRegistrationNumber: {
                value: (_181 = (_180 = params.properties.counterpartRegistrationNumber) === null || _180 === void 0 ? void 0 : _180.value) !== null && _181 !== void 0 ? _181 : '',
                values: (_183 = (_182 = params.properties.counterpartRegistrationNumber) === null || _182 === void 0 ? void 0 : _182.values) !== null && _183 !== void 0 ? _183 : [],
                defaultValue: 'counterpartRegistrationNumber',
                possibleValues: null,
            }, counterpartDriverName: {
                value: (_185 = (_184 = params.properties.counterpartDriverName) === null || _184 === void 0 ? void 0 : _184.value) !== null && _185 !== void 0 ? _185 : '',
                values: (_187 = (_186 = params.properties.counterpartDriverName) === null || _186 === void 0 ? void 0 : _186.values) !== null && _187 !== void 0 ? _187 : [],
                defaultValue: 'counterpartDriverName',
                possibleValues: null,
            }, counterpartPhoneNumber: {
                value: (_189 = (_188 = params.properties.counterpartPhoneNumber) === null || _188 === void 0 ? void 0 : _188.value) !== null && _189 !== void 0 ? _189 : '',
                values: (_191 = (_190 = params.properties.counterpartPhoneNumber) === null || _190 === void 0 ? void 0 : _190.values) !== null && _191 !== void 0 ? _191 : [],
                defaultValue: 'counterpartPhoneNumber',
                possibleValues: null,
            }, counterpartVehicleDamageDescription: {
                value: (_193 = (_192 = params.properties.counterpartVehicleDamageDescription) === null || _192 === void 0 ? void 0 : _192.value) !== null && _193 !== void 0 ? _193 : '',
                values: (_195 = (_194 = params.properties.counterpartVehicleDamageDescription) === null || _194 === void 0 ? void 0 : _194.values) !== null && _195 !== void 0 ? _195 : [],
                defaultValue: 'counterpartVehicleDamageDescription',
                possibleValues: null,
            }, accidentPlace: {
                value: (_197 = (_196 = params.properties.accidentPlace) === null || _196 === void 0 ? void 0 : _196.value) !== null && _197 !== void 0 ? _197 : '',
                values: (_199 = (_198 = params.properties.accidentPlace) === null || _198 === void 0 ? void 0 : _198.values) !== null && _199 !== void 0 ? _199 : [],
                defaultValue: '[accidentPlace]',
                possibleValues: null,
            }, trafficLights: {
                value: (_201 = (_200 = params.properties.trafficLights) === null || _200 === void 0 ? void 0 : _200.value) !== null && _201 !== void 0 ? _201 : '',
                values: (_203 = (_202 = params.properties.trafficLights) === null || _202 === void 0 ? void 0 : _202.values) !== null && _203 !== void 0 ? _203 : [],
                defaultValue: '[trafficLights]',
                possibleValues: null,
            }, roadType: {
                value: (_205 = (_204 = params.properties.roadType) === null || _204 === void 0 ? void 0 : _204.value) !== null && _205 !== void 0 ? _205 : '',
                values: (_207 = (_206 = params.properties.roadType) === null || _206 === void 0 ? void 0 : _206.values) !== null && _207 !== void 0 ? _207 : [],
                defaultValue: '[roadType]',
                possibleValues: null,
            }, roadSurface: {
                value: (_209 = (_208 = params.properties.roadSurface) === null || _208 === void 0 ? void 0 : _208.value) !== null && _209 !== void 0 ? _209 : '',
                values: (_211 = (_210 = params.properties.roadSurface) === null || _210 === void 0 ? void 0 : _210.values) !== null && _211 !== void 0 ? _211 : [],
                defaultValue: '[roadSurface]',
                possibleValues: null,
            }, lightning: {
                value: (_213 = (_212 = params.properties.lightning) === null || _212 === void 0 ? void 0 : _212.value) !== null && _213 !== void 0 ? _213 : '',
                values: (_215 = (_214 = params.properties.lightning) === null || _214 === void 0 ? void 0 : _214.values) !== null && _215 !== void 0 ? _215 : [],
                defaultValue: '[lightning]',
                possibleValues: null,
            }, accidentSituation: {
                value: (_217 = (_216 = params.properties.accidentSituation) === null || _216 === void 0 ? void 0 : _216.value) !== null && _217 !== void 0 ? _217 : '',
                values: (_219 = (_218 = params.properties.accidentSituation) === null || _218 === void 0 ? void 0 : _218.values) !== null && _219 !== void 0 ? _219 : [],
                defaultValue: '[accidentSituation]',
                possibleValues: null,
            }, wasDenslyPopulatedArea: {
                value: (_221 = (_220 = params.properties.wasDenslyPopulatedArea) === null || _220 === void 0 ? void 0 : _220.value) !== null && _221 !== void 0 ? _221 : '',
                values: (_223 = (_222 = params.properties.wasDenslyPopulatedArea) === null || _222 === void 0 ? void 0 : _222.values) !== null && _223 !== void 0 ? _223 : [],
                defaultValue: '[wasDenslyPopulatedArea]',
                possibleValues: null,
            }, injuredContainerNode: {
                value: (_225 = (_224 = params.properties.injuredContainerNode) === null || _224 === void 0 ? void 0 : _224.value) !== null && _225 !== void 0 ? _225 : '',
                values: (_227 = (_226 = params.properties.injuredContainerNode) === null || _226 === void 0 ? void 0 : _226.values) !== null && _227 !== void 0 ? _227 : [],
                defaultValue: 'injuredContainerNode',
                possibleValues: null,
            }, injuredFirstName: {
                value: (_229 = (_228 = params.properties.injuredFirstName) === null || _228 === void 0 ? void 0 : _228.value) !== null && _229 !== void 0 ? _229 : '',
                values: (_231 = (_230 = params.properties.injuredFirstName) === null || _230 === void 0 ? void 0 : _230.values) !== null && _231 !== void 0 ? _231 : [],
                defaultValue: 'injuredFirstName',
                possibleValues: null,
            }, injuredSurname: {
                value: (_233 = (_232 = params.properties.injuredSurname) === null || _232 === void 0 ? void 0 : _232.value) !== null && _233 !== void 0 ? _233 : '',
                values: (_235 = (_234 = params.properties.injuredSurname) === null || _234 === void 0 ? void 0 : _234.values) !== null && _235 !== void 0 ? _235 : [],
                defaultValue: 'injuredSurname',
                possibleValues: null,
            }, injuredSsn: {
                value: (_237 = (_236 = params.properties.injuredSsn) === null || _236 === void 0 ? void 0 : _236.value) !== null && _237 !== void 0 ? _237 : '',
                values: (_239 = (_238 = params.properties.injuredSsn) === null || _238 === void 0 ? void 0 : _238.values) !== null && _239 !== void 0 ? _239 : [],
                defaultValue: 'injuredSsn',
                possibleValues: null,
            }, injuredPhone: {
                value: (_241 = (_240 = params.properties.injuredPhone) === null || _240 === void 0 ? void 0 : _240.value) !== null && _241 !== void 0 ? _241 : '',
                values: (_243 = (_242 = params.properties.injuredPhone) === null || _242 === void 0 ? void 0 : _242.values) !== null && _243 !== void 0 ? _243 : [],
                defaultValue: 'injuredPhone',
                possibleValues: null,
            }, injuredRole: {
                value: (_245 = (_244 = params.properties.injuredRole) === null || _244 === void 0 ? void 0 : _244.value) !== null && _245 !== void 0 ? _245 : '',
                values: (_247 = (_246 = params.properties.injuredRole) === null || _246 === void 0 ? void 0 : _246.values) !== null && _247 !== void 0 ? _247 : [],
                defaultValue: 'injuredRole',
                possibleValues: null,
            }, injuredSeverety: {
                value: (_249 = (_248 = params.properties.injuredSeverety) === null || _248 === void 0 ? void 0 : _248.value) !== null && _249 !== void 0 ? _249 : '',
                values: (_251 = (_250 = params.properties.injuredSeverety) === null || _250 === void 0 ? void 0 : _250.values) !== null && _251 !== void 0 ? _251 : [],
                defaultValue: 'injuredSeverety',
                possibleValues: null,
            }, injuredActivity: {
                value: (_253 = (_252 = params.properties.injuredActivity) === null || _252 === void 0 ? void 0 : _252.value) !== null && _253 !== void 0 ? _253 : '',
                values: (_255 = (_254 = params.properties.injuredActivity) === null || _254 === void 0 ? void 0 : _254.values) !== null && _255 !== void 0 ? _255 : [],
                defaultValue: 'injuredActivity',
                possibleValues: null,
            }, glassExpensesDescription: {
                value: (_257 = (_256 = params.properties.glassExpensesDescription) === null || _256 === void 0 ? void 0 : _256.value) !== null && _257 !== void 0 ? _257 : '',
                values: (_259 = (_258 = params.properties.glassExpensesDescription) === null || _258 === void 0 ? void 0 : _258.values) !== null && _259 !== void 0 ? _259 : [],
                defaultValue: '[glassExpensesDescription]',
                possibleValues: null,
            }, otherExpensesDescription: {
                value: (_261 = (_260 = params.properties.otherExpensesDescription) === null || _260 === void 0 ? void 0 : _260.value) !== null && _261 !== void 0 ? _261 : '',
                values: (_263 = (_262 = params.properties.otherExpensesDescription) === null || _262 === void 0 ? void 0 : _262.values) !== null && _263 !== void 0 ? _263 : [],
                defaultValue: '[otherExpensesDescription]',
                possibleValues: null,
            }, secureStorageNode: {
                value: (_265 = (_264 = params.properties.secureStorageNode) === null || _264 === void 0 ? void 0 : _264.value) !== null && _265 !== void 0 ? _265 : '',
                values: (_267 = (_266 = params.properties.secureStorageNode) === null || _266 === void 0 ? void 0 : _266.values) !== null && _267 !== void 0 ? _267 : [],
                defaultValue: '[secureStorageNode]',
                possibleValues: null,
            }, submissionChannel: {
                value: (_269 = (_268 = params.properties.submissionChannel) === null || _268 === void 0 ? void 0 : _268.value) !== null && _269 !== void 0 ? _269 : '',
                values: (_271 = (_270 = params.properties.submissionChannel) === null || _270 === void 0 ? void 0 : _270.values) !== null && _271 !== void 0 ? _271 : [],
                defaultValue: 'IfLogin',
                possibleValues: null,
            }, summary: {
                value: (_273 = (_272 = params.properties.summary) === null || _272 === void 0 ? void 0 : _272.value) !== null && _273 !== void 0 ? _273 : '',
                values: (_275 = (_274 = params.properties.summary) === null || _274 === void 0 ? void 0 : _274.values) !== null && _275 !== void 0 ? _275 : [],
                defaultValue: '[XXXXX.summaryContentOutput]',
                possibleValues: null,
            }, useValueAddedTax: {
                value: (_277 = (_276 = params.properties.useValueAddedTax) === null || _276 === void 0 ? void 0 : _276.value) !== null && _277 !== void 0 ? _277 : '',
                values: (_279 = (_278 = params.properties.useValueAddedTax) === null || _278 === void 0 ? void 0 : _278.values) !== null && _279 !== void 0 ? _279 : [],
                defaultValue: '[useValueAddedTax]',
                possibleValues: null,
            }, attachments: {
                value: (_281 = (_280 = params.properties.attachments) === null || _280 === void 0 ? void 0 : _280.value) !== null && _281 !== void 0 ? _281 : '',
                values: (_283 = (_282 = params.properties.attachments) === null || _282 === void 0 ? void 0 : _282.values) !== null && _283 !== void 0 ? _283 : [],
                defaultValue: '',
                possibleValues: null,
            }, companyId: {
                value: (_285 = (_284 = params.properties.companyId) === null || _284 === void 0 ? void 0 : _284.value) !== null && _285 !== void 0 ? _285 : '',
                values: (_287 = (_286 = params.properties.companyId) === null || _286 === void 0 ? void 0 : _286.values) !== null && _287 !== void 0 ? _287 : [],
                defaultValue: '',
                possibleValues: null,
            }, companyName: {
                value: (_289 = (_288 = params.properties.companyName) === null || _288 === void 0 ? void 0 : _288.value) !== null && _289 !== void 0 ? _289 : '',
                values: (_291 = (_290 = params.properties.companyName) === null || _290 === void 0 ? void 0 : _290.values) !== null && _291 !== void 0 ? _291 : [],
                defaultValue: '',
                possibleValues: null,
            }, otherCosts: {
                value: (_293 = (_292 = params.properties.otherCosts) === null || _292 === void 0 ? void 0 : _292.value) !== null && _293 !== void 0 ? _293 : '',
                values: (_295 = (_294 = params.properties.otherCosts) === null || _294 === void 0 ? void 0 : _294.values) !== null && _295 !== void 0 ? _295 : [],
                defaultValue: '',
                possibleValues: null,
            }, towingCostsSum: {
                value: (_297 = (_296 = params.properties.towingCostsSum) === null || _296 === void 0 ? void 0 : _296.value) !== null && _297 !== void 0 ? _297 : '',
                values: (_299 = (_298 = params.properties.towingCostsSum) === null || _298 === void 0 ? void 0 : _298.values) !== null && _299 !== void 0 ? _299 : [],
                defaultValue: '[towingCostsSum]',
                possibleValues: null,
            }, towingCostsDescription: {
                value: (_301 = (_300 = params.properties.towingCostsDescription) === null || _300 === void 0 ? void 0 : _300.value) !== null && _301 !== void 0 ? _301 : '',
                values: (_303 = (_302 = params.properties.towingCostsDescription) === null || _302 === void 0 ? void 0 : _302.values) !== null && _303 !== void 0 ? _303 : [],
                defaultValue: '[towingCostsDescription]',
                possibleValues: null,
            }, towingVatAmount: {
                value: (_305 = (_304 = params.properties.towingVatAmount) === null || _304 === void 0 ? void 0 : _304.value) !== null && _305 !== void 0 ? _305 : '',
                values: (_307 = (_306 = params.properties.towingVatAmount) === null || _306 === void 0 ? void 0 : _306.values) !== null && _307 !== void 0 ? _307 : [],
                defaultValue: '[towingVatAmount]',
                possibleValues: null,
            }, claimNumber: {
                value: (_309 = (_308 = params.properties.claimNumber) === null || _308 === void 0 ? void 0 : _308.value) !== null && _309 !== void 0 ? _309 : '',
                values: (_311 = (_310 = params.properties.claimNumber) === null || _310 === void 0 ? void 0 : _310.values) !== null && _311 !== void 0 ? _311 : [],
                defaultValue: '[claimNumber]',
                possibleValues: null,
            }, glassCompensationType: {
                value: (_313 = (_312 = params.properties.glassCompensationType) === null || _312 === void 0 ? void 0 : _312.value) !== null && _313 !== void 0 ? _313 : '',
                values: (_315 = (_314 = params.properties.glassCompensationType) === null || _314 === void 0 ? void 0 : _314.values) !== null && _315 !== void 0 ? _315 : [],
                defaultValue: '',
                possibleValues: null,
            }, glassCostsSum: {
                value: (_317 = (_316 = params.properties.glassCostsSum) === null || _316 === void 0 ? void 0 : _316.value) !== null && _317 !== void 0 ? _317 : '',
                values: (_319 = (_318 = params.properties.glassCostsSum) === null || _318 === void 0 ? void 0 : _318.values) !== null && _319 !== void 0 ? _319 : [],
                defaultValue: '',
                possibleValues: null,
            }, glassCostsDescription: {
                value: (_321 = (_320 = params.properties.glassCostsDescription) === null || _320 === void 0 ? void 0 : _320.value) !== null && _321 !== void 0 ? _321 : '',
                values: (_323 = (_322 = params.properties.glassCostsDescription) === null || _322 === void 0 ? void 0 : _322.values) !== null && _323 !== void 0 ? _323 : [],
                defaultValue: '',
                possibleValues: null,
            }, glassVatAmount: {
                value: (_325 = (_324 = params.properties.glassVatAmount) === null || _324 === void 0 ? void 0 : _324.value) !== null && _325 !== void 0 ? _325 : '',
                values: (_327 = (_326 = params.properties.glassVatAmount) === null || _326 === void 0 ? void 0 : _326.values) !== null && _327 !== void 0 ? _327 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_329 = (_328 = params.properties.defaultValidationMessage) === null || _328 === void 0 ? void 0 : _328.value) !== null && _329 !== void 0 ? _329 : '',
                values: (_331 = (_330 = params.properties.defaultValidationMessage) === null || _330 === void 0 ? void 0 : _330.values) !== null && _331 !== void 0 ? _331 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Finland_SummaryNode extends BaseNode {
}
export class Finland_Motor_GetPoliciesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { ssn: {
                value: (_b = (_a = params.properties.ssn) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.ssn) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDate: {
                value: (_f = (_e = params.properties.incidentDate) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.incidentDate) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_k = (_j = params.properties.defaultValidationMessage) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.defaultValidationMessage) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'customerData',
                possibleValues: []
            }, {
                name: 'vehiclesData',
                possibleValues: []
            }, {
                name: 'PhoneNumber',
                possibleValues: []
            }, {
                name: 'Email',
                possibleValues: []
            }, {
                name: 'IsUsingMyPages',
                possibleValues: []
            }
        ];
    }
}
export class Finland_InputCityNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { inputPlaceholder: {
                value: (_b = (_a = params.properties.inputPlaceholder) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.inputPlaceholder) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, noResultsFoundMessage: {
                value: (_f = (_e = params.properties.noResultsFoundMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.noResultsFoundMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, allowAnyValue: {
                value: (_k = (_j = params.properties.allowAnyValue) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.allowAnyValue) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'code',
                possibleValues: []
            }, {
                name: 'text',
                possibleValues: []
            }
        ];
    }
}
export class Finland_MyPagesAuthenticationNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { secureStorageId: {
                value: (_b = (_a = params.properties.secureStorageId) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.secureStorageId) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, useAsAuthorization: {
                value: (_f = (_e = params.properties.useAsAuthorization) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.useAsAuthorization) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: 'false',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_k = (_j = params.properties.defaultValidationMessage) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.defaultValidationMessage) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'ssn',
                possibleValues: []
            }, {
                name: 'name',
                possibleValues: []
            }, {
                name: 'surname',
                possibleValues: []
            }, {
                name: 'nameSurname',
                possibleValues: []
            }, {
                name: 'country',
                possibleValues: []
            }, {
                name: 'bankName',
                possibleValues: []
            }, {
                name: 'authTimestamp',
                possibleValues: []
            }, {
                name: 'AuthorizedUser',
                possibleValues: []
            }
        ];
    }
}
export class Finland_InputBankAccountNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { defaultValidationMessage: {
                value: (_b = (_a = params.properties.defaultValidationMessage) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.defaultValidationMessage) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, toUpperCase: {
                value: (_f = (_e = params.properties.toUpperCase) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.toUpperCase) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, removeWhiteSpaces: {
                value: (_k = (_j = params.properties.removeWhiteSpaces) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.removeWhiteSpaces) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, placeholder: {
                value: (_p = (_o = params.properties.placeholder) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.placeholder) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, maxLengthValidationMessage: {
                value: (_t = (_s = params.properties.maxLengthValidationMessage) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.maxLengthValidationMessage) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'iban',
                possibleValues: []
            }
        ];
    }
}
export class Finland_Motor_InputPostalCodeNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { inputPlaceholder: {
                value: (_b = (_a = params.properties.inputPlaceholder) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.inputPlaceholder) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, noResultsFoundMessage: {
                value: (_f = (_e = params.properties.noResultsFoundMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.noResultsFoundMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, allowAnyValue: {
                value: (_k = (_j = params.properties.allowAnyValue) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.allowAnyValue) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'code',
                possibleValues: []
            }, {
                name: 'text',
                possibleValues: []
            }
        ];
    }
}
export class Finland_MTPL_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { firstName: {
                value: (_b = (_a = params.properties.firstName) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.firstName) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, lastName: {
                value: (_f = (_e = params.properties.lastName) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.lastName) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, customerSsn: {
                value: (_k = (_j = params.properties.customerSsn) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.customerSsn) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, customerNumber: {
                value: (_p = (_o = params.properties.customerNumber) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.customerNumber) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, paymentDate: {
                value: (_t = (_s = params.properties.paymentDate) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.paymentDate) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, accidentDate: {
                value: (_x = (_w = params.properties.accidentDate) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.accidentDate) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, customerEmail: {
                value: (_1 = (_0 = params.properties.customerEmail) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.customerEmail) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, customerPhoneNumber: {
                value: (_5 = (_4 = params.properties.customerPhoneNumber) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.customerPhoneNumber) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, summary: {
                value: (_9 = (_8 = params.properties.summary) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.summary) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '[XXXXX.summaryContentOutput]',
                possibleValues: null,
            }, claimNumber: {
                value: (_13 = (_12 = params.properties.claimNumber) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.claimNumber) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyNumber: {
                value: (_17 = (_16 = params.properties.policyNumber) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.policyNumber) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, licenseNumber: {
                value: (_21 = (_20 = params.properties.licenseNumber) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.licenseNumber) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, vAHAClaimIdentifier: {
                value: (_25 = (_24 = params.properties.vAHAClaimIdentifier) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.vAHAClaimIdentifier) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, sAJPolicyNumber: {
                value: (_29 = (_28 = params.properties.sAJPolicyNumber) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.sAJPolicyNumber) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            }, documentType: {
                value: (_33 = (_32 = params.properties.documentType) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.documentType) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimType: {
                value: (_37 = (_36 = params.properties.claimType) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.claimType) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_41 = (_40 = params.properties.defaultValidationMessage) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.defaultValidationMessage) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Finland_SilentAuthenticationNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { defaultValidationMessage: {
                value: (_b = (_a = params.properties.defaultValidationMessage) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.defaultValidationMessage) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'ssn',
                possibleValues: []
            }, {
                name: 'name',
                possibleValues: []
            }, {
                name: 'surname',
                possibleValues: []
            }, {
                name: 'nameSurname',
                possibleValues: []
            }, {
                name: 'country',
                possibleValues: []
            }, {
                name: 'bankName',
                possibleValues: []
            }, {
                name: 'authTimestamp',
                possibleValues: []
            }, {
                name: 'AuthorizedUser',
                possibleValues: []
            }
        ];
    }
}
export class Sweden_AuthenticationNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { loginButton: {
                value: (_b = (_a = params.properties.loginButton) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.loginButton) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: 'Swedish BankId',
                possibleValues: null,
            }, loginMobileButton: {
                value: (_f = (_e = params.properties.loginMobileButton) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.loginMobileButton) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: 'BankID mobile',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_k = (_j = params.properties.defaultValidationMessage) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.defaultValidationMessage) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'ssn',
                possibleValues: []
            }, {
                name: 'name',
                possibleValues: []
            }, {
                name: 'surname',
                possibleValues: []
            }, {
                name: 'nameSurname',
                possibleValues: []
            }, {
                name: 'country',
                possibleValues: []
            }, {
                name: 'bankName',
                possibleValues: []
            }, {
                name: 'authTimestamp',
                possibleValues: []
            }, {
                name: 'AuthorizedUser',
                possibleValues: []
            }
        ];
    }
}
export class Sweden_Motor_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143, _144, _145, _146, _147, _148, _149, _150, _151, _152, _153, _154, _155, _156, _157, _158, _159, _160, _161, _162, _163, _164, _165, _166, _167, _168, _169, _170, _171, _172, _173, _174, _175, _176, _177, _178, _179, _180, _181, _182, _183, _184, _185, _186, _187, _188, _189, _190, _191, _192, _193, _194, _195, _196, _197, _198, _199, _200, _201, _202, _203, _204, _205, _206, _207, _208, _209, _210, _211, _212, _213, _214, _215, _216, _217, _218, _219, _220, _221, _222, _223, _224, _225, _226, _227, _228, _229, _230, _231, _232, _233, _234, _235, _236, _237, _238, _239, _240, _241, _242, _243;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { sSNDriver: {
                value: (_b = (_a = params.properties.sSNDriver) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.sSNDriver) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, authorizedUserNode: {
                value: (_f = (_e = params.properties.authorizedUserNode) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.authorizedUserNode) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, customerInformationNode: {
                value: (_k = (_j = params.properties.customerInformationNode) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.customerInformationNode) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, enteredPolicyNumber: {
                value: (_p = (_o = params.properties.enteredPolicyNumber) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.enteredPolicyNumber) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '[PolicyNumber]',
                possibleValues: null,
            }, enteredRegistrationNumber: {
                value: (_t = (_s = params.properties.enteredRegistrationNumber) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.enteredRegistrationNumber) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '[VehicleRegistrationNumber]',
                possibleValues: null,
            }, policyInformatioNode: {
                value: (_x = (_w = params.properties.policyInformatioNode) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.policyInformatioNode) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDate: {
                value: (_1 = (_0 = params.properties.incidentDate) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.incidentDate) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '[IncidentDate]',
                possibleValues: null,
            }, incidentTime: {
                value: (_5 = (_4 = params.properties.incidentTime) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.incidentTime) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '[IncidentTime]',
                possibleValues: null,
            }, incidentCountry: {
                value: (_9 = (_8 = params.properties.incidentCountry) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.incidentCountry) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '[IncidentCountry]',
                possibleValues: null,
            }, damagedSide: {
                value: (_13 = (_12 = params.properties.damagedSide) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.damagedSide) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '[DamagedSide]',
                possibleValues: null,
            }, involvedRegistrationNumber: {
                value: (_17 = (_16 = params.properties.involvedRegistrationNumber) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.involvedRegistrationNumber) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '[involvedRegistrationNumber]',
                possibleValues: null,
            }, injuredAnimalType: {
                value: (_21 = (_20 = params.properties.injuredAnimalType) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.injuredAnimalType) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '[AnimalInjuredType]',
                possibleValues: null,
            }, vehicleIsTowed: {
                value: (_25 = (_24 = params.properties.vehicleIsTowed) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.vehicleIsTowed) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '[WehicleIsTowed]',
                possibleValues: null,
            }, vehicleCurrentLocationType: {
                value: (_29 = (_28 = params.properties.vehicleCurrentLocationType) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.vehicleCurrentLocationType) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '[VehicleCurrentLocationType]',
                possibleValues: null,
            }, customerEmail: {
                value: (_33 = (_32 = params.properties.customerEmail) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.customerEmail) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '[CustomerEmail]',
                possibleValues: null,
            }, customerPhone: {
                value: (_37 = (_36 = params.properties.customerPhone) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.customerPhone) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '[CustomerPhone]',
                possibleValues: null,
            }, policeWasInformed: {
                value: (_41 = (_40 = params.properties.policeWasInformed) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.policeWasInformed) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimTypeWaypoint: {
                value: (_45 = (_44 = params.properties.claimTypeWaypoint) === null || _44 === void 0 ? void 0 : _44.value) !== null && _45 !== void 0 ? _45 : '',
                values: (_47 = (_46 = params.properties.claimTypeWaypoint) === null || _46 === void 0 ? void 0 : _46.values) !== null && _47 !== void 0 ? _47 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDescription: {
                value: (_49 = (_48 = params.properties.incidentDescription) === null || _48 === void 0 ? void 0 : _48.value) !== null && _49 !== void 0 ? _49 : '',
                values: (_51 = (_50 = params.properties.incidentDescription) === null || _50 === void 0 ? void 0 : _50.values) !== null && _51 !== void 0 ? _51 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentLocation: {
                value: (_53 = (_52 = params.properties.incidentLocation) === null || _52 === void 0 ? void 0 : _52.value) !== null && _53 !== void 0 ? _53 : '',
                values: (_55 = (_54 = params.properties.incidentLocation) === null || _54 === void 0 ? void 0 : _54.values) !== null && _55 !== void 0 ? _55 : [],
                defaultValue: '',
                possibleValues: null,
            }, wasCollisionWithAnimal: {
                value: (_57 = (_56 = params.properties.wasCollisionWithAnimal) === null || _56 === void 0 ? void 0 : _56.value) !== null && _57 !== void 0 ? _57 : '',
                values: (_59 = (_58 = params.properties.wasCollisionWithAnimal) === null || _58 === void 0 ? void 0 : _58.values) !== null && _59 !== void 0 ? _59 : [],
                defaultValue: '',
                possibleValues: null,
            }, isDriverForeign: {
                value: (_61 = (_60 = params.properties.isDriverForeign) === null || _60 === void 0 ? void 0 : _60.value) !== null && _61 !== void 0 ? _61 : '',
                values: (_63 = (_62 = params.properties.isDriverForeign) === null || _62 === void 0 ? void 0 : _62.values) !== null && _63 !== void 0 ? _63 : [],
                defaultValue: '',
                possibleValues: null,
            }, policeReferenceNumber: {
                value: (_65 = (_64 = params.properties.policeReferenceNumber) === null || _64 === void 0 ? void 0 : _64.value) !== null && _65 !== void 0 ? _65 : '',
                values: (_67 = (_66 = params.properties.policeReferenceNumber) === null || _66 === void 0 ? void 0 : _66.values) !== null && _67 !== void 0 ? _67 : [],
                defaultValue: '',
                possibleValues: null,
            }, injuredPersonNode: {
                value: (_69 = (_68 = params.properties.injuredPersonNode) === null || _68 === void 0 ? void 0 : _68.value) !== null && _69 !== void 0 ? _69 : '',
                values: (_71 = (_70 = params.properties.injuredPersonNode) === null || _70 === void 0 ? void 0 : _70.values) !== null && _71 !== void 0 ? _71 : [],
                defaultValue: '',
                possibleValues: null,
            }, injuredPersonType: {
                value: (_73 = (_72 = params.properties.injuredPersonType) === null || _72 === void 0 ? void 0 : _72.value) !== null && _73 !== void 0 ? _73 : '',
                values: (_75 = (_74 = params.properties.injuredPersonType) === null || _74 === void 0 ? void 0 : _74.values) !== null && _75 !== void 0 ? _75 : [],
                defaultValue: '',
                possibleValues: null,
            }, severityOfInjuries: {
                value: (_77 = (_76 = params.properties.severityOfInjuries) === null || _76 === void 0 ? void 0 : _76.value) !== null && _77 !== void 0 ? _77 : '',
                values: (_79 = (_78 = params.properties.severityOfInjuries) === null || _78 === void 0 ? void 0 : _78.values) !== null && _79 !== void 0 ? _79 : [],
                defaultValue: '',
                possibleValues: null,
            }, injuredSSN: {
                value: (_81 = (_80 = params.properties.injuredSSN) === null || _80 === void 0 ? void 0 : _80.value) !== null && _81 !== void 0 ? _81 : '',
                values: (_83 = (_82 = params.properties.injuredSSN) === null || _82 === void 0 ? void 0 : _82.values) !== null && _83 !== void 0 ? _83 : [],
                defaultValue: '',
                possibleValues: null,
            }, injuredName: {
                value: (_85 = (_84 = params.properties.injuredName) === null || _84 === void 0 ? void 0 : _84.value) !== null && _85 !== void 0 ? _85 : '',
                values: (_87 = (_86 = params.properties.injuredName) === null || _86 === void 0 ? void 0 : _86.values) !== null && _87 !== void 0 ? _87 : [],
                defaultValue: '',
                possibleValues: null,
            }, animalOwnerSsn: {
                value: (_89 = (_88 = params.properties.animalOwnerSsn) === null || _88 === void 0 ? void 0 : _88.value) !== null && _89 !== void 0 ? _89 : '',
                values: (_91 = (_90 = params.properties.animalOwnerSsn) === null || _90 === void 0 ? void 0 : _90.values) !== null && _91 !== void 0 ? _91 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterName: {
                value: (_93 = (_92 = params.properties.reporterName) === null || _92 === void 0 ? void 0 : _92.value) !== null && _93 !== void 0 ? _93 : '',
                values: (_95 = (_94 = params.properties.reporterName) === null || _94 === void 0 ? void 0 : _94.values) !== null && _95 !== void 0 ? _95 : [],
                defaultValue: '[reporterName]',
                possibleValues: null,
            }, reporterSsn: {
                value: (_97 = (_96 = params.properties.reporterSsn) === null || _96 === void 0 ? void 0 : _96.value) !== null && _97 !== void 0 ? _97 : '',
                values: (_99 = (_98 = params.properties.reporterSsn) === null || _98 === void 0 ? void 0 : _98.values) !== null && _99 !== void 0 ? _99 : [],
                defaultValue: '[reporterSsn]',
                possibleValues: null,
            }, reporterPhone: {
                value: (_101 = (_100 = params.properties.reporterPhone) === null || _100 === void 0 ? void 0 : _100.value) !== null && _101 !== void 0 ? _101 : '',
                values: (_103 = (_102 = params.properties.reporterPhone) === null || _102 === void 0 ? void 0 : _102.values) !== null && _103 !== void 0 ? _103 : [],
                defaultValue: '[reporterPhone]',
                possibleValues: null,
            }, reporterEmail: {
                value: (_105 = (_104 = params.properties.reporterEmail) === null || _104 === void 0 ? void 0 : _104.value) !== null && _105 !== void 0 ? _105 : '',
                values: (_107 = (_106 = params.properties.reporterEmail) === null || _106 === void 0 ? void 0 : _106.values) !== null && _107 !== void 0 ? _107 : [],
                defaultValue: '[reporterEmail]',
                possibleValues: null,
            }, reporterIsPolicyHolder: {
                value: (_109 = (_108 = params.properties.reporterIsPolicyHolder) === null || _108 === void 0 ? void 0 : _108.value) !== null && _109 !== void 0 ? _109 : '',
                values: (_111 = (_110 = params.properties.reporterIsPolicyHolder) === null || _110 === void 0 ? void 0 : _110.values) !== null && _111 !== void 0 ? _111 : [],
                defaultValue: '[reporterIsPolicyHolderProperty]',
                possibleValues: null,
            }, incidentTypeDescription: {
                value: (_113 = (_112 = params.properties.incidentTypeDescription) === null || _112 === void 0 ? void 0 : _112.value) !== null && _113 !== void 0 ? _113 : '',
                values: (_115 = (_114 = params.properties.incidentTypeDescription) === null || _114 === void 0 ? void 0 : _114.values) !== null && _115 !== void 0 ? _115 : [],
                defaultValue: '[incidentTypeDescription]',
                possibleValues: null,
            }, collisionTypeDescription: {
                value: (_117 = (_116 = params.properties.collisionTypeDescription) === null || _116 === void 0 ? void 0 : _116.value) !== null && _117 !== void 0 ? _117 : '',
                values: (_119 = (_118 = params.properties.collisionTypeDescription) === null || _118 === void 0 ? void 0 : _118.values) !== null && _119 !== void 0 ? _119 : [],
                defaultValue: '[collisionTypeDescription]',
                possibleValues: null,
            }, injuredAnimalTypeWaypoint: {
                value: (_121 = (_120 = params.properties.injuredAnimalTypeWaypoint) === null || _120 === void 0 ? void 0 : _120.value) !== null && _121 !== void 0 ? _121 : '',
                values: (_123 = (_122 = params.properties.injuredAnimalTypeWaypoint) === null || _122 === void 0 ? void 0 : _122.values) !== null && _123 !== void 0 ? _123 : [],
                defaultValue: '[injuredAnimalTypeWaypoint]',
                possibleValues: null,
            }, damagesToOwnCar: {
                value: (_125 = (_124 = params.properties.damagesToOwnCar) === null || _124 === void 0 ? void 0 : _124.value) !== null && _125 !== void 0 ? _125 : '',
                values: (_127 = (_126 = params.properties.damagesToOwnCar) === null || _126 === void 0 ? void 0 : _126.values) !== null && _127 !== void 0 ? _127 : [],
                defaultValue: '[damagesToOwnCar]',
                possibleValues: null,
            }, reporterRole: {
                value: (_129 = (_128 = params.properties.reporterRole) === null || _128 === void 0 ? void 0 : _128.value) !== null && _129 !== void 0 ? _129 : '',
                values: (_131 = (_130 = params.properties.reporterRole) === null || _130 === void 0 ? void 0 : _130.values) !== null && _131 !== void 0 ? _131 : [],
                defaultValue: '[reporterRole]',
                possibleValues: null,
            }, incidentTypeCode: {
                value: (_133 = (_132 = params.properties.incidentTypeCode) === null || _132 === void 0 ? void 0 : _132.value) !== null && _133 !== void 0 ? _133 : '',
                values: (_135 = (_134 = params.properties.incidentTypeCode) === null || _134 === void 0 ? void 0 : _134.values) !== null && _135 !== void 0 ? _135 : [],
                defaultValue: '[IncidentTypeCode]',
                possibleValues: null,
            }, policyHolderContactEmail: {
                value: (_137 = (_136 = params.properties.policyHolderContactEmail) === null || _136 === void 0 ? void 0 : _136.value) !== null && _137 !== void 0 ? _137 : '',
                values: (_139 = (_138 = params.properties.policyHolderContactEmail) === null || _138 === void 0 ? void 0 : _138.values) !== null && _139 !== void 0 ? _139 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyHolderContactPhone: {
                value: (_141 = (_140 = params.properties.policyHolderContactPhone) === null || _140 === void 0 ? void 0 : _140.value) !== null && _141 !== void 0 ? _141 : '',
                values: (_143 = (_142 = params.properties.policyHolderContactPhone) === null || _142 === void 0 ? void 0 : _142.values) !== null && _143 !== void 0 ? _143 : [],
                defaultValue: '',
                possibleValues: null,
            }, hasWitness: {
                value: (_145 = (_144 = params.properties.hasWitness) === null || _144 === void 0 ? void 0 : _144.value) !== null && _145 !== void 0 ? _145 : '',
                values: (_147 = (_146 = params.properties.hasWitness) === null || _146 === void 0 ? void 0 : _146.values) !== null && _147 !== void 0 ? _147 : [],
                defaultValue: '',
                possibleValues: null,
            }, propertyOwnerOtherProperty: {
                value: (_149 = (_148 = params.properties.propertyOwnerOtherProperty) === null || _148 === void 0 ? void 0 : _148.value) !== null && _149 !== void 0 ? _149 : '',
                values: (_151 = (_150 = params.properties.propertyOwnerOtherProperty) === null || _150 === void 0 ? void 0 : _150.values) !== null && _151 !== void 0 ? _151 : [],
                defaultValue: '',
                possibleValues: null,
            }, vehicleTypeDescription: {
                value: (_153 = (_152 = params.properties.vehicleTypeDescription) === null || _152 === void 0 ? void 0 : _152.value) !== null && _153 !== void 0 ? _153 : '',
                values: (_155 = (_154 = params.properties.vehicleTypeDescription) === null || _154 === void 0 ? void 0 : _154.values) !== null && _155 !== void 0 ? _155 : [],
                defaultValue: '',
                possibleValues: null,
            }, isAnythingElseDamaged: {
                value: (_157 = (_156 = params.properties.isAnythingElseDamaged) === null || _156 === void 0 ? void 0 : _156.value) !== null && _157 !== void 0 ? _157 : '',
                values: (_159 = (_158 = params.properties.isAnythingElseDamaged) === null || _158 === void 0 ? void 0 : _158.values) !== null && _159 !== void 0 ? _159 : [],
                defaultValue: '',
                possibleValues: null,
            }, hasAnythingElseToTell: {
                value: (_161 = (_160 = params.properties.hasAnythingElseToTell) === null || _160 === void 0 ? void 0 : _160.value) !== null && _161 !== void 0 ? _161 : '',
                values: (_163 = (_162 = params.properties.hasAnythingElseToTell) === null || _162 === void 0 ? void 0 : _162.values) !== null && _163 !== void 0 ? _163 : [],
                defaultValue: '',
                possibleValues: null,
            }, witnessesNode: {
                value: (_165 = (_164 = params.properties.witnessesNode) === null || _164 === void 0 ? void 0 : _164.value) !== null && _165 !== void 0 ? _165 : '',
                values: (_167 = (_166 = params.properties.witnessesNode) === null || _166 === void 0 ? void 0 : _166.values) !== null && _167 !== void 0 ? _167 : [],
                defaultValue: '',
                possibleValues: null,
            }, witnessRoleCode: {
                value: (_169 = (_168 = params.properties.witnessRoleCode) === null || _168 === void 0 ? void 0 : _168.value) !== null && _169 !== void 0 ? _169 : '',
                values: (_171 = (_170 = params.properties.witnessRoleCode) === null || _170 === void 0 ? void 0 : _170.values) !== null && _171 !== void 0 ? _171 : [],
                defaultValue: '',
                possibleValues: null,
            }, witnessIncidentDescription: {
                value: (_173 = (_172 = params.properties.witnessIncidentDescription) === null || _172 === void 0 ? void 0 : _172.value) !== null && _173 !== void 0 ? _173 : '',
                values: (_175 = (_174 = params.properties.witnessIncidentDescription) === null || _174 === void 0 ? void 0 : _174.values) !== null && _175 !== void 0 ? _175 : [],
                defaultValue: '',
                possibleValues: null,
            }, vehicleRegistrationCountryCode: {
                value: (_177 = (_176 = params.properties.vehicleRegistrationCountryCode) === null || _176 === void 0 ? void 0 : _176.value) !== null && _177 !== void 0 ? _177 : '',
                values: (_179 = (_178 = params.properties.vehicleRegistrationCountryCode) === null || _178 === void 0 ? void 0 : _178.values) !== null && _179 !== void 0 ? _179 : [],
                defaultValue: '',
                possibleValues: null,
            }, vehicleType: {
                value: (_181 = (_180 = params.properties.vehicleType) === null || _180 === void 0 ? void 0 : _180.value) !== null && _181 !== void 0 ? _181 : '',
                values: (_183 = (_182 = params.properties.vehicleType) === null || _182 === void 0 ? void 0 : _182.values) !== null && _183 !== void 0 ? _183 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantRoleCode: {
                value: (_185 = (_184 = params.properties.claimantRoleCode) === null || _184 === void 0 ? void 0 : _184.value) !== null && _185 !== void 0 ? _185 : '',
                values: (_187 = (_186 = params.properties.claimantRoleCode) === null || _186 === void 0 ? void 0 : _186.values) !== null && _187 !== void 0 ? _187 : [],
                defaultValue: '',
                possibleValues: null,
            }, partyNumber: {
                value: (_189 = (_188 = params.properties.partyNumber) === null || _188 === void 0 ? void 0 : _188.value) !== null && _189 !== void 0 ? _189 : '',
                values: (_191 = (_190 = params.properties.partyNumber) === null || _190 === void 0 ? void 0 : _190.values) !== null && _191 !== void 0 ? _191 : [],
                defaultValue: '',
                possibleValues: null,
            }, organisationNumber: {
                value: (_193 = (_192 = params.properties.organisationNumber) === null || _192 === void 0 ? void 0 : _192.value) !== null && _193 !== void 0 ? _193 : '',
                values: (_195 = (_194 = params.properties.organisationNumber) === null || _194 === void 0 ? void 0 : _194.values) !== null && _195 !== void 0 ? _195 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyHolderBankAccountNr: {
                value: (_197 = (_196 = params.properties.policyHolderBankAccountNr) === null || _196 === void 0 ? void 0 : _196.value) !== null && _197 !== void 0 ? _197 : '',
                values: (_199 = (_198 = params.properties.policyHolderBankAccountNr) === null || _198 === void 0 ? void 0 : _198.values) !== null && _199 !== void 0 ? _199 : [],
                defaultValue: '',
                possibleValues: null,
            }, needOfRentalCar: {
                value: (_201 = (_200 = params.properties.needOfRentalCar) === null || _200 === void 0 ? void 0 : _200.value) !== null && _201 !== void 0 ? _201 : '',
                values: (_203 = (_202 = params.properties.needOfRentalCar) === null || _202 === void 0 ? void 0 : _202.values) !== null && _203 !== void 0 ? _203 : [],
                defaultValue: '',
                possibleValues: null,
            }, businessArea: {
                value: (_205 = (_204 = params.properties.businessArea) === null || _204 === void 0 ? void 0 : _204.value) !== null && _205 !== void 0 ? _205 : '',
                values: (_207 = (_206 = params.properties.businessArea) === null || _206 === void 0 ? void 0 : _206.values) !== null && _207 !== void 0 ? _207 : [],
                defaultValue: '[BusinessArea]',
                possibleValues: null,
            }, pullingVehicleRegistrationNumber: {
                value: (_209 = (_208 = params.properties.pullingVehicleRegistrationNumber) === null || _208 === void 0 ? void 0 : _208.value) !== null && _209 !== void 0 ? _209 : '',
                values: (_211 = (_210 = params.properties.pullingVehicleRegistrationNumber) === null || _210 === void 0 ? void 0 : _210.values) !== null && _211 !== void 0 ? _211 : [],
                defaultValue: '',
                possibleValues: null,
            }, alarmActivatedIndicator: {
                value: (_213 = (_212 = params.properties.alarmActivatedIndicator) === null || _212 === void 0 ? void 0 : _212.value) !== null && _213 !== void 0 ? _213 : '',
                values: (_215 = (_214 = params.properties.alarmActivatedIndicator) === null || _214 === void 0 ? void 0 : _214.values) !== null && _215 !== void 0 ? _215 : [],
                defaultValue: '',
                possibleValues: null,
            }, hasVehicleBeenPulled: {
                value: (_217 = (_216 = params.properties.hasVehicleBeenPulled) === null || _216 === void 0 ? void 0 : _216.value) !== null && _217 !== void 0 ? _217 : '',
                values: (_219 = (_218 = params.properties.hasVehicleBeenPulled) === null || _218 === void 0 ? void 0 : _218.values) !== null && _219 !== void 0 ? _219 : [],
                defaultValue: '',
                possibleValues: null,
            }, summaryDefiniton: {
                value: (_221 = (_220 = params.properties.summaryDefiniton) === null || _220 === void 0 ? void 0 : _220.value) !== null && _221 !== void 0 ? _221 : '',
                values: (_223 = (_222 = params.properties.summaryDefiniton) === null || _222 === void 0 ? void 0 : _222.values) !== null && _223 !== void 0 ? _223 : [],
                defaultValue: '[REPLACE_THIS.summaryContentOutput]',
                possibleValues: null,
            }, policeBreathTest: {
                value: (_225 = (_224 = params.properties.policeBreathTest) === null || _224 === void 0 ? void 0 : _224.value) !== null && _225 !== void 0 ? _225 : '',
                values: (_227 = (_226 = params.properties.policeBreathTest) === null || _226 === void 0 ? void 0 : _226.values) !== null && _227 !== void 0 ? _227 : [],
                defaultValue: '',
                possibleValues: null,
            }, policeBreathTestResult: {
                value: (_229 = (_228 = params.properties.policeBreathTestResult) === null || _228 === void 0 ? void 0 : _228.value) !== null && _229 !== void 0 ? _229 : '',
                values: (_231 = (_230 = params.properties.policeBreathTestResult) === null || _230 === void 0 ? void 0 : _230.values) !== null && _231 !== void 0 ? _231 : [],
                defaultValue: '',
                possibleValues: null,
            }, responsibility: {
                value: (_233 = (_232 = params.properties.responsibility) === null || _232 === void 0 ? void 0 : _232.value) !== null && _233 !== void 0 ? _233 : '',
                values: (_235 = (_234 = params.properties.responsibility) === null || _234 === void 0 ? void 0 : _234.values) !== null && _235 !== void 0 ? _235 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTemplate: {
                value: (_237 = (_236 = params.properties.incidentTemplate) === null || _236 === void 0 ? void 0 : _236.value) !== null && _237 !== void 0 ? _237 : '',
                values: (_239 = (_238 = params.properties.incidentTemplate) === null || _238 === void 0 ? void 0 : _238.values) !== null && _239 !== void 0 ? _239 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_241 = (_240 = params.properties.defaultValidationMessage) === null || _240 === void 0 ? void 0 : _240.value) !== null && _241 !== void 0 ? _241 : '',
                values: (_243 = (_242 = params.properties.defaultValidationMessage) === null || _242 === void 0 ? void 0 : _242.values) !== null && _243 !== void 0 ? _243 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Sweden_SummaryNode extends BaseNode {
}
export class Sweden_Motor_GetPoliciesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { incidentDate: {
                value: (_b = (_a = params.properties.incidentDate) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.incidentDate) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, vehicleRegistrationNumber: {
                value: (_f = (_e = params.properties.vehicleRegistrationNumber) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.vehicleRegistrationNumber) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, policyNumber: {
                value: (_k = (_j = params.properties.policyNumber) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.policyNumber) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, ssn: {
                value: (_p = (_o = params.properties.ssn) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.ssn) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTime: {
                value: (_t = (_s = params.properties.incidentTime) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.incidentTime) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_x = (_w = params.properties.defaultValidationMessage) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.defaultValidationMessage) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'policyData',
                possibleValues: []
            }, {
                name: 'CustomerNumber',
                possibleValues: []
            }, {
                name: 'RegistrationNumber',
                possibleValues: []
            }, {
                name: 'Brand',
                possibleValues: []
            }, {
                name: 'Model',
                possibleValues: []
            }, {
                name: 'PhoneNumber',
                possibleValues: []
            }, {
                name: 'Email',
                possibleValues: []
            }, {
                name: 'PolicyLegalNumber',
                possibleValues: []
            }, {
                name: 'PolicyType',
                possibleValues: []
            }, {
                name: 'PolicyHolderIsReporter',
                possibleValues: []
            }, {
                name: 'warrantyData',
                possibleValues: []
            }, {
                name: 'warrantyEmail',
                possibleValues: []
            }, {
                name: 'warrantyPhoneNumber',
                possibleValues: []
            }, {
                name: 'warrantySsn',
                possibleValues: []
            }, {
                name: 'PolicyHolderContactEmail',
                possibleValues: []
            }, {
                name: 'PolicyHolderContactPhone',
                possibleValues: []
            }, {
                name: 'PolicyVehicleType',
                possibleValues: []
            }, {
                name: 'HasRentalCarCoverage',
                possibleValues: []
            }, {
                name: 'BusinessArea',
                possibleValues: []
            }, {
                name: 'PolicySystemType',
                possibleValues: []
            }, {
                name: 'HasPrivateLeasingCoverage',
                possibleValues: []
            }
        ];
    }
}
export class Sweden_InputCountryNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { inputPlaceholder: {
                value: (_b = (_a = params.properties.inputPlaceholder) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.inputPlaceholder) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, noResultsFoundMessage: {
                value: (_f = (_e = params.properties.noResultsFoundMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.noResultsFoundMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, allowAnyValue: {
                value: (_k = (_j = params.properties.allowAnyValue) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.allowAnyValue) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'code',
                possibleValues: []
            }, {
                name: 'text',
                possibleValues: []
            }
        ];
    }
}
export class Sweden_Property_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { claimType: {
                value: (_b = (_a = params.properties.claimType) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.claimType) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenHtmlFileName: {
                value: (_f = (_e = params.properties.frontenHtmlFileName) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.frontenHtmlFileName) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenSummaryDefinition: {
                value: (_k = (_j = params.properties.frontenSummaryDefinition) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.frontenSummaryDefinition) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '[XXXXX.summaryContentOutput]',
                possibleValues: null,
            }, frontenBusinessArea: {
                value: (_p = (_o = params.properties.frontenBusinessArea) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.frontenBusinessArea) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenCategory: {
                value: (_t = (_s = params.properties.frontenCategory) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.frontenCategory) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenDocumentType: {
                value: (_x = (_w = params.properties.frontenDocumentType) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.frontenDocumentType) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenQueue: {
                value: (_1 = (_0 = params.properties.frontenQueue) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.frontenQueue) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, businessArea: {
                value: (_5 = (_4 = params.properties.businessArea) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.businessArea) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, customerName: {
                value: (_9 = (_8 = params.properties.customerName) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.customerName) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, customerEmail: {
                value: (_13 = (_12 = params.properties.customerEmail) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.customerEmail) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, customerPhone: {
                value: (_17 = (_16 = params.properties.customerPhone) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.customerPhone) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantRoleCode: {
                value: (_21 = (_20 = params.properties.claimantRoleCode) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.claimantRoleCode) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantSsn: {
                value: (_25 = (_24 = params.properties.claimantSsn) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.claimantSsn) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimCoverageNumber: {
                value: (_29 = (_28 = params.properties.claimCoverageNumber) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.claimCoverageNumber) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyNumber: {
                value: (_33 = (_32 = params.properties.policyNumber) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.policyNumber) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDate: {
                value: (_37 = (_36 = params.properties.incidentDate) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.incidentDate) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '',
                possibleValues: null,
            }, analysisCode: {
                value: (_41 = (_40 = params.properties.analysisCode) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.analysisCode) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '',
                possibleValues: null,
            }, skipFenixRegistration: {
                value: (_45 = (_44 = params.properties.skipFenixRegistration) === null || _44 === void 0 ? void 0 : _44.value) !== null && _45 !== void 0 ? _45 : '',
                values: (_47 = (_46 = params.properties.skipFenixRegistration) === null || _46 === void 0 ? void 0 : _46.values) !== null && _47 !== void 0 ? _47 : [],
                defaultValue: '',
                possibleValues: null,
            }, parentType: {
                value: (_49 = (_48 = params.properties.parentType) === null || _48 === void 0 ? void 0 : _48.value) !== null && _49 !== void 0 ? _49 : '',
                values: (_51 = (_50 = params.properties.parentType) === null || _50 === void 0 ? void 0 : _50.values) !== null && _51 !== void 0 ? _51 : [],
                defaultValue: '',
                possibleValues: null,
            }, stargatePayloadType: {
                value: (_53 = (_52 = params.properties.stargatePayloadType) === null || _52 === void 0 ? void 0 : _52.value) !== null && _53 !== void 0 ? _53 : '',
                values: (_55 = (_54 = params.properties.stargatePayloadType) === null || _54 === void 0 ? void 0 : _54.values) !== null && _55 !== void 0 ? _55 : [],
                defaultValue: '',
                possibleValues: null,
            }, stargateClaimType: {
                value: (_57 = (_56 = params.properties.stargateClaimType) === null || _56 === void 0 ? void 0 : _56.value) !== null && _57 !== void 0 ? _57 : '',
                values: (_59 = (_58 = params.properties.stargateClaimType) === null || _58 === void 0 ? void 0 : _58.values) !== null && _59 !== void 0 ? _59 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_61 = (_60 = params.properties.defaultValidationMessage) === null || _60 === void 0 ? void 0 : _60.value) !== null && _61 !== void 0 ? _61 : '',
                values: (_63 = (_62 = params.properties.defaultValidationMessage) === null || _62 === void 0 ? void 0 : _62.values) !== null && _63 !== void 0 ? _63 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Sweden_Property_GetPoliciesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { customerSsn: {
                value: (_b = (_a = params.properties.customerSsn) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.customerSsn) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDate: {
                value: (_f = (_e = params.properties.incidentDate) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.incidentDate) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, orderedProductParts: {
                value: (_k = (_j = params.properties.orderedProductParts) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.orderedProductParts) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, coverageTypeNumber: {
                value: (_p = (_o = params.properties.coverageTypeNumber) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.coverageTypeNumber) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_t = (_s = params.properties.defaultValidationMessage) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.defaultValidationMessage) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Sweden_PersonalInjury_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { claimType: {
                value: (_b = (_a = params.properties.claimType) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.claimType) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDate: {
                value: (_f = (_e = params.properties.incidentDate) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.incidentDate) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenSummaryDefinition: {
                value: (_k = (_j = params.properties.frontenSummaryDefinition) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.frontenSummaryDefinition) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '[XXXXX.summaryContentOutput]',
                possibleValues: null,
            }, frontenHtmlFileName: {
                value: (_p = (_o = params.properties.frontenHtmlFileName) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.frontenHtmlFileName) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenBusinessArea: {
                value: (_t = (_s = params.properties.frontenBusinessArea) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.frontenBusinessArea) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenCategory: {
                value: (_x = (_w = params.properties.frontenCategory) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.frontenCategory) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenDocumentType: {
                value: (_1 = (_0 = params.properties.frontenDocumentType) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.frontenDocumentType) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenQueue: {
                value: (_5 = (_4 = params.properties.frontenQueue) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.frontenQueue) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, businessArea: {
                value: (_9 = (_8 = params.properties.businessArea) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.businessArea) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, customerName: {
                value: (_13 = (_12 = params.properties.customerName) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.customerName) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, customerEmail: {
                value: (_17 = (_16 = params.properties.customerEmail) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.customerEmail) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, customerPhone: {
                value: (_21 = (_20 = params.properties.customerPhone) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.customerPhone) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, customerNumber: {
                value: (_25 = (_24 = params.properties.customerNumber) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.customerNumber) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_29 = (_28 = params.properties.defaultValidationMessage) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.defaultValidationMessage) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Sweden_FollowUp_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { frontenSummaryDefinition: {
                value: (_b = (_a = params.properties.frontenSummaryDefinition) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.frontenSummaryDefinition) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '[XXXXX.summaryContentOutput]',
                possibleValues: null,
            }, frontenHtmlFileName: {
                value: (_f = (_e = params.properties.frontenHtmlFileName) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.frontenHtmlFileName) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenBusinessArea: {
                value: (_k = (_j = params.properties.frontenBusinessArea) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.frontenBusinessArea) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenCategory: {
                value: (_p = (_o = params.properties.frontenCategory) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.frontenCategory) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenDocumentType: {
                value: (_t = (_s = params.properties.frontenDocumentType) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.frontenDocumentType) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenQueue: {
                value: (_x = (_w = params.properties.frontenQueue) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.frontenQueue) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, businessArea: {
                value: (_1 = (_0 = params.properties.businessArea) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.businessArea) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, lineOfBusiness: {
                value: (_5 = (_4 = params.properties.lineOfBusiness) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.lineOfBusiness) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, insuredObject: {
                value: (_9 = (_8 = params.properties.insuredObject) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.insuredObject) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, customerNumber: {
                value: (_13 = (_12 = params.properties.customerNumber) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.customerNumber) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyNumber: {
                value: (_17 = (_16 = params.properties.policyNumber) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.policyNumber) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimNumber: {
                value: (_21 = (_20 = params.properties.claimNumber) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.claimNumber) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimType: {
                value: (_25 = (_24 = params.properties.claimType) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.claimType) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, parentType: {
                value: (_29 = (_28 = params.properties.parentType) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.parentType) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimReportName: {
                value: (_33 = (_32 = params.properties.claimReportName) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.claimReportName) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenUserId: {
                value: (_37 = (_36 = params.properties.frontenUserId) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.frontenUserId) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_41 = (_40 = params.properties.defaultValidationMessage) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.defaultValidationMessage) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Sweden_SilentAuthenticationNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { defaultValidationMessage: {
                value: (_b = (_a = params.properties.defaultValidationMessage) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.defaultValidationMessage) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'ssn',
                possibleValues: []
            }, {
                name: 'name',
                possibleValues: []
            }, {
                name: 'surname',
                possibleValues: []
            }, {
                name: 'nameSurname',
                possibleValues: []
            }, {
                name: 'country',
                possibleValues: []
            }, {
                name: 'bankName',
                possibleValues: []
            }, {
                name: 'authTimestamp',
                possibleValues: []
            }, {
                name: 'AuthorizedUser',
                possibleValues: []
            }
        ];
    }
}
export class Ba_InputAttachmentNode extends BaseNode {
}
export class Ba_SendDataNode extends BaseNode {
}
export class Ba_MapNode extends BaseNode {
}
export class Ba_SummaryNode extends BaseNode {
}
export class Ba_CheckAuthenticationNode extends BaseNode {
}
export class Ba_AuthenticationNode extends BaseNode {
}
export class Ba_GetCustomerInformationNode extends BaseNode {
}
export class Ba_BankAccountNode extends BaseNode {
}
export class Ba_GetUserPoliciesNode extends BaseNode {
}
export class Ba_GetUserInsuredPersonsNode extends BaseNode {
}
export class Ba_UserInsuredPersonsNode extends BaseNode {
}
export class Ba_CustomDropdownNode extends BaseNode {
}
export class Ba_GetInsuredPersonsListNode extends BaseNode {
}
export class Ba_TotalAmountNode extends BaseNode {
}
export class Ba_GetUserVehiclesNode extends BaseNode {
}
export class Ba_UserVehiclesNode extends BaseNode {
}
export class Ba_AccidentActNode extends BaseNode {
}
export class Ba_DriverDetailsNode extends BaseNode {
}
export class Ba_SecondVehicleNode extends BaseNode {
}
export class Ba_PoliceStationNode extends BaseNode {
}
export class Ba_SteeringNode extends BaseNode {
}
export class Ba_GetUserObjectsNode extends BaseNode {
}
export class Ba_UserObjectsNode extends BaseNode {
}
export class Ba_DamagedObjectNode extends BaseNode {
}
export class Ba_GetUserPetsNode extends BaseNode {
}
export class Ba_UserPetsNode extends BaseNode {
}
export class Ba_CreditCardTypeNode extends BaseNode {
}
export class Ba_SufferedPersonsNode extends BaseNode {
}
export class Ba_TravelInputCountryNode extends BaseNode {
}
export class Denmark_Commercial_Travel_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { reporterEmail: {
                value: (_b = (_a = params.properties.reporterEmail) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.reporterEmail) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPhone: {
                value: (_f = (_e = params.properties.reporterPhone) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.reporterPhone) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterName: {
                value: (_k = (_j = params.properties.reporterName) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.reporterName) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterSurname: {
                value: (_p = (_o = params.properties.reporterSurname) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.reporterSurname) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterSsn: {
                value: (_t = (_s = params.properties.reporterSsn) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.reporterSsn) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, bankAccountNumber: {
                value: (_x = (_w = params.properties.bankAccountNumber) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.bankAccountNumber) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, travelType: {
                value: (_1 = (_0 = params.properties.travelType) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.travelType) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, cancellationCause: {
                value: (_5 = (_4 = params.properties.cancellationCause) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.cancellationCause) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyNumber: {
                value: (_9 = (_8 = params.properties.policyNumber) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.policyNumber) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantListNodeName: {
                value: (_13 = (_12 = params.properties.claimantListNodeName) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.claimantListNodeName) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantStreetNodeName: {
                value: (_17 = (_16 = params.properties.claimantStreetNodeName) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.claimantStreetNodeName) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantHouseNumberNodeName: {
                value: (_21 = (_20 = params.properties.claimantHouseNumberNodeName) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.claimantHouseNumberNodeName) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantNameNodeName: {
                value: (_25 = (_24 = params.properties.claimantNameNodeName) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.claimantNameNodeName) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantSurnameNodeName: {
                value: (_29 = (_28 = params.properties.claimantSurnameNodeName) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.claimantSurnameNodeName) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantSsnNodeName: {
                value: (_33 = (_32 = params.properties.claimantSsnNodeName) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.claimantSsnNodeName) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantPostalCodeNodeName: {
                value: (_37 = (_36 = params.properties.claimantPostalCodeNodeName) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.claimantPostalCodeNodeName) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantTypeNodeName: {
                value: (_41 = (_40 = params.properties.claimantTypeNodeName) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.claimantTypeNodeName) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantCountryNodeName: {
                value: (_45 = (_44 = params.properties.claimantCountryNodeName) === null || _44 === void 0 ? void 0 : _44.value) !== null && _45 !== void 0 ? _45 : '',
                values: (_47 = (_46 = params.properties.claimantCountryNodeName) === null || _46 === void 0 ? void 0 : _46.values) !== null && _47 !== void 0 ? _47 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimType: {
                value: (_49 = (_48 = params.properties.claimType) === null || _48 === void 0 ? void 0 : _48.value) !== null && _49 !== void 0 ? _49 : '',
                values: (_51 = (_50 = params.properties.claimType) === null || _50 === void 0 ? void 0 : _50.values) !== null && _51 !== void 0 ? _51 : [],
                defaultValue: '',
                possibleValues: null,
            }, destinationCountry: {
                value: (_53 = (_52 = params.properties.destinationCountry) === null || _52 === void 0 ? void 0 : _52.value) !== null && _53 !== void 0 ? _53 : '',
                values: (_55 = (_54 = params.properties.destinationCountry) === null || _54 === void 0 ? void 0 : _54.values) !== null && _55 !== void 0 ? _55 : [],
                defaultValue: '',
                possibleValues: null,
            }, description: {
                value: (_57 = (_56 = params.properties.description) === null || _56 === void 0 ? void 0 : _56.value) !== null && _57 !== void 0 ? _57 : '',
                values: (_59 = (_58 = params.properties.description) === null || _58 === void 0 ? void 0 : _58.values) !== null && _59 !== void 0 ? _59 : [],
                defaultValue: '',
                possibleValues: null,
            }, luggageCauseType: {
                value: (_61 = (_60 = params.properties.luggageCauseType) === null || _60 === void 0 ? void 0 : _60.value) !== null && _61 !== void 0 ? _61 : '',
                values: (_63 = (_62 = params.properties.luggageCauseType) === null || _62 === void 0 ? void 0 : _62.values) !== null && _63 !== void 0 ? _63 : [],
                defaultValue: '',
                possibleValues: null,
            }, isTheClaimDueToCoronaVirus: {
                value: (_65 = (_64 = params.properties.isTheClaimDueToCoronaVirus) === null || _64 === void 0 ? void 0 : _64.value) !== null && _65 !== void 0 ? _65 : '',
                values: (_67 = (_66 = params.properties.isTheClaimDueToCoronaVirus) === null || _66 === void 0 ? void 0 : _66.values) !== null && _67 !== void 0 ? _67 : [],
                defaultValue: '',
                possibleValues: null,
            }, evacuationCause: {
                value: (_69 = (_68 = params.properties.evacuationCause) === null || _68 === void 0 ? void 0 : _68.value) !== null && _69 !== void 0 ? _69 : '',
                values: (_71 = (_70 = params.properties.evacuationCause) === null || _70 === void 0 ? void 0 : _70.values) !== null && _71 !== void 0 ? _71 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDate: {
                value: (_73 = (_72 = params.properties.incidentDate) === null || _72 === void 0 ? void 0 : _72.value) !== null && _73 !== void 0 ? _73 : '',
                values: (_75 = (_74 = params.properties.incidentDate) === null || _74 === void 0 ? void 0 : _74.values) !== null && _75 !== void 0 ? _75 : [],
                defaultValue: '',
                possibleValues: null,
            }, routeStartDate: {
                value: (_77 = (_76 = params.properties.routeStartDate) === null || _76 === void 0 ? void 0 : _76.value) !== null && _77 !== void 0 ? _77 : '',
                values: (_79 = (_78 = params.properties.routeStartDate) === null || _78 === void 0 ? void 0 : _78.values) !== null && _79 !== void 0 ? _79 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_81 = (_80 = params.properties.defaultValidationMessage) === null || _80 === void 0 ? void 0 : _80.value) !== null && _81 !== void 0 ? _81 : '',
                values: (_83 = (_82 = params.properties.defaultValidationMessage) === null || _82 === void 0 ? void 0 : _82.values) !== null && _83 !== void 0 ? _83 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Ba_HealthInputAttachmentNode extends BaseNode {
}
export class Finland_PersonalInjury_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143, _144, _145, _146, _147, _148, _149, _150, _151, _152, _153, _154, _155, _156, _157, _158, _159, _160, _161, _162, _163, _164, _165, _166, _167, _168, _169, _170, _171, _172, _173, _174, _175, _176, _177, _178, _179, _180, _181, _182, _183, _184, _185, _186, _187, _188, _189, _190, _191, _192, _193, _194, _195, _196, _197, _198, _199, _200, _201, _202, _203, _204, _205, _206, _207, _208, _209, _210, _211, _212, _213, _214, _215, _216, _217, _218, _219, _220, _221, _222, _223, _224, _225, _226, _227, _228, _229, _230, _231, _232, _233, _234, _235, _236, _237, _238, _239, _240, _241, _242, _243, _244, _245, _246, _247, _248, _249, _250, _251, _252, _253, _254, _255, _256, _257, _258, _259, _260, _261, _262, _263, _264, _265, _266, _267, _268, _269, _270, _271, _272, _273, _274, _275, _276, _277, _278, _279, _280, _281, _282, _283, _284, _285, _286, _287, _288, _289, _290, _291, _292, _293, _294, _295, _296, _297, _298, _299, _300, _301, _302, _303, _304, _305, _306, _307, _308, _309, _310, _311, _312, _313, _314, _315, _316, _317, _318, _319;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { accidentInjuryType: {
                value: (_b = (_a = params.properties.accidentInjuryType) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.accidentInjuryType) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBankAccountNumber: {
                value: (_f = (_e = params.properties.compensationBankAccountNumber) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.compensationBankAccountNumber) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryCity: {
                value: (_k = (_j = params.properties.compensationBeneficiaryCity) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.compensationBeneficiaryCity) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryEmailAddress: {
                value: (_p = (_o = params.properties.compensationBeneficiaryEmailAddress) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.compensationBeneficiaryEmailAddress) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryFirstName: {
                value: (_t = (_s = params.properties.compensationBeneficiaryFirstName) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.compensationBeneficiaryFirstName) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryLastName: {
                value: (_x = (_w = params.properties.compensationBeneficiaryLastName) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.compensationBeneficiaryLastName) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryPersonId: {
                value: (_1 = (_0 = params.properties.compensationBeneficiaryPersonId) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.compensationBeneficiaryPersonId) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryPhoneNumber: {
                value: (_5 = (_4 = params.properties.compensationBeneficiaryPhoneNumber) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.compensationBeneficiaryPhoneNumber) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryPostalCode: {
                value: (_9 = (_8 = params.properties.compensationBeneficiaryPostalCode) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.compensationBeneficiaryPostalCode) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryRole: {
                value: (_13 = (_12 = params.properties.compensationBeneficiaryRole) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.compensationBeneficiaryRole) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryStreetAddress: {
                value: (_17 = (_16 = params.properties.compensationBeneficiaryStreetAddress) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.compensationBeneficiaryStreetAddress) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationCostItemNode: {
                value: (_21 = (_20 = params.properties.compensationCostItemNode) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.compensationCostItemNode) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationCostItemCostAmount: {
                value: (_25 = (_24 = params.properties.compensationCostItemCostAmount) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.compensationCostItemCostAmount) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationCostItemCostDate: {
                value: (_29 = (_28 = params.properties.compensationCostItemCostDate) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.compensationCostItemCostDate) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationCostItemCostDescription: {
                value: (_33 = (_32 = params.properties.compensationCostItemCostDescription) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.compensationCostItemCostDescription) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationCostItemCostType: {
                value: (_37 = (_36 = params.properties.compensationCostItemCostType) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.compensationCostItemCostType) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '',
                possibleValues: null,
            }, formType: {
                value: (_41 = (_40 = params.properties.formType) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.formType) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAccidentBodyPart: {
                value: (_45 = (_44 = params.properties.incidentAccidentBodyPart) === null || _44 === void 0 ? void 0 : _44.value) !== null && _45 !== void 0 ? _45 : '',
                values: (_47 = (_46 = params.properties.incidentAccidentBodyPart) === null || _46 === void 0 ? void 0 : _46.values) !== null && _47 !== void 0 ? _47 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAccidentBodyPartCodeName: {
                value: (_49 = (_48 = params.properties.incidentAccidentBodyPartCodeName) === null || _48 === void 0 ? void 0 : _48.value) !== null && _49 !== void 0 ? _49 : '',
                values: (_51 = (_50 = params.properties.incidentAccidentBodyPartCodeName) === null || _50 === void 0 ? void 0 : _50.values) !== null && _51 !== void 0 ? _51 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAccidentBodyPartSide: {
                value: (_53 = (_52 = params.properties.incidentAccidentBodyPartSide) === null || _52 === void 0 ? void 0 : _52.value) !== null && _53 !== void 0 ? _53 : '',
                values: (_55 = (_54 = params.properties.incidentAccidentBodyPartSide) === null || _54 === void 0 ? void 0 : _54.values) !== null && _55 !== void 0 ? _55 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAccidentHasOccurredInCompetition: {
                value: (_57 = (_56 = params.properties.incidentAccidentHasOccurredInCompetition) === null || _56 === void 0 ? void 0 : _56.value) !== null && _57 !== void 0 ? _57 : '',
                values: (_59 = (_58 = params.properties.incidentAccidentHasOccurredInCompetition) === null || _58 === void 0 ? void 0 : _58.values) !== null && _59 !== void 0 ? _59 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAccidentHasSportLicence: {
                value: (_61 = (_60 = params.properties.incidentAccidentHasSportLicence) === null || _60 === void 0 ? void 0 : _60.value) !== null && _61 !== void 0 ? _61 : '',
                values: (_63 = (_62 = params.properties.incidentAccidentHasSportLicence) === null || _62 === void 0 ? void 0 : _62.values) !== null && _63 !== void 0 ? _63 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAccidentSportCodeId: {
                value: (_65 = (_64 = params.properties.incidentAccidentSportCodeId) === null || _64 === void 0 ? void 0 : _64.value) !== null && _65 !== void 0 ? _65 : '',
                values: (_67 = (_66 = params.properties.incidentAccidentSportCodeId) === null || _66 === void 0 ? void 0 : _66.values) !== null && _67 !== void 0 ? _67 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAccidentSportCodeName: {
                value: (_69 = (_68 = params.properties.incidentAccidentSportCodeName) === null || _68 === void 0 ? void 0 : _68.value) !== null && _69 !== void 0 ? _69 : '',
                values: (_71 = (_70 = params.properties.incidentAccidentSportCodeName) === null || _70 === void 0 ? void 0 : _70.values) !== null && _71 !== void 0 ? _71 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAccidentSportLicenceName: {
                value: (_73 = (_72 = params.properties.incidentAccidentSportLicenceName) === null || _72 === void 0 ? void 0 : _72.value) !== null && _73 !== void 0 ? _73 : '',
                values: (_75 = (_74 = params.properties.incidentAccidentSportLicenceName) === null || _74 === void 0 ? void 0 : _74.values) !== null && _75 !== void 0 ? _75 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAccidentSportUnionName: {
                value: (_77 = (_76 = params.properties.incidentAccidentSportUnionName) === null || _76 === void 0 ? void 0 : _76.value) !== null && _77 !== void 0 ? _77 : '',
                values: (_79 = (_78 = params.properties.incidentAccidentSportUnionName) === null || _78 === void 0 ? void 0 : _78.values) !== null && _79 !== void 0 ? _79 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAccidentWasAssault: {
                value: (_81 = (_80 = params.properties.incidentAccidentWasAssault) === null || _80 === void 0 ? void 0 : _80.value) !== null && _81 !== void 0 ? _81 : '',
                values: (_83 = (_82 = params.properties.incidentAccidentWasAssault) === null || _82 === void 0 ? void 0 : _82.values) !== null && _83 !== void 0 ? _83 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentCircumstance: {
                value: (_85 = (_84 = params.properties.incidentCircumstance) === null || _84 === void 0 ? void 0 : _84.value) !== null && _85 !== void 0 ? _85 : '',
                values: (_87 = (_86 = params.properties.incidentCircumstance) === null || _86 === void 0 ? void 0 : _86.values) !== null && _87 !== void 0 ? _87 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentCountry: {
                value: (_89 = (_88 = params.properties.incidentCountry) === null || _88 === void 0 ? void 0 : _88.value) !== null && _89 !== void 0 ? _89 : '',
                values: (_91 = (_90 = params.properties.incidentCountry) === null || _90 === void 0 ? void 0 : _90.values) !== null && _91 !== void 0 ? _91 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDescription: {
                value: (_93 = (_92 = params.properties.incidentDescription) === null || _92 === void 0 ? void 0 : _92.value) !== null && _93 !== void 0 ? _93 : '',
                values: (_95 = (_94 = params.properties.incidentDescription) === null || _94 === void 0 ? void 0 : _94.values) !== null && _95 !== void 0 ? _95 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDiagnosisCodeId: {
                value: (_97 = (_96 = params.properties.incidentDiagnosisCodeId) === null || _96 === void 0 ? void 0 : _96.value) !== null && _97 !== void 0 ? _97 : '',
                values: (_99 = (_98 = params.properties.incidentDiagnosisCodeId) === null || _98 === void 0 ? void 0 : _98.values) !== null && _99 !== void 0 ? _99 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDiagnosisCodeName: {
                value: (_101 = (_100 = params.properties.incidentDiagnosisCodeName) === null || _100 === void 0 ? void 0 : _100.value) !== null && _101 !== void 0 ? _101 : '',
                values: (_103 = (_102 = params.properties.incidentDiagnosisCodeName) === null || _102 === void 0 ? void 0 : _102.values) !== null && _103 !== void 0 ? _103 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentEarlierTreatmentDate: {
                value: (_105 = (_104 = params.properties.incidentEarlierTreatmentDate) === null || _104 === void 0 ? void 0 : _104.value) !== null && _105 !== void 0 ? _105 : '',
                values: (_107 = (_106 = params.properties.incidentEarlierTreatmentDate) === null || _106 === void 0 ? void 0 : _106.values) !== null && _107 !== void 0 ? _107 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentEarlierTreatmentPlace: {
                value: (_109 = (_108 = params.properties.incidentEarlierTreatmentPlace) === null || _108 === void 0 ? void 0 : _108.value) !== null && _109 !== void 0 ? _109 : '',
                values: (_111 = (_110 = params.properties.incidentEarlierTreatmentPlace) === null || _110 === void 0 ? void 0 : _110.values) !== null && _111 !== void 0 ? _111 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentHasAlcoholOrDrugsInvolved: {
                value: (_113 = (_112 = params.properties.incidentHasAlcoholOrDrugsInvolved) === null || _112 === void 0 ? void 0 : _112.value) !== null && _113 !== void 0 ? _113 : '',
                values: (_115 = (_114 = params.properties.incidentHasAlcoholOrDrugsInvolved) === null || _114 === void 0 ? void 0 : _114.values) !== null && _115 !== void 0 ? _115 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentHasEarlierSymptons: {
                value: (_117 = (_116 = params.properties.incidentHasEarlierSymptons) === null || _116 === void 0 ? void 0 : _116.value) !== null && _117 !== void 0 ? _117 : '',
                values: (_119 = (_118 = params.properties.incidentHasEarlierSymptons) === null || _118 === void 0 ? void 0 : _118.values) !== null && _119 !== void 0 ? _119 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentHospitalAndTown: {
                value: (_121 = (_120 = params.properties.incidentHospitalAndTown) === null || _120 === void 0 ? void 0 : _120.value) !== null && _121 !== void 0 ? _121 : '',
                values: (_123 = (_122 = params.properties.incidentHospitalAndTown) === null || _122 === void 0 ? void 0 : _122.values) !== null && _123 !== void 0 ? _123 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentHospitalName: {
                value: (_125 = (_124 = params.properties.incidentHospitalName) === null || _124 === void 0 ? void 0 : _124.value) !== null && _125 !== void 0 ? _125 : '',
                values: (_127 = (_126 = params.properties.incidentHospitalName) === null || _126 === void 0 ? void 0 : _126.values) !== null && _127 !== void 0 ? _127 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentHospitalTreatmentEndDate: {
                value: (_129 = (_128 = params.properties.incidentHospitalTreatmentEndDate) === null || _128 === void 0 ? void 0 : _128.value) !== null && _129 !== void 0 ? _129 : '',
                values: (_131 = (_130 = params.properties.incidentHospitalTreatmentEndDate) === null || _130 === void 0 ? void 0 : _130.values) !== null && _131 !== void 0 ? _131 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentHospitalTreatmentStartDate: {
                value: (_133 = (_132 = params.properties.incidentHospitalTreatmentStartDate) === null || _132 === void 0 ? void 0 : _132.value) !== null && _133 !== void 0 ? _133 : '',
                values: (_135 = (_134 = params.properties.incidentHospitalTreatmentStartDate) === null || _134 === void 0 ? void 0 : _134.values) !== null && _135 !== void 0 ? _135 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentIncidentCause: {
                value: (_137 = (_136 = params.properties.incidentIncidentCause) === null || _136 === void 0 ? void 0 : _136.value) !== null && _137 !== void 0 ? _137 : '',
                values: (_139 = (_138 = params.properties.incidentIncidentCause) === null || _138 === void 0 ? void 0 : _138.values) !== null && _139 !== void 0 ? _139 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentIncidentDate: {
                value: (_141 = (_140 = params.properties.incidentIncidentDate) === null || _140 === void 0 ? void 0 : _140.value) !== null && _141 !== void 0 ? _141 : '',
                values: (_143 = (_142 = params.properties.incidentIncidentDate) === null || _142 === void 0 ? void 0 : _142.values) !== null && _143 !== void 0 ? _143 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentIncidentTime: {
                value: (_145 = (_144 = params.properties.incidentIncidentTime) === null || _144 === void 0 ? void 0 : _144.value) !== null && _145 !== void 0 ? _145 : '',
                values: (_147 = (_146 = params.properties.incidentIncidentTime) === null || _146 === void 0 ? void 0 : _146.values) !== null && _147 !== void 0 ? _147 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentIncidentType: {
                value: (_149 = (_148 = params.properties.incidentIncidentType) === null || _148 === void 0 ? void 0 : _148.value) !== null && _149 !== void 0 ? _149 : '',
                values: (_151 = (_150 = params.properties.incidentIncidentType) === null || _150 === void 0 ? void 0 : _150.values) !== null && _151 !== void 0 ? _151 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentInformedBefore: {
                value: (_153 = (_152 = params.properties.incidentInformedBefore) === null || _152 === void 0 ? void 0 : _152.value) !== null && _153 !== void 0 ? _153 : '',
                values: (_155 = (_154 = params.properties.incidentInformedBefore) === null || _154 === void 0 ? void 0 : _154.values) !== null && _155 !== void 0 ? _155 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentInsuredCity: {
                value: (_157 = (_156 = params.properties.incidentInsuredCity) === null || _156 === void 0 ? void 0 : _156.value) !== null && _157 !== void 0 ? _157 : '',
                values: (_159 = (_158 = params.properties.incidentInsuredCity) === null || _158 === void 0 ? void 0 : _158.values) !== null && _159 !== void 0 ? _159 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentInsuredFirsName: {
                value: (_161 = (_160 = params.properties.incidentInsuredFirsName) === null || _160 === void 0 ? void 0 : _160.value) !== null && _161 !== void 0 ? _161 : '',
                values: (_163 = (_162 = params.properties.incidentInsuredFirsName) === null || _162 === void 0 ? void 0 : _162.values) !== null && _163 !== void 0 ? _163 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentInsuredLastName: {
                value: (_165 = (_164 = params.properties.incidentInsuredLastName) === null || _164 === void 0 ? void 0 : _164.value) !== null && _165 !== void 0 ? _165 : '',
                values: (_167 = (_166 = params.properties.incidentInsuredLastName) === null || _166 === void 0 ? void 0 : _166.values) !== null && _167 !== void 0 ? _167 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentInsuredPersonId: {
                value: (_169 = (_168 = params.properties.incidentInsuredPersonId) === null || _168 === void 0 ? void 0 : _168.value) !== null && _169 !== void 0 ? _169 : '',
                values: (_171 = (_170 = params.properties.incidentInsuredPersonId) === null || _170 === void 0 ? void 0 : _170.values) !== null && _171 !== void 0 ? _171 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentInsuredPhoneNumber: {
                value: (_173 = (_172 = params.properties.incidentInsuredPhoneNumber) === null || _172 === void 0 ? void 0 : _172.value) !== null && _173 !== void 0 ? _173 : '',
                values: (_175 = (_174 = params.properties.incidentInsuredPhoneNumber) === null || _174 === void 0 ? void 0 : _174.values) !== null && _175 !== void 0 ? _175 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentInsuredPostalCode: {
                value: (_177 = (_176 = params.properties.incidentInsuredPostalCode) === null || _176 === void 0 ? void 0 : _176.value) !== null && _177 !== void 0 ? _177 : '',
                values: (_179 = (_178 = params.properties.incidentInsuredPostalCode) === null || _178 === void 0 ? void 0 : _178.values) !== null && _179 !== void 0 ? _179 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentInsuredStreetAddress: {
                value: (_181 = (_180 = params.properties.incidentInsuredStreetAddress) === null || _180 === void 0 ? void 0 : _180.value) !== null && _181 !== void 0 ? _181 : '',
                values: (_183 = (_182 = params.properties.incidentInsuredStreetAddress) === null || _182 === void 0 ? void 0 : _182.values) !== null && _183 !== void 0 ? _183 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentMunicipality: {
                value: (_185 = (_184 = params.properties.incidentMunicipality) === null || _184 === void 0 ? void 0 : _184.value) !== null && _185 !== void 0 ? _185 : '',
                values: (_187 = (_186 = params.properties.incidentMunicipality) === null || _186 === void 0 ? void 0 : _186.values) !== null && _187 !== void 0 ? _187 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTravelCancelationRefundApplied: {
                value: (_189 = (_188 = params.properties.incidentTravelCancelationRefundApplied) === null || _188 === void 0 ? void 0 : _188.value) !== null && _189 !== void 0 ? _189 : '',
                values: (_191 = (_190 = params.properties.incidentTravelCancelationRefundApplied) === null || _190 === void 0 ? void 0 : _190.values) !== null && _191 !== void 0 ? _191 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTravelCancelReason: {
                value: (_193 = (_192 = params.properties.incidentTravelCancelReason) === null || _192 === void 0 ? void 0 : _192.value) !== null && _193 !== void 0 ? _193 : '',
                values: (_195 = (_194 = params.properties.incidentTravelCancelReason) === null || _194 === void 0 ? void 0 : _194.values) !== null && _195 !== void 0 ? _195 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTravelDelayReason: {
                value: (_197 = (_196 = params.properties.incidentTravelDelayReason) === null || _196 === void 0 ? void 0 : _196.value) !== null && _197 !== void 0 ? _197 : '',
                values: (_199 = (_198 = params.properties.incidentTravelDelayReason) === null || _198 === void 0 ? void 0 : _198.values) !== null && _199 !== void 0 ? _199 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTravelDelayReasonTransportation: {
                value: (_201 = (_200 = params.properties.incidentTravelDelayReasonTransportation) === null || _200 === void 0 ? void 0 : _200.value) !== null && _201 !== void 0 ? _201 : '',
                values: (_203 = (_202 = params.properties.incidentTravelDelayReasonTransportation) === null || _202 === void 0 ? void 0 : _202.values) !== null && _203 !== void 0 ? _203 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTravelLeisureHomeDesription: {
                value: (_205 = (_204 = params.properties.incidentTravelLeisureHomeDesription) === null || _204 === void 0 ? void 0 : _204.value) !== null && _205 !== void 0 ? _205 : '',
                values: (_207 = (_206 = params.properties.incidentTravelLeisureHomeDesription) === null || _206 === void 0 ? void 0 : _206.values) !== null && _207 !== void 0 ? _207 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTravelOriginalCost: {
                value: (_209 = (_208 = params.properties.incidentTravelOriginalCost) === null || _208 === void 0 ? void 0 : _208.value) !== null && _209 !== void 0 ? _209 : '',
                values: (_211 = (_210 = params.properties.incidentTravelOriginalCost) === null || _210 === void 0 ? void 0 : _210.values) !== null && _211 !== void 0 ? _211 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTravelOriginalEndDate: {
                value: (_213 = (_212 = params.properties.incidentTravelOriginalEndDate) === null || _212 === void 0 ? void 0 : _212.value) !== null && _213 !== void 0 ? _213 : '',
                values: (_215 = (_214 = params.properties.incidentTravelOriginalEndDate) === null || _214 === void 0 ? void 0 : _214.values) !== null && _215 !== void 0 ? _215 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTravelOriginalStarDate: {
                value: (_217 = (_216 = params.properties.incidentTravelOriginalStarDate) === null || _216 === void 0 ? void 0 : _216.value) !== null && _217 !== void 0 ? _217 : '',
                values: (_219 = (_218 = params.properties.incidentTravelOriginalStarDate) === null || _218 === void 0 ? void 0 : _218.values) !== null && _219 !== void 0 ? _219 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTravelReason: {
                value: (_221 = (_220 = params.properties.incidentTravelReason) === null || _220 === void 0 ? void 0 : _220.value) !== null && _221 !== void 0 ? _221 : '',
                values: (_223 = (_222 = params.properties.incidentTravelReason) === null || _222 === void 0 ? void 0 : _222.values) !== null && _223 !== void 0 ? _223 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTravelReservationDate: {
                value: (_225 = (_224 = params.properties.incidentTravelReservationDate) === null || _224 === void 0 ? void 0 : _224.value) !== null && _225 !== void 0 ? _225 : '',
                values: (_227 = (_226 = params.properties.incidentTravelReservationDate) === null || _226 === void 0 ? void 0 : _226.values) !== null && _227 !== void 0 ? _227 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTravelTravelEndDate: {
                value: (_229 = (_228 = params.properties.incidentTravelTravelEndDate) === null || _228 === void 0 ? void 0 : _228.value) !== null && _229 !== void 0 ? _229 : '',
                values: (_231 = (_230 = params.properties.incidentTravelTravelEndDate) === null || _230 === void 0 ? void 0 : _230.values) !== null && _231 !== void 0 ? _231 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTravelTravelStartDate: {
                value: (_233 = (_232 = params.properties.incidentTravelTravelStartDate) === null || _232 === void 0 ? void 0 : _232.value) !== null && _233 !== void 0 ? _233 : '',
                values: (_235 = (_234 = params.properties.incidentTravelTravelStartDate) === null || _234 === void 0 ? void 0 : _234.values) !== null && _235 !== void 0 ? _235 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTreatmentStartedDate: {
                value: (_237 = (_236 = params.properties.incidentTreatmentStartedDate) === null || _236 === void 0 ? void 0 : _236.value) !== null && _237 !== void 0 ? _237 : '',
                values: (_239 = (_238 = params.properties.incidentTreatmentStartedDate) === null || _238 === void 0 ? void 0 : _238.values) !== null && _239 !== void 0 ? _239 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterCity: {
                value: (_241 = (_240 = params.properties.reporterCity) === null || _240 === void 0 ? void 0 : _240.value) !== null && _241 !== void 0 ? _241 : '',
                values: (_243 = (_242 = params.properties.reporterCity) === null || _242 === void 0 ? void 0 : _242.values) !== null && _243 !== void 0 ? _243 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterCustomerReference: {
                value: (_245 = (_244 = params.properties.reporterCustomerReference) === null || _244 === void 0 ? void 0 : _244.value) !== null && _245 !== void 0 ? _245 : '',
                values: (_247 = (_246 = params.properties.reporterCustomerReference) === null || _246 === void 0 ? void 0 : _246.values) !== null && _247 !== void 0 ? _247 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterEmailAddress: {
                value: (_249 = (_248 = params.properties.reporterEmailAddress) === null || _248 === void 0 ? void 0 : _248.value) !== null && _249 !== void 0 ? _249 : '',
                values: (_251 = (_250 = params.properties.reporterEmailAddress) === null || _250 === void 0 ? void 0 : _250.values) !== null && _251 !== void 0 ? _251 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterFirstName: {
                value: (_253 = (_252 = params.properties.reporterFirstName) === null || _252 === void 0 ? void 0 : _252.value) !== null && _253 !== void 0 ? _253 : '',
                values: (_255 = (_254 = params.properties.reporterFirstName) === null || _254 === void 0 ? void 0 : _254.values) !== null && _255 !== void 0 ? _255 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterLastName: {
                value: (_257 = (_256 = params.properties.reporterLastName) === null || _256 === void 0 ? void 0 : _256.value) !== null && _257 !== void 0 ? _257 : '',
                values: (_259 = (_258 = params.properties.reporterLastName) === null || _258 === void 0 ? void 0 : _258.values) !== null && _259 !== void 0 ? _259 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPersonId: {
                value: (_261 = (_260 = params.properties.reporterPersonId) === null || _260 === void 0 ? void 0 : _260.value) !== null && _261 !== void 0 ? _261 : '',
                values: (_263 = (_262 = params.properties.reporterPersonId) === null || _262 === void 0 ? void 0 : _262.values) !== null && _263 !== void 0 ? _263 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPhoneNumber: {
                value: (_265 = (_264 = params.properties.reporterPhoneNumber) === null || _264 === void 0 ? void 0 : _264.value) !== null && _265 !== void 0 ? _265 : '',
                values: (_267 = (_266 = params.properties.reporterPhoneNumber) === null || _266 === void 0 ? void 0 : _266.values) !== null && _267 !== void 0 ? _267 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPostalCode: {
                value: (_269 = (_268 = params.properties.reporterPostalCode) === null || _268 === void 0 ? void 0 : _268.value) !== null && _269 !== void 0 ? _269 : '',
                values: (_271 = (_270 = params.properties.reporterPostalCode) === null || _270 === void 0 ? void 0 : _270.values) !== null && _271 !== void 0 ? _271 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterStreetAddress: {
                value: (_273 = (_272 = params.properties.reporterStreetAddress) === null || _272 === void 0 ? void 0 : _272.value) !== null && _273 !== void 0 ? _273 : '',
                values: (_275 = (_274 = params.properties.reporterStreetAddress) === null || _274 === void 0 ? void 0 : _274.values) !== null && _275 !== void 0 ? _275 : [],
                defaultValue: '',
                possibleValues: null,
            }, unionSelectedUnion: {
                value: (_277 = (_276 = params.properties.unionSelectedUnion) === null || _276 === void 0 ? void 0 : _276.value) !== null && _277 !== void 0 ? _277 : '',
                values: (_279 = (_278 = params.properties.unionSelectedUnion) === null || _278 === void 0 ? void 0 : _278.values) !== null && _279 !== void 0 ? _279 : [],
                defaultValue: '',
                possibleValues: null,
            }, unionSelectedUnionName: {
                value: (_281 = (_280 = params.properties.unionSelectedUnionName) === null || _280 === void 0 ? void 0 : _280.value) !== null && _281 !== void 0 ? _281 : '',
                values: (_283 = (_282 = params.properties.unionSelectedUnionName) === null || _282 === void 0 ? void 0 : _282.values) !== null && _283 !== void 0 ? _283 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimType: {
                value: (_285 = (_284 = params.properties.claimType) === null || _284 === void 0 ? void 0 : _284.value) !== null && _285 !== void 0 ? _285 : '',
                values: (_287 = (_286 = params.properties.claimType) === null || _286 === void 0 ? void 0 : _286.values) !== null && _287 !== void 0 ? _287 : [],
                defaultValue: '',
                possibleValues: null,
            }, htmlNotification: {
                value: (_289 = (_288 = params.properties.htmlNotification) === null || _288 === void 0 ? void 0 : _288.value) !== null && _289 !== void 0 ? _289 : '',
                values: (_291 = (_290 = params.properties.htmlNotification) === null || _290 === void 0 ? void 0 : _290.values) !== null && _291 !== void 0 ? _291 : [],
                defaultValue: '',
                possibleValues: null,
            }, channel: {
                value: (_293 = (_292 = params.properties.channel) === null || _292 === void 0 ? void 0 : _292.value) !== null && _293 !== void 0 ? _293 : '',
                values: (_295 = (_294 = params.properties.channel) === null || _294 === void 0 ? void 0 : _294.values) !== null && _295 !== void 0 ? _295 : [],
                defaultValue: '',
                possibleValues: null,
            }, powerOfAttorney: {
                value: (_297 = (_296 = params.properties.powerOfAttorney) === null || _296 === void 0 ? void 0 : _296.value) !== null && _297 !== void 0 ? _297 : '',
                values: (_299 = (_298 = params.properties.powerOfAttorney) === null || _298 === void 0 ? void 0 : _298.values) !== null && _299 !== void 0 ? _299 : [],
                defaultValue: '',
                possibleValues: null,
            }, bankName: {
                value: (_301 = (_300 = params.properties.bankName) === null || _300 === void 0 ? void 0 : _300.value) !== null && _301 !== void 0 ? _301 : '',
                values: (_303 = (_302 = params.properties.bankName) === null || _302 === void 0 ? void 0 : _302.values) !== null && _303 !== void 0 ? _303 : [],
                defaultValue: '',
                possibleValues: null,
            }, authTimestamp: {
                value: (_305 = (_304 = params.properties.authTimestamp) === null || _304 === void 0 ? void 0 : _304.value) !== null && _305 !== void 0 ? _305 : '',
                values: (_307 = (_306 = params.properties.authTimestamp) === null || _306 === void 0 ? void 0 : _306.values) !== null && _307 !== void 0 ? _307 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTravelPlace: {
                value: (_309 = (_308 = params.properties.incidentTravelPlace) === null || _308 === void 0 ? void 0 : _308.value) !== null && _309 !== void 0 ? _309 : '',
                values: (_311 = (_310 = params.properties.incidentTravelPlace) === null || _310 === void 0 ? void 0 : _310.values) !== null && _311 !== void 0 ? _311 : [],
                defaultValue: '',
                possibleValues: null,
            }, cancellationCostIncludeOthers: {
                value: (_313 = (_312 = params.properties.cancellationCostIncludeOthers) === null || _312 === void 0 ? void 0 : _312.value) !== null && _313 !== void 0 ? _313 : '',
                values: (_315 = (_314 = params.properties.cancellationCostIncludeOthers) === null || _314 === void 0 ? void 0 : _314.values) !== null && _315 !== void 0 ? _315 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_317 = (_316 = params.properties.defaultValidationMessage) === null || _316 === void 0 ? void 0 : _316.value) !== null && _317 !== void 0 ? _317 : '',
                values: (_319 = (_318 = params.properties.defaultValidationMessage) === null || _318 === void 0 ? void 0 : _318.values) !== null && _319 !== void 0 ? _319 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Finland_PersonalInjury_SportCodeNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { inputPlaceholder: {
                value: (_b = (_a = params.properties.inputPlaceholder) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.inputPlaceholder) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, noResultsFoundMessage: {
                value: (_f = (_e = params.properties.noResultsFoundMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.noResultsFoundMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, allowAnyValue: {
                value: (_k = (_j = params.properties.allowAnyValue) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.allowAnyValue) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'code',
                possibleValues: []
            }, {
                name: 'text',
                possibleValues: []
            }
        ];
    }
}
export class Finland_PersonalInjury_DiagnosisCodeNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { inputPlaceholder: {
                value: (_b = (_a = params.properties.inputPlaceholder) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.inputPlaceholder) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, noResultsFoundMessage: {
                value: (_f = (_e = params.properties.noResultsFoundMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.noResultsFoundMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, allowAnyValue: {
                value: (_k = (_j = params.properties.allowAnyValue) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.allowAnyValue) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'code',
                possibleValues: []
            }, {
                name: 'text',
                possibleValues: []
            }
        ];
    }
}
export class Finland_PersonalInjury_MedicineCodeNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { inputPlaceholder: {
                value: (_b = (_a = params.properties.inputPlaceholder) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.inputPlaceholder) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, noResultsFoundMessage: {
                value: (_f = (_e = params.properties.noResultsFoundMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.noResultsFoundMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, allowAnyValue: {
                value: (_k = (_j = params.properties.allowAnyValue) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.allowAnyValue) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: 'true',
                possibleValues: ['true', 'false'],
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'code',
                possibleValues: []
            }, {
                name: 'text',
                possibleValues: []
            }
        ];
    }
}
export class Finland_PersonalInjury_BodyPartCodeNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { inputPlaceholder: {
                value: (_b = (_a = params.properties.inputPlaceholder) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.inputPlaceholder) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, noResultsFoundMessage: {
                value: (_f = (_e = params.properties.noResultsFoundMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.noResultsFoundMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, allowAnyValue: {
                value: (_k = (_j = params.properties.allowAnyValue) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.allowAnyValue) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'code',
                possibleValues: []
            }, {
                name: 'text',
                possibleValues: []
            }
        ];
    }
}
export class Finland_PersonalInjury_TradeUnionCodeNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { inputPlaceholder: {
                value: (_b = (_a = params.properties.inputPlaceholder) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.inputPlaceholder) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, noResultsFoundMessage: {
                value: (_f = (_e = params.properties.noResultsFoundMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.noResultsFoundMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, allowAnyValue: {
                value: (_k = (_j = params.properties.allowAnyValue) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.allowAnyValue) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'code',
                possibleValues: []
            }, {
                name: 'text',
                possibleValues: []
            }
        ];
    }
}
export class Finland_HealthNavigator_ClaimLiabilitySearchNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { incidentDate: {
                value: (_b = (_a = params.properties.incidentDate) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.incidentDate) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentType: {
                value: (_f = (_e = params.properties.incidentType) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.incidentType) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, ssn: {
                value: (_k = (_j = params.properties.ssn) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.ssn) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, symptomCodes: {
                value: (_p = (_o = params.properties.symptomCodes) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.symptomCodes) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, accidentIncidentCause: {
                value: (_t = (_s = params.properties.accidentIncidentCause) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.accidentIncidentCause) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, accidentInjuryType: {
                value: (_x = (_w = params.properties.accidentInjuryType) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.accidentInjuryType) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, accidentBodyPart: {
                value: (_1 = (_0 = params.properties.accidentBodyPart) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.accidentBodyPart) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, accidentHasOccurredInCompetition: {
                value: (_5 = (_4 = params.properties.accidentHasOccurredInCompetition) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.accidentHasOccurredInCompetition) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, accidentWasAssault: {
                value: (_9 = (_8 = params.properties.accidentWasAssault) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.accidentWasAssault) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, accidentHasAlcoholOrDrugsInvolved: {
                value: (_13 = (_12 = params.properties.accidentHasAlcoholOrDrugsInvolved) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.accidentHasAlcoholOrDrugsInvolved) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, accidentCircumstance: {
                value: (_17 = (_16 = params.properties.accidentCircumstance) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.accidentCircumstance) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, accidentHasEarlierSymptoms: {
                value: (_21 = (_20 = params.properties.accidentHasEarlierSymptoms) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.accidentHasEarlierSymptoms) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, accidentIsWideAccident: {
                value: (_25 = (_24 = params.properties.accidentIsWideAccident) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.accidentIsWideAccident) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_29 = (_28 = params.properties.defaultValidationMessage) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.defaultValidationMessage) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'isClaimLiable',
                possibleValues: []
            }, {
                name: 'deductibleAmount',
                possibleValues: []
            }, {
                name: 'deductibleType',
                possibleValues: []
            }, {
                name: 'deductibleLeftAmount',
                possibleValues: []
            }, {
                name: 'termEndDate',
                possibleValues: []
            }, {
                name: 'policyNumber',
                possibleValues: []
            }, {
                name: 'policyHolderCustomerNumber',
                possibleValues: []
            }, {
                name: 'incidentInsuredCustomerNumber',
                possibleValues: []
            }, {
                name: 'externalSessionId',
                possibleValues: []
            }, {
                name: 'showDeductibleAdditionalText',
                possibleValues: []
            }, {
                name: 'claimsCount',
                possibleValues: []
            }, {
                name: 'caseType',
                possibleValues: []
            }, {
                name: 'coverageAmountSmall',
                possibleValues: []
            }, {
                name: 'claimNumber',
                possibleValues: []
            }, {
                name: 'coverageType',
                possibleValues: []
            }, {
                name: 'insuredAge',
                possibleValues: []
            }, {
                name: 'policyCoverageNumber',
                possibleValues: []
            }, {
                name: 'policyUnitAtRiskNumber',
                possibleValues: []
            }, {
                name: 'liabilityReasons',
                possibleValues: []
            }, {
                name: 'policyHolderCustomerReference',
                possibleValues: []
            }, {
                name: 'ageOfInsured',
                possibleValues: []
            }
        ];
    }
}
export class Finland_HealthNavigator_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143, _144, _145, _146, _147, _148, _149, _150, _151, _152, _153, _154, _155, _156, _157, _158, _159, _160, _161, _162, _163, _164, _165, _166, _167, _168, _169, _170, _171, _172, _173, _174, _175, _176, _177, _178, _179, _180, _181, _182, _183, _184, _185, _186, _187, _188, _189, _190, _191, _192, _193, _194, _195, _196, _197, _198, _199, _200, _201, _202, _203, _204, _205, _206, _207, _208, _209, _210, _211, _212, _213, _214, _215, _216, _217, _218, _219, _220, _221, _222, _223, _224, _225, _226, _227, _228, _229, _230, _231, _232, _233, _234, _235, _236, _237, _238, _239, _240, _241, _242, _243, _244, _245, _246, _247, _248, _249, _250, _251, _252, _253, _254, _255;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { channel: {
                value: (_b = (_a = params.properties.channel) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.channel) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, customerServiceLanguage: {
                value: (_f = (_e = params.properties.customerServiceLanguage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.customerServiceLanguage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, summary: {
                value: (_k = (_j = params.properties.summary) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.summary) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, decicionDeductibleLeftAmount: {
                value: (_p = (_o = params.properties.decicionDeductibleLeftAmount) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.decicionDeductibleLeftAmount) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, decicionDeductibleAmount: {
                value: (_t = (_s = params.properties.decicionDeductibleAmount) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.decicionDeductibleAmount) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, decisionDeductibleType: {
                value: (_x = (_w = params.properties.decisionDeductibleType) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.decisionDeductibleType) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, decisionIsClaimLiable: {
                value: (_1 = (_0 = params.properties.decisionIsClaimLiable) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.decisionIsClaimLiable) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, decisionCustomerNumber: {
                value: (_5 = (_4 = params.properties.decisionCustomerNumber) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.decisionCustomerNumber) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, decisionPolicyNumber: {
                value: (_9 = (_8 = params.properties.decisionPolicyNumber) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.decisionPolicyNumber) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, decisionTermEndDate: {
                value: (_13 = (_12 = params.properties.decisionTermEndDate) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.decisionTermEndDate) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAccidentBodyPart: {
                value: (_17 = (_16 = params.properties.incidentAccidentBodyPart) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.incidentAccidentBodyPart) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAccidentBodyPartSide: {
                value: (_21 = (_20 = params.properties.incidentAccidentBodyPartSide) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.incidentAccidentBodyPartSide) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAccidentHasOccurredInCompetition: {
                value: (_25 = (_24 = params.properties.incidentAccidentHasOccurredInCompetition) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.incidentAccidentHasOccurredInCompetition) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAccidentHasSportLicense: {
                value: (_29 = (_28 = params.properties.incidentAccidentHasSportLicense) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.incidentAccidentHasSportLicense) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAccidentInjuryType: {
                value: (_33 = (_32 = params.properties.incidentAccidentInjuryType) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.incidentAccidentInjuryType) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAccidentSportLicenseName: {
                value: (_37 = (_36 = params.properties.incidentAccidentSportLicenseName) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.incidentAccidentSportLicenseName) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAccidentSportUnionName: {
                value: (_41 = (_40 = params.properties.incidentAccidentSportUnionName) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.incidentAccidentSportUnionName) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAccidentWasAssault: {
                value: (_45 = (_44 = params.properties.incidentAccidentWasAssault) === null || _44 === void 0 ? void 0 : _44.value) !== null && _45 !== void 0 ? _45 : '',
                values: (_47 = (_46 = params.properties.incidentAccidentWasAssault) === null || _46 === void 0 ? void 0 : _46.values) !== null && _47 !== void 0 ? _47 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAccidentSportCode: {
                value: (_49 = (_48 = params.properties.incidentAccidentSportCode) === null || _48 === void 0 ? void 0 : _48.value) !== null && _49 !== void 0 ? _49 : '',
                values: (_51 = (_50 = params.properties.incidentAccidentSportCode) === null || _50 === void 0 ? void 0 : _50.values) !== null && _51 !== void 0 ? _51 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentCircumstance: {
                value: (_53 = (_52 = params.properties.incidentCircumstance) === null || _52 === void 0 ? void 0 : _52.value) !== null && _53 !== void 0 ? _53 : '',
                values: (_55 = (_54 = params.properties.incidentCircumstance) === null || _54 === void 0 ? void 0 : _54.values) !== null && _55 !== void 0 ? _55 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentCircumstanceDescription: {
                value: (_57 = (_56 = params.properties.incidentCircumstanceDescription) === null || _56 === void 0 ? void 0 : _56.value) !== null && _57 !== void 0 ? _57 : '',
                values: (_59 = (_58 = params.properties.incidentCircumstanceDescription) === null || _58 === void 0 ? void 0 : _58.values) !== null && _59 !== void 0 ? _59 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentCountry: {
                value: (_61 = (_60 = params.properties.incidentCountry) === null || _60 === void 0 ? void 0 : _60.value) !== null && _61 !== void 0 ? _61 : '',
                values: (_63 = (_62 = params.properties.incidentCountry) === null || _62 === void 0 ? void 0 : _62.values) !== null && _63 !== void 0 ? _63 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentEarlierTreatmentDate: {
                value: (_65 = (_64 = params.properties.incidentEarlierTreatmentDate) === null || _64 === void 0 ? void 0 : _64.value) !== null && _65 !== void 0 ? _65 : '',
                values: (_67 = (_66 = params.properties.incidentEarlierTreatmentDate) === null || _66 === void 0 ? void 0 : _66.values) !== null && _67 !== void 0 ? _67 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentEarlierTreatmentPlace: {
                value: (_69 = (_68 = params.properties.incidentEarlierTreatmentPlace) === null || _68 === void 0 ? void 0 : _68.value) !== null && _69 !== void 0 ? _69 : '',
                values: (_71 = (_70 = params.properties.incidentEarlierTreatmentPlace) === null || _70 === void 0 ? void 0 : _70.values) !== null && _71 !== void 0 ? _71 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentHasEarlierSymptons: {
                value: (_73 = (_72 = params.properties.incidentHasEarlierSymptons) === null || _72 === void 0 ? void 0 : _72.value) !== null && _73 !== void 0 ? _73 : '',
                values: (_75 = (_74 = params.properties.incidentHasEarlierSymptons) === null || _74 === void 0 ? void 0 : _74.values) !== null && _75 !== void 0 ? _75 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentHospitalAndTown: {
                value: (_77 = (_76 = params.properties.incidentHospitalAndTown) === null || _76 === void 0 ? void 0 : _76.value) !== null && _77 !== void 0 ? _77 : '',
                values: (_79 = (_78 = params.properties.incidentHospitalAndTown) === null || _78 === void 0 ? void 0 : _78.values) !== null && _79 !== void 0 ? _79 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentIncidentCause: {
                value: (_81 = (_80 = params.properties.incidentIncidentCause) === null || _80 === void 0 ? void 0 : _80.value) !== null && _81 !== void 0 ? _81 : '',
                values: (_83 = (_82 = params.properties.incidentIncidentCause) === null || _82 === void 0 ? void 0 : _82.values) !== null && _83 !== void 0 ? _83 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentIncidentDate: {
                value: (_85 = (_84 = params.properties.incidentIncidentDate) === null || _84 === void 0 ? void 0 : _84.value) !== null && _85 !== void 0 ? _85 : '',
                values: (_87 = (_86 = params.properties.incidentIncidentDate) === null || _86 === void 0 ? void 0 : _86.values) !== null && _87 !== void 0 ? _87 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentIncidentTime: {
                value: (_89 = (_88 = params.properties.incidentIncidentTime) === null || _88 === void 0 ? void 0 : _88.value) !== null && _89 !== void 0 ? _89 : '',
                values: (_91 = (_90 = params.properties.incidentIncidentTime) === null || _90 === void 0 ? void 0 : _90.values) !== null && _91 !== void 0 ? _91 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentIncidentType: {
                value: (_93 = (_92 = params.properties.incidentIncidentType) === null || _92 === void 0 ? void 0 : _92.value) !== null && _93 !== void 0 ? _93 : '',
                values: (_95 = (_94 = params.properties.incidentIncidentType) === null || _94 === void 0 ? void 0 : _94.values) !== null && _95 !== void 0 ? _95 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentInformedBefore: {
                value: (_97 = (_96 = params.properties.incidentInformedBefore) === null || _96 === void 0 ? void 0 : _96.value) !== null && _97 !== void 0 ? _97 : '',
                values: (_99 = (_98 = params.properties.incidentInformedBefore) === null || _98 === void 0 ? void 0 : _98.values) !== null && _99 !== void 0 ? _99 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentIsReporterCaretaker: {
                value: (_101 = (_100 = params.properties.incidentIsReporterCaretaker) === null || _100 === void 0 ? void 0 : _100.value) !== null && _101 !== void 0 ? _101 : '',
                values: (_103 = (_102 = params.properties.incidentIsReporterCaretaker) === null || _102 === void 0 ? void 0 : _102.values) !== null && _103 !== void 0 ? _103 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentMunicipality: {
                value: (_105 = (_104 = params.properties.incidentMunicipality) === null || _104 === void 0 ? void 0 : _104.value) !== null && _105 !== void 0 ? _105 : '',
                values: (_107 = (_106 = params.properties.incidentMunicipality) === null || _106 === void 0 ? void 0 : _106.values) !== null && _107 !== void 0 ? _107 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentSymptomCodes: {
                value: (_109 = (_108 = params.properties.incidentSymptomCodes) === null || _108 === void 0 ? void 0 : _108.value) !== null && _109 !== void 0 ? _109 : '',
                values: (_111 = (_110 = params.properties.incidentSymptomCodes) === null || _110 === void 0 ? void 0 : _110.values) !== null && _111 !== void 0 ? _111 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentSymptoms: {
                value: (_113 = (_112 = params.properties.incidentSymptoms) === null || _112 === void 0 ? void 0 : _112.value) !== null && _113 !== void 0 ? _113 : '',
                values: (_115 = (_114 = params.properties.incidentSymptoms) === null || _114 === void 0 ? void 0 : _114.values) !== null && _115 !== void 0 ? _115 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTreatmentStartedDate: {
                value: (_117 = (_116 = params.properties.incidentTreatmentStartedDate) === null || _116 === void 0 ? void 0 : _116.value) !== null && _117 !== void 0 ? _117 : '',
                values: (_119 = (_118 = params.properties.incidentTreatmentStartedDate) === null || _118 === void 0 ? void 0 : _118.values) !== null && _119 !== void 0 ? _119 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentInsuredFirstName: {
                value: (_121 = (_120 = params.properties.incidentInsuredFirstName) === null || _120 === void 0 ? void 0 : _120.value) !== null && _121 !== void 0 ? _121 : '',
                values: (_123 = (_122 = params.properties.incidentInsuredFirstName) === null || _122 === void 0 ? void 0 : _122.values) !== null && _123 !== void 0 ? _123 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentInsuredLastName: {
                value: (_125 = (_124 = params.properties.incidentInsuredLastName) === null || _124 === void 0 ? void 0 : _124.value) !== null && _125 !== void 0 ? _125 : '',
                values: (_127 = (_126 = params.properties.incidentInsuredLastName) === null || _126 === void 0 ? void 0 : _126.values) !== null && _127 !== void 0 ? _127 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentInsuredPersonId: {
                value: (_129 = (_128 = params.properties.incidentInsuredPersonId) === null || _128 === void 0 ? void 0 : _128.value) !== null && _129 !== void 0 ? _129 : '',
                values: (_131 = (_130 = params.properties.incidentInsuredPersonId) === null || _130 === void 0 ? void 0 : _130.values) !== null && _131 !== void 0 ? _131 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentHasAlcoholOrDrugsInvolved: {
                value: (_133 = (_132 = params.properties.incidentHasAlcoholOrDrugsInvolved) === null || _132 === void 0 ? void 0 : _132.value) !== null && _133 !== void 0 ? _133 : '',
                values: (_135 = (_134 = params.properties.incidentHasAlcoholOrDrugsInvolved) === null || _134 === void 0 ? void 0 : _134.values) !== null && _135 !== void 0 ? _135 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentIsWideAccident: {
                value: (_137 = (_136 = params.properties.incidentIsWideAccident) === null || _136 === void 0 ? void 0 : _136.value) !== null && _137 !== void 0 ? _137 : '',
                values: (_139 = (_138 = params.properties.incidentIsWideAccident) === null || _138 === void 0 ? void 0 : _138.values) !== null && _139 !== void 0 ? _139 : [],
                defaultValue: '',
                possibleValues: null,
            }, mRIPermission: {
                value: (_141 = (_140 = params.properties.mRIPermission) === null || _140 === void 0 ? void 0 : _140.value) !== null && _141 !== void 0 ? _141 : '',
                values: (_143 = (_142 = params.properties.mRIPermission) === null || _142 === void 0 ? void 0 : _142.values) !== null && _143 !== void 0 ? _143 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterCity: {
                value: (_145 = (_144 = params.properties.reporterCity) === null || _144 === void 0 ? void 0 : _144.value) !== null && _145 !== void 0 ? _145 : '',
                values: (_147 = (_146 = params.properties.reporterCity) === null || _146 === void 0 ? void 0 : _146.values) !== null && _147 !== void 0 ? _147 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterCustomerNumber: {
                value: (_149 = (_148 = params.properties.reporterCustomerNumber) === null || _148 === void 0 ? void 0 : _148.value) !== null && _149 !== void 0 ? _149 : '',
                values: (_151 = (_150 = params.properties.reporterCustomerNumber) === null || _150 === void 0 ? void 0 : _150.values) !== null && _151 !== void 0 ? _151 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentInsuredCustomerNumber: {
                value: (_153 = (_152 = params.properties.incidentInsuredCustomerNumber) === null || _152 === void 0 ? void 0 : _152.value) !== null && _153 !== void 0 ? _153 : '',
                values: (_155 = (_154 = params.properties.incidentInsuredCustomerNumber) === null || _154 === void 0 ? void 0 : _154.values) !== null && _155 !== void 0 ? _155 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyHolderCustomerNumber: {
                value: (_157 = (_156 = params.properties.policyHolderCustomerNumber) === null || _156 === void 0 ? void 0 : _156.value) !== null && _157 !== void 0 ? _157 : '',
                values: (_159 = (_158 = params.properties.policyHolderCustomerNumber) === null || _158 === void 0 ? void 0 : _158.values) !== null && _159 !== void 0 ? _159 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterEmailAddress: {
                value: (_161 = (_160 = params.properties.reporterEmailAddress) === null || _160 === void 0 ? void 0 : _160.value) !== null && _161 !== void 0 ? _161 : '',
                values: (_163 = (_162 = params.properties.reporterEmailAddress) === null || _162 === void 0 ? void 0 : _162.values) !== null && _163 !== void 0 ? _163 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterFirstName: {
                value: (_165 = (_164 = params.properties.reporterFirstName) === null || _164 === void 0 ? void 0 : _164.value) !== null && _165 !== void 0 ? _165 : '',
                values: (_167 = (_166 = params.properties.reporterFirstName) === null || _166 === void 0 ? void 0 : _166.values) !== null && _167 !== void 0 ? _167 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterLastName: {
                value: (_169 = (_168 = params.properties.reporterLastName) === null || _168 === void 0 ? void 0 : _168.value) !== null && _169 !== void 0 ? _169 : '',
                values: (_171 = (_170 = params.properties.reporterLastName) === null || _170 === void 0 ? void 0 : _170.values) !== null && _171 !== void 0 ? _171 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPersonId: {
                value: (_173 = (_172 = params.properties.reporterPersonId) === null || _172 === void 0 ? void 0 : _172.value) !== null && _173 !== void 0 ? _173 : '',
                values: (_175 = (_174 = params.properties.reporterPersonId) === null || _174 === void 0 ? void 0 : _174.values) !== null && _175 !== void 0 ? _175 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPhoneNumber: {
                value: (_177 = (_176 = params.properties.reporterPhoneNumber) === null || _176 === void 0 ? void 0 : _176.value) !== null && _177 !== void 0 ? _177 : '',
                values: (_179 = (_178 = params.properties.reporterPhoneNumber) === null || _178 === void 0 ? void 0 : _178.values) !== null && _179 !== void 0 ? _179 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPostalCode: {
                value: (_181 = (_180 = params.properties.reporterPostalCode) === null || _180 === void 0 ? void 0 : _180.value) !== null && _181 !== void 0 ? _181 : '',
                values: (_183 = (_182 = params.properties.reporterPostalCode) === null || _182 === void 0 ? void 0 : _182.values) !== null && _183 !== void 0 ? _183 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterStreetAddress: {
                value: (_185 = (_184 = params.properties.reporterStreetAddress) === null || _184 === void 0 ? void 0 : _184.value) !== null && _185 !== void 0 ? _185 : '',
                values: (_187 = (_186 = params.properties.reporterStreetAddress) === null || _186 === void 0 ? void 0 : _186.values) !== null && _187 !== void 0 ? _187 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBankAccountNumber: {
                value: (_189 = (_188 = params.properties.compensationBankAccountNumber) === null || _188 === void 0 ? void 0 : _188.value) !== null && _189 !== void 0 ? _189 : '',
                values: (_191 = (_190 = params.properties.compensationBankAccountNumber) === null || _190 === void 0 ? void 0 : _190.values) !== null && _191 !== void 0 ? _191 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryFirstName: {
                value: (_193 = (_192 = params.properties.compensationBeneficiaryFirstName) === null || _192 === void 0 ? void 0 : _192.value) !== null && _193 !== void 0 ? _193 : '',
                values: (_195 = (_194 = params.properties.compensationBeneficiaryFirstName) === null || _194 === void 0 ? void 0 : _194.values) !== null && _195 !== void 0 ? _195 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryLastName: {
                value: (_197 = (_196 = params.properties.compensationBeneficiaryLastName) === null || _196 === void 0 ? void 0 : _196.value) !== null && _197 !== void 0 ? _197 : '',
                values: (_199 = (_198 = params.properties.compensationBeneficiaryLastName) === null || _198 === void 0 ? void 0 : _198.values) !== null && _199 !== void 0 ? _199 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryPersonId: {
                value: (_201 = (_200 = params.properties.compensationBeneficiaryPersonId) === null || _200 === void 0 ? void 0 : _200.value) !== null && _201 !== void 0 ? _201 : '',
                values: (_203 = (_202 = params.properties.compensationBeneficiaryPersonId) === null || _202 === void 0 ? void 0 : _202.values) !== null && _203 !== void 0 ? _203 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryPhoneNumber: {
                value: (_205 = (_204 = params.properties.compensationBeneficiaryPhoneNumber) === null || _204 === void 0 ? void 0 : _204.value) !== null && _205 !== void 0 ? _205 : '',
                values: (_207 = (_206 = params.properties.compensationBeneficiaryPhoneNumber) === null || _206 === void 0 ? void 0 : _206.values) !== null && _207 !== void 0 ? _207 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryRole: {
                value: (_209 = (_208 = params.properties.compensationBeneficiaryRole) === null || _208 === void 0 ? void 0 : _208.value) !== null && _209 !== void 0 ? _209 : '',
                values: (_211 = (_210 = params.properties.compensationBeneficiaryRole) === null || _210 === void 0 ? void 0 : _210.values) !== null && _211 !== void 0 ? _211 : [],
                defaultValue: '',
                possibleValues: null,
            }, liabilityReasons: {
                value: (_213 = (_212 = params.properties.liabilityReasons) === null || _212 === void 0 ? void 0 : _212.value) !== null && _213 !== void 0 ? _213 : '',
                values: (_215 = (_214 = params.properties.liabilityReasons) === null || _214 === void 0 ? void 0 : _214.values) !== null && _215 !== void 0 ? _215 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyUnitAtRiskNumber: {
                value: (_217 = (_216 = params.properties.policyUnitAtRiskNumber) === null || _216 === void 0 ? void 0 : _216.value) !== null && _217 !== void 0 ? _217 : '',
                values: (_219 = (_218 = params.properties.policyUnitAtRiskNumber) === null || _218 === void 0 ? void 0 : _218.values) !== null && _219 !== void 0 ? _219 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyUnitAtRisksCoverageNumber: {
                value: (_221 = (_220 = params.properties.policyUnitAtRisksCoverageNumber) === null || _220 === void 0 ? void 0 : _220.value) !== null && _221 !== void 0 ? _221 : '',
                values: (_223 = (_222 = params.properties.policyUnitAtRisksCoverageNumber) === null || _222 === void 0 ? void 0 : _222.values) !== null && _223 !== void 0 ? _223 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyUnitAtRisksCoverageType: {
                value: (_225 = (_224 = params.properties.policyUnitAtRisksCoverageType) === null || _224 === void 0 ? void 0 : _224.value) !== null && _225 !== void 0 ? _225 : '',
                values: (_227 = (_226 = params.properties.policyUnitAtRisksCoverageType) === null || _226 === void 0 ? void 0 : _226.values) !== null && _227 !== void 0 ? _227 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimsCount: {
                value: (_229 = (_228 = params.properties.claimsCount) === null || _228 === void 0 ? void 0 : _228.value) !== null && _229 !== void 0 ? _229 : '',
                values: (_231 = (_230 = params.properties.claimsCount) === null || _230 === void 0 ? void 0 : _230.values) !== null && _231 !== void 0 ? _231 : [],
                defaultValue: '',
                possibleValues: null,
            }, caseType: {
                value: (_233 = (_232 = params.properties.caseType) === null || _232 === void 0 ? void 0 : _232.value) !== null && _233 !== void 0 ? _233 : '',
                values: (_235 = (_234 = params.properties.caseType) === null || _234 === void 0 ? void 0 : _234.values) !== null && _235 !== void 0 ? _235 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimNumber: {
                value: (_237 = (_236 = params.properties.claimNumber) === null || _236 === void 0 ? void 0 : _236.value) !== null && _237 !== void 0 ? _237 : '',
                values: (_239 = (_238 = params.properties.claimNumber) === null || _238 === void 0 ? void 0 : _238.values) !== null && _239 !== void 0 ? _239 : [],
                defaultValue: '',
                possibleValues: null,
            }, powerOfAttorney: {
                value: (_241 = (_240 = params.properties.powerOfAttorney) === null || _240 === void 0 ? void 0 : _240.value) !== null && _241 !== void 0 ? _241 : '',
                values: (_243 = (_242 = params.properties.powerOfAttorney) === null || _242 === void 0 ? void 0 : _242.values) !== null && _243 !== void 0 ? _243 : [],
                defaultValue: '',
                possibleValues: null,
            }, loginInfoBankName: {
                value: (_245 = (_244 = params.properties.loginInfoBankName) === null || _244 === void 0 ? void 0 : _244.value) !== null && _245 !== void 0 ? _245 : '',
                values: (_247 = (_246 = params.properties.loginInfoBankName) === null || _246 === void 0 ? void 0 : _246.values) !== null && _247 !== void 0 ? _247 : [],
                defaultValue: '',
                possibleValues: null,
            }, loginInfoAuthTimestamp: {
                value: (_249 = (_248 = params.properties.loginInfoAuthTimestamp) === null || _248 === void 0 ? void 0 : _248.value) !== null && _249 !== void 0 ? _249 : '',
                values: (_251 = (_250 = params.properties.loginInfoAuthTimestamp) === null || _250 === void 0 ? void 0 : _250.values) !== null && _251 !== void 0 ? _251 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_253 = (_252 = params.properties.defaultValidationMessage) === null || _252 === void 0 ? void 0 : _252.value) !== null && _253 !== void 0 ? _253 : '',
                values: (_255 = (_254 = params.properties.defaultValidationMessage) === null || _254 === void 0 ? void 0 : _254.values) !== null && _255 !== void 0 ? _255 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Finland_PersonalInjury_GetInsuredPeopleNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { ssn: {
                value: (_b = (_a = params.properties.ssn) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.ssn) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'AvailableVariables',
                possibleValues: ['insuredPeople']
            }
        ];
    }
}
export class Finland_PersonalInjury_ShowInsuredPeopleNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { insuredPeople: {
                value: (_b = (_a = params.properties.insuredPeople) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.insuredPeople) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '[XXXXX.insuredPeople]',
                possibleValues: null,
            }, availableVariables: {
                value: (_f = (_e = params.properties.availableVariables) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.availableVariables) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: ['firstName', 'lastName', 'ssn', 'phone', 'bankAccount'],
            }, defaultValidationMessage: {
                value: (_k = (_j = params.properties.defaultValidationMessage) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.defaultValidationMessage) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Finland_WorkersCompensation_GetPoliciesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { customerNumber: {
                value: (_b = (_a = params.properties.customerNumber) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.customerNumber) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDate: {
                value: (_f = (_e = params.properties.incidentDate) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.incidentDate) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, policyNumber: {
                value: (_k = (_j = params.properties.policyNumber) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.policyNumber) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Finland_WorkersCompensation_ShowPoliciesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { policies: {
                value: (_b = (_a = params.properties.policies) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.policies) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'ChosenPolicy',
                possibleValues: []
            }, {
                name: 'PolicyNumber',
                possibleValues: []
            }, {
                name: 'HasOnePolicy',
                possibleValues: []
            }
        ];
    }
}
export class Finland_WorkersCompensation_GetUserInformationNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { customerNumber: {
                value: (_b = (_a = params.properties.customerNumber) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.customerNumber) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, nationalIdentity: {
                value: (_f = (_e = params.properties.nationalIdentity) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.nationalIdentity) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, nationalIdentityCountry: {
                value: (_k = (_j = params.properties.nationalIdentityCountry) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.nationalIdentityCountry) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: 'FI',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'role',
                possibleValues: []
            }
        ];
    }
}
export class Finland_WorkersCompensation_ShowExposuresNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { policy: {
                value: (_b = (_a = params.properties.policy) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.policy) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'ChosenExposure',
                possibleValues: []
            }, {
                name: 'ObjectId',
                possibleValues: []
            }, {
                name: 'DisplayName',
                possibleValues: []
            }, {
                name: 'ExposureType',
                possibleValues: []
            }
        ];
    }
}
export class Finland_WorkersCompensation_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { incidentDate: {
                value: (_b = (_a = params.properties.incidentDate) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.incidentDate) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '[incidentDate]',
                possibleValues: null,
            }, customerName: {
                value: (_f = (_e = params.properties.customerName) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.customerName) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '[customerName]',
                possibleValues: null,
            }, customerSsn: {
                value: (_k = (_j = params.properties.customerSsn) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.customerSsn) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '[customerSsn]',
                possibleValues: null,
            }, claimType: {
                value: (_p = (_o = params.properties.claimType) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.claimType) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '[claimType]',
                possibleValues: null,
            }, summary: {
                value: (_t = (_s = params.properties.summary) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.summary) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '[XXXXX.summaryContentOutput]',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_x = (_w = params.properties.defaultValidationMessage) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.defaultValidationMessage) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Finland_WorkersCompensation_ShowOccupationalClassesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { occupationalClasses: {
                value: (_b = (_a = params.properties.occupationalClasses) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.occupationalClasses) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'ChosenOccupationalClass',
                possibleValues: []
            }
        ];
    }
}
export class Finland_WorkersCompensation_GetOccupationalClassesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { chosenExposure: {
                value: (_b = (_a = params.properties.chosenExposure) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.chosenExposure) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, chosenExposureObjectId: {
                value: (_f = (_e = params.properties.chosenExposureObjectId) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.chosenExposureObjectId) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, chosenPolicy: {
                value: (_k = (_j = params.properties.chosenPolicy) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.chosenPolicy) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'OccupationalClasses',
                possibleValues: []
            }, {
                name: 'SingleOccupationalClass',
                possibleValues: []
            }
        ];
    }
}
export class Finland_Animal_CatBreedsNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { inputPlaceholder: {
                value: (_b = (_a = params.properties.inputPlaceholder) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.inputPlaceholder) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, noResultsFoundMessage: {
                value: (_f = (_e = params.properties.noResultsFoundMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.noResultsFoundMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, allowAnyValue: {
                value: (_k = (_j = params.properties.allowAnyValue) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.allowAnyValue) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: 'true',
                possibleValues: ['true', 'false'],
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'code',
                possibleValues: []
            }, {
                name: 'text',
                possibleValues: []
            }
        ];
    }
}
export class Finland_Animal_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143, _144, _145, _146, _147, _148, _149, _150, _151, _152, _153, _154, _155, _156, _157, _158, _159, _160, _161, _162, _163, _164, _165, _166, _167, _168, _169, _170, _171, _172, _173, _174, _175, _176, _177, _178, _179, _180, _181, _182, _183, _184, _185, _186, _187, _188, _189, _190, _191, _192, _193, _194, _195, _196, _197, _198, _199, _200, _201, _202, _203;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { reporterFirstName: {
                value: (_b = (_a = params.properties.reporterFirstName) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.reporterFirstName) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterLastName: {
                value: (_f = (_e = params.properties.reporterLastName) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.reporterLastName) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPersonId: {
                value: (_k = (_j = params.properties.reporterPersonId) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.reporterPersonId) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterStreetAddress: {
                value: (_p = (_o = params.properties.reporterStreetAddress) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.reporterStreetAddress) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPostalCode: {
                value: (_t = (_s = params.properties.reporterPostalCode) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.reporterPostalCode) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterCity: {
                value: (_x = (_w = params.properties.reporterCity) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.reporterCity) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPhoneNumber: {
                value: (_1 = (_0 = params.properties.reporterPhoneNumber) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.reporterPhoneNumber) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterEmailAddress: {
                value: (_5 = (_4 = params.properties.reporterEmailAddress) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.reporterEmailAddress) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterCustomerReference: {
                value: (_9 = (_8 = params.properties.reporterCustomerReference) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.reporterCustomerReference) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBankAccountNumber: {
                value: (_13 = (_12 = params.properties.compensationBankAccountNumber) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.compensationBankAccountNumber) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, isReportedPolicyHolder: {
                value: (_17 = (_16 = params.properties.isReportedPolicyHolder) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.isReportedPolicyHolder) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderFirstName: {
                value: (_21 = (_20 = params.properties.reportedPolicyHolderFirstName) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.reportedPolicyHolderFirstName) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderLastName: {
                value: (_25 = (_24 = params.properties.reportedPolicyHolderLastName) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.reportedPolicyHolderLastName) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderPersonId: {
                value: (_29 = (_28 = params.properties.reportedPolicyHolderPersonId) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.reportedPolicyHolderPersonId) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderStreetAddress: {
                value: (_33 = (_32 = params.properties.reportedPolicyHolderStreetAddress) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.reportedPolicyHolderStreetAddress) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderPostalCode: {
                value: (_37 = (_36 = params.properties.reportedPolicyHolderPostalCode) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.reportedPolicyHolderPostalCode) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderCity: {
                value: (_41 = (_40 = params.properties.reportedPolicyHolderCity) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.reportedPolicyHolderCity) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderPhoneNumber: {
                value: (_45 = (_44 = params.properties.reportedPolicyHolderPhoneNumber) === null || _44 === void 0 ? void 0 : _44.value) !== null && _45 !== void 0 ? _45 : '',
                values: (_47 = (_46 = params.properties.reportedPolicyHolderPhoneNumber) === null || _46 === void 0 ? void 0 : _46.values) !== null && _47 !== void 0 ? _47 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderEmailAddress: {
                value: (_49 = (_48 = params.properties.reportedPolicyHolderEmailAddress) === null || _48 === void 0 ? void 0 : _48.value) !== null && _49 !== void 0 ? _49 : '',
                values: (_51 = (_50 = params.properties.reportedPolicyHolderEmailAddress) === null || _50 === void 0 ? void 0 : _50.values) !== null && _51 !== void 0 ? _51 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryRole: {
                value: (_53 = (_52 = params.properties.compensationBeneficiaryRole) === null || _52 === void 0 ? void 0 : _52.value) !== null && _53 !== void 0 ? _53 : '',
                values: (_55 = (_54 = params.properties.compensationBeneficiaryRole) === null || _54 === void 0 ? void 0 : _54.values) !== null && _55 !== void 0 ? _55 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryFirstName: {
                value: (_57 = (_56 = params.properties.compensationBeneficiaryFirstName) === null || _56 === void 0 ? void 0 : _56.value) !== null && _57 !== void 0 ? _57 : '',
                values: (_59 = (_58 = params.properties.compensationBeneficiaryFirstName) === null || _58 === void 0 ? void 0 : _58.values) !== null && _59 !== void 0 ? _59 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryLastName: {
                value: (_61 = (_60 = params.properties.compensationBeneficiaryLastName) === null || _60 === void 0 ? void 0 : _60.value) !== null && _61 !== void 0 ? _61 : '',
                values: (_63 = (_62 = params.properties.compensationBeneficiaryLastName) === null || _62 === void 0 ? void 0 : _62.values) !== null && _63 !== void 0 ? _63 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryPersonId: {
                value: (_65 = (_64 = params.properties.compensationBeneficiaryPersonId) === null || _64 === void 0 ? void 0 : _64.value) !== null && _65 !== void 0 ? _65 : '',
                values: (_67 = (_66 = params.properties.compensationBeneficiaryPersonId) === null || _66 === void 0 ? void 0 : _66.values) !== null && _67 !== void 0 ? _67 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryStreetAddress: {
                value: (_69 = (_68 = params.properties.compensationBeneficiaryStreetAddress) === null || _68 === void 0 ? void 0 : _68.value) !== null && _69 !== void 0 ? _69 : '',
                values: (_71 = (_70 = params.properties.compensationBeneficiaryStreetAddress) === null || _70 === void 0 ? void 0 : _70.values) !== null && _71 !== void 0 ? _71 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryPostalCode: {
                value: (_73 = (_72 = params.properties.compensationBeneficiaryPostalCode) === null || _72 === void 0 ? void 0 : _72.value) !== null && _73 !== void 0 ? _73 : '',
                values: (_75 = (_74 = params.properties.compensationBeneficiaryPostalCode) === null || _74 === void 0 ? void 0 : _74.values) !== null && _75 !== void 0 ? _75 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryCity: {
                value: (_77 = (_76 = params.properties.compensationBeneficiaryCity) === null || _76 === void 0 ? void 0 : _76.value) !== null && _77 !== void 0 ? _77 : '',
                values: (_79 = (_78 = params.properties.compensationBeneficiaryCity) === null || _78 === void 0 ? void 0 : _78.values) !== null && _79 !== void 0 ? _79 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryPhoneNumber: {
                value: (_81 = (_80 = params.properties.compensationBeneficiaryPhoneNumber) === null || _80 === void 0 ? void 0 : _80.value) !== null && _81 !== void 0 ? _81 : '',
                values: (_83 = (_82 = params.properties.compensationBeneficiaryPhoneNumber) === null || _82 === void 0 ? void 0 : _82.values) !== null && _83 !== void 0 ? _83 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryEmailAddress: {
                value: (_85 = (_84 = params.properties.compensationBeneficiaryEmailAddress) === null || _84 === void 0 ? void 0 : _84.value) !== null && _85 !== void 0 ? _85 : '',
                values: (_87 = (_86 = params.properties.compensationBeneficiaryEmailAddress) === null || _86 === void 0 ? void 0 : _86.values) !== null && _87 !== void 0 ? _87 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationCostItemsCaruselNode: {
                value: (_89 = (_88 = params.properties.compensationCostItemsCaruselNode) === null || _88 === void 0 ? void 0 : _88.value) !== null && _89 !== void 0 ? _89 : '',
                values: (_91 = (_90 = params.properties.compensationCostItemsCaruselNode) === null || _90 === void 0 ? void 0 : _90.values) !== null && _91 !== void 0 ? _91 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationCostType: {
                value: (_93 = (_92 = params.properties.compensationCostType) === null || _92 === void 0 ? void 0 : _92.value) !== null && _93 !== void 0 ? _93 : '',
                values: (_95 = (_94 = params.properties.compensationCostType) === null || _94 === void 0 ? void 0 : _94.values) !== null && _95 !== void 0 ? _95 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationCostDescription: {
                value: (_97 = (_96 = params.properties.compensationCostDescription) === null || _96 === void 0 ? void 0 : _96.value) !== null && _97 !== void 0 ? _97 : '',
                values: (_99 = (_98 = params.properties.compensationCostDescription) === null || _98 === void 0 ? void 0 : _98.values) !== null && _99 !== void 0 ? _99 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationCostDate: {
                value: (_101 = (_100 = params.properties.compensationCostDate) === null || _100 === void 0 ? void 0 : _100.value) !== null && _101 !== void 0 ? _101 : '',
                values: (_103 = (_102 = params.properties.compensationCostDate) === null || _102 === void 0 ? void 0 : _102.values) !== null && _103 !== void 0 ? _103 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationCostAmount: {
                value: (_105 = (_104 = params.properties.compensationCostAmount) === null || _104 === void 0 ? void 0 : _104.value) !== null && _105 !== void 0 ? _105 : '',
                values: (_107 = (_106 = params.properties.compensationCostAmount) === null || _106 === void 0 ? void 0 : _106.values) !== null && _107 !== void 0 ? _107 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDate: {
                value: (_109 = (_108 = params.properties.incidentDate) === null || _108 === void 0 ? void 0 : _108.value) !== null && _109 !== void 0 ? _109 : '',
                values: (_111 = (_110 = params.properties.incidentDate) === null || _110 === void 0 ? void 0 : _110.values) !== null && _111 !== void 0 ? _111 : [],
                defaultValue: '',
                possibleValues: null,
            }, deathDate: {
                value: (_113 = (_112 = params.properties.deathDate) === null || _112 === void 0 ? void 0 : _112.value) !== null && _113 !== void 0 ? _113 : '',
                values: (_115 = (_114 = params.properties.deathDate) === null || _114 === void 0 ? void 0 : _114.values) !== null && _115 !== void 0 ? _115 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentCountry: {
                value: (_117 = (_116 = params.properties.incidentCountry) === null || _116 === void 0 ? void 0 : _116.value) !== null && _117 !== void 0 ? _117 : '',
                values: (_119 = (_118 = params.properties.incidentCountry) === null || _118 === void 0 ? void 0 : _118.values) !== null && _119 !== void 0 ? _119 : [],
                defaultValue: '',
                possibleValues: null,
            }, circumstanceDescr: {
                value: (_121 = (_120 = params.properties.circumstanceDescr) === null || _120 === void 0 ? void 0 : _120.value) !== null && _121 !== void 0 ? _121 : '',
                values: (_123 = (_122 = params.properties.circumstanceDescr) === null || _122 === void 0 ? void 0 : _122.values) !== null && _123 !== void 0 ? _123 : [],
                defaultValue: '',
                possibleValues: null,
            }, diagnosisCode: {
                value: (_125 = (_124 = params.properties.diagnosisCode) === null || _124 === void 0 ? void 0 : _124.value) !== null && _125 !== void 0 ? _125 : '',
                values: (_127 = (_126 = params.properties.diagnosisCode) === null || _126 === void 0 ? void 0 : _126.values) !== null && _127 !== void 0 ? _127 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentType: {
                value: (_129 = (_128 = params.properties.incidentType) === null || _128 === void 0 ? void 0 : _128.value) !== null && _129 !== void 0 ? _129 : '',
                values: (_131 = (_130 = params.properties.incidentType) === null || _130 === void 0 ? void 0 : _130.values) !== null && _131 !== void 0 ? _131 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentSymptomsStartedDate: {
                value: (_133 = (_132 = params.properties.incidentSymptomsStartedDate) === null || _132 === void 0 ? void 0 : _132.value) !== null && _133 !== void 0 ? _133 : '',
                values: (_135 = (_134 = params.properties.incidentSymptomsStartedDate) === null || _134 === void 0 ? void 0 : _134.values) !== null && _135 !== void 0 ? _135 : [],
                defaultValue: '',
                possibleValues: null,
            }, insuredAnimalSpecies: {
                value: (_137 = (_136 = params.properties.insuredAnimalSpecies) === null || _136 === void 0 ? void 0 : _136.value) !== null && _137 !== void 0 ? _137 : '',
                values: (_139 = (_138 = params.properties.insuredAnimalSpecies) === null || _138 === void 0 ? void 0 : _138.values) !== null && _139 !== void 0 ? _139 : [],
                defaultValue: '',
                possibleValues: null,
            }, insuredAnimalNickName: {
                value: (_141 = (_140 = params.properties.insuredAnimalNickName) === null || _140 === void 0 ? void 0 : _140.value) !== null && _141 !== void 0 ? _141 : '',
                values: (_143 = (_142 = params.properties.insuredAnimalNickName) === null || _142 === void 0 ? void 0 : _142.values) !== null && _143 !== void 0 ? _143 : [],
                defaultValue: '',
                possibleValues: null,
            }, insuredAnimalOfficialName: {
                value: (_145 = (_144 = params.properties.insuredAnimalOfficialName) === null || _144 === void 0 ? void 0 : _144.value) !== null && _145 !== void 0 ? _145 : '',
                values: (_147 = (_146 = params.properties.insuredAnimalOfficialName) === null || _146 === void 0 ? void 0 : _146.values) !== null && _147 !== void 0 ? _147 : [],
                defaultValue: '',
                possibleValues: null,
            }, insuredAnimalBreed: {
                value: (_149 = (_148 = params.properties.insuredAnimalBreed) === null || _148 === void 0 ? void 0 : _148.value) !== null && _149 !== void 0 ? _149 : '',
                values: (_151 = (_150 = params.properties.insuredAnimalBreed) === null || _150 === void 0 ? void 0 : _150.values) !== null && _151 !== void 0 ? _151 : [],
                defaultValue: '',
                possibleValues: null,
            }, insuredAnimalBreedDescription: {
                value: (_153 = (_152 = params.properties.insuredAnimalBreedDescription) === null || _152 === void 0 ? void 0 : _152.value) !== null && _153 !== void 0 ? _153 : '',
                values: (_155 = (_154 = params.properties.insuredAnimalBreedDescription) === null || _154 === void 0 ? void 0 : _154.values) !== null && _155 !== void 0 ? _155 : [],
                defaultValue: '',
                possibleValues: null,
            }, insuredAnimalDateOfBirth: {
                value: (_157 = (_156 = params.properties.insuredAnimalDateOfBirth) === null || _156 === void 0 ? void 0 : _156.value) !== null && _157 !== void 0 ? _157 : '',
                values: (_159 = (_158 = params.properties.insuredAnimalDateOfBirth) === null || _158 === void 0 ? void 0 : _158.values) !== null && _159 !== void 0 ? _159 : [],
                defaultValue: '',
                possibleValues: null,
            }, insuredAnimalGender: {
                value: (_161 = (_160 = params.properties.insuredAnimalGender) === null || _160 === void 0 ? void 0 : _160.value) !== null && _161 !== void 0 ? _161 : '',
                values: (_163 = (_162 = params.properties.insuredAnimalGender) === null || _162 === void 0 ? void 0 : _162.values) !== null && _163 !== void 0 ? _163 : [],
                defaultValue: '',
                possibleValues: null,
            }, insuredAnimalOwnerType: {
                value: (_165 = (_164 = params.properties.insuredAnimalOwnerType) === null || _164 === void 0 ? void 0 : _164.value) !== null && _165 !== void 0 ? _165 : '',
                values: (_167 = (_166 = params.properties.insuredAnimalOwnerType) === null || _166 === void 0 ? void 0 : _166.values) !== null && _167 !== void 0 ? _167 : [],
                defaultValue: '',
                possibleValues: null,
            }, insuredAnimalOwnerName: {
                value: (_169 = (_168 = params.properties.insuredAnimalOwnerName) === null || _168 === void 0 ? void 0 : _168.value) !== null && _169 !== void 0 ? _169 : '',
                values: (_171 = (_170 = params.properties.insuredAnimalOwnerName) === null || _170 === void 0 ? void 0 : _170.values) !== null && _171 !== void 0 ? _171 : [],
                defaultValue: '',
                possibleValues: null,
            }, summaryDefinition: {
                value: (_173 = (_172 = params.properties.summaryDefinition) === null || _172 === void 0 ? void 0 : _172.value) !== null && _173 !== void 0 ? _173 : '',
                values: (_175 = (_174 = params.properties.summaryDefinition) === null || _174 === void 0 ? void 0 : _174.values) !== null && _175 !== void 0 ? _175 : [],
                defaultValue: '',
                possibleValues: null,
            }, channel: {
                value: (_177 = (_176 = params.properties.channel) === null || _176 === void 0 ? void 0 : _176.value) !== null && _177 !== void 0 ? _177 : '',
                values: (_179 = (_178 = params.properties.channel) === null || _178 === void 0 ? void 0 : _178.values) !== null && _179 !== void 0 ? _179 : [],
                defaultValue: '',
                possibleValues: null,
            }, customerName: {
                value: (_181 = (_180 = params.properties.customerName) === null || _180 === void 0 ? void 0 : _180.value) !== null && _181 !== void 0 ? _181 : '',
                values: (_183 = (_182 = params.properties.customerName) === null || _182 === void 0 ? void 0 : _182.values) !== null && _183 !== void 0 ? _183 : [],
                defaultValue: '',
                possibleValues: null,
            }, customerEmail: {
                value: (_185 = (_184 = params.properties.customerEmail) === null || _184 === void 0 ? void 0 : _184.value) !== null && _185 !== void 0 ? _185 : '',
                values: (_187 = (_186 = params.properties.customerEmail) === null || _186 === void 0 ? void 0 : _186.values) !== null && _187 !== void 0 ? _187 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimType: {
                value: (_189 = (_188 = params.properties.claimType) === null || _188 === void 0 ? void 0 : _188.value) !== null && _189 !== void 0 ? _189 : '',
                values: (_191 = (_190 = params.properties.claimType) === null || _190 === void 0 ? void 0 : _190.values) !== null && _191 !== void 0 ? _191 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyNumber: {
                value: (_193 = (_192 = params.properties.policyNumber) === null || _192 === void 0 ? void 0 : _192.value) !== null && _193 !== void 0 ? _193 : '',
                values: (_195 = (_194 = params.properties.policyNumber) === null || _194 === void 0 ? void 0 : _194.values) !== null && _195 !== void 0 ? _195 : [],
                defaultValue: '',
                possibleValues: null,
            }, objectSearchXml: {
                value: (_197 = (_196 = params.properties.objectSearchXml) === null || _196 === void 0 ? void 0 : _196.value) !== null && _197 !== void 0 ? _197 : '',
                values: (_199 = (_198 = params.properties.objectSearchXml) === null || _198 === void 0 ? void 0 : _198.values) !== null && _199 !== void 0 ? _199 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_201 = (_200 = params.properties.defaultValidationMessage) === null || _200 === void 0 ? void 0 : _200.value) !== null && _201 !== void 0 ? _201 : '',
                values: (_203 = (_202 = params.properties.defaultValidationMessage) === null || _202 === void 0 ? void 0 : _202.values) !== null && _203 !== void 0 ? _203 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Finland_Animal_DogBreedsNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { inputPlaceholder: {
                value: (_b = (_a = params.properties.inputPlaceholder) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.inputPlaceholder) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, noResultsFoundMessage: {
                value: (_f = (_e = params.properties.noResultsFoundMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.noResultsFoundMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, allowAnyValue: {
                value: (_k = (_j = params.properties.allowAnyValue) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.allowAnyValue) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: 'true',
                possibleValues: ['true', 'false'],
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'code',
                possibleValues: []
            }, {
                name: 'text',
                possibleValues: []
            }
        ];
    }
}
export class Finland_Animal_AnimalDiagnosisNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { inputPlaceholder: {
                value: (_b = (_a = params.properties.inputPlaceholder) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.inputPlaceholder) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, noResultsFoundMessage: {
                value: (_f = (_e = params.properties.noResultsFoundMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.noResultsFoundMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, allowAnyValue: {
                value: (_k = (_j = params.properties.allowAnyValue) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.allowAnyValue) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'code',
                possibleValues: []
            }, {
                name: 'text',
                possibleValues: []
            }
        ];
    }
}
export class Finland_Animal_GetPoliciesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { customerSsn: {
                value: (_b = (_a = params.properties.customerSsn) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.customerSsn) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDate: {
                value: (_f = (_e = params.properties.incidentDate) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.incidentDate) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_k = (_j = params.properties.defaultValidationMessage) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.defaultValidationMessage) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'Policies',
                possibleValues: []
            }, {
                name: 'chosenPolicy',
                possibleValues: []
            }, {
                name: 'policyNumber',
                possibleValues: []
            }, {
                name: 'animalName',
                possibleValues: []
            }, {
                name: 'dateOfBirth',
                possibleValues: []
            }, {
                name: 'animalSex',
                possibleValues: []
            }, {
                name: 'externalInformation',
                possibleValues: []
            }, {
                name: 'animalSpecies',
                possibleValues: []
            }, {
                name: 'animalBreed',
                possibleValues: []
            }
        ];
    }
}
export class Finland_Animal_ShowPoliciesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { policies: {
                value: (_b = (_a = params.properties.policies) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.policies) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'chosenPolicy',
                possibleValues: []
            }, {
                name: 'policyNumber',
                possibleValues: []
            }, {
                name: 'animalName',
                possibleValues: []
            }, {
                name: 'dateOfBirth',
                possibleValues: []
            }, {
                name: 'animalSex',
                possibleValues: []
            }, {
                name: 'externalInformation',
                possibleValues: []
            }, {
                name: 'animalSpecies',
                possibleValues: []
            }, {
                name: 'animalBreed',
                possibleValues: []
            }
        ];
    }
}
export class Finland_Property_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143, _144, _145, _146, _147, _148, _149, _150, _151, _152, _153, _154, _155, _156, _157, _158, _159, _160, _161, _162, _163, _164, _165, _166, _167, _168, _169, _170, _171, _172, _173, _174, _175, _176, _177, _178, _179, _180, _181, _182, _183, _184, _185, _186, _187, _188, _189, _190, _191, _192, _193, _194, _195, _196, _197, _198, _199, _200, _201, _202, _203, _204, _205, _206, _207, _208, _209, _210, _211, _212, _213, _214, _215, _216, _217, _218, _219, _220, _221, _222, _223;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { policyHolderSsn: {
                value: (_b = (_a = params.properties.policyHolderSsn) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.policyHolderSsn) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, policyHolderFirstname: {
                value: (_f = (_e = params.properties.policyHolderFirstname) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.policyHolderFirstname) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, policyHolderSurname: {
                value: (_k = (_j = params.properties.policyHolderSurname) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.policyHolderSurname) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, policyHolderAddress: {
                value: (_p = (_o = params.properties.policyHolderAddress) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.policyHolderAddress) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, policyHolderPostCode: {
                value: (_t = (_s = params.properties.policyHolderPostCode) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.policyHolderPostCode) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterCity: {
                value: (_x = (_w = params.properties.reporterCity) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.reporterCity) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, policyHolderPhone: {
                value: (_1 = (_0 = params.properties.policyHolderPhone) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.policyHolderPhone) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyHolderEmail: {
                value: (_5 = (_4 = params.properties.policyHolderEmail) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.policyHolderEmail) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyHolderCity: {
                value: (_9 = (_8 = params.properties.policyHolderCity) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.policyHolderCity) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantSsn: {
                value: (_13 = (_12 = params.properties.claimantSsn) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.claimantSsn) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantFirstname: {
                value: (_17 = (_16 = params.properties.claimantFirstname) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.claimantFirstname) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantSurname: {
                value: (_21 = (_20 = params.properties.claimantSurname) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.claimantSurname) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantAddress: {
                value: (_25 = (_24 = params.properties.claimantAddress) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.claimantAddress) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantPostCode: {
                value: (_29 = (_28 = params.properties.claimantPostCode) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.claimantPostCode) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantCity: {
                value: (_33 = (_32 = params.properties.claimantCity) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.claimantCity) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantPhone: {
                value: (_37 = (_36 = params.properties.claimantPhone) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.claimantPhone) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantEmail: {
                value: (_41 = (_40 = params.properties.claimantEmail) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.claimantEmail) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantBankAccountNumber: {
                value: (_45 = (_44 = params.properties.claimantBankAccountNumber) === null || _44 === void 0 ? void 0 : _44.value) !== null && _45 !== void 0 ? _45 : '',
                values: (_47 = (_46 = params.properties.claimantBankAccountNumber) === null || _46 === void 0 ? void 0 : _46.values) !== null && _47 !== void 0 ? _47 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterSsn: {
                value: (_49 = (_48 = params.properties.reporterSsn) === null || _48 === void 0 ? void 0 : _48.value) !== null && _49 !== void 0 ? _49 : '',
                values: (_51 = (_50 = params.properties.reporterSsn) === null || _50 === void 0 ? void 0 : _50.values) !== null && _51 !== void 0 ? _51 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterFirstname: {
                value: (_53 = (_52 = params.properties.reporterFirstname) === null || _52 === void 0 ? void 0 : _52.value) !== null && _53 !== void 0 ? _53 : '',
                values: (_55 = (_54 = params.properties.reporterFirstname) === null || _54 === void 0 ? void 0 : _54.values) !== null && _55 !== void 0 ? _55 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterSurname: {
                value: (_57 = (_56 = params.properties.reporterSurname) === null || _56 === void 0 ? void 0 : _56.value) !== null && _57 !== void 0 ? _57 : '',
                values: (_59 = (_58 = params.properties.reporterSurname) === null || _58 === void 0 ? void 0 : _58.values) !== null && _59 !== void 0 ? _59 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPhone: {
                value: (_61 = (_60 = params.properties.reporterPhone) === null || _60 === void 0 ? void 0 : _60.value) !== null && _61 !== void 0 ? _61 : '',
                values: (_63 = (_62 = params.properties.reporterPhone) === null || _62 === void 0 ? void 0 : _62.values) !== null && _63 !== void 0 ? _63 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterEmail: {
                value: (_65 = (_64 = params.properties.reporterEmail) === null || _64 === void 0 ? void 0 : _64.value) !== null && _65 !== void 0 ? _65 : '',
                values: (_67 = (_66 = params.properties.reporterEmail) === null || _66 === void 0 ? void 0 : _66.values) !== null && _67 !== void 0 ? _67 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterAddress: {
                value: (_69 = (_68 = params.properties.reporterAddress) === null || _68 === void 0 ? void 0 : _68.value) !== null && _69 !== void 0 ? _69 : '',
                values: (_71 = (_70 = params.properties.reporterAddress) === null || _70 === void 0 ? void 0 : _70.values) !== null && _71 !== void 0 ? _71 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPostCode: {
                value: (_73 = (_72 = params.properties.reporterPostCode) === null || _72 === void 0 ? void 0 : _72.value) !== null && _73 !== void 0 ? _73 : '',
                values: (_75 = (_74 = params.properties.reporterPostCode) === null || _74 === void 0 ? void 0 : _74.values) !== null && _75 !== void 0 ? _75 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentType: {
                value: (_77 = (_76 = params.properties.incidentType) === null || _76 === void 0 ? void 0 : _76.value) !== null && _77 !== void 0 ? _77 : '',
                values: (_79 = (_78 = params.properties.incidentType) === null || _78 === void 0 ? void 0 : _78.values) !== null && _79 !== void 0 ? _79 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentHasHappenedWhileTraveling: {
                value: (_81 = (_80 = params.properties.incidentHasHappenedWhileTraveling) === null || _80 === void 0 ? void 0 : _80.value) !== null && _81 !== void 0 ? _81 : '',
                values: (_83 = (_82 = params.properties.incidentHasHappenedWhileTraveling) === null || _82 === void 0 ? void 0 : _82.values) !== null && _83 !== void 0 ? _83 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDate: {
                value: (_85 = (_84 = params.properties.incidentDate) === null || _84 === void 0 ? void 0 : _84.value) !== null && _85 !== void 0 ? _85 : '',
                values: (_87 = (_86 = params.properties.incidentDate) === null || _86 === void 0 ? void 0 : _86.values) !== null && _87 !== void 0 ? _87 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDescription: {
                value: (_89 = (_88 = params.properties.incidentDescription) === null || _88 === void 0 ? void 0 : _88.value) !== null && _89 !== void 0 ? _89 : '',
                values: (_91 = (_90 = params.properties.incidentDescription) === null || _90 === void 0 ? void 0 : _90.values) !== null && _91 !== void 0 ? _91 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAddressStreet: {
                value: (_93 = (_92 = params.properties.incidentAddressStreet) === null || _92 === void 0 ? void 0 : _92.value) !== null && _93 !== void 0 ? _93 : '',
                values: (_95 = (_94 = params.properties.incidentAddressStreet) === null || _94 === void 0 ? void 0 : _94.values) !== null && _95 !== void 0 ? _95 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAddressCity: {
                value: (_97 = (_96 = params.properties.incidentAddressCity) === null || _96 === void 0 ? void 0 : _96.value) !== null && _97 !== void 0 ? _97 : '',
                values: (_99 = (_98 = params.properties.incidentAddressCity) === null || _98 === void 0 ? void 0 : _98.values) !== null && _99 !== void 0 ? _99 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAddressPostalCode: {
                value: (_101 = (_100 = params.properties.incidentAddressPostalCode) === null || _100 === void 0 ? void 0 : _100.value) !== null && _101 !== void 0 ? _101 : '',
                values: (_103 = (_102 = params.properties.incidentAddressPostalCode) === null || _102 === void 0 ? void 0 : _102.values) !== null && _103 !== void 0 ? _103 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAddressCountry: {
                value: (_105 = (_104 = params.properties.incidentAddressCountry) === null || _104 === void 0 ? void 0 : _104.value) !== null && _105 !== void 0 ? _105 : '',
                values: (_107 = (_106 = params.properties.incidentAddressCountry) === null || _106 === void 0 ? void 0 : _106.values) !== null && _107 !== void 0 ? _107 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentAddressMunicipality: {
                value: (_109 = (_108 = params.properties.incidentAddressMunicipality) === null || _108 === void 0 ? void 0 : _108.value) !== null && _109 !== void 0 ? _109 : '',
                values: (_111 = (_110 = params.properties.incidentAddressMunicipality) === null || _110 === void 0 ? void 0 : _110.values) !== null && _111 !== void 0 ? _111 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentWhenDidTravelStart: {
                value: (_113 = (_112 = params.properties.incidentWhenDidTravelStart) === null || _112 === void 0 ? void 0 : _112.value) !== null && _113 !== void 0 ? _113 : '',
                values: (_115 = (_114 = params.properties.incidentWhenDidTravelStart) === null || _114 === void 0 ? void 0 : _114.values) !== null && _115 !== void 0 ? _115 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentPoliceReport: {
                value: (_117 = (_116 = params.properties.incidentPoliceReport) === null || _116 === void 0 ? void 0 : _116.value) !== null && _117 !== void 0 ? _117 : '',
                values: (_119 = (_118 = params.properties.incidentPoliceReport) === null || _118 === void 0 ? void 0 : _118.values) !== null && _119 !== void 0 ? _119 : [],
                defaultValue: '',
                possibleValues: null,
            }, partnerPermisson: {
                value: (_121 = (_120 = params.properties.partnerPermisson) === null || _120 === void 0 ? void 0 : _120.value) !== null && _121 !== void 0 ? _121 : '',
                values: (_123 = (_122 = params.properties.partnerPermisson) === null || _122 === void 0 ? void 0 : _122.values) !== null && _123 !== void 0 ? _123 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTheftLastSeenDate: {
                value: (_125 = (_124 = params.properties.incidentTheftLastSeenDate) === null || _124 === void 0 ? void 0 : _124.value) !== null && _125 !== void 0 ? _125 : '',
                values: (_127 = (_126 = params.properties.incidentTheftLastSeenDate) === null || _126 === void 0 ? void 0 : _126.values) !== null && _127 !== void 0 ? _127 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTheftLastSeenTime: {
                value: (_129 = (_128 = params.properties.incidentTheftLastSeenTime) === null || _128 === void 0 ? void 0 : _128.value) !== null && _129 !== void 0 ? _129 : '',
                values: (_131 = (_130 = params.properties.incidentTheftLastSeenTime) === null || _130 === void 0 ? void 0 : _130.values) !== null && _131 !== void 0 ? _131 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTheftWhenNoticedDate: {
                value: (_133 = (_132 = params.properties.incidentTheftWhenNoticedDate) === null || _132 === void 0 ? void 0 : _132.value) !== null && _133 !== void 0 ? _133 : '',
                values: (_135 = (_134 = params.properties.incidentTheftWhenNoticedDate) === null || _134 === void 0 ? void 0 : _134.values) !== null && _135 !== void 0 ? _135 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTheftWhenNoticedTime: {
                value: (_137 = (_136 = params.properties.incidentTheftWhenNoticedTime) === null || _136 === void 0 ? void 0 : _136.value) !== null && _137 !== void 0 ? _137 : '',
                values: (_139 = (_138 = params.properties.incidentTheftWhenNoticedTime) === null || _138 === void 0 ? void 0 : _138.values) !== null && _139 !== void 0 ? _139 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTheftLastSeenLocationDescription: {
                value: (_141 = (_140 = params.properties.incidentTheftLastSeenLocationDescription) === null || _140 === void 0 ? void 0 : _140.value) !== null && _141 !== void 0 ? _141 : '',
                values: (_143 = (_142 = params.properties.incidentTheftLastSeenLocationDescription) === null || _142 === void 0 ? void 0 : _142.values) !== null && _143 !== void 0 ? _143 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectsCarouselName: {
                value: (_145 = (_144 = params.properties.lossObjectsCarouselName) === null || _144 === void 0 ? void 0 : _144.value) !== null && _145 !== void 0 ? _145 : '',
                values: (_147 = (_146 = params.properties.lossObjectsCarouselName) === null || _146 === void 0 ? void 0 : _146.values) !== null && _147 !== void 0 ? _147 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectType: {
                value: (_149 = (_148 = params.properties.lossObjectType) === null || _148 === void 0 ? void 0 : _148.value) !== null && _149 !== void 0 ? _149 : '',
                values: (_151 = (_150 = params.properties.lossObjectType) === null || _150 === void 0 ? void 0 : _150.values) !== null && _151 !== void 0 ? _151 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectMake: {
                value: (_153 = (_152 = params.properties.lossObjectMake) === null || _152 === void 0 ? void 0 : _152.value) !== null && _153 !== void 0 ? _153 : '',
                values: (_155 = (_154 = params.properties.lossObjectMake) === null || _154 === void 0 ? void 0 : _154.values) !== null && _155 !== void 0 ? _155 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectOtherItemDamaged: {
                value: (_157 = (_156 = params.properties.lossObjectOtherItemDamaged) === null || _156 === void 0 ? void 0 : _156.value) !== null && _157 !== void 0 ? _157 : '',
                values: (_159 = (_158 = params.properties.lossObjectOtherItemDamaged) === null || _158 === void 0 ? void 0 : _158.values) !== null && _159 !== void 0 ? _159 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectModel: {
                value: (_161 = (_160 = params.properties.lossObjectModel) === null || _160 === void 0 ? void 0 : _160.value) !== null && _161 !== void 0 ? _161 : '',
                values: (_163 = (_162 = params.properties.lossObjectModel) === null || _162 === void 0 ? void 0 : _162.values) !== null && _163 !== void 0 ? _163 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectDescription: {
                value: (_165 = (_164 = params.properties.lossObjectDescription) === null || _164 === void 0 ? void 0 : _164.value) !== null && _165 !== void 0 ? _165 : '',
                values: (_167 = (_166 = params.properties.lossObjectDescription) === null || _166 === void 0 ? void 0 : _166.values) !== null && _167 !== void 0 ? _167 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectAge: {
                value: (_169 = (_168 = params.properties.lossObjectAge) === null || _168 === void 0 ? void 0 : _168.value) !== null && _169 !== void 0 ? _169 : '',
                values: (_171 = (_170 = params.properties.lossObjectAge) === null || _170 === void 0 ? void 0 : _170.values) !== null && _171 !== void 0 ? _171 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectPriceAsNewAmount: {
                value: (_173 = (_172 = params.properties.lossObjectPriceAsNewAmount) === null || _172 === void 0 ? void 0 : _172.value) !== null && _173 !== void 0 ? _173 : '',
                values: (_175 = (_174 = params.properties.lossObjectPriceAsNewAmount) === null || _174 === void 0 ? void 0 : _174.values) !== null && _175 !== void 0 ? _175 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectRepairCostAmount: {
                value: (_177 = (_176 = params.properties.lossObjectRepairCostAmount) === null || _176 === void 0 ? void 0 : _176.value) !== null && _177 !== void 0 ? _177 : '',
                values: (_179 = (_178 = params.properties.lossObjectRepairCostAmount) === null || _178 === void 0 ? void 0 : _178.values) !== null && _179 !== void 0 ? _179 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectRepairType: {
                value: (_181 = (_180 = params.properties.lossObjectRepairType) === null || _180 === void 0 ? void 0 : _180.value) !== null && _181 !== void 0 ? _181 : '',
                values: (_183 = (_182 = params.properties.lossObjectRepairType) === null || _182 === void 0 ? void 0 : _182.values) !== null && _183 !== void 0 ? _183 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectOwnerName: {
                value: (_185 = (_184 = params.properties.lossObjectOwnerName) === null || _184 === void 0 ? void 0 : _184.value) !== null && _185 !== void 0 ? _185 : '',
                values: (_187 = (_186 = params.properties.lossObjectOwnerName) === null || _186 === void 0 ? void 0 : _186.values) !== null && _187 !== void 0 ? _187 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectOwnerType: {
                value: (_189 = (_188 = params.properties.lossObjectOwnerType) === null || _188 === void 0 ? void 0 : _188.value) !== null && _189 !== void 0 ? _189 : '',
                values: (_191 = (_190 = params.properties.lossObjectOwnerType) === null || _190 === void 0 ? void 0 : _190.values) !== null && _191 !== void 0 ? _191 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectOwnerIsSameHouseHold: {
                value: (_193 = (_192 = params.properties.lossObjectOwnerIsSameHouseHold) === null || _192 === void 0 ? void 0 : _192.value) !== null && _193 !== void 0 ? _193 : '',
                values: (_195 = (_194 = params.properties.lossObjectOwnerIsSameHouseHold) === null || _194 === void 0 ? void 0 : _194.values) !== null && _195 !== void 0 ? _195 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectOwnerPersonId: {
                value: (_197 = (_196 = params.properties.lossObjectOwnerPersonId) === null || _196 === void 0 ? void 0 : _196.value) !== null && _197 !== void 0 ? _197 : '',
                values: (_199 = (_198 = params.properties.lossObjectOwnerPersonId) === null || _198 === void 0 ? void 0 : _198.values) !== null && _199 !== void 0 ? _199 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectIsScreenDamaged: {
                value: (_201 = (_200 = params.properties.lossObjectIsScreenDamaged) === null || _200 === void 0 ? void 0 : _200.value) !== null && _201 !== void 0 ? _201 : '',
                values: (_203 = (_202 = params.properties.lossObjectIsScreenDamaged) === null || _202 === void 0 ? void 0 : _202.values) !== null && _203 !== void 0 ? _203 : [],
                defaultValue: '',
                possibleValues: null,
            }, hasBeenPurchasedAsUsed: {
                value: (_205 = (_204 = params.properties.hasBeenPurchasedAsUsed) === null || _204 === void 0 ? void 0 : _204.value) !== null && _205 !== void 0 ? _205 : '',
                values: (_207 = (_206 = params.properties.hasBeenPurchasedAsUsed) === null || _206 === void 0 ? void 0 : _206.values) !== null && _207 !== void 0 ? _207 : [],
                defaultValue: '',
                possibleValues: null,
            }, usedPhonePurchaseLocation: {
                value: (_209 = (_208 = params.properties.usedPhonePurchaseLocation) === null || _208 === void 0 ? void 0 : _208.value) !== null && _209 !== void 0 ? _209 : '',
                values: (_211 = (_210 = params.properties.usedPhonePurchaseLocation) === null || _210 === void 0 ? void 0 : _210.values) !== null && _211 !== void 0 ? _211 : [],
                defaultValue: '',
                possibleValues: null,
            }, summaryDefinition: {
                value: (_213 = (_212 = params.properties.summaryDefinition) === null || _212 === void 0 ? void 0 : _212.value) !== null && _213 !== void 0 ? _213 : '',
                values: (_215 = (_214 = params.properties.summaryDefinition) === null || _214 === void 0 ? void 0 : _214.values) !== null && _215 !== void 0 ? _215 : [],
                defaultValue: '',
                possibleValues: null,
            }, submissionChannel: {
                value: (_217 = (_216 = params.properties.submissionChannel) === null || _216 === void 0 ? void 0 : _216.value) !== null && _217 !== void 0 ? _217 : '',
                values: (_219 = (_218 = params.properties.submissionChannel) === null || _218 === void 0 ? void 0 : _218.values) !== null && _219 !== void 0 ? _219 : [],
                defaultValue: 'OpenPages',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_221 = (_220 = params.properties.defaultValidationMessage) === null || _220 === void 0 ? void 0 : _220.value) !== null && _221 !== void 0 ? _221 : '',
                values: (_223 = (_222 = params.properties.defaultValidationMessage) === null || _222 === void 0 ? void 0 : _222.values) !== null && _223 !== void 0 ? _223 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Finland_Boat_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143, _144, _145, _146, _147, _148, _149, _150, _151, _152, _153, _154, _155, _156, _157, _158, _159, _160, _161, _162, _163, _164, _165, _166, _167, _168, _169, _170, _171, _172, _173, _174, _175, _176, _177, _178, _179, _180, _181, _182, _183, _184, _185, _186, _187, _188, _189, _190, _191, _192, _193, _194, _195, _196, _197, _198, _199, _200, _201, _202, _203, _204, _205, _206, _207, _208, _209, _210, _211;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { accidentDate: {
                value: (_b = (_a = params.properties.accidentDate) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.accidentDate) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, accidentTime: {
                value: (_f = (_e = params.properties.accidentTime) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.accidentTime) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, domesticOrForeignCountry: {
                value: (_k = (_j = params.properties.domesticOrForeignCountry) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.domesticOrForeignCountry) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentCity: {
                value: (_p = (_o = params.properties.incidentCity) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.incidentCity) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentCountryNew: {
                value: (_t = (_s = params.properties.incidentCountryNew) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.incidentCountryNew) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, moreDefinedAccidentPlace: {
                value: (_x = (_w = params.properties.moreDefinedAccidentPlace) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.moreDefinedAccidentPlace) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, whatCausedAccident: {
                value: (_1 = (_0 = params.properties.whatCausedAccident) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.whatCausedAccident) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, fireCause: {
                value: (_5 = (_4 = params.properties.fireCause) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.fireCause) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentCauseDescription: {
                value: (_9 = (_8 = params.properties.incidentCauseDescription) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.incidentCauseDescription) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, descriptionOfTheAccidentAndDamages: {
                value: (_13 = (_12 = params.properties.descriptionOfTheAccidentAndDamages) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.descriptionOfTheAccidentAndDamages) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, descriptionOfTheAccidentAndDamagesTheft: {
                value: (_17 = (_16 = params.properties.descriptionOfTheAccidentAndDamagesTheft) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.descriptionOfTheAccidentAndDamagesTheft) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, lockedOrNot: {
                value: (_21 = (_20 = params.properties.lockedOrNot) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.lockedOrNot) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, howItemsWereLocked: {
                value: (_25 = (_24 = params.properties.howItemsWereLocked) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.howItemsWereLocked) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, policeReport: {
                value: (_29 = (_28 = params.properties.policeReport) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.policeReport) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            }, policeReportNr: {
                value: (_33 = (_32 = params.properties.policeReportNr) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.policeReportNr) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '',
                possibleValues: null,
            }, alcoholOrDrugs: {
                value: (_37 = (_36 = params.properties.alcoholOrDrugs) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.alcoholOrDrugs) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '',
                possibleValues: null,
            }, boatMakeAndModel: {
                value: (_41 = (_40 = params.properties.boatMakeAndModel) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.boatMakeAndModel) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '',
                possibleValues: null,
            }, isTheBoatRegistered: {
                value: (_45 = (_44 = params.properties.isTheBoatRegistered) === null || _44 === void 0 ? void 0 : _44.value) !== null && _45 !== void 0 ? _45 : '',
                values: (_47 = (_46 = params.properties.isTheBoatRegistered) === null || _46 === void 0 ? void 0 : _46.values) !== null && _47 !== void 0 ? _47 : [],
                defaultValue: '',
                possibleValues: null,
            }, boatRegisterNumber: {
                value: (_49 = (_48 = params.properties.boatRegisterNumber) === null || _48 === void 0 ? void 0 : _48.value) !== null && _49 !== void 0 ? _49 : '',
                values: (_51 = (_50 = params.properties.boatRegisterNumber) === null || _50 === void 0 ? void 0 : _50.values) !== null && _51 !== void 0 ? _51 : [],
                defaultValue: '',
                possibleValues: null,
            }, boatOwner: {
                value: (_53 = (_52 = params.properties.boatOwner) === null || _52 === void 0 ? void 0 : _52.value) !== null && _53 !== void 0 ? _53 : '',
                values: (_55 = (_54 = params.properties.boatOwner) === null || _54 === void 0 ? void 0 : _54.values) !== null && _55 !== void 0 ? _55 : [],
                defaultValue: '',
                possibleValues: null,
            }, boatOwnerBankName: {
                value: (_57 = (_56 = params.properties.boatOwnerBankName) === null || _56 === void 0 ? void 0 : _56.value) !== null && _57 !== void 0 ? _57 : '',
                values: (_59 = (_58 = params.properties.boatOwnerBankName) === null || _58 === void 0 ? void 0 : _58.values) !== null && _59 !== void 0 ? _59 : [],
                defaultValue: '',
                possibleValues: null,
            }, boatOwnerOtherName: {
                value: (_61 = (_60 = params.properties.boatOwnerOtherName) === null || _60 === void 0 ? void 0 : _60.value) !== null && _61 !== void 0 ? _61 : '',
                values: (_63 = (_62 = params.properties.boatOwnerOtherName) === null || _62 === void 0 ? void 0 : _62.values) !== null && _63 !== void 0 ? _63 : [],
                defaultValue: '',
                possibleValues: null,
            }, boatOwnerOtherSSN: {
                value: (_65 = (_64 = params.properties.boatOwnerOtherSSN) === null || _64 === void 0 ? void 0 : _64.value) !== null && _65 !== void 0 ? _65 : '',
                values: (_67 = (_66 = params.properties.boatOwnerOtherSSN) === null || _66 === void 0 ? void 0 : _66.values) !== null && _67 !== void 0 ? _67 : [],
                defaultValue: '',
                possibleValues: null,
            }, boatOwnersName: {
                value: (_69 = (_68 = params.properties.boatOwnersName) === null || _68 === void 0 ? void 0 : _68.value) !== null && _69 !== void 0 ? _69 : '',
                values: (_71 = (_70 = params.properties.boatOwnersName) === null || _70 === void 0 ? void 0 : _70.values) !== null && _71 !== void 0 ? _71 : [],
                defaultValue: '',
                possibleValues: null,
            }, rentalUsage: {
                value: (_73 = (_72 = params.properties.rentalUsage) === null || _72 === void 0 ? void 0 : _72.value) !== null && _73 !== void 0 ? _73 : '',
                values: (_75 = (_74 = params.properties.rentalUsage) === null || _74 === void 0 ? void 0 : _74.values) !== null && _75 !== void 0 ? _75 : [],
                defaultValue: '',
                possibleValues: null,
            }, rentalUsageWhat: {
                value: (_77 = (_76 = params.properties.rentalUsageWhat) === null || _76 === void 0 ? void 0 : _76.value) !== null && _77 !== void 0 ? _77 : '',
                values: (_79 = (_78 = params.properties.rentalUsageWhat) === null || _78 === void 0 ? void 0 : _78.values) !== null && _79 !== void 0 ? _79 : [],
                defaultValue: '',
                possibleValues: null,
            }, damageToMotor: {
                value: (_81 = (_80 = params.properties.damageToMotor) === null || _80 === void 0 ? void 0 : _80.value) !== null && _81 !== void 0 ? _81 : '',
                values: (_83 = (_82 = params.properties.damageToMotor) === null || _82 === void 0 ? void 0 : _82.values) !== null && _83 !== void 0 ? _83 : [],
                defaultValue: '',
                possibleValues: null,
            }, motorMakeAndModel: {
                value: (_85 = (_84 = params.properties.motorMakeAndModel) === null || _84 === void 0 ? void 0 : _84.value) !== null && _85 !== void 0 ? _85 : '',
                values: (_87 = (_86 = params.properties.motorMakeAndModel) === null || _86 === void 0 ? void 0 : _86.values) !== null && _87 !== void 0 ? _87 : [],
                defaultValue: '',
                possibleValues: null,
            }, motorDamages: {
                value: (_89 = (_88 = params.properties.motorDamages) === null || _88 === void 0 ? void 0 : _88.value) !== null && _89 !== void 0 ? _89 : '',
                values: (_91 = (_90 = params.properties.motorDamages) === null || _90 === void 0 ? void 0 : _90.values) !== null && _91 !== void 0 ? _91 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterFirstName: {
                value: (_93 = (_92 = params.properties.reporterFirstName) === null || _92 === void 0 ? void 0 : _92.value) !== null && _93 !== void 0 ? _93 : '',
                values: (_95 = (_94 = params.properties.reporterFirstName) === null || _94 === void 0 ? void 0 : _94.values) !== null && _95 !== void 0 ? _95 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterLastName: {
                value: (_97 = (_96 = params.properties.reporterLastName) === null || _96 === void 0 ? void 0 : _96.value) !== null && _97 !== void 0 ? _97 : '',
                values: (_99 = (_98 = params.properties.reporterLastName) === null || _98 === void 0 ? void 0 : _98.values) !== null && _99 !== void 0 ? _99 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPersonId: {
                value: (_101 = (_100 = params.properties.reporterPersonId) === null || _100 === void 0 ? void 0 : _100.value) !== null && _101 !== void 0 ? _101 : '',
                values: (_103 = (_102 = params.properties.reporterPersonId) === null || _102 === void 0 ? void 0 : _102.values) !== null && _103 !== void 0 ? _103 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterStreetAddress: {
                value: (_105 = (_104 = params.properties.reporterStreetAddress) === null || _104 === void 0 ? void 0 : _104.value) !== null && _105 !== void 0 ? _105 : '',
                values: (_107 = (_106 = params.properties.reporterStreetAddress) === null || _106 === void 0 ? void 0 : _106.values) !== null && _107 !== void 0 ? _107 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPostalCode: {
                value: (_109 = (_108 = params.properties.reporterPostalCode) === null || _108 === void 0 ? void 0 : _108.value) !== null && _109 !== void 0 ? _109 : '',
                values: (_111 = (_110 = params.properties.reporterPostalCode) === null || _110 === void 0 ? void 0 : _110.values) !== null && _111 !== void 0 ? _111 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterCity: {
                value: (_113 = (_112 = params.properties.reporterCity) === null || _112 === void 0 ? void 0 : _112.value) !== null && _113 !== void 0 ? _113 : '',
                values: (_115 = (_114 = params.properties.reporterCity) === null || _114 === void 0 ? void 0 : _114.values) !== null && _115 !== void 0 ? _115 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPhoneNumber: {
                value: (_117 = (_116 = params.properties.reporterPhoneNumber) === null || _116 === void 0 ? void 0 : _116.value) !== null && _117 !== void 0 ? _117 : '',
                values: (_119 = (_118 = params.properties.reporterPhoneNumber) === null || _118 === void 0 ? void 0 : _118.values) !== null && _119 !== void 0 ? _119 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterEmailAddress: {
                value: (_121 = (_120 = params.properties.reporterEmailAddress) === null || _120 === void 0 ? void 0 : _120.value) !== null && _121 !== void 0 ? _121 : '',
                values: (_123 = (_122 = params.properties.reporterEmailAddress) === null || _122 === void 0 ? void 0 : _122.values) !== null && _123 !== void 0 ? _123 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterCustomerReference: {
                value: (_125 = (_124 = params.properties.reporterCustomerReference) === null || _124 === void 0 ? void 0 : _124.value) !== null && _125 !== void 0 ? _125 : '',
                values: (_127 = (_126 = params.properties.reporterCustomerReference) === null || _126 === void 0 ? void 0 : _126.values) !== null && _127 !== void 0 ? _127 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterIsPolicyHolder: {
                value: (_129 = (_128 = params.properties.reporterIsPolicyHolder) === null || _128 === void 0 ? void 0 : _128.value) !== null && _129 !== void 0 ? _129 : '',
                values: (_131 = (_130 = params.properties.reporterIsPolicyHolder) === null || _130 === void 0 ? void 0 : _130.values) !== null && _131 !== void 0 ? _131 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderFirstName: {
                value: (_133 = (_132 = params.properties.reportedPolicyHolderFirstName) === null || _132 === void 0 ? void 0 : _132.value) !== null && _133 !== void 0 ? _133 : '',
                values: (_135 = (_134 = params.properties.reportedPolicyHolderFirstName) === null || _134 === void 0 ? void 0 : _134.values) !== null && _135 !== void 0 ? _135 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderLastName: {
                value: (_137 = (_136 = params.properties.reportedPolicyHolderLastName) === null || _136 === void 0 ? void 0 : _136.value) !== null && _137 !== void 0 ? _137 : '',
                values: (_139 = (_138 = params.properties.reportedPolicyHolderLastName) === null || _138 === void 0 ? void 0 : _138.values) !== null && _139 !== void 0 ? _139 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderPersonId: {
                value: (_141 = (_140 = params.properties.reportedPolicyHolderPersonId) === null || _140 === void 0 ? void 0 : _140.value) !== null && _141 !== void 0 ? _141 : '',
                values: (_143 = (_142 = params.properties.reportedPolicyHolderPersonId) === null || _142 === void 0 ? void 0 : _142.values) !== null && _143 !== void 0 ? _143 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderStreetAddress: {
                value: (_145 = (_144 = params.properties.reportedPolicyHolderStreetAddress) === null || _144 === void 0 ? void 0 : _144.value) !== null && _145 !== void 0 ? _145 : '',
                values: (_147 = (_146 = params.properties.reportedPolicyHolderStreetAddress) === null || _146 === void 0 ? void 0 : _146.values) !== null && _147 !== void 0 ? _147 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderPostalCode: {
                value: (_149 = (_148 = params.properties.reportedPolicyHolderPostalCode) === null || _148 === void 0 ? void 0 : _148.value) !== null && _149 !== void 0 ? _149 : '',
                values: (_151 = (_150 = params.properties.reportedPolicyHolderPostalCode) === null || _150 === void 0 ? void 0 : _150.values) !== null && _151 !== void 0 ? _151 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderCity: {
                value: (_153 = (_152 = params.properties.reportedPolicyHolderCity) === null || _152 === void 0 ? void 0 : _152.value) !== null && _153 !== void 0 ? _153 : '',
                values: (_155 = (_154 = params.properties.reportedPolicyHolderCity) === null || _154 === void 0 ? void 0 : _154.values) !== null && _155 !== void 0 ? _155 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderPhoneNumber: {
                value: (_157 = (_156 = params.properties.reportedPolicyHolderPhoneNumber) === null || _156 === void 0 ? void 0 : _156.value) !== null && _157 !== void 0 ? _157 : '',
                values: (_159 = (_158 = params.properties.reportedPolicyHolderPhoneNumber) === null || _158 === void 0 ? void 0 : _158.values) !== null && _159 !== void 0 ? _159 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderEmailAddress: {
                value: (_161 = (_160 = params.properties.reportedPolicyHolderEmailAddress) === null || _160 === void 0 ? void 0 : _160.value) !== null && _161 !== void 0 ? _161 : '',
                values: (_163 = (_162 = params.properties.reportedPolicyHolderEmailAddress) === null || _162 === void 0 ? void 0 : _162.values) !== null && _163 !== void 0 ? _163 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryRole: {
                value: (_165 = (_164 = params.properties.compensationBeneficiaryRole) === null || _164 === void 0 ? void 0 : _164.value) !== null && _165 !== void 0 ? _165 : '',
                values: (_167 = (_166 = params.properties.compensationBeneficiaryRole) === null || _166 === void 0 ? void 0 : _166.values) !== null && _167 !== void 0 ? _167 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryFirstName: {
                value: (_169 = (_168 = params.properties.compensationBeneficiaryFirstName) === null || _168 === void 0 ? void 0 : _168.value) !== null && _169 !== void 0 ? _169 : '',
                values: (_171 = (_170 = params.properties.compensationBeneficiaryFirstName) === null || _170 === void 0 ? void 0 : _170.values) !== null && _171 !== void 0 ? _171 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryLastName: {
                value: (_173 = (_172 = params.properties.compensationBeneficiaryLastName) === null || _172 === void 0 ? void 0 : _172.value) !== null && _173 !== void 0 ? _173 : '',
                values: (_175 = (_174 = params.properties.compensationBeneficiaryLastName) === null || _174 === void 0 ? void 0 : _174.values) !== null && _175 !== void 0 ? _175 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryPersonId: {
                value: (_177 = (_176 = params.properties.compensationBeneficiaryPersonId) === null || _176 === void 0 ? void 0 : _176.value) !== null && _177 !== void 0 ? _177 : '',
                values: (_179 = (_178 = params.properties.compensationBeneficiaryPersonId) === null || _178 === void 0 ? void 0 : _178.values) !== null && _179 !== void 0 ? _179 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryStreetAddress: {
                value: (_181 = (_180 = params.properties.compensationBeneficiaryStreetAddress) === null || _180 === void 0 ? void 0 : _180.value) !== null && _181 !== void 0 ? _181 : '',
                values: (_183 = (_182 = params.properties.compensationBeneficiaryStreetAddress) === null || _182 === void 0 ? void 0 : _182.values) !== null && _183 !== void 0 ? _183 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryPostalCode: {
                value: (_185 = (_184 = params.properties.compensationBeneficiaryPostalCode) === null || _184 === void 0 ? void 0 : _184.value) !== null && _185 !== void 0 ? _185 : '',
                values: (_187 = (_186 = params.properties.compensationBeneficiaryPostalCode) === null || _186 === void 0 ? void 0 : _186.values) !== null && _187 !== void 0 ? _187 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryCity: {
                value: (_189 = (_188 = params.properties.compensationBeneficiaryCity) === null || _188 === void 0 ? void 0 : _188.value) !== null && _189 !== void 0 ? _189 : '',
                values: (_191 = (_190 = params.properties.compensationBeneficiaryCity) === null || _190 === void 0 ? void 0 : _190.values) !== null && _191 !== void 0 ? _191 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryEmailAddress: {
                value: (_193 = (_192 = params.properties.compensationBeneficiaryEmailAddress) === null || _192 === void 0 ? void 0 : _192.value) !== null && _193 !== void 0 ? _193 : '',
                values: (_195 = (_194 = params.properties.compensationBeneficiaryEmailAddress) === null || _194 === void 0 ? void 0 : _194.values) !== null && _195 !== void 0 ? _195 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryPhoneNumber: {
                value: (_197 = (_196 = params.properties.compensationBeneficiaryPhoneNumber) === null || _196 === void 0 ? void 0 : _196.value) !== null && _197 !== void 0 ? _197 : '',
                values: (_199 = (_198 = params.properties.compensationBeneficiaryPhoneNumber) === null || _198 === void 0 ? void 0 : _198.values) !== null && _199 !== void 0 ? _199 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBankAccountNumber: {
                value: (_201 = (_200 = params.properties.compensationBankAccountNumber) === null || _200 === void 0 ? void 0 : _200.value) !== null && _201 !== void 0 ? _201 : '',
                values: (_203 = (_202 = params.properties.compensationBankAccountNumber) === null || _202 === void 0 ? void 0 : _202.values) !== null && _203 !== void 0 ? _203 : [],
                defaultValue: '',
                possibleValues: null,
            }, summaryDefinition: {
                value: (_205 = (_204 = params.properties.summaryDefinition) === null || _204 === void 0 ? void 0 : _204.value) !== null && _205 !== void 0 ? _205 : '',
                values: (_207 = (_206 = params.properties.summaryDefinition) === null || _206 === void 0 ? void 0 : _206.values) !== null && _207 !== void 0 ? _207 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_209 = (_208 = params.properties.defaultValidationMessage) === null || _208 === void 0 ? void 0 : _208.value) !== null && _209 !== void 0 ? _209 : '',
                values: (_211 = (_210 = params.properties.defaultValidationMessage) === null || _210 === void 0 ? void 0 : _210.values) !== null && _211 !== void 0 ? _211 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Finland_Into_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { reporterFirstName: {
                value: (_b = (_a = params.properties.reporterFirstName) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.reporterFirstName) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterLastName: {
                value: (_f = (_e = params.properties.reporterLastName) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.reporterLastName) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, customerSsn: {
                value: (_k = (_j = params.properties.customerSsn) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.customerSsn) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, customerCompanyID: {
                value: (_p = (_o = params.properties.customerCompanyID) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.customerCompanyID) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, customerNumber: {
                value: (_t = (_s = params.properties.customerNumber) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.customerNumber) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, customerEmail: {
                value: (_x = (_w = params.properties.customerEmail) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.customerEmail) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, customerPhoneNumber: {
                value: (_1 = (_0 = params.properties.customerPhoneNumber) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.customerPhoneNumber) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimNumber: {
                value: (_5 = (_4 = params.properties.claimNumber) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.claimNumber) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyNumber: {
                value: (_9 = (_8 = params.properties.policyNumber) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.policyNumber) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, vahaClaimIdentifier: {
                value: (_13 = (_12 = params.properties.vahaClaimIdentifier) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.vahaClaimIdentifier) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, sajPolicyNumber: {
                value: (_17 = (_16 = params.properties.sajPolicyNumber) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.sajPolicyNumber) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimDate: {
                value: (_21 = (_20 = params.properties.claimDate) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.claimDate) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, costDate: {
                value: (_25 = (_24 = params.properties.costDate) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.costDate) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimType: {
                value: (_29 = (_28 = params.properties.claimType) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.claimType) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            }, summary: {
                value: (_33 = (_32 = params.properties.summary) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.summary) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '',
                possibleValues: null,
            }, stargatePayloadType: {
                value: (_37 = (_36 = params.properties.stargatePayloadType) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.stargatePayloadType) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '',
                possibleValues: null,
            }, intoQueueId: {
                value: (_41 = (_40 = params.properties.intoQueueId) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.intoQueueId) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '',
                possibleValues: null,
            }, typeId: {
                value: (_45 = (_44 = params.properties.typeId) === null || _44 === void 0 ? void 0 : _44.value) !== null && _45 !== void 0 ? _45 : '',
                values: (_47 = (_46 = params.properties.typeId) === null || _46 === void 0 ? void 0 : _46.values) !== null && _47 !== void 0 ? _47 : [],
                defaultValue: '',
                possibleValues: null,
            }, headingData: {
                value: (_49 = (_48 = params.properties.headingData) === null || _48 === void 0 ? void 0 : _48.value) !== null && _49 !== void 0 ? _49 : '',
                values: (_51 = (_50 = params.properties.headingData) === null || _50 === void 0 ? void 0 : _50.values) !== null && _51 !== void 0 ? _51 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_53 = (_52 = params.properties.defaultValidationMessage) === null || _52 === void 0 ? void 0 : _52.value) !== null && _53 !== void 0 ? _53 : '',
                values: (_55 = (_54 = params.properties.defaultValidationMessage) === null || _54 === void 0 ? void 0 : _54.values) !== null && _55 !== void 0 ? _55 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Test_CountryNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { inputPlaceholder: {
                value: (_b = (_a = params.properties.inputPlaceholder) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.inputPlaceholder) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, noResultsFoundMessage: {
                value: (_f = (_e = params.properties.noResultsFoundMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.noResultsFoundMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, allowAnyValue: {
                value: (_k = (_j = params.properties.allowAnyValue) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.allowAnyValue) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'code',
                possibleValues: []
            }, {
                name: 'text',
                possibleValues: []
            }
        ];
    }
}
export class Norway_Property_GetPoliciesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { customerNumber: {
                value: (_b = (_a = params.properties.customerNumber) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.customerNumber) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, claimType: {
                value: (_f = (_e = params.properties.claimType) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.claimType) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_k = (_j = params.properties.defaultValidationMessage) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.defaultValidationMessage) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'PolicyData',
                possibleValues: []
            }, {
                name: 'ChosenPolicy',
                possibleValues: []
            }, {
                name: 'PolicyNumber',
                possibleValues: []
            }, {
                name: 'PolicyObjectNumber',
                possibleValues: []
            }, {
                name: 'ObjectInfo',
                possibleValues: []
            }
        ];
    }
}
export class Norway_Property_ShowPoliciesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { policyData: {
                value: (_b = (_a = params.properties.policyData) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.policyData) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'ChosenPolicy',
                possibleValues: []
            }, {
                name: 'PolicyNumber',
                possibleValues: []
            }, {
                name: 'PolicyObjectNumber',
                possibleValues: []
            }, {
                name: 'ObjectInfo',
                possibleValues: []
            }
        ];
    }
}
export class Norway_PersonalInjury_Commercial_GetPoliciesNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { policyNumber: {
                value: (_b = (_a = params.properties.policyNumber) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.policyNumber) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDate: {
                value: (_f = (_e = params.properties.incidentDate) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.incidentDate) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, resultProperties: {
                value: (_k = (_j = params.properties.resultProperties) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.resultProperties) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: ['Result', 'policyCustomerNumber', 'policyNumberFound'],
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Norway_PersonalInjury_Commercial_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { claimantAddress: {
                value: (_b = (_a = params.properties.claimantAddress) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.claimantAddress) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantCity: {
                value: (_f = (_e = params.properties.claimantCity) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.claimantCity) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantCountry: {
                value: (_k = (_j = params.properties.claimantCountry) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.claimantCountry) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantEmail: {
                value: (_p = (_o = params.properties.claimantEmail) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.claimantEmail) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantFirstName: {
                value: (_t = (_s = params.properties.claimantFirstName) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.claimantFirstName) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantPhone: {
                value: (_x = (_w = params.properties.claimantPhone) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.claimantPhone) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantPostCode: {
                value: (_1 = (_0 = params.properties.claimantPostCode) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.claimantPostCode) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantSocialSecurityNumber: {
                value: (_5 = (_4 = params.properties.claimantSocialSecurityNumber) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.claimantSocialSecurityNumber) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantSurname: {
                value: (_9 = (_8 = params.properties.claimantSurname) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.claimantSurname) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantType: {
                value: (_13 = (_12 = params.properties.claimantType) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.claimantType) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimantCustomerNumber: {
                value: (_17 = (_16 = params.properties.claimantCustomerNumber) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.claimantCustomerNumber) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, countryId: {
                value: (_21 = (_20 = params.properties.countryId) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.countryId) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, countryName: {
                value: (_25 = (_24 = params.properties.countryName) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.countryName) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, placeOfAccidentLocation: {
                value: (_29 = (_28 = params.properties.placeOfAccidentLocation) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.placeOfAccidentLocation) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterEmail: {
                value: (_33 = (_32 = params.properties.reporterEmail) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.reporterEmail) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterFirstName: {
                value: (_37 = (_36 = params.properties.reporterFirstName) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.reporterFirstName) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPhoneNumber: {
                value: (_41 = (_40 = params.properties.reporterPhoneNumber) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.reporterPhoneNumber) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterSocialSecurityNumber: {
                value: (_45 = (_44 = params.properties.reporterSocialSecurityNumber) === null || _44 === void 0 ? void 0 : _44.value) !== null && _45 !== void 0 ? _45 : '',
                values: (_47 = (_46 = params.properties.reporterSocialSecurityNumber) === null || _46 === void 0 ? void 0 : _46.values) !== null && _47 !== void 0 ? _47 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterSurname: {
                value: (_49 = (_48 = params.properties.reporterSurname) === null || _48 === void 0 ? void 0 : _48.value) !== null && _49 !== void 0 ? _49 : '',
                values: (_51 = (_50 = params.properties.reporterSurname) === null || _50 === void 0 ? void 0 : _50.values) !== null && _51 !== void 0 ? _51 : [],
                defaultValue: '',
                possibleValues: null,
            }, description: {
                value: (_53 = (_52 = params.properties.description) === null || _52 === void 0 ? void 0 : _52.value) !== null && _53 !== void 0 ? _53 : '',
                values: (_55 = (_54 = params.properties.description) === null || _54 === void 0 ? void 0 : _54.values) !== null && _55 !== void 0 ? _55 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimType: {
                value: (_57 = (_56 = params.properties.claimType) === null || _56 === void 0 ? void 0 : _56.value) !== null && _57 !== void 0 ? _57 : '',
                values: (_59 = (_58 = params.properties.claimType) === null || _58 === void 0 ? void 0 : _58.values) !== null && _59 !== void 0 ? _59 : [],
                defaultValue: '',
                possibleValues: null,
            }, policyNumber: {
                value: (_61 = (_60 = params.properties.policyNumber) === null || _60 === void 0 ? void 0 : _60.value) !== null && _61 !== void 0 ? _61 : '',
                values: (_63 = (_62 = params.properties.policyNumber) === null || _62 === void 0 ? void 0 : _62.values) !== null && _63 !== void 0 ? _63 : [],
                defaultValue: '',
                possibleValues: null,
            }, claimDate: {
                value: (_65 = (_64 = params.properties.claimDate) === null || _64 === void 0 ? void 0 : _64.value) !== null && _65 !== void 0 ? _65 : '',
                values: (_67 = (_66 = params.properties.claimDate) === null || _66 === void 0 ? void 0 : _66.values) !== null && _67 !== void 0 ? _67 : [],
                defaultValue: '',
                possibleValues: null,
            }, employmentDateStart: {
                value: (_69 = (_68 = params.properties.employmentDateStart) === null || _68 === void 0 ? void 0 : _68.value) !== null && _69 !== void 0 ? _69 : '',
                values: (_71 = (_70 = params.properties.employmentDateStart) === null || _70 === void 0 ? void 0 : _70.values) !== null && _71 !== void 0 ? _71 : [],
                defaultValue: '',
                possibleValues: null,
            }, summaryDefinition: {
                value: (_73 = (_72 = params.properties.summaryDefinition) === null || _72 === void 0 ? void 0 : _72.value) !== null && _73 !== void 0 ? _73 : '',
                values: (_75 = (_74 = params.properties.summaryDefinition) === null || _74 === void 0 ? void 0 : _74.values) !== null && _75 !== void 0 ? _75 : [],
                defaultValue: '[XXXXX.summaryContentOutput]',
                possibleValues: null,
            }, languageCode: {
                value: (_77 = (_76 = params.properties.languageCode) === null || _76 === void 0 ? void 0 : _76.value) !== null && _77 !== void 0 ? _77 : '',
                values: (_79 = (_78 = params.properties.languageCode) === null || _78 === void 0 ? void 0 : _78.values) !== null && _79 !== void 0 ? _79 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_81 = (_80 = params.properties.defaultValidationMessage) === null || _80 === void 0 ? void 0 : _80.value) !== null && _81 !== void 0 ? _81 : '',
                values: (_83 = (_82 = params.properties.defaultValidationMessage) === null || _82 === void 0 ? void 0 : _82.values) !== null && _83 !== void 0 ? _83 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Norway_Expatriates_CountryNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { inputPlaceholder: {
                value: (_b = (_a = params.properties.inputPlaceholder) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.inputPlaceholder) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, noResultsFoundMessage: {
                value: (_f = (_e = params.properties.noResultsFoundMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.noResultsFoundMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, allowAnyValue: {
                value: (_k = (_j = params.properties.allowAnyValue) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.allowAnyValue) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'code',
                possibleValues: []
            }, {
                name: 'text',
                possibleValues: []
            }
        ];
    }
}
export class Norway_Expatriates_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { travelType: {
                value: (_b = (_a = params.properties.travelType) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.travelType) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '[travelType]',
                possibleValues: null,
            }, cancellationCause: {
                value: (_f = (_e = params.properties.cancellationCause) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.cancellationCause) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '[cancellationCause]',
                possibleValues: null,
            }, policyNumber: {
                value: (_k = (_j = params.properties.policyNumber) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.policyNumber) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '[policyNumber]',
                possibleValues: null,
            }, claimantListNodeName: {
                value: (_p = (_o = params.properties.claimantListNodeName) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.claimantListNodeName) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: 'claimantListNodeName',
                possibleValues: null,
            }, claimantTypeTextNodeName: {
                value: (_t = (_s = params.properties.claimantTypeTextNodeName) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.claimantTypeTextNodeName) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: 'claimantTypeText',
                possibleValues: null,
            }, wpClaimantTypeNodeName: {
                value: (_x = (_w = params.properties.wpClaimantTypeNodeName) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.wpClaimantTypeNodeName) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: 'wpClaimantType',
                possibleValues: null,
            }, claimantNameNodeName: {
                value: (_1 = (_0 = params.properties.claimantNameNodeName) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.claimantNameNodeName) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: 'ClaimantNameDataId',
                possibleValues: null,
            }, claimantSurnameNodeName: {
                value: (_5 = (_4 = params.properties.claimantSurnameNodeName) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.claimantSurnameNodeName) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: 'ClaimantSurnameDataId',
                possibleValues: null,
            }, claimantSsnNodeName: {
                value: (_9 = (_8 = params.properties.claimantSsnNodeName) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.claimantSsnNodeName) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: 'ClaimantSsnDataId',
                possibleValues: null,
            }, claimantCountryNodeName: {
                value: (_13 = (_12 = params.properties.claimantCountryNodeName) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.claimantCountryNodeName) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: 'ClaimantCountryDataId',
                possibleValues: null,
            }, destinationCountry: {
                value: (_17 = (_16 = params.properties.destinationCountry) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.destinationCountry) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '[destinationCountry]',
                possibleValues: null,
            }, wpLuggageCauseType: {
                value: (_21 = (_20 = params.properties.wpLuggageCauseType) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.wpLuggageCauseType) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '[wpLuggageCauseType]',
                possibleValues: null,
            }, isTheClaimDueToCoronaVirus: {
                value: (_25 = (_24 = params.properties.isTheClaimDueToCoronaVirus) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.isTheClaimDueToCoronaVirus) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: 'false',
                possibleValues: null,
            }, incidentDate: {
                value: (_29 = (_28 = params.properties.incidentDate) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.incidentDate) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '[incidentDate]',
                possibleValues: null,
            }, routeStartDate: {
                value: (_33 = (_32 = params.properties.routeStartDate) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.routeStartDate) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '[routeStartDate]',
                possibleValues: null,
            }, claimType: {
                value: (_37 = (_36 = params.properties.claimType) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.claimType) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '[claimType]',
                possibleValues: null,
            }, claimTypeText: {
                value: (_41 = (_40 = params.properties.claimTypeText) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.claimTypeText) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '[claimTypeText]',
                possibleValues: null,
            }, businessArea: {
                value: (_45 = (_44 = params.properties.businessArea) === null || _44 === void 0 ? void 0 : _44.value) !== null && _45 !== void 0 ? _45 : '',
                values: (_47 = (_46 = params.properties.businessArea) === null || _46 === void 0 ? void 0 : _46.values) !== null && _47 !== void 0 ? _47 : [],
                defaultValue: '[businessArea]',
                possibleValues: null,
            }, authorizedUserNode: {
                value: (_49 = (_48 = params.properties.authorizedUserNode) === null || _48 === void 0 ? void 0 : _48.value) !== null && _49 !== void 0 ? _49 : '',
                values: (_51 = (_50 = params.properties.authorizedUserNode) === null || _50 === void 0 ? void 0 : _50.values) !== null && _51 !== void 0 ? _51 : [],
                defaultValue: '[authorizedUserNode]',
                possibleValues: null,
            }, summaryDefinition: {
                value: (_53 = (_52 = params.properties.summaryDefinition) === null || _52 === void 0 ? void 0 : _52.value) !== null && _53 !== void 0 ? _53 : '',
                values: (_55 = (_54 = params.properties.summaryDefinition) === null || _54 === void 0 ? void 0 : _54.values) !== null && _55 !== void 0 ? _55 : [],
                defaultValue: '[summaryDefinition.summaryContentOutput]',
                possibleValues: null,
            }, customerInformationNode: {
                value: (_57 = (_56 = params.properties.customerInformationNode) === null || _56 === void 0 ? void 0 : _56.value) !== null && _57 !== void 0 ? _57 : '',
                values: (_59 = (_58 = params.properties.customerInformationNode) === null || _58 === void 0 ? void 0 : _58.values) !== null && _59 !== void 0 ? _59 : [],
                defaultValue: '[customerInformationNode]',
                possibleValues: null,
            }, reporterEmail: {
                value: (_61 = (_60 = params.properties.reporterEmail) === null || _60 === void 0 ? void 0 : _60.value) !== null && _61 !== void 0 ? _61 : '',
                values: (_63 = (_62 = params.properties.reporterEmail) === null || _62 === void 0 ? void 0 : _62.values) !== null && _63 !== void 0 ? _63 : [],
                defaultValue: '[reporterEmail]',
                possibleValues: null,
            }, reporterPhone: {
                value: (_65 = (_64 = params.properties.reporterPhone) === null || _64 === void 0 ? void 0 : _64.value) !== null && _65 !== void 0 ? _65 : '',
                values: (_67 = (_66 = params.properties.reporterPhone) === null || _66 === void 0 ? void 0 : _66.values) !== null && _67 !== void 0 ? _67 : [],
                defaultValue: '[reporterPhone]',
                possibleValues: null,
            }, productArea: {
                value: (_69 = (_68 = params.properties.productArea) === null || _68 === void 0 ? void 0 : _68.value) !== null && _69 !== void 0 ? _69 : '',
                values: (_71 = (_70 = params.properties.productArea) === null || _70 === void 0 ? void 0 : _70.values) !== null && _71 !== void 0 ? _71 : [],
                defaultValue: '[productArea]',
                possibleValues: null,
            }, customerNumber: {
                value: (_73 = (_72 = params.properties.customerNumber) === null || _72 === void 0 ? void 0 : _72.value) !== null && _73 !== void 0 ? _73 : '',
                values: (_75 = (_74 = params.properties.customerNumber) === null || _74 === void 0 ? void 0 : _74.values) !== null && _75 !== void 0 ? _75 : [],
                defaultValue: '[customerNumber]',
                possibleValues: null,
            }, customerName: {
                value: (_77 = (_76 = params.properties.customerName) === null || _76 === void 0 ? void 0 : _76.value) !== null && _77 !== void 0 ? _77 : '',
                values: (_79 = (_78 = params.properties.customerName) === null || _78 === void 0 ? void 0 : _78.values) !== null && _79 !== void 0 ? _79 : [],
                defaultValue: '[customerName]',
                possibleValues: null,
            }, reporterName: {
                value: (_81 = (_80 = params.properties.reporterName) === null || _80 === void 0 ? void 0 : _80.value) !== null && _81 !== void 0 ? _81 : '',
                values: (_83 = (_82 = params.properties.reporterName) === null || _82 === void 0 ? void 0 : _82.values) !== null && _83 !== void 0 ? _83 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterSurname: {
                value: (_85 = (_84 = params.properties.reporterSurname) === null || _84 === void 0 ? void 0 : _84.value) !== null && _85 !== void 0 ? _85 : '',
                values: (_87 = (_86 = params.properties.reporterSurname) === null || _86 === void 0 ? void 0 : _86.values) !== null && _87 !== void 0 ? _87 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterSsn: {
                value: (_89 = (_88 = params.properties.reporterSsn) === null || _88 === void 0 ? void 0 : _88.value) !== null && _89 !== void 0 ? _89 : '',
                values: (_91 = (_90 = params.properties.reporterSsn) === null || _90 === void 0 ? void 0 : _90.values) !== null && _91 !== void 0 ? _91 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_93 = (_92 = params.properties.defaultValidationMessage) === null || _92 === void 0 ? void 0 : _92.value) !== null && _93 !== void 0 ? _93 : '',
                values: (_95 = (_94 = params.properties.defaultValidationMessage) === null || _94 === void 0 ? void 0 : _94.values) !== null && _95 !== void 0 ? _95 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Norway_Property_Private_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { claimType: {
                value: (_b = (_a = params.properties.claimType) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.claimType) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, customerName: {
                value: (_f = (_e = params.properties.customerName) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.customerName) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, customerEmail: {
                value: (_k = (_j = params.properties.customerEmail) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.customerEmail) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, customerPhone: {
                value: (_p = (_o = params.properties.customerPhone) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.customerPhone) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, policyNumber: {
                value: (_t = (_s = params.properties.policyNumber) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.policyNumber) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, policyObjectNumber: {
                value: (_x = (_w = params.properties.policyObjectNumber) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.policyObjectNumber) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDate: {
                value: (_1 = (_0 = params.properties.incidentDate) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.incidentDate) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, webFormCaimType: {
                value: (_5 = (_4 = params.properties.webFormCaimType) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.webFormCaimType) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, customerNumber: {
                value: (_9 = (_8 = params.properties.customerNumber) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.customerNumber) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, naturalDamageCode: {
                value: (_13 = (_12 = params.properties.naturalDamageCode) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.naturalDamageCode) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenSummaryDefinition: {
                value: (_17 = (_16 = params.properties.frontenSummaryDefinition) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.frontenSummaryDefinition) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '[SummaryDefinition]',
                possibleValues: null,
            }, frontenHtmlFileName: {
                value: (_21 = (_20 = params.properties.frontenHtmlFileName) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.frontenHtmlFileName) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenClaimReporterName: {
                value: (_25 = (_24 = params.properties.frontenClaimReporterName) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.frontenClaimReporterName) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenCategory: {
                value: (_29 = (_28 = params.properties.frontenCategory) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.frontenCategory) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            }, frontenQueue: {
                value: (_33 = (_32 = params.properties.frontenQueue) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.frontenQueue) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_37 = (_36 = params.properties.defaultValidationMessage) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.defaultValidationMessage) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Finland_Athletes_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { incidentDate: {
                value: (_b = (_a = params.properties.incidentDate) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.incidentDate) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '[incidentDate]',
                possibleValues: null,
            }, customerName: {
                value: (_f = (_e = params.properties.customerName) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.customerName) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '[customerName]',
                possibleValues: null,
            }, customerSsn: {
                value: (_k = (_j = params.properties.customerSsn) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.customerSsn) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '[customerSsn]',
                possibleValues: null,
            }, claimType: {
                value: (_p = (_o = params.properties.claimType) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.claimType) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '[claimType]',
                possibleValues: null,
            }, summary: {
                value: (_t = (_s = params.properties.summary) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.summary) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '[XXXXX.summaryContentOutput]',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_x = (_w = params.properties.defaultValidationMessage) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.defaultValidationMessage) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'sentClaimData',
                possibleValues: []
            }
        ];
    }
}
export class Finland_Travel_SendDataNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143, _144, _145, _146, _147, _148, _149, _150, _151, _152, _153, _154, _155, _156, _157, _158, _159, _160, _161, _162, _163, _164, _165, _166, _167, _168, _169, _170, _171, _172, _173, _174, _175, _176, _177, _178, _179, _180, _181, _182, _183, _184, _185, _186, _187, _188, _189, _190, _191, _192, _193, _194, _195, _196, _197, _198, _199, _200, _201, _202, _203, _204, _205, _206, _207, _208, _209, _210, _211, _212, _213, _214, _215, _216, _217, _218, _219, _220, _221, _222, _223, _224, _225, _226, _227, _228, _229, _230, _231, _232, _233, _234, _235, _236, _237, _238, _239, _240, _241, _242, _243, _244, _245, _246, _247, _248, _249, _250, _251, _252, _253, _254, _255, _256, _257, _258, _259, _260, _261, _262, _263, _264, _265, _266, _267, _268, _269, _270, _271, _272, _273, _274, _275, _276, _277, _278, _279;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { reporterCustomerReference: {
                value: (_b = (_a = params.properties.reporterCustomerReference) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.reporterCustomerReference) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPersonId: {
                value: (_f = (_e = params.properties.reporterPersonId) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.reporterPersonId) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterFirstName: {
                value: (_k = (_j = params.properties.reporterFirstName) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.reporterFirstName) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterLastName: {
                value: (_p = (_o = params.properties.reporterLastName) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.reporterLastName) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterStreetAddress: {
                value: (_t = (_s = params.properties.reporterStreetAddress) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                values: (_v = (_u = params.properties.reporterStreetAddress) === null || _u === void 0 ? void 0 : _u.values) !== null && _v !== void 0 ? _v : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterMunicipality: {
                value: (_x = (_w = params.properties.reporterMunicipality) === null || _w === void 0 ? void 0 : _w.value) !== null && _x !== void 0 ? _x : '',
                values: (_z = (_y = params.properties.reporterMunicipality) === null || _y === void 0 ? void 0 : _y.values) !== null && _z !== void 0 ? _z : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPostalCode: {
                value: (_1 = (_0 = params.properties.reporterPostalCode) === null || _0 === void 0 ? void 0 : _0.value) !== null && _1 !== void 0 ? _1 : '',
                values: (_3 = (_2 = params.properties.reporterPostalCode) === null || _2 === void 0 ? void 0 : _2.values) !== null && _3 !== void 0 ? _3 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterCity: {
                value: (_5 = (_4 = params.properties.reporterCity) === null || _4 === void 0 ? void 0 : _4.value) !== null && _5 !== void 0 ? _5 : '',
                values: (_7 = (_6 = params.properties.reporterCity) === null || _6 === void 0 ? void 0 : _6.values) !== null && _7 !== void 0 ? _7 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterPhoneNumber: {
                value: (_9 = (_8 = params.properties.reporterPhoneNumber) === null || _8 === void 0 ? void 0 : _8.value) !== null && _9 !== void 0 ? _9 : '',
                values: (_11 = (_10 = params.properties.reporterPhoneNumber) === null || _10 === void 0 ? void 0 : _10.values) !== null && _11 !== void 0 ? _11 : [],
                defaultValue: '',
                possibleValues: null,
            }, reporterEmailAddress: {
                value: (_13 = (_12 = params.properties.reporterEmailAddress) === null || _12 === void 0 ? void 0 : _12.value) !== null && _13 !== void 0 ? _13 : '',
                values: (_15 = (_14 = params.properties.reporterEmailAddress) === null || _14 === void 0 ? void 0 : _14.values) !== null && _15 !== void 0 ? _15 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderPersonId: {
                value: (_17 = (_16 = params.properties.reportedPolicyHolderPersonId) === null || _16 === void 0 ? void 0 : _16.value) !== null && _17 !== void 0 ? _17 : '',
                values: (_19 = (_18 = params.properties.reportedPolicyHolderPersonId) === null || _18 === void 0 ? void 0 : _18.values) !== null && _19 !== void 0 ? _19 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderFirstName: {
                value: (_21 = (_20 = params.properties.reportedPolicyHolderFirstName) === null || _20 === void 0 ? void 0 : _20.value) !== null && _21 !== void 0 ? _21 : '',
                values: (_23 = (_22 = params.properties.reportedPolicyHolderFirstName) === null || _22 === void 0 ? void 0 : _22.values) !== null && _23 !== void 0 ? _23 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderLastName: {
                value: (_25 = (_24 = params.properties.reportedPolicyHolderLastName) === null || _24 === void 0 ? void 0 : _24.value) !== null && _25 !== void 0 ? _25 : '',
                values: (_27 = (_26 = params.properties.reportedPolicyHolderLastName) === null || _26 === void 0 ? void 0 : _26.values) !== null && _27 !== void 0 ? _27 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderStreetAddress: {
                value: (_29 = (_28 = params.properties.reportedPolicyHolderStreetAddress) === null || _28 === void 0 ? void 0 : _28.value) !== null && _29 !== void 0 ? _29 : '',
                values: (_31 = (_30 = params.properties.reportedPolicyHolderStreetAddress) === null || _30 === void 0 ? void 0 : _30.values) !== null && _31 !== void 0 ? _31 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderMunicipality: {
                value: (_33 = (_32 = params.properties.reportedPolicyHolderMunicipality) === null || _32 === void 0 ? void 0 : _32.value) !== null && _33 !== void 0 ? _33 : '',
                values: (_35 = (_34 = params.properties.reportedPolicyHolderMunicipality) === null || _34 === void 0 ? void 0 : _34.values) !== null && _35 !== void 0 ? _35 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderPostalCode: {
                value: (_37 = (_36 = params.properties.reportedPolicyHolderPostalCode) === null || _36 === void 0 ? void 0 : _36.value) !== null && _37 !== void 0 ? _37 : '',
                values: (_39 = (_38 = params.properties.reportedPolicyHolderPostalCode) === null || _38 === void 0 ? void 0 : _38.values) !== null && _39 !== void 0 ? _39 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderCity: {
                value: (_41 = (_40 = params.properties.reportedPolicyHolderCity) === null || _40 === void 0 ? void 0 : _40.value) !== null && _41 !== void 0 ? _41 : '',
                values: (_43 = (_42 = params.properties.reportedPolicyHolderCity) === null || _42 === void 0 ? void 0 : _42.values) !== null && _43 !== void 0 ? _43 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderPhoneNumber: {
                value: (_45 = (_44 = params.properties.reportedPolicyHolderPhoneNumber) === null || _44 === void 0 ? void 0 : _44.value) !== null && _45 !== void 0 ? _45 : '',
                values: (_47 = (_46 = params.properties.reportedPolicyHolderPhoneNumber) === null || _46 === void 0 ? void 0 : _46.values) !== null && _47 !== void 0 ? _47 : [],
                defaultValue: '',
                possibleValues: null,
            }, reportedPolicyHolderEmailAddress: {
                value: (_49 = (_48 = params.properties.reportedPolicyHolderEmailAddress) === null || _48 === void 0 ? void 0 : _48.value) !== null && _49 !== void 0 ? _49 : '',
                values: (_51 = (_50 = params.properties.reportedPolicyHolderEmailAddress) === null || _50 === void 0 ? void 0 : _50.values) !== null && _51 !== void 0 ? _51 : [],
                defaultValue: '',
                possibleValues: null,
            }, isReportedPolicyHolder: {
                value: (_53 = (_52 = params.properties.isReportedPolicyHolder) === null || _52 === void 0 ? void 0 : _52.value) !== null && _53 !== void 0 ? _53 : '',
                values: (_55 = (_54 = params.properties.isReportedPolicyHolder) === null || _54 === void 0 ? void 0 : _54.values) !== null && _55 !== void 0 ? _55 : [],
                defaultValue: '',
                possibleValues: null,
            }, tradeUnion: {
                value: (_57 = (_56 = params.properties.tradeUnion) === null || _56 === void 0 ? void 0 : _56.value) !== null && _57 !== void 0 ? _57 : '',
                values: (_59 = (_58 = params.properties.tradeUnion) === null || _58 === void 0 ? void 0 : _58.values) !== null && _59 !== void 0 ? _59 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryRole: {
                value: (_61 = (_60 = params.properties.compensationBeneficiaryRole) === null || _60 === void 0 ? void 0 : _60.value) !== null && _61 !== void 0 ? _61 : '',
                values: (_63 = (_62 = params.properties.compensationBeneficiaryRole) === null || _62 === void 0 ? void 0 : _62.values) !== null && _63 !== void 0 ? _63 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBankAccountNumber: {
                value: (_65 = (_64 = params.properties.compensationBankAccountNumber) === null || _64 === void 0 ? void 0 : _64.value) !== null && _65 !== void 0 ? _65 : '',
                values: (_67 = (_66 = params.properties.compensationBankAccountNumber) === null || _66 === void 0 ? void 0 : _66.values) !== null && _67 !== void 0 ? _67 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryPersonId: {
                value: (_69 = (_68 = params.properties.compensationBeneficiaryPersonId) === null || _68 === void 0 ? void 0 : _68.value) !== null && _69 !== void 0 ? _69 : '',
                values: (_71 = (_70 = params.properties.compensationBeneficiaryPersonId) === null || _70 === void 0 ? void 0 : _70.values) !== null && _71 !== void 0 ? _71 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryFirstName: {
                value: (_73 = (_72 = params.properties.compensationBeneficiaryFirstName) === null || _72 === void 0 ? void 0 : _72.value) !== null && _73 !== void 0 ? _73 : '',
                values: (_75 = (_74 = params.properties.compensationBeneficiaryFirstName) === null || _74 === void 0 ? void 0 : _74.values) !== null && _75 !== void 0 ? _75 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryLastName: {
                value: (_77 = (_76 = params.properties.compensationBeneficiaryLastName) === null || _76 === void 0 ? void 0 : _76.value) !== null && _77 !== void 0 ? _77 : '',
                values: (_79 = (_78 = params.properties.compensationBeneficiaryLastName) === null || _78 === void 0 ? void 0 : _78.values) !== null && _79 !== void 0 ? _79 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryStreetAddress: {
                value: (_81 = (_80 = params.properties.compensationBeneficiaryStreetAddress) === null || _80 === void 0 ? void 0 : _80.value) !== null && _81 !== void 0 ? _81 : '',
                values: (_83 = (_82 = params.properties.compensationBeneficiaryStreetAddress) === null || _82 === void 0 ? void 0 : _82.values) !== null && _83 !== void 0 ? _83 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryMunicipality: {
                value: (_85 = (_84 = params.properties.compensationBeneficiaryMunicipality) === null || _84 === void 0 ? void 0 : _84.value) !== null && _85 !== void 0 ? _85 : '',
                values: (_87 = (_86 = params.properties.compensationBeneficiaryMunicipality) === null || _86 === void 0 ? void 0 : _86.values) !== null && _87 !== void 0 ? _87 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryPostalCode: {
                value: (_89 = (_88 = params.properties.compensationBeneficiaryPostalCode) === null || _88 === void 0 ? void 0 : _88.value) !== null && _89 !== void 0 ? _89 : '',
                values: (_91 = (_90 = params.properties.compensationBeneficiaryPostalCode) === null || _90 === void 0 ? void 0 : _90.values) !== null && _91 !== void 0 ? _91 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryCity: {
                value: (_93 = (_92 = params.properties.compensationBeneficiaryCity) === null || _92 === void 0 ? void 0 : _92.value) !== null && _93 !== void 0 ? _93 : '',
                values: (_95 = (_94 = params.properties.compensationBeneficiaryCity) === null || _94 === void 0 ? void 0 : _94.values) !== null && _95 !== void 0 ? _95 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryPhoneNumber: {
                value: (_97 = (_96 = params.properties.compensationBeneficiaryPhoneNumber) === null || _96 === void 0 ? void 0 : _96.value) !== null && _97 !== void 0 ? _97 : '',
                values: (_99 = (_98 = params.properties.compensationBeneficiaryPhoneNumber) === null || _98 === void 0 ? void 0 : _98.values) !== null && _99 !== void 0 ? _99 : [],
                defaultValue: '',
                possibleValues: null,
            }, compensationBeneficiaryEmailAddress: {
                value: (_101 = (_100 = params.properties.compensationBeneficiaryEmailAddress) === null || _100 === void 0 ? void 0 : _100.value) !== null && _101 !== void 0 ? _101 : '',
                values: (_103 = (_102 = params.properties.compensationBeneficiaryEmailAddress) === null || _102 === void 0 ? void 0 : _102.values) !== null && _103 !== void 0 ? _103 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentDate: {
                value: (_105 = (_104 = params.properties.incidentDate) === null || _104 === void 0 ? void 0 : _104.value) !== null && _105 !== void 0 ? _105 : '',
                values: (_107 = (_106 = params.properties.incidentDate) === null || _106 === void 0 ? void 0 : _106.values) !== null && _107 !== void 0 ? _107 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentType: {
                value: (_109 = (_108 = params.properties.incidentType) === null || _108 === void 0 ? void 0 : _108.value) !== null && _109 !== void 0 ? _109 : '',
                values: (_111 = (_110 = params.properties.incidentType) === null || _110 === void 0 ? void 0 : _110.values) !== null && _111 !== void 0 ? _111 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentCountry: {
                value: (_113 = (_112 = params.properties.incidentCountry) === null || _112 === void 0 ? void 0 : _112.value) !== null && _113 !== void 0 ? _113 : '',
                values: (_115 = (_114 = params.properties.incidentCountry) === null || _114 === void 0 ? void 0 : _114.values) !== null && _115 !== void 0 ? _115 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentCountryCode: {
                value: (_117 = (_116 = params.properties.incidentCountryCode) === null || _116 === void 0 ? void 0 : _116.value) !== null && _117 !== void 0 ? _117 : '',
                values: (_119 = (_118 = params.properties.incidentCountryCode) === null || _118 === void 0 ? void 0 : _118.values) !== null && _119 !== void 0 ? _119 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentMunicipality: {
                value: (_121 = (_120 = params.properties.incidentMunicipality) === null || _120 === void 0 ? void 0 : _120.value) !== null && _121 !== void 0 ? _121 : '',
                values: (_123 = (_122 = params.properties.incidentMunicipality) === null || _122 === void 0 ? void 0 : _122.values) !== null && _123 !== void 0 ? _123 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentMunicipalityCode: {
                value: (_125 = (_124 = params.properties.incidentMunicipalityCode) === null || _124 === void 0 ? void 0 : _124.value) !== null && _125 !== void 0 ? _125 : '',
                values: (_127 = (_126 = params.properties.incidentMunicipalityCode) === null || _126 === void 0 ? void 0 : _126.values) !== null && _127 !== void 0 ? _127 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentCircumstanceDescr: {
                value: (_129 = (_128 = params.properties.incidentCircumstanceDescr) === null || _128 === void 0 ? void 0 : _128.value) !== null && _129 !== void 0 ? _129 : '',
                values: (_131 = (_130 = params.properties.incidentCircumstanceDescr) === null || _130 === void 0 ? void 0 : _130.values) !== null && _131 !== void 0 ? _131 : [],
                defaultValue: '',
                possibleValues: null,
            }, incidentTravelStartDate: {
                value: (_133 = (_132 = params.properties.incidentTravelStartDate) === null || _132 === void 0 ? void 0 : _132.value) !== null && _133 !== void 0 ? _133 : '',
                values: (_135 = (_134 = params.properties.incidentTravelStartDate) === null || _134 === void 0 ? void 0 : _134.values) !== null && _135 !== void 0 ? _135 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectsCarouselName: {
                value: (_137 = (_136 = params.properties.lossObjectsCarouselName) === null || _136 === void 0 ? void 0 : _136.value) !== null && _137 !== void 0 ? _137 : '',
                values: (_139 = (_138 = params.properties.lossObjectsCarouselName) === null || _138 === void 0 ? void 0 : _138.values) !== null && _139 !== void 0 ? _139 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectType: {
                value: (_141 = (_140 = params.properties.lossObjectType) === null || _140 === void 0 ? void 0 : _140.value) !== null && _141 !== void 0 ? _141 : '',
                values: (_143 = (_142 = params.properties.lossObjectType) === null || _142 === void 0 ? void 0 : _142.values) !== null && _143 !== void 0 ? _143 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectTypeDesc: {
                value: (_145 = (_144 = params.properties.lossObjectTypeDesc) === null || _144 === void 0 ? void 0 : _144.value) !== null && _145 !== void 0 ? _145 : '',
                values: (_147 = (_146 = params.properties.lossObjectTypeDesc) === null || _146 === void 0 ? void 0 : _146.values) !== null && _147 !== void 0 ? _147 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectBrand: {
                value: (_149 = (_148 = params.properties.lossObjectBrand) === null || _148 === void 0 ? void 0 : _148.value) !== null && _149 !== void 0 ? _149 : '',
                values: (_151 = (_150 = params.properties.lossObjectBrand) === null || _150 === void 0 ? void 0 : _150.values) !== null && _151 !== void 0 ? _151 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectOtherBrand: {
                value: (_153 = (_152 = params.properties.lossObjectOtherBrand) === null || _152 === void 0 ? void 0 : _152.value) !== null && _153 !== void 0 ? _153 : '',
                values: (_155 = (_154 = params.properties.lossObjectOtherBrand) === null || _154 === void 0 ? void 0 : _154.values) !== null && _155 !== void 0 ? _155 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectModel: {
                value: (_157 = (_156 = params.properties.lossObjectModel) === null || _156 === void 0 ? void 0 : _156.value) !== null && _157 !== void 0 ? _157 : '',
                values: (_159 = (_158 = params.properties.lossObjectModel) === null || _158 === void 0 ? void 0 : _158.values) !== null && _159 !== void 0 ? _159 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectOtherModel: {
                value: (_161 = (_160 = params.properties.lossObjectOtherModel) === null || _160 === void 0 ? void 0 : _160.value) !== null && _161 !== void 0 ? _161 : '',
                values: (_163 = (_162 = params.properties.lossObjectOtherModel) === null || _162 === void 0 ? void 0 : _162.values) !== null && _163 !== void 0 ? _163 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectDeviceDescription: {
                value: (_165 = (_164 = params.properties.lossObjectDeviceDescription) === null || _164 === void 0 ? void 0 : _164.value) !== null && _165 !== void 0 ? _165 : '',
                values: (_167 = (_166 = params.properties.lossObjectDeviceDescription) === null || _166 === void 0 ? void 0 : _166.values) !== null && _167 !== void 0 ? _167 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectYearOfPurchace: {
                value: (_169 = (_168 = params.properties.lossObjectYearOfPurchace) === null || _168 === void 0 ? void 0 : _168.value) !== null && _169 !== void 0 ? _169 : '',
                values: (_171 = (_170 = params.properties.lossObjectYearOfPurchace) === null || _170 === void 0 ? void 0 : _170.values) !== null && _171 !== void 0 ? _171 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectNewPurchaseValue: {
                value: (_173 = (_172 = params.properties.lossObjectNewPurchaseValue) === null || _172 === void 0 ? void 0 : _172.value) !== null && _173 !== void 0 ? _173 : '',
                values: (_175 = (_174 = params.properties.lossObjectNewPurchaseValue) === null || _174 === void 0 ? void 0 : _174.values) !== null && _175 !== void 0 ? _175 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectRepairCosts: {
                value: (_177 = (_176 = params.properties.lossObjectRepairCosts) === null || _176 === void 0 ? void 0 : _176.value) !== null && _177 !== void 0 ? _177 : '',
                values: (_179 = (_178 = params.properties.lossObjectRepairCosts) === null || _178 === void 0 ? void 0 : _178.values) !== null && _179 !== void 0 ? _179 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectOwner: {
                value: (_181 = (_180 = params.properties.lossObjectOwner) === null || _180 === void 0 ? void 0 : _180.value) !== null && _181 !== void 0 ? _181 : '',
                values: (_183 = (_182 = params.properties.lossObjectOwner) === null || _182 === void 0 ? void 0 : _182.values) !== null && _183 !== void 0 ? _183 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectOwnerName: {
                value: (_185 = (_184 = params.properties.lossObjectOwnerName) === null || _184 === void 0 ? void 0 : _184.value) !== null && _185 !== void 0 ? _185 : '',
                values: (_187 = (_186 = params.properties.lossObjectOwnerName) === null || _186 === void 0 ? void 0 : _186.values) !== null && _187 !== void 0 ? _187 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectRepairCostEstimatedOnType: {
                value: (_189 = (_188 = params.properties.lossObjectRepairCostEstimatedOnType) === null || _188 === void 0 ? void 0 : _188.value) !== null && _189 !== void 0 ? _189 : '',
                values: (_191 = (_190 = params.properties.lossObjectRepairCostEstimatedOnType) === null || _190 === void 0 ? void 0 : _190.values) !== null && _191 !== void 0 ? _191 : [],
                defaultValue: '',
                possibleValues: null,
            }, lossObjectQuantity: {
                value: (_193 = (_192 = params.properties.lossObjectQuantity) === null || _192 === void 0 ? void 0 : _192.value) !== null && _193 !== void 0 ? _193 : '',
                values: (_195 = (_194 = params.properties.lossObjectQuantity) === null || _194 === void 0 ? void 0 : _194.values) !== null && _195 !== void 0 ? _195 : [],
                defaultValue: '',
                possibleValues: null,
            }, theftIsTheftNoticed: {
                value: (_197 = (_196 = params.properties.theftIsTheftNoticed) === null || _196 === void 0 ? void 0 : _196.value) !== null && _197 !== void 0 ? _197 : '',
                values: (_199 = (_198 = params.properties.theftIsTheftNoticed) === null || _198 === void 0 ? void 0 : _198.values) !== null && _199 !== void 0 ? _199 : [],
                defaultValue: '',
                possibleValues: null,
            }, theftPlaceLastSeenDescr: {
                value: (_201 = (_200 = params.properties.theftPlaceLastSeenDescr) === null || _200 === void 0 ? void 0 : _200.value) !== null && _201 !== void 0 ? _201 : '',
                values: (_203 = (_202 = params.properties.theftPlaceLastSeenDescr) === null || _202 === void 0 ? void 0 : _202.values) !== null && _203 !== void 0 ? _203 : [],
                defaultValue: '',
                possibleValues: null,
            }, theftDateLastSeen: {
                value: (_205 = (_204 = params.properties.theftDateLastSeen) === null || _204 === void 0 ? void 0 : _204.value) !== null && _205 !== void 0 ? _205 : '',
                values: (_207 = (_206 = params.properties.theftDateLastSeen) === null || _206 === void 0 ? void 0 : _206.values) !== null && _207 !== void 0 ? _207 : [],
                defaultValue: '',
                possibleValues: null,
            }, theftTimeLastSeen: {
                value: (_209 = (_208 = params.properties.theftTimeLastSeen) === null || _208 === void 0 ? void 0 : _208.value) !== null && _209 !== void 0 ? _209 : '',
                values: (_211 = (_210 = params.properties.theftTimeLastSeen) === null || _210 === void 0 ? void 0 : _210.values) !== null && _211 !== void 0 ? _211 : [],
                defaultValue: '',
                possibleValues: null,
            }, theftDateNoticed: {
                value: (_213 = (_212 = params.properties.theftDateNoticed) === null || _212 === void 0 ? void 0 : _212.value) !== null && _213 !== void 0 ? _213 : '',
                values: (_215 = (_214 = params.properties.theftDateNoticed) === null || _214 === void 0 ? void 0 : _214.values) !== null && _215 !== void 0 ? _215 : [],
                defaultValue: '',
                possibleValues: null,
            }, theftTimeNoticed: {
                value: (_217 = (_216 = params.properties.theftTimeNoticed) === null || _216 === void 0 ? void 0 : _216.value) !== null && _217 !== void 0 ? _217 : '',
                values: (_219 = (_218 = params.properties.theftTimeNoticed) === null || _218 === void 0 ? void 0 : _218.values) !== null && _219 !== void 0 ? _219 : [],
                defaultValue: '',
                possibleValues: null,
            }, theftActivityDescr: {
                value: (_221 = (_220 = params.properties.theftActivityDescr) === null || _220 === void 0 ? void 0 : _220.value) !== null && _221 !== void 0 ? _221 : '',
                values: (_223 = (_222 = params.properties.theftActivityDescr) === null || _222 === void 0 ? void 0 : _222.values) !== null && _223 !== void 0 ? _223 : [],
                defaultValue: '',
                possibleValues: null,
            }, theftAdditionalDescr: {
                value: (_225 = (_224 = params.properties.theftAdditionalDescr) === null || _224 === void 0 ? void 0 : _224.value) !== null && _225 !== void 0 ? _225 : '',
                values: (_227 = (_226 = params.properties.theftAdditionalDescr) === null || _226 === void 0 ? void 0 : _226.values) !== null && _227 !== void 0 ? _227 : [],
                defaultValue: '',
                possibleValues: null,
            }, delayDestinationCountry: {
                value: (_229 = (_228 = params.properties.delayDestinationCountry) === null || _228 === void 0 ? void 0 : _228.value) !== null && _229 !== void 0 ? _229 : '',
                values: (_231 = (_230 = params.properties.delayDestinationCountry) === null || _230 === void 0 ? void 0 : _230.values) !== null && _231 !== void 0 ? _231 : [],
                defaultValue: '',
                possibleValues: null,
            }, delayOriginalArrivalDate: {
                value: (_233 = (_232 = params.properties.delayOriginalArrivalDate) === null || _232 === void 0 ? void 0 : _232.value) !== null && _233 !== void 0 ? _233 : '',
                values: (_235 = (_234 = params.properties.delayOriginalArrivalDate) === null || _234 === void 0 ? void 0 : _234.values) !== null && _235 !== void 0 ? _235 : [],
                defaultValue: '',
                possibleValues: null,
            }, delayOriginalArrivalTime: {
                value: (_237 = (_236 = params.properties.delayOriginalArrivalTime) === null || _236 === void 0 ? void 0 : _236.value) !== null && _237 !== void 0 ? _237 : '',
                values: (_239 = (_238 = params.properties.delayOriginalArrivalTime) === null || _238 === void 0 ? void 0 : _238.values) !== null && _239 !== void 0 ? _239 : [],
                defaultValue: '',
                possibleValues: null,
            }, delayActualArrivalDate: {
                value: (_241 = (_240 = params.properties.delayActualArrivalDate) === null || _240 === void 0 ? void 0 : _240.value) !== null && _241 !== void 0 ? _241 : '',
                values: (_243 = (_242 = params.properties.delayActualArrivalDate) === null || _242 === void 0 ? void 0 : _242.values) !== null && _243 !== void 0 ? _243 : [],
                defaultValue: '',
                possibleValues: null,
            }, delayActualArrivalTime: {
                value: (_245 = (_244 = params.properties.delayActualArrivalTime) === null || _244 === void 0 ? void 0 : _244.value) !== null && _245 !== void 0 ? _245 : '',
                values: (_247 = (_246 = params.properties.delayActualArrivalTime) === null || _246 === void 0 ? void 0 : _246.values) !== null && _247 !== void 0 ? _247 : [],
                defaultValue: '',
                possibleValues: null,
            }, delayQuantityOfLuggage: {
                value: (_249 = (_248 = params.properties.delayQuantityOfLuggage) === null || _248 === void 0 ? void 0 : _248.value) !== null && _249 !== void 0 ? _249 : '',
                values: (_251 = (_250 = params.properties.delayQuantityOfLuggage) === null || _250 === void 0 ? void 0 : _250.values) !== null && _251 !== void 0 ? _251 : [],
                defaultValue: '',
                possibleValues: null,
            }, delayNecessitiesCosts: {
                value: (_253 = (_252 = params.properties.delayNecessitiesCosts) === null || _252 === void 0 ? void 0 : _252.value) !== null && _253 !== void 0 ? _253 : '',
                values: (_255 = (_254 = params.properties.delayNecessitiesCosts) === null || _254 === void 0 ? void 0 : _254.values) !== null && _255 !== void 0 ? _255 : [],
                defaultValue: '',
                possibleValues: null,
            }, missingDestinationCountry: {
                value: (_257 = (_256 = params.properties.missingDestinationCountry) === null || _256 === void 0 ? void 0 : _256.value) !== null && _257 !== void 0 ? _257 : '',
                values: (_259 = (_258 = params.properties.missingDestinationCountry) === null || _258 === void 0 ? void 0 : _258.values) !== null && _259 !== void 0 ? _259 : [],
                defaultValue: '',
                possibleValues: null,
            }, missingOriginalArrivalDate: {
                value: (_261 = (_260 = params.properties.missingOriginalArrivalDate) === null || _260 === void 0 ? void 0 : _260.value) !== null && _261 !== void 0 ? _261 : '',
                values: (_263 = (_262 = params.properties.missingOriginalArrivalDate) === null || _262 === void 0 ? void 0 : _262.values) !== null && _263 !== void 0 ? _263 : [],
                defaultValue: '',
                possibleValues: null,
            }, missingOriginalArrivalTime: {
                value: (_265 = (_264 = params.properties.missingOriginalArrivalTime) === null || _264 === void 0 ? void 0 : _264.value) !== null && _265 !== void 0 ? _265 : '',
                values: (_267 = (_266 = params.properties.missingOriginalArrivalTime) === null || _266 === void 0 ? void 0 : _266.values) !== null && _267 !== void 0 ? _267 : [],
                defaultValue: '',
                possibleValues: null,
            }, pasiNotificationHtml: {
                value: (_269 = (_268 = params.properties.pasiNotificationHtml) === null || _268 === void 0 ? void 0 : _268.value) !== null && _269 !== void 0 ? _269 : '',
                values: (_271 = (_270 = params.properties.pasiNotificationHtml) === null || _270 === void 0 ? void 0 : _270.values) !== null && _271 !== void 0 ? _271 : [],
                defaultValue: '',
                possibleValues: null,
            }, channel: {
                value: (_273 = (_272 = params.properties.channel) === null || _272 === void 0 ? void 0 : _272.value) !== null && _273 !== void 0 ? _273 : '',
                values: (_275 = (_274 = params.properties.channel) === null || _274 === void 0 ? void 0 : _274.values) !== null && _275 !== void 0 ? _275 : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_277 = (_276 = params.properties.defaultValidationMessage) === null || _276 === void 0 ? void 0 : _276.value) !== null && _277 !== void 0 ? _277 : '',
                values: (_279 = (_278 = params.properties.defaultValidationMessage) === null || _278 === void 0 ? void 0 : _278.values) !== null && _279 !== void 0 ? _279 : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Finland_Travel_GetUserInformationNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { reporterSsn: {
                value: (_b = (_a = params.properties.reporterSsn) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.reporterSsn) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, defaultValidationMessage: {
                value: (_f = (_e = params.properties.defaultValidationMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.defaultValidationMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            } });
    }
}
export class Finland_InputCountryNode extends BaseNode {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        super(params);
        this.properties = Object.assign(Object.assign({}, this.properties), { inputPlaceholder: {
                value: (_b = (_a = params.properties.inputPlaceholder) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '',
                values: (_d = (_c = params.properties.inputPlaceholder) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [],
                defaultValue: '',
                possibleValues: null,
            }, noResultsFoundMessage: {
                value: (_f = (_e = params.properties.noResultsFoundMessage) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
                values: (_h = (_g = params.properties.noResultsFoundMessage) === null || _g === void 0 ? void 0 : _g.values) !== null && _h !== void 0 ? _h : [],
                defaultValue: '',
                possibleValues: null,
            }, allowAnyValue: {
                value: (_k = (_j = params.properties.allowAnyValue) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : '',
                values: (_m = (_l = params.properties.allowAnyValue) === null || _l === void 0 ? void 0 : _l.values) !== null && _m !== void 0 ? _m : [],
                defaultValue: 'false',
                possibleValues: ['true', 'false'],
            }, defaultValidationMessage: {
                value: (_p = (_o = params.properties.defaultValidationMessage) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                values: (_r = (_q = params.properties.defaultValidationMessage) === null || _q === void 0 ? void 0 : _q.values) !== null && _r !== void 0 ? _r : [],
                defaultValue: '',
                possibleValues: null,
            } });
        this.outputProperties = [
            {
                name: 'code',
                possibleValues: []
            }, {
                name: 'text',
                possibleValues: []
            }
        ];
    }
}
//# sourceMappingURL=nodeDefinitions.js.map